export default {
  cidades: [{
    'id': '1',
    'nome': 'Afonso Cláudio',
    'estado': 'ES'
  },
  {
    'id': '2',
    'nome': 'Água Doce do Norte',
    'estado': 'ES'
  },
  {
    'id': '3',
    'nome': 'Águia Branca',
    'estado': 'ES'
  },
  {
    'id': '4',
    'nome': 'Alegre',
    'estado': 'ES'
  },
  {
    'id': '5',
    'nome': 'Alfredo Chaves',
    'estado': 'ES'
  },
  {
    'id': '6',
    'nome': 'Alto Rio Novo',
    'estado': 'ES'
  },
  {
    'id': '7',
    'nome': 'Anchieta',
    'estado': 'ES'
  },
  {
    'id': '8',
    'nome': 'Apiacá',
    'estado': 'ES'
  },
  {
    'id': '9',
    'nome': 'Aracruz',
    'estado': 'ES'
  },
  {
    'id': '10',
    'nome': 'Atilio Vivacqua',
    'estado': 'ES'
  },
  {
    'id': '11',
    'nome': 'Baixo Guandu',
    'estado': 'ES'
  },
  {
    'id': '12',
    'nome': 'Barra de São Francisco',
    'estado': 'ES'
  },
  {
    'id': '13',
    'nome': 'Boa Esperança',
    'estado': 'ES'
  },
  {
    'id': '14',
    'nome': 'Bom Jesus do Norte',
    'estado': 'ES'
  },
  {
    'id': '15',
    'nome': 'Brejetuba',
    'estado': 'ES'
  },
  {
    'id': '16',
    'nome': 'Cachoeiro de Itapemirim',
    'estado': 'ES'
  },
  {
    'id': '17',
    'nome': 'Cariacica',
    'estado': 'ES'
  },
  {
    'id': '18',
    'nome': 'Castelo',
    'estado': 'ES'
  },
  {
    'id': '19',
    'nome': 'Colatina',
    'estado': 'ES'
  },
  {
    'id': '20',
    'nome': 'Conceição da Barra',
    'estado': 'ES'
  },
  {
    'id': '21',
    'nome': 'Conceição do Castelo',
    'estado': 'ES'
  },
  {
    'id': '22',
    'nome': 'Divino de São Lourenço',
    'estado': 'ES'
  },
  {
    'id': '23',
    'nome': 'Domingos Martins',
    'estado': 'ES'
  },
  {
    'id': '24',
    'nome': 'Dores do Rio Preto',
    'estado': 'ES'
  },
  {
    'id': '25',
    'nome': 'Ecoporanga',
    'estado': 'ES'
  },
  {
    'id': '26',
    'nome': 'Fundão',
    'estado': 'ES'
  },
  {
    'id': '27',
    'nome': 'Governador Lindenberg',
    'estado': 'ES'
  },
  {
    'id': '28',
    'nome': 'Guaçuí',
    'estado': 'ES'
  },
  {
    'id': '29',
    'nome': 'Guarapari',
    'estado': 'ES'
  },
  {
    'id': '30',
    'nome': 'Ibatiba',
    'estado': 'ES'
  },
  {
    'id': '31',
    'nome': 'Ibiraçu',
    'estado': 'ES'
  },
  {
    'id': '32',
    'nome': 'Ibitirama',
    'estado': 'ES'
  },
  {
    'id': '33',
    'nome': 'Iconha',
    'estado': 'ES'
  },
  {
    'id': '34',
    'nome': 'Irupi',
    'estado': 'ES'
  },
  {
    'id': '35',
    'nome': 'Itaguaçu',
    'estado': 'ES'
  },
  {
    'id': '36',
    'nome': 'Itapemirim',
    'estado': 'ES'
  },
  {
    'id': '37',
    'nome': 'Itarana',
    'estado': 'ES'
  },
  {
    'id': '38',
    'nome': 'Iúna',
    'estado': 'ES'
  },
  {
    'id': '39',
    'nome': 'Jaguaré',
    'estado': 'ES'
  },
  {
    'id': '40',
    'nome': 'Jerônimo Monteiro',
    'estado': 'ES'
  },
  {
    'id': '41',
    'nome': 'João Neiva',
    'estado': 'ES'
  },
  {
    'id': '42',
    'nome': 'Laranja da Terra',
    'estado': 'ES'
  },
  {
    'id': '43',
    'nome': 'Linhares',
    'estado': 'ES'
  },
  {
    'id': '44',
    'nome': 'Mantenópolis',
    'estado': 'ES'
  },
  {
    'id': '45',
    'nome': 'Marataízes',
    'estado': 'ES'
  },
  {
    'id': '46',
    'nome': 'Marechal Floriano',
    'estado': 'ES'
  },
  {
    'id': '47',
    'nome': 'Marilândia',
    'estado': 'ES'
  },
  {
    'id': '48',
    'nome': 'Mimoso do Sul',
    'estado': 'ES'
  },
  {
    'id': '49',
    'nome': 'Montanha',
    'estado': 'ES'
  },
  {
    'id': '50',
    'nome': 'Mucurici',
    'estado': 'ES'
  },
  {
    'id': '51',
    'nome': 'Muniz Freire',
    'estado': 'ES'
  },
  {
    'id': '52',
    'nome': 'Muqui',
    'estado': 'ES'
  },
  {
    'id': '53',
    'nome': 'Nova Venécia',
    'estado': 'ES'
  },
  {
    'id': '54',
    'nome': 'Pancas',
    'estado': 'ES'
  },
  {
    'id': '55',
    'nome': 'Pedro Canário',
    'estado': 'ES'
  },
  {
    'id': '56',
    'nome': 'Pinheiros',
    'estado': 'ES'
  },
  {
    'id': '57',
    'nome': 'Piúma',
    'estado': 'ES'
  },
  {
    'id': '58',
    'nome': 'Ponto Belo',
    'estado': 'ES'
  },
  {
    'id': '59',
    'nome': 'Presidente Kennedy',
    'estado': 'ES'
  },
  {
    'id': '60',
    'nome': 'Rio Bananal',
    'estado': 'ES'
  },
  {
    'id': '61',
    'nome': 'Rio Novo do Sul',
    'estado': 'ES'
  },
  {
    'id': '62',
    'nome': 'Santa Leopoldina',
    'estado': 'ES'
  },
  {
    'id': '63',
    'nome': 'Santa Maria de Jetibá',
    'estado': 'ES'
  },
  {
    'id': '64',
    'nome': 'Santa Teresa',
    'estado': 'ES'
  },
  {
    'id': '65',
    'nome': 'São Domingos do Norte',
    'estado': 'ES'
  },
  {
    'id': '66',
    'nome': 'São Gabriel da Palha',
    'estado': 'ES'
  },
  {
    'id': '67',
    'nome': 'São José do Calçado',
    'estado': 'ES'
  },
  {
    'id': '68',
    'nome': 'São Mateus',
    'estado': 'ES'
  },
  {
    'id': '69',
    'nome': 'São Roque do Canaã',
    'estado': 'ES'
  },
  {
    'id': '70',
    'nome': 'Serra',
    'estado': 'ES'
  },
  {
    'id': '71',
    'nome': 'Sooretama',
    'estado': 'ES'
  },
  {
    'id': '72',
    'nome': 'Vargem Alta',
    'estado': 'ES'
  },
  {
    'id': '73',
    'nome': 'Venda Nova do Imigrante',
    'estado': 'ES'
  },
  {
    'id': '74',
    'nome': 'Viana',
    'estado': 'ES'
  },
  {
    'id': '75',
    'nome': 'Vila Pavão',
    'estado': 'ES'
  },
  {
    'id': '76',
    'nome': 'Vila Valério',
    'estado': 'ES'
  },
  {
    'id': '77',
    'nome': 'Vila Velha',
    'estado': 'ES'
  },
  {
    'id': '78',
    'nome': 'Vitória',
    'estado': 'ES'
  },
  {
    'id': '79',
    'nome': 'Acrelândia',
    'estado': 'AC'
  },
  {
    'id': '80',
    'nome': 'Assis Brasil',
    'estado': 'AC'
  },
  {
    'id': '81',
    'nome': 'Brasiléia',
    'estado': 'AC'
  },
  {
    'id': '82',
    'nome': 'Bujari',
    'estado': 'AC'
  },
  {
    'id': '83',
    'nome': 'Capixaba',
    'estado': 'AC'
  },
  {
    'id': '84',
    'nome': 'Cruzeiro do Sul',
    'estado': 'AC'
  },
  {
    'id': '85',
    'nome': 'Epitaciolândia',
    'estado': 'AC'
  },
  {
    'id': '86',
    'nome': 'Feijó',
    'estado': 'AC'
  },
  {
    'id': '87',
    'nome': 'Jordão',
    'estado': 'AC'
  },
  {
    'id': '88',
    'nome': 'Mâncio Lima',
    'estado': 'AC'
  },
  {
    'id': '89',
    'nome': 'Manoel Urbano',
    'estado': 'AC'
  },
  {
    'id': '90',
    'nome': 'Marechal Thaumaturgo',
    'estado': 'AC'
  },
  {
    'id': '91',
    'nome': 'Plácido de Castro',
    'estado': 'AC'
  },
  {
    'id': '92',
    'nome': 'Porto Acre',
    'estado': 'AC'
  },
  {
    'id': '93',
    'nome': 'Porto Walter',
    'estado': 'AC'
  },
  {
    'id': '94',
    'nome': 'Rio Branco',
    'estado': 'AC'
  },
  {
    'id': '95',
    'nome': 'Rodrigues Alves',
    'estado': 'AC'
  },
  {
    'id': '96',
    'nome': 'Santa Rosa do Purus',
    'estado': 'AC'
  },
  {
    'id': '97',
    'nome': 'Sena Madureira',
    'estado': 'AC'
  },
  {
    'id': '98',
    'nome': 'Senador Guiomard',
    'estado': 'AC'
  },
  {
    'id': '99',
    'nome': 'Tarauacá',
    'estado': 'AC'
  },
  {
    'id': '100',
    'nome': 'Xapuri',
    'estado': 'AC'
  },
  {
    'id': '101',
    'nome': 'Água Branca',
    'estado': 'AL'
  },
  {
    'id': '102',
    'nome': 'Anadia',
    'estado': 'AL'
  },
  {
    'id': '103',
    'nome': 'Arapiraca',
    'estado': 'AL'
  },
  {
    'id': '104',
    'nome': 'Atalaia',
    'estado': 'AL'
  },
  {
    'id': '105',
    'nome': 'Barra de Santo Antônio',
    'estado': 'AL'
  },
  {
    'id': '106',
    'nome': 'Barra de São Miguel',
    'estado': 'AL'
  },
  {
    'id': '107',
    'nome': 'Batalha',
    'estado': 'AL'
  },
  {
    'id': '108',
    'nome': 'Belém',
    'estado': 'AL'
  },
  {
    'id': '109',
    'nome': 'Belo Monte',
    'estado': 'AL'
  },
  {
    'id': '110',
    'nome': 'Boca da Mata',
    'estado': 'AL'
  },
  {
    'id': '111',
    'nome': 'Branquinha',
    'estado': 'AL'
  },
  {
    'id': '112',
    'nome': 'Cacimbinhas',
    'estado': 'AL'
  },
  {
    'id': '113',
    'nome': 'Cajueiro',
    'estado': 'AL'
  },
  {
    'id': '114',
    'nome': 'Campestre',
    'estado': 'AL'
  },
  {
    'id': '115',
    'nome': 'Campo Alegre',
    'estado': 'AL'
  },
  {
    'id': '116',
    'nome': 'Campo Grande',
    'estado': 'AL'
  },
  {
    'id': '117',
    'nome': 'Canapi',
    'estado': 'AL'
  },
  {
    'id': '118',
    'nome': 'Capela',
    'estado': 'AL'
  },
  {
    'id': '119',
    'nome': 'Carneiros',
    'estado': 'AL'
  },
  {
    'id': '120',
    'nome': 'Chã Preta',
    'estado': 'AL'
  },
  {
    'id': '121',
    'nome': 'Coité do Nóia',
    'estado': 'AL'
  },
  {
    'id': '122',
    'nome': 'Colônia Leopoldina',
    'estado': 'AL'
  },
  {
    'id': '123',
    'nome': 'Coqueiro Seco',
    'estado': 'AL'
  },
  {
    'id': '124',
    'nome': 'Coruripe',
    'estado': 'AL'
  },
  {
    'id': '125',
    'nome': 'Craíbas',
    'estado': 'AL'
  },
  {
    'id': '126',
    'nome': 'Delmiro Gouveia',
    'estado': 'AL'
  },
  {
    'id': '127',
    'nome': 'Dois Riachos',
    'estado': 'AL'
  },
  {
    'id': '128',
    'nome': 'Estrela de Alagoas',
    'estado': 'AL'
  },
  {
    'id': '129',
    'nome': 'Feira Grande',
    'estado': 'AL'
  },
  {
    'id': '130',
    'nome': 'Feliz Deserto',
    'estado': 'AL'
  },
  {
    'id': '131',
    'nome': 'Flexeiras',
    'estado': 'AL'
  },
  {
    'id': '132',
    'nome': 'Girau do Ponciano',
    'estado': 'AL'
  },
  {
    'id': '133',
    'nome': 'Ibateguara',
    'estado': 'AL'
  },
  {
    'id': '134',
    'nome': 'Igaci',
    'estado': 'AL'
  },
  {
    'id': '135',
    'nome': 'Igreja Nova',
    'estado': 'AL'
  },
  {
    'id': '136',
    'nome': 'Inhapi',
    'estado': 'AL'
  },
  {
    'id': '137',
    'nome': 'Jacaré dos Homens',
    'estado': 'AL'
  },
  {
    'id': '138',
    'nome': 'Jacuípe',
    'estado': 'AL'
  },
  {
    'id': '139',
    'nome': 'Japaratinga',
    'estado': 'AL'
  },
  {
    'id': '140',
    'nome': 'Jaramataia',
    'estado': 'AL'
  },
  {
    'id': '141',
    'nome': 'Jequiá da Praia',
    'estado': 'AL'
  },
  {
    'id': '142',
    'nome': 'Joaquim Gomes',
    'estado': 'AL'
  },
  {
    'id': '143',
    'nome': 'Jundiá',
    'estado': 'AL'
  },
  {
    'id': '144',
    'nome': 'Junqueiro',
    'estado': 'AL'
  },
  {
    'id': '145',
    'nome': 'Lagoa da Canoa',
    'estado': 'AL'
  },
  {
    'id': '146',
    'nome': 'Limoeiro de Anadia',
    'estado': 'AL'
  },
  {
    'id': '147',
    'nome': 'Maceió',
    'estado': 'AL'
  },
  {
    'id': '148',
    'nome': 'Major Isidoro',
    'estado': 'AL'
  },
  {
    'id': '149',
    'nome': 'Mar Vermelho',
    'estado': 'AL'
  },
  {
    'id': '150',
    'nome': 'Maragogi',
    'estado': 'AL'
  },
  {
    'id': '151',
    'nome': 'Maravilha',
    'estado': 'AL'
  },
  {
    'id': '152',
    'nome': 'Marechal Deodoro',
    'estado': 'AL'
  },
  {
    'id': '153',
    'nome': 'Maribondo',
    'estado': 'AL'
  },
  {
    'id': '154',
    'nome': 'Mata Grande',
    'estado': 'AL'
  },
  {
    'id': '155',
    'nome': 'Matriz de Camaragibe',
    'estado': 'AL'
  },
  {
    'id': '156',
    'nome': 'Messias',
    'estado': 'AL'
  },
  {
    'id': '157',
    'nome': 'Minador do Negrão',
    'estado': 'AL'
  },
  {
    'id': '158',
    'nome': 'Monteirópolis',
    'estado': 'AL'
  },
  {
    'id': '159',
    'nome': 'Murici',
    'estado': 'AL'
  },
  {
    'id': '160',
    'nome': 'Novo Lino',
    'estado': 'AL'
  },
  {
    'id': '161',
    'nome': 'Olho d`Água das Flores',
    'estado': 'AL'
  },
  {
    'id': '162',
    'nome': 'Olho d`Água do Casado',
    'estado': 'AL'
  },
  {
    'id': '163',
    'nome': 'Olho d`Água Grande',
    'estado': 'AL'
  },
  {
    'id': '164',
    'nome': 'Olivença',
    'estado': 'AL'
  },
  {
    'id': '165',
    'nome': 'Ouro Branco',
    'estado': 'AL'
  },
  {
    'id': '166',
    'nome': 'Palestina',
    'estado': 'AL'
  },
  {
    'id': '167',
    'nome': 'Palmeira dos Índios',
    'estado': 'AL'
  },
  {
    'id': '168',
    'nome': 'Pão de Açúcar',
    'estado': 'AL'
  },
  {
    'id': '169',
    'nome': 'Pariconha',
    'estado': 'AL'
  },
  {
    'id': '170',
    'nome': 'Paripueira',
    'estado': 'AL'
  },
  {
    'id': '171',
    'nome': 'Passo de Camaragibe',
    'estado': 'AL'
  },
  {
    'id': '172',
    'nome': 'Paulo Jacinto',
    'estado': 'AL'
  },
  {
    'id': '173',
    'nome': 'Penedo',
    'estado': 'AL'
  },
  {
    'id': '174',
    'nome': 'Piaçabuçu',
    'estado': 'AL'
  },
  {
    'id': '175',
    'nome': 'Pilar',
    'estado': 'AL'
  },
  {
    'id': '176',
    'nome': 'Pindoba',
    'estado': 'AL'
  },
  {
    'id': '177',
    'nome': 'Piranhas',
    'estado': 'AL'
  },
  {
    'id': '178',
    'nome': 'Poço das Trincheiras',
    'estado': 'AL'
  },
  {
    'id': '179',
    'nome': 'Porto Calvo',
    'estado': 'AL'
  },
  {
    'id': '180',
    'nome': 'Porto de Pedras',
    'estado': 'AL'
  },
  {
    'id': '181',
    'nome': 'Porto Real do Colégio',
    'estado': 'AL'
  },
  {
    'id': '182',
    'nome': 'Quebrangulo',
    'estado': 'AL'
  },
  {
    'id': '183',
    'nome': 'Rio Largo',
    'estado': 'AL'
  },
  {
    'id': '184',
    'nome': 'Roteiro',
    'estado': 'AL'
  },
  {
    'id': '185',
    'nome': 'Santa Luzia do Norte',
    'estado': 'AL'
  },
  {
    'id': '186',
    'nome': 'Santana do Ipanema',
    'estado': 'AL'
  },
  {
    'id': '187',
    'nome': 'Santana do Mundaú',
    'estado': 'AL'
  },
  {
    'id': '188',
    'nome': 'São Brás',
    'estado': 'AL'
  },
  {
    'id': '189',
    'nome': 'São José da Laje',
    'estado': 'AL'
  },
  {
    'id': '190',
    'nome': 'São José da Tapera',
    'estado': 'AL'
  },
  {
    'id': '191',
    'nome': 'São Luís do Quitunde',
    'estado': 'AL'
  },
  {
    'id': '192',
    'nome': 'São Miguel dos Campos',
    'estado': 'AL'
  },
  {
    'id': '193',
    'nome': 'São Miguel dos Milagres',
    'estado': 'AL'
  },
  {
    'id': '194',
    'nome': 'São Sebastião',
    'estado': 'AL'
  },
  {
    'id': '195',
    'nome': 'Satuba',
    'estado': 'AL'
  },
  {
    'id': '196',
    'nome': 'Senador Rui Palmeira',
    'estado': 'AL'
  },
  {
    'id': '197',
    'nome': 'Tanque d`Arca',
    'estado': 'AL'
  },
  {
    'id': '198',
    'nome': 'Taquarana',
    'estado': 'AL'
  },
  {
    'id': '199',
    'nome': 'Teotônio Vilela',
    'estado': 'AL'
  },
  {
    'id': '200',
    'nome': 'Traipu',
    'estado': 'AL'
  },
  {
    'id': '201',
    'nome': 'União dos Palmares',
    'estado': 'AL'
  },
  {
    'id': '202',
    'nome': 'Viçosa',
    'estado': 'AL'
  },
  {
    'id': '203',
    'nome': 'Amapá',
    'estado': 'AP'
  },
  {
    'id': '204',
    'nome': 'Calçoene',
    'estado': 'AP'
  },
  {
    'id': '205',
    'nome': 'Cutias',
    'estado': 'AP'
  },
  {
    'id': '206',
    'nome': 'Ferreira Gomes',
    'estado': 'AP'
  },
  {
    'id': '207',
    'nome': 'Itaubal',
    'estado': 'AP'
  },
  {
    'id': '208',
    'nome': 'Laranjal do Jari',
    'estado': 'AP'
  },
  {
    'id': '209',
    'nome': 'Macapá',
    'estado': 'AP'
  },
  {
    'id': '210',
    'nome': 'Mazagão',
    'estado': 'AP'
  },
  {
    'id': '211',
    'nome': 'Oiapoque',
    'estado': 'AP'
  },
  {
    'id': '212',
    'nome': 'Pedra Branca do Amaparí',
    'estado': 'AP'
  },
  {
    'id': '213',
    'nome': 'Porto Grande',
    'estado': 'AP'
  },
  {
    'id': '214',
    'nome': 'Pracuúba',
    'estado': 'AP'
  },
  {
    'id': '215',
    'nome': 'Santana',
    'estado': 'AP'
  },
  {
    'id': '216',
    'nome': 'Serra do Navio',
    'estado': 'AP'
  },
  {
    'id': '217',
    'nome': 'Tartarugalzinho',
    'estado': 'AP'
  },
  {
    'id': '218',
    'nome': 'Vitória do Jari',
    'estado': 'AP'
  },
  {
    'id': '219',
    'nome': 'Alvarães',
    'estado': 'AM'
  },
  {
    'id': '220',
    'nome': 'Amaturá',
    'estado': 'AM'
  },
  {
    'id': '221',
    'nome': 'Anamã',
    'estado': 'AM'
  },
  {
    'id': '222',
    'nome': 'Anori',
    'estado': 'AM'
  },
  {
    'id': '223',
    'nome': 'Apuí',
    'estado': 'AM'
  },
  {
    'id': '224',
    'nome': 'Atalaia do Norte',
    'estado': 'AM'
  },
  {
    'id': '225',
    'nome': 'Autazes',
    'estado': 'AM'
  },
  {
    'id': '226',
    'nome': 'Barcelos',
    'estado': 'AM'
  },
  {
    'id': '227',
    'nome': 'Barreirinha',
    'estado': 'AM'
  },
  {
    'id': '228',
    'nome': 'Benjamin Constant',
    'estado': 'AM'
  },
  {
    'id': '229',
    'nome': 'Beruri',
    'estado': 'AM'
  },
  {
    'id': '230',
    'nome': 'Boa Vista do Ramos',
    'estado': 'AM'
  },
  {
    'id': '231',
    'nome': 'Boca do Acre',
    'estado': 'AM'
  },
  {
    'id': '232',
    'nome': 'Borba',
    'estado': 'AM'
  },
  {
    'id': '233',
    'nome': 'Caapiranga',
    'estado': 'AM'
  },
  {
    'id': '234',
    'nome': 'Canutama',
    'estado': 'AM'
  },
  {
    'id': '235',
    'nome': 'Carauari',
    'estado': 'AM'
  },
  {
    'id': '236',
    'nome': 'Careiro',
    'estado': 'AM'
  },
  {
    'id': '237',
    'nome': 'Careiro da Várzea',
    'estado': 'AM'
  },
  {
    'id': '238',
    'nome': 'Coari',
    'estado': 'AM'
  },
  {
    'id': '239',
    'nome': 'Codajás',
    'estado': 'AM'
  },
  {
    'id': '240',
    'nome': 'Eirunepé',
    'estado': 'AM'
  },
  {
    'id': '241',
    'nome': 'Envira',
    'estado': 'AM'
  },
  {
    'id': '242',
    'nome': 'Fonte Boa',
    'estado': 'AM'
  },
  {
    'id': '243',
    'nome': 'Guajará',
    'estado': 'AM'
  },
  {
    'id': '244',
    'nome': 'Humaitá',
    'estado': 'AM'
  },
  {
    'id': '245',
    'nome': 'Ipixuna',
    'estado': 'AM'
  },
  {
    'id': '246',
    'nome': 'Iranduba',
    'estado': 'AM'
  },
  {
    'id': '247',
    'nome': 'Itacoatiara',
    'estado': 'AM'
  },
  {
    'id': '248',
    'nome': 'Itamarati',
    'estado': 'AM'
  },
  {
    'id': '249',
    'nome': 'Itapiranga',
    'estado': 'AM'
  },
  {
    'id': '250',
    'nome': 'Japurá',
    'estado': 'AM'
  },
  {
    'id': '251',
    'nome': 'Juruá',
    'estado': 'AM'
  },
  {
    'id': '252',
    'nome': 'Jutaí',
    'estado': 'AM'
  },
  {
    'id': '253',
    'nome': 'Lábrea',
    'estado': 'AM'
  },
  {
    'id': '254',
    'nome': 'Manacapuru',
    'estado': 'AM'
  },
  {
    'id': '255',
    'nome': 'Manaquiri',
    'estado': 'AM'
  },
  {
    'id': '256',
    'nome': 'Manaus',
    'estado': 'AM'
  },
  {
    'id': '257',
    'nome': 'Manicoré',
    'estado': 'AM'
  },
  {
    'id': '258',
    'nome': 'Maraã',
    'estado': 'AM'
  },
  {
    'id': '259',
    'nome': 'Maués',
    'estado': 'AM'
  },
  {
    'id': '260',
    'nome': 'Nhamundá',
    'estado': 'AM'
  },
  {
    'id': '261',
    'nome': 'Nova Olinda do Norte',
    'estado': 'AM'
  },
  {
    'id': '262',
    'nome': 'Novo Airão',
    'estado': 'AM'
  },
  {
    'id': '263',
    'nome': 'Novo Aripuanã',
    'estado': 'AM'
  },
  {
    'id': '264',
    'nome': 'Parintins',
    'estado': 'AM'
  },
  {
    'id': '265',
    'nome': 'Pauini',
    'estado': 'AM'
  },
  {
    'id': '266',
    'nome': 'Presidente Figueiredo',
    'estado': 'AM'
  },
  {
    'id': '267',
    'nome': 'Rio Preto da Eva',
    'estado': 'AM'
  },
  {
    'id': '268',
    'nome': 'Santa Isabel do Rio Negro',
    'estado': 'AM'
  },
  {
    'id': '269',
    'nome': 'Santo Antônio do Içá',
    'estado': 'AM'
  },
  {
    'id': '270',
    'nome': 'São Gabriel da Cachoeira',
    'estado': 'AM'
  },
  {
    'id': '271',
    'nome': 'São Paulo de Olivença',
    'estado': 'AM'
  },
  {
    'id': '272',
    'nome': 'São Sebastião do Uatumã',
    'estado': 'AM'
  },
  {
    'id': '273',
    'nome': 'Silves',
    'estado': 'AM'
  },
  {
    'id': '274',
    'nome': 'Tabatinga',
    'estado': 'AM'
  },
  {
    'id': '275',
    'nome': 'Tapauá',
    'estado': 'AM'
  },
  {
    'id': '276',
    'nome': 'Tefé',
    'estado': 'AM'
  },
  {
    'id': '277',
    'nome': 'Tonantins',
    'estado': 'AM'
  },
  {
    'id': '278',
    'nome': 'Uarini',
    'estado': 'AM'
  },
  {
    'id': '279',
    'nome': 'Urucará',
    'estado': 'AM'
  },
  {
    'id': '280',
    'nome': 'Urucurituba',
    'estado': 'AM'
  },
  {
    'id': '281',
    'nome': 'Abaíra',
    'estado': 'BA'
  },
  {
    'id': '282',
    'nome': 'Abaré',
    'estado': 'BA'
  },
  {
    'id': '283',
    'nome': 'Acajutiba',
    'estado': 'BA'
  },
  {
    'id': '284',
    'nome': 'Adustina',
    'estado': 'BA'
  },
  {
    'id': '285',
    'nome': 'Água Fria',
    'estado': 'BA'
  },
  {
    'id': '286',
    'nome': 'Aiquara',
    'estado': 'BA'
  },
  {
    'id': '287',
    'nome': 'Alagoinhas',
    'estado': 'BA'
  },
  {
    'id': '288',
    'nome': 'Alcobaça',
    'estado': 'BA'
  },
  {
    'id': '289',
    'nome': 'Almadina',
    'estado': 'BA'
  },
  {
    'id': '290',
    'nome': 'Amargosa',
    'estado': 'BA'
  },
  {
    'id': '291',
    'nome': 'Amélia Rodrigues',
    'estado': 'BA'
  },
  {
    'id': '292',
    'nome': 'América Dourada',
    'estado': 'BA'
  },
  {
    'id': '293',
    'nome': 'Anagé',
    'estado': 'BA'
  },
  {
    'id': '294',
    'nome': 'Andaraí',
    'estado': 'BA'
  },
  {
    'id': '295',
    'nome': 'Andorinha',
    'estado': 'BA'
  },
  {
    'id': '296',
    'nome': 'Angical',
    'estado': 'BA'
  },
  {
    'id': '297',
    'nome': 'Anguera',
    'estado': 'BA'
  },
  {
    'id': '298',
    'nome': 'Antas',
    'estado': 'BA'
  },
  {
    'id': '299',
    'nome': 'Antônio Cardoso',
    'estado': 'BA'
  },
  {
    'id': '300',
    'nome': 'Antônio Gonçalves',
    'estado': 'BA'
  },
  {
    'id': '301',
    'nome': 'Aporá',
    'estado': 'BA'
  },
  {
    'id': '302',
    'nome': 'Apuarema',
    'estado': 'BA'
  },
  {
    'id': '303',
    'nome': 'Araças',
    'estado': 'BA'
  },
  {
    'id': '304',
    'nome': 'Aracatu',
    'estado': 'BA'
  },
  {
    'id': '305',
    'nome': 'Araci',
    'estado': 'BA'
  },
  {
    'id': '306',
    'nome': 'Aramari',
    'estado': 'BA'
  },
  {
    'id': '307',
    'nome': 'Arataca',
    'estado': 'BA'
  },
  {
    'id': '308',
    'nome': 'Aratuípe',
    'estado': 'BA'
  },
  {
    'id': '309',
    'nome': 'Aurelino Leal',
    'estado': 'BA'
  },
  {
    'id': '310',
    'nome': 'Baianópolis',
    'estado': 'BA'
  },
  {
    'id': '311',
    'nome': 'Baixa Grande',
    'estado': 'BA'
  },
  {
    'id': '312',
    'nome': 'Banzaê',
    'estado': 'BA'
  },
  {
    'id': '313',
    'nome': 'Barra',
    'estado': 'BA'
  },
  {
    'id': '314',
    'nome': 'Barra da Estiva',
    'estado': 'BA'
  },
  {
    'id': '315',
    'nome': 'Barra do Choça',
    'estado': 'BA'
  },
  {
    'id': '316',
    'nome': 'Barra do Mendes',
    'estado': 'BA'
  },
  {
    'id': '317',
    'nome': 'Barra do Rocha',
    'estado': 'BA'
  },
  {
    'id': '318',
    'nome': 'Barreiras',
    'estado': 'BA'
  },
  {
    'id': '319',
    'nome': 'Barro Alto',
    'estado': 'BA'
  },
  {
    'id': '320',
    'nome': 'Barro Preto (antigo Gov. Lomanto Jr.)',
    'estado': 'BA'
  },
  {
    'id': '321',
    'nome': 'Barrocas',
    'estado': 'BA'
  },
  {
    'id': '322',
    'nome': 'Belmonte',
    'estado': 'BA'
  },
  {
    'id': '323',
    'nome': 'Belo Campo',
    'estado': 'BA'
  },
  {
    'id': '324',
    'nome': 'Biritinga',
    'estado': 'BA'
  },
  {
    'id': '325',
    'nome': 'Boa Nova',
    'estado': 'BA'
  },
  {
    'id': '326',
    'nome': 'Boa Vista do Tupim',
    'estado': 'BA'
  },
  {
    'id': '327',
    'nome': 'Bom Jesus da Lapa',
    'estado': 'BA'
  },
  {
    'id': '328',
    'nome': 'Bom Jesus da Serra',
    'estado': 'BA'
  },
  {
    'id': '329',
    'nome': 'Boninal',
    'estado': 'BA'
  },
  {
    'id': '330',
    'nome': 'Bonito',
    'estado': 'BA'
  },
  {
    'id': '331',
    'nome': 'Boquira',
    'estado': 'BA'
  },
  {
    'id': '332',
    'nome': 'Botuporã',
    'estado': 'BA'
  },
  {
    'id': '333',
    'nome': 'Brejões',
    'estado': 'BA'
  },
  {
    'id': '334',
    'nome': 'Brejolândia',
    'estado': 'BA'
  },
  {
    'id': '335',
    'nome': 'Brotas de Macaúbas',
    'estado': 'BA'
  },
  {
    'id': '336',
    'nome': 'Brumado',
    'estado': 'BA'
  },
  {
    'id': '337',
    'nome': 'Buerarema',
    'estado': 'BA'
  },
  {
    'id': '338',
    'nome': 'Buritirama',
    'estado': 'BA'
  },
  {
    'id': '339',
    'nome': 'Caatiba',
    'estado': 'BA'
  },
  {
    'id': '340',
    'nome': 'Cabaceiras do Paraguaçu',
    'estado': 'BA'
  },
  {
    'id': '341',
    'nome': 'Cachoeira',
    'estado': 'BA'
  },
  {
    'id': '342',
    'nome': 'Caculé',
    'estado': 'BA'
  },
  {
    'id': '343',
    'nome': 'Caém',
    'estado': 'BA'
  },
  {
    'id': '344',
    'nome': 'Caetanos',
    'estado': 'BA'
  },
  {
    'id': '345',
    'nome': 'Caetité',
    'estado': 'BA'
  },
  {
    'id': '346',
    'nome': 'Cafarnaum',
    'estado': 'BA'
  },
  {
    'id': '347',
    'nome': 'Cairu',
    'estado': 'BA'
  },
  {
    'id': '348',
    'nome': 'Caldeirão Grande',
    'estado': 'BA'
  },
  {
    'id': '349',
    'nome': 'Camacan',
    'estado': 'BA'
  },
  {
    'id': '350',
    'nome': 'Camaçari',
    'estado': 'BA'
  },
  {
    'id': '351',
    'nome': 'Camamu',
    'estado': 'BA'
  },
  {
    'id': '352',
    'nome': 'Campo Alegre de Lourdes',
    'estado': 'BA'
  },
  {
    'id': '353',
    'nome': 'Campo Formoso',
    'estado': 'BA'
  },
  {
    'id': '354',
    'nome': 'Canápolis',
    'estado': 'BA'
  },
  {
    'id': '355',
    'nome': 'Canarana',
    'estado': 'BA'
  },
  {
    'id': '356',
    'nome': 'Canavieiras',
    'estado': 'BA'
  },
  {
    'id': '357',
    'nome': 'Candeal',
    'estado': 'BA'
  },
  {
    'id': '358',
    'nome': 'Candeias',
    'estado': 'BA'
  },
  {
    'id': '359',
    'nome': 'Candiba',
    'estado': 'BA'
  },
  {
    'id': '360',
    'nome': 'Cândido Sales',
    'estado': 'BA'
  },
  {
    'id': '361',
    'nome': 'Cansanção',
    'estado': 'BA'
  },
  {
    'id': '362',
    'nome': 'Canudos',
    'estado': 'BA'
  },
  {
    'id': '363',
    'nome': 'Capela do Alto Alegre',
    'estado': 'BA'
  },
  {
    'id': '364',
    'nome': 'Capim Grosso',
    'estado': 'BA'
  },
  {
    'id': '365',
    'nome': 'Caraíbas',
    'estado': 'BA'
  },
  {
    'id': '366',
    'nome': 'Caravelas',
    'estado': 'BA'
  },
  {
    'id': '367',
    'nome': 'Cardeal da Silva',
    'estado': 'BA'
  },
  {
    'id': '368',
    'nome': 'Carinhanha',
    'estado': 'BA'
  },
  {
    'id': '369',
    'nome': 'Casa Nova',
    'estado': 'BA'
  },
  {
    'id': '370',
    'nome': 'Castro Alves',
    'estado': 'BA'
  },
  {
    'id': '371',
    'nome': 'Catolândia',
    'estado': 'BA'
  },
  {
    'id': '372',
    'nome': 'Catu',
    'estado': 'BA'
  },
  {
    'id': '373',
    'nome': 'Caturama',
    'estado': 'BA'
  },
  {
    'id': '374',
    'nome': 'Central',
    'estado': 'BA'
  },
  {
    'id': '375',
    'nome': 'Chorrochó',
    'estado': 'BA'
  },
  {
    'id': '376',
    'nome': 'Cícero Dantas',
    'estado': 'BA'
  },
  {
    'id': '377',
    'nome': 'Cipó',
    'estado': 'BA'
  },
  {
    'id': '378',
    'nome': 'Coaraci',
    'estado': 'BA'
  },
  {
    'id': '379',
    'nome': 'Cocos',
    'estado': 'BA'
  },
  {
    'id': '380',
    'nome': 'Conceição da Feira',
    'estado': 'BA'
  },
  {
    'id': '381',
    'nome': 'Conceição do Almeida',
    'estado': 'BA'
  },
  {
    'id': '382',
    'nome': 'Conceição do Coité',
    'estado': 'BA'
  },
  {
    'id': '383',
    'nome': 'Conceição do Jacuípe',
    'estado': 'BA'
  },
  {
    'id': '384',
    'nome': 'Conde',
    'estado': 'BA'
  },
  {
    'id': '385',
    'nome': 'Condeúba',
    'estado': 'BA'
  },
  {
    'id': '386',
    'nome': 'Contendas do Sincorá',
    'estado': 'BA'
  },
  {
    'id': '387',
    'nome': 'Coração de Maria',
    'estado': 'BA'
  },
  {
    'id': '388',
    'nome': 'Cordeiros',
    'estado': 'BA'
  },
  {
    'id': '389',
    'nome': 'Coribe',
    'estado': 'BA'
  },
  {
    'id': '390',
    'nome': 'Coronel João Sá',
    'estado': 'BA'
  },
  {
    'id': '391',
    'nome': 'Correntina',
    'estado': 'BA'
  },
  {
    'id': '392',
    'nome': 'Cotegipe',
    'estado': 'BA'
  },
  {
    'id': '393',
    'nome': 'Cravolândia',
    'estado': 'BA'
  },
  {
    'id': '394',
    'nome': 'Crisópolis',
    'estado': 'BA'
  },
  {
    'id': '395',
    'nome': 'Cristópolis',
    'estado': 'BA'
  },
  {
    'id': '396',
    'nome': 'Cruz das Almas',
    'estado': 'BA'
  },
  {
    'id': '397',
    'nome': 'Curaçá',
    'estado': 'BA'
  },
  {
    'id': '398',
    'nome': 'Dário Meira',
    'estado': 'BA'
  },
  {
    'id': '399',
    'nome': 'Dias d`Ávila',
    'estado': 'BA'
  },
  {
    'id': '400',
    'nome': 'Dom Basílio',
    'estado': 'BA'
  },
  {
    'id': '401',
    'nome': 'Dom Macedo Costa',
    'estado': 'BA'
  },
  {
    'id': '402',
    'nome': 'Elísio Medrado',
    'estado': 'BA'
  },
  {
    'id': '403',
    'nome': 'Encruzilhada',
    'estado': 'BA'
  },
  {
    'id': '404',
    'nome': 'Entre Rios',
    'estado': 'BA'
  },
  {
    'id': '405',
    'nome': 'Érico Cardoso',
    'estado': 'BA'
  },
  {
    'id': '406',
    'nome': 'Esplanada',
    'estado': 'BA'
  },
  {
    'id': '407',
    'nome': 'Euclides da Cunha',
    'estado': 'BA'
  },
  {
    'id': '408',
    'nome': 'Eunápolis',
    'estado': 'BA'
  },
  {
    'id': '409',
    'nome': 'Fátima',
    'estado': 'BA'
  },
  {
    'id': '410',
    'nome': 'Feira da Mata',
    'estado': 'BA'
  },
  {
    'id': '411',
    'nome': 'Feira de Santana',
    'estado': 'BA'
  },
  {
    'id': '412',
    'nome': 'Filadélfia',
    'estado': 'BA'
  },
  {
    'id': '413',
    'nome': 'Firmino Alves',
    'estado': 'BA'
  },
  {
    'id': '414',
    'nome': 'Floresta Azul',
    'estado': 'BA'
  },
  {
    'id': '415',
    'nome': 'Formosa do Rio Preto',
    'estado': 'BA'
  },
  {
    'id': '416',
    'nome': 'Gandu',
    'estado': 'BA'
  },
  {
    'id': '417',
    'nome': 'Gavião',
    'estado': 'BA'
  },
  {
    'id': '418',
    'nome': 'Gentio do Ouro',
    'estado': 'BA'
  },
  {
    'id': '419',
    'nome': 'Glória',
    'estado': 'BA'
  },
  {
    'id': '420',
    'nome': 'Gongogi',
    'estado': 'BA'
  },
  {
    'id': '421',
    'nome': 'Governador Mangabeira',
    'estado': 'BA'
  },
  {
    'id': '422',
    'nome': 'Guajeru',
    'estado': 'BA'
  },
  {
    'id': '423',
    'nome': 'Guanambi',
    'estado': 'BA'
  },
  {
    'id': '424',
    'nome': 'Guaratinga',
    'estado': 'BA'
  },
  {
    'id': '425',
    'nome': 'Heliópolis',
    'estado': 'BA'
  },
  {
    'id': '426',
    'nome': 'Iaçu',
    'estado': 'BA'
  },
  {
    'id': '427',
    'nome': 'Ibiassucê',
    'estado': 'BA'
  },
  {
    'id': '428',
    'nome': 'Ibicaraí',
    'estado': 'BA'
  },
  {
    'id': '429',
    'nome': 'Ibicoara',
    'estado': 'BA'
  },
  {
    'id': '430',
    'nome': 'Ibicuí',
    'estado': 'BA'
  },
  {
    'id': '431',
    'nome': 'Ibipeba',
    'estado': 'BA'
  },
  {
    'id': '432',
    'nome': 'Ibipitanga',
    'estado': 'BA'
  },
  {
    'id': '433',
    'nome': 'Ibiquera',
    'estado': 'BA'
  },
  {
    'id': '434',
    'nome': 'Ibirapitanga',
    'estado': 'BA'
  },
  {
    'id': '435',
    'nome': 'Ibirapuã',
    'estado': 'BA'
  },
  {
    'id': '436',
    'nome': 'Ibirataia',
    'estado': 'BA'
  },
  {
    'id': '437',
    'nome': 'Ibitiara',
    'estado': 'BA'
  },
  {
    'id': '438',
    'nome': 'Ibititá',
    'estado': 'BA'
  },
  {
    'id': '439',
    'nome': 'Ibotirama',
    'estado': 'BA'
  },
  {
    'id': '440',
    'nome': 'Ichu',
    'estado': 'BA'
  },
  {
    'id': '441',
    'nome': 'Igaporã',
    'estado': 'BA'
  },
  {
    'id': '442',
    'nome': 'Igrapiúna',
    'estado': 'BA'
  },
  {
    'id': '443',
    'nome': 'Iguaí',
    'estado': 'BA'
  },
  {
    'id': '444',
    'nome': 'Ilhéus',
    'estado': 'BA'
  },
  {
    'id': '445',
    'nome': 'Inhambupe',
    'estado': 'BA'
  },
  {
    'id': '446',
    'nome': 'Ipecaetá',
    'estado': 'BA'
  },
  {
    'id': '447',
    'nome': 'Ipiaú',
    'estado': 'BA'
  },
  {
    'id': '448',
    'nome': 'Ipirá',
    'estado': 'BA'
  },
  {
    'id': '449',
    'nome': 'Ipupiara',
    'estado': 'BA'
  },
  {
    'id': '450',
    'nome': 'Irajuba',
    'estado': 'BA'
  },
  {
    'id': '451',
    'nome': 'Iramaia',
    'estado': 'BA'
  },
  {
    'id': '452',
    'nome': 'Iraquara',
    'estado': 'BA'
  },
  {
    'id': '453',
    'nome': 'Irará',
    'estado': 'BA'
  },
  {
    'id': '454',
    'nome': 'Irecê',
    'estado': 'BA'
  },
  {
    'id': '455',
    'nome': 'Itabela',
    'estado': 'BA'
  },
  {
    'id': '456',
    'nome': 'Itaberaba',
    'estado': 'BA'
  },
  {
    'id': '457',
    'nome': 'Itabuna',
    'estado': 'BA'
  },
  {
    'id': '458',
    'nome': 'Itacaré',
    'estado': 'BA'
  },
  {
    'id': '459',
    'nome': 'Itaeté',
    'estado': 'BA'
  },
  {
    'id': '460',
    'nome': 'Itagi',
    'estado': 'BA'
  },
  {
    'id': '461',
    'nome': 'Itagibá',
    'estado': 'BA'
  },
  {
    'id': '462',
    'nome': 'Itagimirim',
    'estado': 'BA'
  },
  {
    'id': '463',
    'nome': 'Itaguaçu da Bahia',
    'estado': 'BA'
  },
  {
    'id': '464',
    'nome': 'Itaju do Colônia',
    'estado': 'BA'
  },
  {
    'id': '465',
    'nome': 'Itajuípe',
    'estado': 'BA'
  },
  {
    'id': '466',
    'nome': 'Itamaraju',
    'estado': 'BA'
  },
  {
    'id': '467',
    'nome': 'Itamari',
    'estado': 'BA'
  },
  {
    'id': '468',
    'nome': 'Itambé',
    'estado': 'BA'
  },
  {
    'id': '469',
    'nome': 'Itanagra',
    'estado': 'BA'
  },
  {
    'id': '470',
    'nome': 'Itanhém',
    'estado': 'BA'
  },
  {
    'id': '471',
    'nome': 'Itaparica',
    'estado': 'BA'
  },
  {
    'id': '472',
    'nome': 'Itapé',
    'estado': 'BA'
  },
  {
    'id': '473',
    'nome': 'Itapebi',
    'estado': 'BA'
  },
  {
    'id': '474',
    'nome': 'Itapetinga',
    'estado': 'BA'
  },
  {
    'id': '475',
    'nome': 'Itapicuru',
    'estado': 'BA'
  },
  {
    'id': '476',
    'nome': 'Itapitanga',
    'estado': 'BA'
  },
  {
    'id': '477',
    'nome': 'Itaquara',
    'estado': 'BA'
  },
  {
    'id': '478',
    'nome': 'Itarantim',
    'estado': 'BA'
  },
  {
    'id': '479',
    'nome': 'Itatim',
    'estado': 'BA'
  },
  {
    'id': '480',
    'nome': 'Itiruçu',
    'estado': 'BA'
  },
  {
    'id': '481',
    'nome': 'Itiúba',
    'estado': 'BA'
  },
  {
    'id': '482',
    'nome': 'Itororó',
    'estado': 'BA'
  },
  {
    'id': '483',
    'nome': 'Ituaçu',
    'estado': 'BA'
  },
  {
    'id': '484',
    'nome': 'Ituberá',
    'estado': 'BA'
  },
  {
    'id': '485',
    'nome': 'Iuiú',
    'estado': 'BA'
  },
  {
    'id': '486',
    'nome': 'Jaborandi',
    'estado': 'BA'
  },
  {
    'id': '487',
    'nome': 'Jacaraci',
    'estado': 'BA'
  },
  {
    'id': '488',
    'nome': 'Jacobina',
    'estado': 'BA'
  },
  {
    'id': '489',
    'nome': 'Jaguaquara',
    'estado': 'BA'
  },
  {
    'id': '490',
    'nome': 'Jaguarari',
    'estado': 'BA'
  },
  {
    'id': '491',
    'nome': 'Jaguaripe',
    'estado': 'BA'
  },
  {
    'id': '492',
    'nome': 'Jandaíra',
    'estado': 'BA'
  },
  {
    'id': '493',
    'nome': 'Jequié',
    'estado': 'BA'
  },
  {
    'id': '494',
    'nome': 'Jeremoabo',
    'estado': 'BA'
  },
  {
    'id': '495',
    'nome': 'Jiquiriçá',
    'estado': 'BA'
  },
  {
    'id': '496',
    'nome': 'Jitaúna',
    'estado': 'BA'
  },
  {
    'id': '497',
    'nome': 'João Dourado',
    'estado': 'BA'
  },
  {
    'id': '498',
    'nome': 'Juazeiro',
    'estado': 'BA'
  },
  {
    'id': '499',
    'nome': 'Jucuruçu',
    'estado': 'BA'
  },
  {
    'id': '500',
    'nome': 'Jussara',
    'estado': 'BA'
  },
  {
    'id': '501',
    'nome': 'Jussari',
    'estado': 'BA'
  },
  {
    'id': '502',
    'nome': 'Jussiape',
    'estado': 'BA'
  },
  {
    'id': '503',
    'nome': 'Lafaiete Coutinho',
    'estado': 'BA'
  },
  {
    'id': '504',
    'nome': 'Lagoa Real',
    'estado': 'BA'
  },
  {
    'id': '505',
    'nome': 'Laje',
    'estado': 'BA'
  },
  {
    'id': '506',
    'nome': 'Lajedão',
    'estado': 'BA'
  },
  {
    'id': '507',
    'nome': 'Lajedinho',
    'estado': 'BA'
  },
  {
    'id': '508',
    'nome': 'Lajedo do Tabocal',
    'estado': 'BA'
  },
  {
    'id': '509',
    'nome': 'Lamarão',
    'estado': 'BA'
  },
  {
    'id': '510',
    'nome': 'Lapão',
    'estado': 'BA'
  },
  {
    'id': '511',
    'nome': 'Lauro de Freitas',
    'estado': 'BA'
  },
  {
    'id': '512',
    'nome': 'Lençóis',
    'estado': 'BA'
  },
  {
    'id': '513',
    'nome': 'Licínio de Almeida',
    'estado': 'BA'
  },
  {
    'id': '514',
    'nome': 'Livramento de Nossa Senhora',
    'estado': 'BA'
  },
  {
    'id': '515',
    'nome': 'Luís Eduardo Magalhães',
    'estado': 'BA'
  },
  {
    'id': '516',
    'nome': 'Macajuba',
    'estado': 'BA'
  },
  {
    'id': '517',
    'nome': 'Macarani',
    'estado': 'BA'
  },
  {
    'id': '518',
    'nome': 'Macaúbas',
    'estado': 'BA'
  },
  {
    'id': '519',
    'nome': 'Macururé',
    'estado': 'BA'
  },
  {
    'id': '520',
    'nome': 'Madre de Deus',
    'estado': 'BA'
  },
  {
    'id': '521',
    'nome': 'Maetinga',
    'estado': 'BA'
  },
  {
    'id': '522',
    'nome': 'Maiquinique',
    'estado': 'BA'
  },
  {
    'id': '523',
    'nome': 'Mairi',
    'estado': 'BA'
  },
  {
    'id': '524',
    'nome': 'Malhada',
    'estado': 'BA'
  },
  {
    'id': '525',
    'nome': 'Malhada de Pedras',
    'estado': 'BA'
  },
  {
    'id': '526',
    'nome': 'Manoel Vitorino',
    'estado': 'BA'
  },
  {
    'id': '527',
    'nome': 'Mansidão',
    'estado': 'BA'
  },
  {
    'id': '528',
    'nome': 'Maracás',
    'estado': 'BA'
  },
  {
    'id': '529',
    'nome': 'Maragogipe',
    'estado': 'BA'
  },
  {
    'id': '530',
    'nome': 'Maraú',
    'estado': 'BA'
  },
  {
    'id': '531',
    'nome': 'Marcionílio Souza',
    'estado': 'BA'
  },
  {
    'id': '532',
    'nome': 'Mascote',
    'estado': 'BA'
  },
  {
    'id': '533',
    'nome': 'Mata de São João',
    'estado': 'BA'
  },
  {
    'id': '534',
    'nome': 'Matina',
    'estado': 'BA'
  },
  {
    'id': '535',
    'nome': 'Medeiros Neto',
    'estado': 'BA'
  },
  {
    'id': '536',
    'nome': 'Miguel Calmon',
    'estado': 'BA'
  },
  {
    'id': '537',
    'nome': 'Milagres',
    'estado': 'BA'
  },
  {
    'id': '538',
    'nome': 'Mirangaba',
    'estado': 'BA'
  },
  {
    'id': '539',
    'nome': 'Mirante',
    'estado': 'BA'
  },
  {
    'id': '540',
    'nome': 'Monte Santo',
    'estado': 'BA'
  },
  {
    'id': '541',
    'nome': 'Morpará',
    'estado': 'BA'
  },
  {
    'id': '542',
    'nome': 'Morro do Chapéu',
    'estado': 'BA'
  },
  {
    'id': '543',
    'nome': 'Mortugaba',
    'estado': 'BA'
  },
  {
    'id': '544',
    'nome': 'Mucugê',
    'estado': 'BA'
  },
  {
    'id': '545',
    'nome': 'Mucuri',
    'estado': 'BA'
  },
  {
    'id': '546',
    'nome': 'Mulungu do Morro',
    'estado': 'BA'
  },
  {
    'id': '547',
    'nome': 'Mundo Novo',
    'estado': 'BA'
  },
  {
    'id': '548',
    'nome': 'Muniz Ferreira',
    'estado': 'BA'
  },
  {
    'id': '549',
    'nome': 'Muquém de São Francisco',
    'estado': 'BA'
  },
  {
    'id': '550',
    'nome': 'Muritiba',
    'estado': 'BA'
  },
  {
    'id': '551',
    'nome': 'Mutuípe',
    'estado': 'BA'
  },
  {
    'id': '552',
    'nome': 'Nazaré',
    'estado': 'BA'
  },
  {
    'id': '553',
    'nome': 'Nilo Peçanha',
    'estado': 'BA'
  },
  {
    'id': '554',
    'nome': 'Nordestina',
    'estado': 'BA'
  },
  {
    'id': '555',
    'nome': 'Nova Canaã',
    'estado': 'BA'
  },
  {
    'id': '556',
    'nome': 'Nova Fátima',
    'estado': 'BA'
  },
  {
    'id': '557',
    'nome': 'Nova Ibiá',
    'estado': 'BA'
  },
  {
    'id': '558',
    'nome': 'Nova Itarana',
    'estado': 'BA'
  },
  {
    'id': '559',
    'nome': 'Nova Redenção',
    'estado': 'BA'
  },
  {
    'id': '560',
    'nome': 'Nova Soure',
    'estado': 'BA'
  },
  {
    'id': '561',
    'nome': 'Nova Viçosa',
    'estado': 'BA'
  },
  {
    'id': '562',
    'nome': 'Novo Horizonte',
    'estado': 'BA'
  },
  {
    'id': '563',
    'nome': 'Novo Triunfo',
    'estado': 'BA'
  },
  {
    'id': '564',
    'nome': 'Olindina',
    'estado': 'BA'
  },
  {
    'id': '565',
    'nome': 'Oliveira dos Brejinhos',
    'estado': 'BA'
  },
  {
    'id': '566',
    'nome': 'Ouriçangas',
    'estado': 'BA'
  },
  {
    'id': '567',
    'nome': 'Ourolândia',
    'estado': 'BA'
  },
  {
    'id': '568',
    'nome': 'Palmas de Monte Alto',
    'estado': 'BA'
  },
  {
    'id': '569',
    'nome': 'Palmeiras',
    'estado': 'BA'
  },
  {
    'id': '570',
    'nome': 'Paramirim',
    'estado': 'BA'
  },
  {
    'id': '571',
    'nome': 'Paratinga',
    'estado': 'BA'
  },
  {
    'id': '572',
    'nome': 'Paripiranga',
    'estado': 'BA'
  },
  {
    'id': '573',
    'nome': 'Pau Brasil',
    'estado': 'BA'
  },
  {
    'id': '574',
    'nome': 'Paulo Afonso',
    'estado': 'BA'
  },
  {
    'id': '575',
    'nome': 'Pé de Serra',
    'estado': 'BA'
  },
  {
    'id': '576',
    'nome': 'Pedrão',
    'estado': 'BA'
  },
  {
    'id': '577',
    'nome': 'Pedro Alexandre',
    'estado': 'BA'
  },
  {
    'id': '578',
    'nome': 'Piatã',
    'estado': 'BA'
  },
  {
    'id': '579',
    'nome': 'Pilão Arcado',
    'estado': 'BA'
  },
  {
    'id': '580',
    'nome': 'Pindaí',
    'estado': 'BA'
  },
  {
    'id': '581',
    'nome': 'Pindobaçu',
    'estado': 'BA'
  },
  {
    'id': '582',
    'nome': 'Pintadas',
    'estado': 'BA'
  },
  {
    'id': '583',
    'nome': 'Piraí do Norte',
    'estado': 'BA'
  },
  {
    'id': '584',
    'nome': 'Piripá',
    'estado': 'BA'
  },
  {
    'id': '585',
    'nome': 'Piritiba',
    'estado': 'BA'
  },
  {
    'id': '586',
    'nome': 'Planaltino',
    'estado': 'BA'
  },
  {
    'id': '587',
    'nome': 'Planalto',
    'estado': 'BA'
  },
  {
    'id': '588',
    'nome': 'Poções',
    'estado': 'BA'
  },
  {
    'id': '589',
    'nome': 'Pojuca',
    'estado': 'BA'
  },
  {
    'id': '590',
    'nome': 'Ponto Novo',
    'estado': 'BA'
  },
  {
    'id': '591',
    'nome': 'Porto Seguro',
    'estado': 'BA'
  },
  {
    'id': '592',
    'nome': 'Potiraguá',
    'estado': 'BA'
  },
  {
    'id': '593',
    'nome': 'Prado',
    'estado': 'BA'
  },
  {
    'id': '594',
    'nome': 'Presidente Dutra',
    'estado': 'BA'
  },
  {
    'id': '595',
    'nome': 'Presidente Jânio Quadros',
    'estado': 'BA'
  },
  {
    'id': '596',
    'nome': 'Presidente Tancredo Neves',
    'estado': 'BA'
  },
  {
    'id': '597',
    'nome': 'Queimadas',
    'estado': 'BA'
  },
  {
    'id': '598',
    'nome': 'Quijingue',
    'estado': 'BA'
  },
  {
    'id': '599',
    'nome': 'Quixabeira',
    'estado': 'BA'
  },
  {
    'id': '600',
    'nome': 'Rafael Jambeiro',
    'estado': 'BA'
  },
  {
    'id': '601',
    'nome': 'Remanso',
    'estado': 'BA'
  },
  {
    'id': '602',
    'nome': 'Retirolândia',
    'estado': 'BA'
  },
  {
    'id': '603',
    'nome': 'Riachão das Neves',
    'estado': 'BA'
  },
  {
    'id': '604',
    'nome': 'Riachão do Jacuípe',
    'estado': 'BA'
  },
  {
    'id': '605',
    'nome': 'Riacho de Santana',
    'estado': 'BA'
  },
  {
    'id': '606',
    'nome': 'Ribeira do Amparo',
    'estado': 'BA'
  },
  {
    'id': '607',
    'nome': 'Ribeira do Pombal',
    'estado': 'BA'
  },
  {
    'id': '608',
    'nome': 'Ribeirão do Largo',
    'estado': 'BA'
  },
  {
    'id': '609',
    'nome': 'Rio de Contas',
    'estado': 'BA'
  },
  {
    'id': '610',
    'nome': 'Rio do Antônio',
    'estado': 'BA'
  },
  {
    'id': '611',
    'nome': 'Rio do Pires',
    'estado': 'BA'
  },
  {
    'id': '612',
    'nome': 'Rio Real',
    'estado': 'BA'
  },
  {
    'id': '613',
    'nome': 'Rodelas',
    'estado': 'BA'
  },
  {
    'id': '614',
    'nome': 'Ruy Barbosa',
    'estado': 'BA'
  },
  {
    'id': '615',
    'nome': 'Salinas da Margarida',
    'estado': 'BA'
  },
  {
    'id': '616',
    'nome': 'Salvador',
    'estado': 'BA'
  },
  {
    'id': '617',
    'nome': 'Santa Bárbara',
    'estado': 'BA'
  },
  {
    'id': '618',
    'nome': 'Santa Brígida',
    'estado': 'BA'
  },
  {
    'id': '619',
    'nome': 'Santa Cruz Cabrália',
    'estado': 'BA'
  },
  {
    'id': '620',
    'nome': 'Santa Cruz da Vitória',
    'estado': 'BA'
  },
  {
    'id': '621',
    'nome': 'Santa Inês',
    'estado': 'BA'
  },
  {
    'id': '622',
    'nome': 'Santa Luzia',
    'estado': 'BA'
  },
  {
    'id': '623',
    'nome': 'Santa Maria da Vitória',
    'estado': 'BA'
  },
  {
    'id': '624',
    'nome': 'Santa Rita de Cássia',
    'estado': 'BA'
  },
  {
    'id': '625',
    'nome': 'Santa Teresinha',
    'estado': 'BA'
  },
  {
    'id': '626',
    'nome': 'Santaluz',
    'estado': 'BA'
  },
  {
    'id': '627',
    'nome': 'Santana',
    'estado': 'BA'
  },
  {
    'id': '628',
    'nome': 'Santanópolis',
    'estado': 'BA'
  },
  {
    'id': '629',
    'nome': 'Santo Amaro',
    'estado': 'BA'
  },
  {
    'id': '630',
    'nome': 'Santo Antônio de Jesus',
    'estado': 'BA'
  },
  {
    'id': '631',
    'nome': 'Santo Estêvão',
    'estado': 'BA'
  },
  {
    'id': '632',
    'nome': 'São Desidério',
    'estado': 'BA'
  },
  {
    'id': '633',
    'nome': 'São Domingos',
    'estado': 'BA'
  },
  {
    'id': '634',
    'nome': 'São Felipe',
    'estado': 'BA'
  },
  {
    'id': '635',
    'nome': 'São Félix',
    'estado': 'BA'
  },
  {
    'id': '636',
    'nome': 'São Félix do Coribe',
    'estado': 'BA'
  },
  {
    'id': '637',
    'nome': 'São Francisco do Conde',
    'estado': 'BA'
  },
  {
    'id': '638',
    'nome': 'São Gabriel',
    'estado': 'BA'
  },
  {
    'id': '639',
    'nome': 'São Gonçalo dos Campos',
    'estado': 'BA'
  },
  {
    'id': '640',
    'nome': 'São José da Vitória',
    'estado': 'BA'
  },
  {
    'id': '641',
    'nome': 'São José do Jacuípe',
    'estado': 'BA'
  },
  {
    'id': '642',
    'nome': 'São Miguel das Matas',
    'estado': 'BA'
  },
  {
    'id': '643',
    'nome': 'São Sebastião do Passé',
    'estado': 'BA'
  },
  {
    'id': '644',
    'nome': 'Sapeaçu',
    'estado': 'BA'
  },
  {
    'id': '645',
    'nome': 'Sátiro Dias',
    'estado': 'BA'
  },
  {
    'id': '646',
    'nome': 'Saubara',
    'estado': 'BA'
  },
  {
    'id': '647',
    'nome': 'Saúde',
    'estado': 'BA'
  },
  {
    'id': '648',
    'nome': 'Seabra',
    'estado': 'BA'
  },
  {
    'id': '649',
    'nome': 'Sebastião Laranjeiras',
    'estado': 'BA'
  },
  {
    'id': '650',
    'nome': 'Senhor do Bonfim',
    'estado': 'BA'
  },
  {
    'id': '651',
    'nome': 'Sento Sé',
    'estado': 'BA'
  },
  {
    'id': '652',
    'nome': 'Serra do Ramalho',
    'estado': 'BA'
  },
  {
    'id': '653',
    'nome': 'Serra Dourada',
    'estado': 'BA'
  },
  {
    'id': '654',
    'nome': 'Serra Preta',
    'estado': 'BA'
  },
  {
    'id': '655',
    'nome': 'Serrinha',
    'estado': 'BA'
  },
  {
    'id': '656',
    'nome': 'Serrolândia',
    'estado': 'BA'
  },
  {
    'id': '657',
    'nome': 'Simões Filho',
    'estado': 'BA'
  },
  {
    'id': '658',
    'nome': 'Sítio do Mato',
    'estado': 'BA'
  },
  {
    'id': '659',
    'nome': 'Sítio do Quinto',
    'estado': 'BA'
  },
  {
    'id': '660',
    'nome': 'Sobradinho',
    'estado': 'BA'
  },
  {
    'id': '661',
    'nome': 'Souto Soares',
    'estado': 'BA'
  },
  {
    'id': '662',
    'nome': 'Tabocas do Brejo Velho',
    'estado': 'BA'
  },
  {
    'id': '663',
    'nome': 'Tanhaçu',
    'estado': 'BA'
  },
  {
    'id': '664',
    'nome': 'Tanque Novo',
    'estado': 'BA'
  },
  {
    'id': '665',
    'nome': 'Tanquinho',
    'estado': 'BA'
  },
  {
    'id': '666',
    'nome': 'Taperoá',
    'estado': 'BA'
  },
  {
    'id': '667',
    'nome': 'Tapiramutá',
    'estado': 'BA'
  },
  {
    'id': '668',
    'nome': 'Teixeira de Freitas',
    'estado': 'BA'
  },
  {
    'id': '669',
    'nome': 'Teodoro Sampaio',
    'estado': 'BA'
  },
  {
    'id': '670',
    'nome': 'Teofilândia',
    'estado': 'BA'
  },
  {
    'id': '671',
    'nome': 'Teolândia',
    'estado': 'BA'
  },
  {
    'id': '672',
    'nome': 'Terra Nova',
    'estado': 'BA'
  },
  {
    'id': '673',
    'nome': 'Tremedal',
    'estado': 'BA'
  },
  {
    'id': '674',
    'nome': 'Tucano',
    'estado': 'BA'
  },
  {
    'id': '675',
    'nome': 'Uauá',
    'estado': 'BA'
  },
  {
    'id': '676',
    'nome': 'Ubaíra',
    'estado': 'BA'
  },
  {
    'id': '677',
    'nome': 'Ubaitaba',
    'estado': 'BA'
  },
  {
    'id': '678',
    'nome': 'Ubatã',
    'estado': 'BA'
  },
  {
    'id': '679',
    'nome': 'Uibaí',
    'estado': 'BA'
  },
  {
    'id': '680',
    'nome': 'Umburanas',
    'estado': 'BA'
  },
  {
    'id': '681',
    'nome': 'Una',
    'estado': 'BA'
  },
  {
    'id': '682',
    'nome': 'Urandi',
    'estado': 'BA'
  },
  {
    'id': '683',
    'nome': 'Uruçuca',
    'estado': 'BA'
  },
  {
    'id': '684',
    'nome': 'Utinga',
    'estado': 'BA'
  },
  {
    'id': '685',
    'nome': 'Valença',
    'estado': 'BA'
  },
  {
    'id': '686',
    'nome': 'Valente',
    'estado': 'BA'
  },
  {
    'id': '687',
    'nome': 'Várzea da Roça',
    'estado': 'BA'
  },
  {
    'id': '688',
    'nome': 'Várzea do Poço',
    'estado': 'BA'
  },
  {
    'id': '689',
    'nome': 'Várzea Nova',
    'estado': 'BA'
  },
  {
    'id': '690',
    'nome': 'Varzedo',
    'estado': 'BA'
  },
  {
    'id': '691',
    'nome': 'Vera Cruz',
    'estado': 'BA'
  },
  {
    'id': '692',
    'nome': 'Vereda',
    'estado': 'BA'
  },
  {
    'id': '693',
    'nome': 'Vitória da Conquista',
    'estado': 'BA'
  },
  {
    'id': '694',
    'nome': 'Wagner',
    'estado': 'BA'
  },
  {
    'id': '695',
    'nome': 'Wanderley',
    'estado': 'BA'
  },
  {
    'id': '696',
    'nome': 'Wenceslau Guimarães',
    'estado': 'BA'
  },
  {
    'id': '697',
    'nome': 'Xique-Xique',
    'estado': 'BA'
  },
  {
    'id': '698',
    'nome': 'Abaiara',
    'estado': 'CE'
  },
  {
    'id': '699',
    'nome': 'Acarape',
    'estado': 'CE'
  },
  {
    'id': '700',
    'nome': 'Acaraú',
    'estado': 'CE'
  },
  {
    'id': '701',
    'nome': 'Acopiara',
    'estado': 'CE'
  },
  {
    'id': '702',
    'nome': 'Aiuaba',
    'estado': 'CE'
  },
  {
    'id': '703',
    'nome': 'Alcântaras',
    'estado': 'CE'
  },
  {
    'id': '704',
    'nome': 'Altaneira',
    'estado': 'CE'
  },
  {
    'id': '705',
    'nome': 'Alto Santo',
    'estado': 'CE'
  },
  {
    'id': '706',
    'nome': 'Amontada',
    'estado': 'CE'
  },
  {
    'id': '707',
    'nome': 'Antonina do Norte',
    'estado': 'CE'
  },
  {
    'id': '708',
    'nome': 'Apuiarés',
    'estado': 'CE'
  },
  {
    'id': '709',
    'nome': 'Aquiraz',
    'estado': 'CE'
  },
  {
    'id': '710',
    'nome': 'Aracati',
    'estado': 'CE'
  },
  {
    'id': '711',
    'nome': 'Aracoiaba',
    'estado': 'CE'
  },
  {
    'id': '712',
    'nome': 'Ararendá',
    'estado': 'CE'
  },
  {
    'id': '713',
    'nome': 'Araripe',
    'estado': 'CE'
  },
  {
    'id': '714',
    'nome': 'Aratuba',
    'estado': 'CE'
  },
  {
    'id': '715',
    'nome': 'Arneiroz',
    'estado': 'CE'
  },
  {
    'id': '716',
    'nome': 'Assaré',
    'estado': 'CE'
  },
  {
    'id': '717',
    'nome': 'Aurora',
    'estado': 'CE'
  },
  {
    'id': '718',
    'nome': 'Baixio',
    'estado': 'CE'
  },
  {
    'id': '719',
    'nome': 'Banabuiú',
    'estado': 'CE'
  },
  {
    'id': '720',
    'nome': 'Barbalha',
    'estado': 'CE'
  },
  {
    'id': '721',
    'nome': 'Barreira',
    'estado': 'CE'
  },
  {
    'id': '722',
    'nome': 'Barro',
    'estado': 'CE'
  },
  {
    'id': '723',
    'nome': 'Barroquinha',
    'estado': 'CE'
  },
  {
    'id': '724',
    'nome': 'Baturité',
    'estado': 'CE'
  },
  {
    'id': '725',
    'nome': 'Beberibe',
    'estado': 'CE'
  },
  {
    'id': '726',
    'nome': 'Bela Cruz',
    'estado': 'CE'
  },
  {
    'id': '727',
    'nome': 'Boa Viagem',
    'estado': 'CE'
  },
  {
    'id': '728',
    'nome': 'Brejo Santo',
    'estado': 'CE'
  },
  {
    'id': '729',
    'nome': 'Camocim',
    'estado': 'CE'
  },
  {
    'id': '730',
    'nome': 'Campos Sales',
    'estado': 'CE'
  },
  {
    'id': '731',
    'nome': 'Canindé',
    'estado': 'CE'
  },
  {
    'id': '732',
    'nome': 'Capistrano',
    'estado': 'CE'
  },
  {
    'id': '733',
    'nome': 'Caridade',
    'estado': 'CE'
  },
  {
    'id': '734',
    'nome': 'Cariré',
    'estado': 'CE'
  },
  {
    'id': '735',
    'nome': 'Caririaçu',
    'estado': 'CE'
  },
  {
    'id': '736',
    'nome': 'Cariús',
    'estado': 'CE'
  },
  {
    'id': '737',
    'nome': 'Carnaubal',
    'estado': 'CE'
  },
  {
    'id': '738',
    'nome': 'Cascavel',
    'estado': 'CE'
  },
  {
    'id': '739',
    'nome': 'Catarina',
    'estado': 'CE'
  },
  {
    'id': '740',
    'nome': 'Catunda',
    'estado': 'CE'
  },
  {
    'id': '741',
    'nome': 'Caucaia',
    'estado': 'CE'
  },
  {
    'id': '742',
    'nome': 'Cedro',
    'estado': 'CE'
  },
  {
    'id': '743',
    'nome': 'Chaval',
    'estado': 'CE'
  },
  {
    'id': '744',
    'nome': 'Choró',
    'estado': 'CE'
  },
  {
    'id': '745',
    'nome': 'Chorozinho',
    'estado': 'CE'
  },
  {
    'id': '746',
    'nome': 'Coreaú',
    'estado': 'CE'
  },
  {
    'id': '747',
    'nome': 'Crateús',
    'estado': 'CE'
  },
  {
    'id': '748',
    'nome': 'Crato',
    'estado': 'CE'
  },
  {
    'id': '749',
    'nome': 'Croatá',
    'estado': 'CE'
  },
  {
    'id': '750',
    'nome': 'Cruz',
    'estado': 'CE'
  },
  {
    'id': '751',
    'nome': 'Deputado Irapuan Pinheiro',
    'estado': 'CE'
  },
  {
    'id': '752',
    'nome': 'Ererê',
    'estado': 'CE'
  },
  {
    'id': '753',
    'nome': 'Eusébio',
    'estado': 'CE'
  },
  {
    'id': '754',
    'nome': 'Farias Brito',
    'estado': 'CE'
  },
  {
    'id': '755',
    'nome': 'Forquilha',
    'estado': 'CE'
  },
  {
    'id': '756',
    'nome': 'Fortaleza',
    'estado': 'CE'
  },
  {
    'id': '757',
    'nome': 'Fortim',
    'estado': 'CE'
  },
  {
    'id': '758',
    'nome': 'Frecheirinha',
    'estado': 'CE'
  },
  {
    'id': '759',
    'nome': 'General Sampaio',
    'estado': 'CE'
  },
  {
    'id': '760',
    'nome': 'Graça',
    'estado': 'CE'
  },
  {
    'id': '761',
    'nome': 'Granja',
    'estado': 'CE'
  },
  {
    'id': '762',
    'nome': 'Granjeiro',
    'estado': 'CE'
  },
  {
    'id': '763',
    'nome': 'Groaíras',
    'estado': 'CE'
  },
  {
    'id': '764',
    'nome': 'Guaiúba',
    'estado': 'CE'
  },
  {
    'id': '765',
    'nome': 'Guaraciaba do Norte',
    'estado': 'CE'
  },
  {
    'id': '766',
    'nome': 'Guaramiranga',
    'estado': 'CE'
  },
  {
    'id': '767',
    'nome': 'Hidrolândia',
    'estado': 'CE'
  },
  {
    'id': '768',
    'nome': 'Horizonte',
    'estado': 'CE'
  },
  {
    'id': '769',
    'nome': 'Ibaretama',
    'estado': 'CE'
  },
  {
    'id': '770',
    'nome': 'Ibiapina',
    'estado': 'CE'
  },
  {
    'id': '771',
    'nome': 'Ibicuitinga',
    'estado': 'CE'
  },
  {
    'id': '772',
    'nome': 'Icapuí',
    'estado': 'CE'
  },
  {
    'id': '773',
    'nome': 'Icó',
    'estado': 'CE'
  },
  {
    'id': '774',
    'nome': 'Iguatu',
    'estado': 'CE'
  },
  {
    'id': '775',
    'nome': 'Independência',
    'estado': 'CE'
  },
  {
    'id': '776',
    'nome': 'Ipaporanga',
    'estado': 'CE'
  },
  {
    'id': '777',
    'nome': 'Ipaumirim',
    'estado': 'CE'
  },
  {
    'id': '778',
    'nome': 'Ipu',
    'estado': 'CE'
  },
  {
    'id': '779',
    'nome': 'Ipueiras',
    'estado': 'CE'
  },
  {
    'id': '780',
    'nome': 'Iracema',
    'estado': 'CE'
  },
  {
    'id': '781',
    'nome': 'Irauçuba',
    'estado': 'CE'
  },
  {
    'id': '782',
    'nome': 'Itaiçaba',
    'estado': 'CE'
  },
  {
    'id': '783',
    'nome': 'Itaitinga',
    'estado': 'CE'
  },
  {
    'id': '784',
    'nome': 'Itapagé',
    'estado': 'CE'
  },
  {
    'id': '785',
    'nome': 'Itapipoca',
    'estado': 'CE'
  },
  {
    'id': '786',
    'nome': 'Itapiúna',
    'estado': 'CE'
  },
  {
    'id': '787',
    'nome': 'Itarema',
    'estado': 'CE'
  },
  {
    'id': '788',
    'nome': 'Itatira',
    'estado': 'CE'
  },
  {
    'id': '789',
    'nome': 'Jaguaretama',
    'estado': 'CE'
  },
  {
    'id': '790',
    'nome': 'Jaguaribara',
    'estado': 'CE'
  },
  {
    'id': '791',
    'nome': 'Jaguaribe',
    'estado': 'CE'
  },
  {
    'id': '792',
    'nome': 'Jaguaruana',
    'estado': 'CE'
  },
  {
    'id': '793',
    'nome': 'Jardim',
    'estado': 'CE'
  },
  {
    'id': '794',
    'nome': 'Jati',
    'estado': 'CE'
  },
  {
    'id': '795',
    'nome': 'Jijoca de Jericoacoara',
    'estado': 'CE'
  },
  {
    'id': '796',
    'nome': 'Juazeiro do Norte',
    'estado': 'CE'
  },
  {
    'id': '797',
    'nome': 'Jucás',
    'estado': 'CE'
  },
  {
    'id': '798',
    'nome': 'Lavras da Mangabeira',
    'estado': 'CE'
  },
  {
    'id': '799',
    'nome': 'Limoeiro do Norte',
    'estado': 'CE'
  },
  {
    'id': '800',
    'nome': 'Madalena',
    'estado': 'CE'
  },
  {
    'id': '801',
    'nome': 'Maracanaú',
    'estado': 'CE'
  },
  {
    'id': '802',
    'nome': 'Maranguape',
    'estado': 'CE'
  },
  {
    'id': '803',
    'nome': 'Marco',
    'estado': 'CE'
  },
  {
    'id': '804',
    'nome': 'Martinópole',
    'estado': 'CE'
  },
  {
    'id': '805',
    'nome': 'Massapê',
    'estado': 'CE'
  },
  {
    'id': '806',
    'nome': 'Mauriti',
    'estado': 'CE'
  },
  {
    'id': '807',
    'nome': 'Meruoca',
    'estado': 'CE'
  },
  {
    'id': '808',
    'nome': 'Milagres',
    'estado': 'CE'
  },
  {
    'id': '809',
    'nome': 'Milhã',
    'estado': 'CE'
  },
  {
    'id': '810',
    'nome': 'Miraíma',
    'estado': 'CE'
  },
  {
    'id': '811',
    'nome': 'Missão Velha',
    'estado': 'CE'
  },
  {
    'id': '812',
    'nome': 'Mombaça',
    'estado': 'CE'
  },
  {
    'id': '813',
    'nome': 'Monsenhor Tabosa',
    'estado': 'CE'
  },
  {
    'id': '814',
    'nome': 'Morada Nova',
    'estado': 'CE'
  },
  {
    'id': '815',
    'nome': 'Moraújo',
    'estado': 'CE'
  },
  {
    'id': '816',
    'nome': 'Morrinhos',
    'estado': 'CE'
  },
  {
    'id': '817',
    'nome': 'Mucambo',
    'estado': 'CE'
  },
  {
    'id': '818',
    'nome': 'Mulungu',
    'estado': 'CE'
  },
  {
    'id': '819',
    'nome': 'Nova Olinda',
    'estado': 'CE'
  },
  {
    'id': '820',
    'nome': 'Nova Russas',
    'estado': 'CE'
  },
  {
    'id': '821',
    'nome': 'Novo Oriente',
    'estado': 'CE'
  },
  {
    'id': '822',
    'nome': 'Ocara',
    'estado': 'CE'
  },
  {
    'id': '823',
    'nome': 'Orós',
    'estado': 'CE'
  },
  {
    'id': '824',
    'nome': 'Pacajus',
    'estado': 'CE'
  },
  {
    'id': '825',
    'nome': 'Pacatuba',
    'estado': 'CE'
  },
  {
    'id': '826',
    'nome': 'Pacoti',
    'estado': 'CE'
  },
  {
    'id': '827',
    'nome': 'Pacujá',
    'estado': 'CE'
  },
  {
    'id': '828',
    'nome': 'Palhano',
    'estado': 'CE'
  },
  {
    'id': '829',
    'nome': 'Palmácia',
    'estado': 'CE'
  },
  {
    'id': '830',
    'nome': 'Paracuru',
    'estado': 'CE'
  },
  {
    'id': '831',
    'nome': 'Paraipaba',
    'estado': 'CE'
  },
  {
    'id': '832',
    'nome': 'Parambu',
    'estado': 'CE'
  },
  {
    'id': '833',
    'nome': 'Paramoti',
    'estado': 'CE'
  },
  {
    'id': '834',
    'nome': 'Pedra Branca',
    'estado': 'CE'
  },
  {
    'id': '835',
    'nome': 'Penaforte',
    'estado': 'CE'
  },
  {
    'id': '836',
    'nome': 'Pentecoste',
    'estado': 'CE'
  },
  {
    'id': '837',
    'nome': 'Pereiro',
    'estado': 'CE'
  },
  {
    'id': '838',
    'nome': 'Pindoretama',
    'estado': 'CE'
  },
  {
    'id': '839',
    'nome': 'Piquet Carneiro',
    'estado': 'CE'
  },
  {
    'id': '840',
    'nome': 'Pires Ferreira',
    'estado': 'CE'
  },
  {
    'id': '841',
    'nome': 'Poranga',
    'estado': 'CE'
  },
  {
    'id': '842',
    'nome': 'Porteiras',
    'estado': 'CE'
  },
  {
    'id': '843',
    'nome': 'Potengi',
    'estado': 'CE'
  },
  {
    'id': '844',
    'nome': 'Potiretama',
    'estado': 'CE'
  },
  {
    'id': '845',
    'nome': 'Quiterianópolis',
    'estado': 'CE'
  },
  {
    'id': '846',
    'nome': 'Quixadá',
    'estado': 'CE'
  },
  {
    'id': '847',
    'nome': 'Quixelô',
    'estado': 'CE'
  },
  {
    'id': '848',
    'nome': 'Quixeramobim',
    'estado': 'CE'
  },
  {
    'id': '849',
    'nome': 'Quixeré',
    'estado': 'CE'
  },
  {
    'id': '850',
    'nome': 'Redenção',
    'estado': 'CE'
  },
  {
    'id': '851',
    'nome': 'Reriutaba',
    'estado': 'CE'
  },
  {
    'id': '852',
    'nome': 'Russas',
    'estado': 'CE'
  },
  {
    'id': '853',
    'nome': 'Saboeiro',
    'estado': 'CE'
  },
  {
    'id': '854',
    'nome': 'Salitre',
    'estado': 'CE'
  },
  {
    'id': '855',
    'nome': 'Santa Quitéria',
    'estado': 'CE'
  },
  {
    'id': '856',
    'nome': 'Santana do Acaraú',
    'estado': 'CE'
  },
  {
    'id': '857',
    'nome': 'Santana do Cariri',
    'estado': 'CE'
  },
  {
    'id': '858',
    'nome': 'São Benedito',
    'estado': 'CE'
  },
  {
    'id': '859',
    'nome': 'São Gonçalo do Amarante',
    'estado': 'CE'
  },
  {
    'id': '860',
    'nome': 'São João do Jaguaribe',
    'estado': 'CE'
  },
  {
    'id': '861',
    'nome': 'São Luís do Curu',
    'estado': 'CE'
  },
  {
    'id': '862',
    'nome': 'Senador Pompeu',
    'estado': 'CE'
  },
  {
    'id': '863',
    'nome': 'Senador Sá',
    'estado': 'CE'
  },
  {
    'id': '864',
    'nome': 'Sobral',
    'estado': 'CE'
  },
  {
    'id': '865',
    'nome': 'Solonópole',
    'estado': 'CE'
  },
  {
    'id': '866',
    'nome': 'Tabuleiro do Norte',
    'estado': 'CE'
  },
  {
    'id': '867',
    'nome': 'Tamboril',
    'estado': 'CE'
  },
  {
    'id': '868',
    'nome': 'Tarrafas',
    'estado': 'CE'
  },
  {
    'id': '869',
    'nome': 'Tauá',
    'estado': 'CE'
  },
  {
    'id': '870',
    'nome': 'Tejuçuoca',
    'estado': 'CE'
  },
  {
    'id': '871',
    'nome': 'Tianguá',
    'estado': 'CE'
  },
  {
    'id': '872',
    'nome': 'Trairi',
    'estado': 'CE'
  },
  {
    'id': '873',
    'nome': 'Tururu',
    'estado': 'CE'
  },
  {
    'id': '874',
    'nome': 'Ubajara',
    'estado': 'CE'
  },
  {
    'id': '875',
    'nome': 'Umari',
    'estado': 'CE'
  },
  {
    'id': '876',
    'nome': 'Umirim',
    'estado': 'CE'
  },
  {
    'id': '877',
    'nome': 'Uruburetama',
    'estado': 'CE'
  },
  {
    'id': '878',
    'nome': 'Uruoca',
    'estado': 'CE'
  },
  {
    'id': '879',
    'nome': 'Varjota',
    'estado': 'CE'
  },
  {
    'id': '880',
    'nome': 'Várzea Alegre',
    'estado': 'CE'
  },
  {
    'id': '881',
    'nome': 'Viçosa do Ceará',
    'estado': 'CE'
  },
  {
    'id': '882',
    'nome': 'Brasília',
    'estado': 'DF'
  },
  {
    'id': '883',
    'nome': 'Abadia de Goiás',
    'estado': 'GO'
  },
  {
    'id': '884',
    'nome': 'Abadiânia',
    'estado': 'GO'
  },
  {
    'id': '885',
    'nome': 'Acreúna',
    'estado': 'GO'
  },
  {
    'id': '886',
    'nome': 'Adelândia',
    'estado': 'GO'
  },
  {
    'id': '887',
    'nome': 'Água Fria de Goiás',
    'estado': 'GO'
  },
  {
    'id': '888',
    'nome': 'Água Limpa',
    'estado': 'GO'
  },
  {
    'id': '889',
    'nome': 'Águas Lindas de Goiás',
    'estado': 'GO'
  },
  {
    'id': '890',
    'nome': 'Alexânia',
    'estado': 'GO'
  },
  {
    'id': '891',
    'nome': 'Aloândia',
    'estado': 'GO'
  },
  {
    'id': '892',
    'nome': 'Alto Horizonte',
    'estado': 'GO'
  },
  {
    'id': '893',
    'nome': 'Alto Paraíso de Goiás',
    'estado': 'GO'
  },
  {
    'id': '894',
    'nome': 'Alvorada do Norte',
    'estado': 'GO'
  },
  {
    'id': '895',
    'nome': 'Amaralina',
    'estado': 'GO'
  },
  {
    'id': '896',
    'nome': 'Americano do Brasil',
    'estado': 'GO'
  },
  {
    'id': '897',
    'nome': 'Amorinópolis',
    'estado': 'GO'
  },
  {
    'id': '898',
    'nome': 'Anápolis',
    'estado': 'GO'
  },
  {
    'id': '899',
    'nome': 'Anhanguera',
    'estado': 'GO'
  },
  {
    'id': '900',
    'nome': 'Anicuns',
    'estado': 'GO'
  },
  {
    'id': '901',
    'nome': 'Aparecida de Goiânia',
    'estado': 'GO'
  },
  {
    'id': '902',
    'nome': 'Aparecida do Rio Doce',
    'estado': 'GO'
  },
  {
    'id': '903',
    'nome': 'Aporé',
    'estado': 'GO'
  },
  {
    'id': '904',
    'nome': 'Araçu',
    'estado': 'GO'
  },
  {
    'id': '905',
    'nome': 'Aragarças',
    'estado': 'GO'
  },
  {
    'id': '906',
    'nome': 'Aragoiânia',
    'estado': 'GO'
  },
  {
    'id': '907',
    'nome': 'Araguapaz',
    'estado': 'GO'
  },
  {
    'id': '908',
    'nome': 'Arenópolis',
    'estado': 'GO'
  },
  {
    'id': '909',
    'nome': 'Aruanã',
    'estado': 'GO'
  },
  {
    'id': '910',
    'nome': 'Aurilândia',
    'estado': 'GO'
  },
  {
    'id': '911',
    'nome': 'Avelinópolis',
    'estado': 'GO'
  },
  {
    'id': '912',
    'nome': 'Baliza',
    'estado': 'GO'
  },
  {
    'id': '913',
    'nome': 'Barro Alto',
    'estado': 'GO'
  },
  {
    'id': '914',
    'nome': 'Bela Vista de Goiás',
    'estado': 'GO'
  },
  {
    'id': '915',
    'nome': 'Bom Jardim de Goiás',
    'estado': 'GO'
  },
  {
    'id': '916',
    'nome': 'Bom Jesus de Goiás',
    'estado': 'GO'
  },
  {
    'id': '917',
    'nome': 'Bonfinópolis',
    'estado': 'GO'
  },
  {
    'id': '918',
    'nome': 'Bonópolis',
    'estado': 'GO'
  },
  {
    'id': '919',
    'nome': 'Brazabrantes',
    'estado': 'GO'
  },
  {
    'id': '920',
    'nome': 'Britânia',
    'estado': 'GO'
  },
  {
    'id': '921',
    'nome': 'Buriti Alegre',
    'estado': 'GO'
  },
  {
    'id': '922',
    'nome': 'Buriti de Goiás',
    'estado': 'GO'
  },
  {
    'id': '923',
    'nome': 'Buritinópolis',
    'estado': 'GO'
  },
  {
    'id': '924',
    'nome': 'Cabeceiras',
    'estado': 'GO'
  },
  {
    'id': '925',
    'nome': 'Cachoeira Alta',
    'estado': 'GO'
  },
  {
    'id': '926',
    'nome': 'Cachoeira de Goiás',
    'estado': 'GO'
  },
  {
    'id': '927',
    'nome': 'Cachoeira Dourada',
    'estado': 'GO'
  },
  {
    'id': '928',
    'nome': 'Caçu',
    'estado': 'GO'
  },
  {
    'id': '929',
    'nome': 'Caiapônia',
    'estado': 'GO'
  },
  {
    'id': '930',
    'nome': 'Caldas Novas',
    'estado': 'GO'
  },
  {
    'id': '931',
    'nome': 'Caldazinha',
    'estado': 'GO'
  },
  {
    'id': '932',
    'nome': 'Campestre de Goiás',
    'estado': 'GO'
  },
  {
    'id': '933',
    'nome': 'Campinaçu',
    'estado': 'GO'
  },
  {
    'id': '934',
    'nome': 'Campinorte',
    'estado': 'GO'
  },
  {
    'id': '935',
    'nome': 'Campo Alegre de Goiás',
    'estado': 'GO'
  },
  {
    'id': '936',
    'nome': 'Campo Limpo de Goiás',
    'estado': 'GO'
  },
  {
    'id': '937',
    'nome': 'Campos Belos',
    'estado': 'GO'
  },
  {
    'id': '938',
    'nome': 'Campos Verdes',
    'estado': 'GO'
  },
  {
    'id': '939',
    'nome': 'Carmo do Rio Verde',
    'estado': 'GO'
  },
  {
    'id': '940',
    'nome': 'Castelândia',
    'estado': 'GO'
  },
  {
    'id': '941',
    'nome': 'Catalão',
    'estado': 'GO'
  },
  {
    'id': '942',
    'nome': 'Caturaí',
    'estado': 'GO'
  },
  {
    'id': '943',
    'nome': 'Cavalcante',
    'estado': 'GO'
  },
  {
    'id': '944',
    'nome': 'Ceres',
    'estado': 'GO'
  },
  {
    'id': '945',
    'nome': 'Cezarina',
    'estado': 'GO'
  },
  {
    'id': '946',
    'nome': 'Chapadão do Céu',
    'estado': 'GO'
  },
  {
    'id': '947',
    'nome': 'Cidade Ocidental',
    'estado': 'GO'
  },
  {
    'id': '948',
    'nome': 'Cocalzinho de Goiás',
    'estado': 'GO'
  },
  {
    'id': '949',
    'nome': 'Colinas do Sul',
    'estado': 'GO'
  },
  {
    'id': '950',
    'nome': 'Córrego do Ouro',
    'estado': 'GO'
  },
  {
    'id': '951',
    'nome': 'Corumbá de Goiás',
    'estado': 'GO'
  },
  {
    'id': '952',
    'nome': 'Corumbaíba',
    'estado': 'GO'
  },
  {
    'id': '953',
    'nome': 'Cristalina',
    'estado': 'GO'
  },
  {
    'id': '954',
    'nome': 'Cristianópolis',
    'estado': 'GO'
  },
  {
    'id': '955',
    'nome': 'Crixás',
    'estado': 'GO'
  },
  {
    'id': '956',
    'nome': 'Cromínia',
    'estado': 'GO'
  },
  {
    'id': '957',
    'nome': 'Cumari',
    'estado': 'GO'
  },
  {
    'id': '958',
    'nome': 'Damianópolis',
    'estado': 'GO'
  },
  {
    'id': '959',
    'nome': 'Damolândia',
    'estado': 'GO'
  },
  {
    'id': '960',
    'nome': 'Davinópolis',
    'estado': 'GO'
  },
  {
    'id': '961',
    'nome': 'Diorama',
    'estado': 'GO'
  },
  {
    'id': '962',
    'nome': 'Divinópolis de Goiás',
    'estado': 'GO'
  },
  {
    'id': '963',
    'nome': 'Doverlândia',
    'estado': 'GO'
  },
  {
    'id': '964',
    'nome': 'Edealina',
    'estado': 'GO'
  },
  {
    'id': '965',
    'nome': 'Edéia',
    'estado': 'GO'
  },
  {
    'id': '966',
    'nome': 'Estrela do Norte',
    'estado': 'GO'
  },
  {
    'id': '967',
    'nome': 'Faina',
    'estado': 'GO'
  },
  {
    'id': '968',
    'nome': 'Fazenda Nova',
    'estado': 'GO'
  },
  {
    'id': '969',
    'nome': 'Firminópolis',
    'estado': 'GO'
  },
  {
    'id': '970',
    'nome': 'Flores de Goiás',
    'estado': 'GO'
  },
  {
    'id': '971',
    'nome': 'Formosa',
    'estado': 'GO'
  },
  {
    'id': '972',
    'nome': 'Formoso',
    'estado': 'GO'
  },
  {
    'id': '973',
    'nome': 'Gameleira de Goiás',
    'estado': 'GO'
  },
  {
    'id': '974',
    'nome': 'Goianápolis',
    'estado': 'GO'
  },
  {
    'id': '975',
    'nome': 'Goiandira',
    'estado': 'GO'
  },
  {
    'id': '976',
    'nome': 'Goianésia',
    'estado': 'GO'
  },
  {
    'id': '977',
    'nome': 'Goiânia',
    'estado': 'GO'
  },
  {
    'id': '978',
    'nome': 'Goianira',
    'estado': 'GO'
  },
  {
    'id': '979',
    'nome': 'Goiás',
    'estado': 'GO'
  },
  {
    'id': '980',
    'nome': 'Goiatuba',
    'estado': 'GO'
  },
  {
    'id': '981',
    'nome': 'Gouvelândia',
    'estado': 'GO'
  },
  {
    'id': '982',
    'nome': 'Guapó',
    'estado': 'GO'
  },
  {
    'id': '983',
    'nome': 'Guaraíta',
    'estado': 'GO'
  },
  {
    'id': '984',
    'nome': 'Guarani de Goiás',
    'estado': 'GO'
  },
  {
    'id': '985',
    'nome': 'Guarinos',
    'estado': 'GO'
  },
  {
    'id': '986',
    'nome': 'Heitoraí',
    'estado': 'GO'
  },
  {
    'id': '987',
    'nome': 'Hidrolândia',
    'estado': 'GO'
  },
  {
    'id': '988',
    'nome': 'Hidrolina',
    'estado': 'GO'
  },
  {
    'id': '989',
    'nome': 'Iaciara',
    'estado': 'GO'
  },
  {
    'id': '990',
    'nome': 'Inaciolândia',
    'estado': 'GO'
  },
  {
    'id': '991',
    'nome': 'Indiara',
    'estado': 'GO'
  },
  {
    'id': '992',
    'nome': 'Inhumas',
    'estado': 'GO'
  },
  {
    'id': '993',
    'nome': 'Ipameri',
    'estado': 'GO'
  },
  {
    'id': '994',
    'nome': 'Ipiranga de Goiás',
    'estado': 'GO'
  },
  {
    'id': '995',
    'nome': 'Iporá',
    'estado': 'GO'
  },
  {
    'id': '996',
    'nome': 'Israelândia',
    'estado': 'GO'
  },
  {
    'id': '997',
    'nome': 'Itaberaí',
    'estado': 'GO'
  },
  {
    'id': '998',
    'nome': 'Itaguari',
    'estado': 'GO'
  },
  {
    'id': '999',
    'nome': 'Itaguaru',
    'estado': 'GO'
  },
  {
    'id': '1000',
    'nome': 'Itajá',
    'estado': 'GO'
  },
  {
    'id': '1001',
    'nome': 'Itapaci',
    'estado': 'GO'
  },
  {
    'id': '1002',
    'nome': 'Itapirapuã',
    'estado': 'GO'
  },
  {
    'id': '1003',
    'nome': 'Itapuranga',
    'estado': 'GO'
  },
  {
    'id': '1004',
    'nome': 'Itarumã',
    'estado': 'GO'
  },
  {
    'id': '1005',
    'nome': 'Itauçu',
    'estado': 'GO'
  },
  {
    'id': '1006',
    'nome': 'Itumbiara',
    'estado': 'GO'
  },
  {
    'id': '1007',
    'nome': 'Ivolândia',
    'estado': 'GO'
  },
  {
    'id': '1008',
    'nome': 'Jandaia',
    'estado': 'GO'
  },
  {
    'id': '1009',
    'nome': 'Jaraguá',
    'estado': 'GO'
  },
  {
    'id': '1010',
    'nome': 'Jataí',
    'estado': 'GO'
  },
  {
    'id': '1011',
    'nome': 'Jaupaci',
    'estado': 'GO'
  },
  {
    'id': '1012',
    'nome': 'Jesúpolis',
    'estado': 'GO'
  },
  {
    'id': '1013',
    'nome': 'Joviânia',
    'estado': 'GO'
  },
  {
    'id': '1014',
    'nome': 'Jussara',
    'estado': 'GO'
  },
  {
    'id': '1015',
    'nome': 'Lagoa Santa',
    'estado': 'GO'
  },
  {
    'id': '1016',
    'nome': 'Leopoldo de Bulhões',
    'estado': 'GO'
  },
  {
    'id': '1017',
    'nome': 'Luziânia',
    'estado': 'GO'
  },
  {
    'id': '1018',
    'nome': 'Mairipotaba',
    'estado': 'GO'
  },
  {
    'id': '1019',
    'nome': 'Mambaí',
    'estado': 'GO'
  },
  {
    'id': '1020',
    'nome': 'Mara Rosa',
    'estado': 'GO'
  },
  {
    'id': '1021',
    'nome': 'Marzagão',
    'estado': 'GO'
  },
  {
    'id': '1022',
    'nome': 'Matrinchã',
    'estado': 'GO'
  },
  {
    'id': '1023',
    'nome': 'Maurilândia',
    'estado': 'GO'
  },
  {
    'id': '1024',
    'nome': 'Mimoso de Goiás',
    'estado': 'GO'
  },
  {
    'id': '1025',
    'nome': 'Minaçu',
    'estado': 'GO'
  },
  {
    'id': '1026',
    'nome': 'Mineiros',
    'estado': 'GO'
  },
  {
    'id': '1027',
    'nome': 'Moiporá',
    'estado': 'GO'
  },
  {
    'id': '1028',
    'nome': 'Monte Alegre de Goiás',
    'estado': 'GO'
  },
  {
    'id': '1029',
    'nome': 'Montes Claros de Goiás',
    'estado': 'GO'
  },
  {
    'id': '1030',
    'nome': 'Montividiu',
    'estado': 'GO'
  },
  {
    'id': '1031',
    'nome': 'Montividiu do Norte',
    'estado': 'GO'
  },
  {
    'id': '1032',
    'nome': 'Morrinhos',
    'estado': 'GO'
  },
  {
    'id': '1033',
    'nome': 'Morro Agudo de Goiás',
    'estado': 'GO'
  },
  {
    'id': '1034',
    'nome': 'Mossâmedes',
    'estado': 'GO'
  },
  {
    'id': '1035',
    'nome': 'Mozarlândia',
    'estado': 'GO'
  },
  {
    'id': '1036',
    'nome': 'Mundo Novo',
    'estado': 'GO'
  },
  {
    'id': '1037',
    'nome': 'Mutunópolis',
    'estado': 'GO'
  },
  {
    'id': '1038',
    'nome': 'Nazário',
    'estado': 'GO'
  },
  {
    'id': '1039',
    'nome': 'Nerópolis',
    'estado': 'GO'
  },
  {
    'id': '1040',
    'nome': 'Niquelândia',
    'estado': 'GO'
  },
  {
    'id': '1041',
    'nome': 'Nova América',
    'estado': 'GO'
  },
  {
    'id': '1042',
    'nome': 'Nova Aurora',
    'estado': 'GO'
  },
  {
    'id': '1043',
    'nome': 'Nova Crixás',
    'estado': 'GO'
  },
  {
    'id': '1044',
    'nome': 'Nova Glória',
    'estado': 'GO'
  },
  {
    'id': '1045',
    'nome': 'Nova Iguaçu de Goiás',
    'estado': 'GO'
  },
  {
    'id': '1046',
    'nome': 'Nova Roma',
    'estado': 'GO'
  },
  {
    'id': '1047',
    'nome': 'Nova Veneza',
    'estado': 'GO'
  },
  {
    'id': '1048',
    'nome': 'Novo Brasil',
    'estado': 'GO'
  },
  {
    'id': '1049',
    'nome': 'Novo Gama',
    'estado': 'GO'
  },
  {
    'id': '1050',
    'nome': 'Novo Planalto',
    'estado': 'GO'
  },
  {
    'id': '1051',
    'nome': 'Orizona',
    'estado': 'GO'
  },
  {
    'id': '1052',
    'nome': 'Ouro Verde de Goiás',
    'estado': 'GO'
  },
  {
    'id': '1053',
    'nome': 'Ouvidor',
    'estado': 'GO'
  },
  {
    'id': '1054',
    'nome': 'Padre Bernardo',
    'estado': 'GO'
  },
  {
    'id': '1055',
    'nome': 'Palestina de Goiás',
    'estado': 'GO'
  },
  {
    'id': '1056',
    'nome': 'Palmeiras de Goiás',
    'estado': 'GO'
  },
  {
    'id': '1057',
    'nome': 'Palmelo',
    'estado': 'GO'
  },
  {
    'id': '1058',
    'nome': 'Palminópolis',
    'estado': 'GO'
  },
  {
    'id': '1059',
    'nome': 'Panamá',
    'estado': 'GO'
  },
  {
    'id': '1060',
    'nome': 'Paranaiguara',
    'estado': 'GO'
  },
  {
    'id': '1061',
    'nome': 'Paraúna',
    'estado': 'GO'
  },
  {
    'id': '1062',
    'nome': 'Perolândia',
    'estado': 'GO'
  },
  {
    'id': '1063',
    'nome': 'Petrolina de Goiás',
    'estado': 'GO'
  },
  {
    'id': '1064',
    'nome': 'Pilar de Goiás',
    'estado': 'GO'
  },
  {
    'id': '1065',
    'nome': 'Piracanjuba',
    'estado': 'GO'
  },
  {
    'id': '1066',
    'nome': 'Piranhas',
    'estado': 'GO'
  },
  {
    'id': '1067',
    'nome': 'Pirenópolis',
    'estado': 'GO'
  },
  {
    'id': '1068',
    'nome': 'Pires do Rio',
    'estado': 'GO'
  },
  {
    'id': '1069',
    'nome': 'Planaltina',
    'estado': 'GO'
  },
  {
    'id': '1070',
    'nome': 'Pontalina',
    'estado': 'GO'
  },
  {
    'id': '1071',
    'nome': 'Porangatu',
    'estado': 'GO'
  },
  {
    'id': '1072',
    'nome': 'Porteirão',
    'estado': 'GO'
  },
  {
    'id': '1073',
    'nome': 'Portelândia',
    'estado': 'GO'
  },
  {
    'id': '1074',
    'nome': 'Posse',
    'estado': 'GO'
  },
  {
    'id': '1075',
    'nome': 'Professor Jamil',
    'estado': 'GO'
  },
  {
    'id': '1076',
    'nome': 'Quirinópolis',
    'estado': 'GO'
  },
  {
    'id': '1077',
    'nome': 'Rialma',
    'estado': 'GO'
  },
  {
    'id': '1078',
    'nome': 'Rianápolis',
    'estado': 'GO'
  },
  {
    'id': '1079',
    'nome': 'Rio Quente',
    'estado': 'GO'
  },
  {
    'id': '1080',
    'nome': 'Rio Verde',
    'estado': 'GO'
  },
  {
    'id': '1081',
    'nome': 'Rubiataba',
    'estado': 'GO'
  },
  {
    'id': '1082',
    'nome': 'Sanclerlândia',
    'estado': 'GO'
  },
  {
    'id': '1083',
    'nome': 'Santa Bárbara de Goiás',
    'estado': 'GO'
  },
  {
    'id': '1084',
    'nome': 'Santa Cruz de Goiás',
    'estado': 'GO'
  },
  {
    'id': '1085',
    'nome': 'Santa Fé de Goiás',
    'estado': 'GO'
  },
  {
    'id': '1086',
    'nome': 'Santa Helena de Goiás',
    'estado': 'GO'
  },
  {
    'id': '1087',
    'nome': 'Santa Isabel',
    'estado': 'GO'
  },
  {
    'id': '1088',
    'nome': 'Santa Rita do Araguaia',
    'estado': 'GO'
  },
  {
    'id': '1089',
    'nome': 'Santa Rita do Novo Destino',
    'estado': 'GO'
  },
  {
    'id': '1090',
    'nome': 'Santa Rosa de Goiás',
    'estado': 'GO'
  },
  {
    'id': '1091',
    'nome': 'Santa Tereza de Goiás',
    'estado': 'GO'
  },
  {
    'id': '1092',
    'nome': 'Santa Terezinha de Goiás',
    'estado': 'GO'
  },
  {
    'id': '1093',
    'nome': 'Santo Antônio da Barra',
    'estado': 'GO'
  },
  {
    'id': '1094',
    'nome': 'Santo Antônio de Goiás',
    'estado': 'GO'
  },
  {
    'id': '1095',
    'nome': 'Santo Antônio do Descoberto',
    'estado': 'GO'
  },
  {
    'id': '1096',
    'nome': 'São Domingos',
    'estado': 'GO'
  },
  {
    'id': '1097',
    'nome': 'São Francisco de Goiás',
    'estado': 'GO'
  },
  {
    'id': '1098',
    'nome': 'São João d`Aliança',
    'estado': 'GO'
  },
  {
    'id': '1099',
    'nome': 'São João da Paraúna',
    'estado': 'GO'
  },
  {
    'id': '1100',
    'nome': 'São Luís de Montes Belos',
    'estado': 'GO'
  },
  {
    'id': '1101',
    'nome': 'São Luíz do Norte',
    'estado': 'GO'
  },
  {
    'id': '1102',
    'nome': 'São Miguel do Araguaia',
    'estado': 'GO'
  },
  {
    'id': '1103',
    'nome': 'São Miguel do Passa Quatro',
    'estado': 'GO'
  },
  {
    'id': '1104',
    'nome': 'São Patrício',
    'estado': 'GO'
  },
  {
    'id': '1105',
    'nome': 'São Simão',
    'estado': 'GO'
  },
  {
    'id': '1106',
    'nome': 'Senador Canedo',
    'estado': 'GO'
  },
  {
    'id': '1107',
    'nome': 'Serranópolis',
    'estado': 'GO'
  },
  {
    'id': '1108',
    'nome': 'Silvânia',
    'estado': 'GO'
  },
  {
    'id': '1109',
    'nome': 'Simolândia',
    'estado': 'GO'
  },
  {
    'id': '1110',
    'nome': 'Sítio d`Abadia',
    'estado': 'GO'
  },
  {
    'id': '1111',
    'nome': 'Taquaral de Goiás',
    'estado': 'GO'
  },
  {
    'id': '1112',
    'nome': 'Teresina de Goiás',
    'estado': 'GO'
  },
  {
    'id': '1113',
    'nome': 'Terezópolis de Goiás',
    'estado': 'GO'
  },
  {
    'id': '1114',
    'nome': 'Três Ranchos',
    'estado': 'GO'
  },
  {
    'id': '1115',
    'nome': 'Trindade',
    'estado': 'GO'
  },
  {
    'id': '1116',
    'nome': 'Trombas',
    'estado': 'GO'
  },
  {
    'id': '1117',
    'nome': 'Turvânia',
    'estado': 'GO'
  },
  {
    'id': '1118',
    'nome': 'Turvelândia',
    'estado': 'GO'
  },
  {
    'id': '1119',
    'nome': 'Uirapuru',
    'estado': 'GO'
  },
  {
    'id': '1120',
    'nome': 'Uruaçu',
    'estado': 'GO'
  },
  {
    'id': '1121',
    'nome': 'Uruana',
    'estado': 'GO'
  },
  {
    'id': '1122',
    'nome': 'Urutaí',
    'estado': 'GO'
  },
  {
    'id': '1123',
    'nome': 'Valparaíso de Goiás',
    'estado': 'GO'
  },
  {
    'id': '1124',
    'nome': 'Varjão',
    'estado': 'GO'
  },
  {
    'id': '1125',
    'nome': 'Vianópolis',
    'estado': 'GO'
  },
  {
    'id': '1126',
    'nome': 'Vicentinópolis',
    'estado': 'GO'
  },
  {
    'id': '1127',
    'nome': 'Vila Boa',
    'estado': 'GO'
  },
  {
    'id': '1128',
    'nome': 'Vila Propício',
    'estado': 'GO'
  },
  {
    'id': '1129',
    'nome': 'Açailândia',
    'estado': 'MA'
  },
  {
    'id': '1130',
    'nome': 'Afonso Cunha',
    'estado': 'MA'
  },
  {
    'id': '1131',
    'nome': 'Água Doce do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1132',
    'nome': 'Alcântara',
    'estado': 'MA'
  },
  {
    'id': '1133',
    'nome': 'Aldeias Altas',
    'estado': 'MA'
  },
  {
    'id': '1134',
    'nome': 'Altamira do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1135',
    'nome': 'Alto Alegre do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1136',
    'nome': 'Alto Alegre do Pindaré',
    'estado': 'MA'
  },
  {
    'id': '1137',
    'nome': 'Alto Parnaíba',
    'estado': 'MA'
  },
  {
    'id': '1138',
    'nome': 'Amapá do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1139',
    'nome': 'Amarante do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1140',
    'nome': 'Anajatuba',
    'estado': 'MA'
  },
  {
    'id': '1141',
    'nome': 'Anapurus',
    'estado': 'MA'
  },
  {
    'id': '1142',
    'nome': 'Apicum-Açu',
    'estado': 'MA'
  },
  {
    'id': '1143',
    'nome': 'Araguanã',
    'estado': 'MA'
  },
  {
    'id': '1144',
    'nome': 'Araioses',
    'estado': 'MA'
  },
  {
    'id': '1145',
    'nome': 'Arame',
    'estado': 'MA'
  },
  {
    'id': '1146',
    'nome': 'Arari',
    'estado': 'MA'
  },
  {
    'id': '1147',
    'nome': 'Axixá',
    'estado': 'MA'
  },
  {
    'id': '1148',
    'nome': 'Bacabal',
    'estado': 'MA'
  },
  {
    'id': '1149',
    'nome': 'Bacabeira',
    'estado': 'MA'
  },
  {
    'id': '1150',
    'nome': 'Bacuri',
    'estado': 'MA'
  },
  {
    'id': '1151',
    'nome': 'Bacurituba',
    'estado': 'MA'
  },
  {
    'id': '1152',
    'nome': 'Balsas',
    'estado': 'MA'
  },
  {
    'id': '1153',
    'nome': 'Barão de Grajaú',
    'estado': 'MA'
  },
  {
    'id': '1154',
    'nome': 'Barra do Corda',
    'estado': 'MA'
  },
  {
    'id': '1155',
    'nome': 'Barreirinhas',
    'estado': 'MA'
  },
  {
    'id': '1156',
    'nome': 'Bela Vista do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1157',
    'nome': 'Belágua',
    'estado': 'MA'
  },
  {
    'id': '1158',
    'nome': 'Benedito Leite',
    'estado': 'MA'
  },
  {
    'id': '1159',
    'nome': 'Bequimão',
    'estado': 'MA'
  },
  {
    'id': '1160',
    'nome': 'Bernardo do Mearim',
    'estado': 'MA'
  },
  {
    'id': '1161',
    'nome': 'Boa Vista do Gurupi',
    'estado': 'MA'
  },
  {
    'id': '1162',
    'nome': 'Bom Jardim',
    'estado': 'MA'
  },
  {
    'id': '1163',
    'nome': 'Bom Jesus das Selvas',
    'estado': 'MA'
  },
  {
    'id': '1164',
    'nome': 'Bom Lugar',
    'estado': 'MA'
  },
  {
    'id': '1165',
    'nome': 'Brejo',
    'estado': 'MA'
  },
  {
    'id': '1166',
    'nome': 'Brejo de Areia',
    'estado': 'MA'
  },
  {
    'id': '1167',
    'nome': 'Buriti',
    'estado': 'MA'
  },
  {
    'id': '1168',
    'nome': 'Buriti Bravo',
    'estado': 'MA'
  },
  {
    'id': '1169',
    'nome': 'Buriticupu',
    'estado': 'MA'
  },
  {
    'id': '1170',
    'nome': 'Buritirana',
    'estado': 'MA'
  },
  {
    'id': '1171',
    'nome': 'Cachoeira Grande',
    'estado': 'MA'
  },
  {
    'id': '1172',
    'nome': 'Cajapió',
    'estado': 'MA'
  },
  {
    'id': '1173',
    'nome': 'Cajari',
    'estado': 'MA'
  },
  {
    'id': '1174',
    'nome': 'Campestre do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1175',
    'nome': 'Cândido Mendes',
    'estado': 'MA'
  },
  {
    'id': '1176',
    'nome': 'Cantanhede',
    'estado': 'MA'
  },
  {
    'id': '1177',
    'nome': 'Capinzal do Norte',
    'estado': 'MA'
  },
  {
    'id': '1178',
    'nome': 'Carolina',
    'estado': 'MA'
  },
  {
    'id': '1179',
    'nome': 'Carutapera',
    'estado': 'MA'
  },
  {
    'id': '1180',
    'nome': 'Caxias',
    'estado': 'MA'
  },
  {
    'id': '1181',
    'nome': 'Cedral',
    'estado': 'MA'
  },
  {
    'id': '1182',
    'nome': 'Central do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1183',
    'nome': 'Centro do Guilherme',
    'estado': 'MA'
  },
  {
    'id': '1184',
    'nome': 'Centro Novo do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1185',
    'nome': 'Chapadinha',
    'estado': 'MA'
  },
  {
    'id': '1186',
    'nome': 'Cidelândia',
    'estado': 'MA'
  },
  {
    'id': '1187',
    'nome': 'Codó',
    'estado': 'MA'
  },
  {
    'id': '1188',
    'nome': 'Coelho Neto',
    'estado': 'MA'
  },
  {
    'id': '1189',
    'nome': 'Colinas',
    'estado': 'MA'
  },
  {
    'id': '1190',
    'nome': 'Conceição do Lago-Açu',
    'estado': 'MA'
  },
  {
    'id': '1191',
    'nome': 'Coroatá',
    'estado': 'MA'
  },
  {
    'id': '1192',
    'nome': 'Cururupu',
    'estado': 'MA'
  },
  {
    'id': '1193',
    'nome': 'Davinópolis',
    'estado': 'MA'
  },
  {
    'id': '1194',
    'nome': 'Dom Pedro',
    'estado': 'MA'
  },
  {
    'id': '1195',
    'nome': 'Duque Bacelar',
    'estado': 'MA'
  },
  {
    'id': '1196',
    'nome': 'Esperantinópolis',
    'estado': 'MA'
  },
  {
    'id': '1197',
    'nome': 'Estreito',
    'estado': 'MA'
  },
  {
    'id': '1198',
    'nome': 'Feira Nova do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1199',
    'nome': 'Fernando Falcão',
    'estado': 'MA'
  },
  {
    'id': '1200',
    'nome': 'Formosa da Serra Negra',
    'estado': 'MA'
  },
  {
    'id': '1201',
    'nome': 'Fortaleza dos Nogueiras',
    'estado': 'MA'
  },
  {
    'id': '1202',
    'nome': 'Fortuna',
    'estado': 'MA'
  },
  {
    'id': '1203',
    'nome': 'Godofredo Viana',
    'estado': 'MA'
  },
  {
    'id': '1204',
    'nome': 'Gonçalves Dias',
    'estado': 'MA'
  },
  {
    'id': '1205',
    'nome': 'Governador Archer',
    'estado': 'MA'
  },
  {
    'id': '1206',
    'nome': 'Governador Edison Lobão',
    'estado': 'MA'
  },
  {
    'id': '1207',
    'nome': 'Governador Eugênio Barros',
    'estado': 'MA'
  },
  {
    'id': '1208',
    'nome': 'Governador Luiz Rocha',
    'estado': 'MA'
  },
  {
    'id': '1209',
    'nome': 'Governador Newton Bello',
    'estado': 'MA'
  },
  {
    'id': '1210',
    'nome': 'Governador Nunes Freire',
    'estado': 'MA'
  },
  {
    'id': '1211',
    'nome': 'Graça Aranha',
    'estado': 'MA'
  },
  {
    'id': '1212',
    'nome': 'Grajaú',
    'estado': 'MA'
  },
  {
    'id': '1213',
    'nome': 'Guimarães',
    'estado': 'MA'
  },
  {
    'id': '1214',
    'nome': 'Humberto de Campos',
    'estado': 'MA'
  },
  {
    'id': '1215',
    'nome': 'Icatu',
    'estado': 'MA'
  },
  {
    'id': '1216',
    'nome': 'Igarapé do Meio',
    'estado': 'MA'
  },
  {
    'id': '1217',
    'nome': 'Igarapé Grande',
    'estado': 'MA'
  },
  {
    'id': '1218',
    'nome': 'Imperatriz',
    'estado': 'MA'
  },
  {
    'id': '1219',
    'nome': 'Itaipava do Grajaú',
    'estado': 'MA'
  },
  {
    'id': '1220',
    'nome': 'Itapecuru Mirim',
    'estado': 'MA'
  },
  {
    'id': '1221',
    'nome': 'Itinga do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1222',
    'nome': 'Jatobá',
    'estado': 'MA'
  },
  {
    'id': '1223',
    'nome': 'Jenipapo dos Vieiras',
    'estado': 'MA'
  },
  {
    'id': '1224',
    'nome': 'João Lisboa',
    'estado': 'MA'
  },
  {
    'id': '1225',
    'nome': 'Joselândia',
    'estado': 'MA'
  },
  {
    'id': '1226',
    'nome': 'Junco do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1227',
    'nome': 'Lago da Pedra',
    'estado': 'MA'
  },
  {
    'id': '1228',
    'nome': 'Lago do Junco',
    'estado': 'MA'
  },
  {
    'id': '1229',
    'nome': 'Lago dos Rodrigues',
    'estado': 'MA'
  },
  {
    'id': '1230',
    'nome': 'Lago Verde',
    'estado': 'MA'
  },
  {
    'id': '1231',
    'nome': 'Lagoa do Mato',
    'estado': 'MA'
  },
  {
    'id': '1232',
    'nome': 'Lagoa Grande do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1233',
    'nome': 'Lajeado Novo',
    'estado': 'MA'
  },
  {
    'id': '1234',
    'nome': 'Lima Campos',
    'estado': 'MA'
  },
  {
    'id': '1235',
    'nome': 'Loreto',
    'estado': 'MA'
  },
  {
    'id': '1236',
    'nome': 'Luís Domingues',
    'estado': 'MA'
  },
  {
    'id': '1237',
    'nome': 'Magalhães de Almeida',
    'estado': 'MA'
  },
  {
    'id': '1238',
    'nome': 'Maracaçumé',
    'estado': 'MA'
  },
  {
    'id': '1239',
    'nome': 'Marajá do Sena',
    'estado': 'MA'
  },
  {
    'id': '1240',
    'nome': 'Maranhãozinho',
    'estado': 'MA'
  },
  {
    'id': '1241',
    'nome': 'Mata Roma',
    'estado': 'MA'
  },
  {
    'id': '1242',
    'nome': 'Matinha',
    'estado': 'MA'
  },
  {
    'id': '1243',
    'nome': 'Matões',
    'estado': 'MA'
  },
  {
    'id': '1244',
    'nome': 'Matões do Norte',
    'estado': 'MA'
  },
  {
    'id': '1245',
    'nome': 'Milagres do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1246',
    'nome': 'Mirador',
    'estado': 'MA'
  },
  {
    'id': '1247',
    'nome': 'Miranda do Norte',
    'estado': 'MA'
  },
  {
    'id': '1248',
    'nome': 'Mirinzal',
    'estado': 'MA'
  },
  {
    'id': '1249',
    'nome': 'Monção',
    'estado': 'MA'
  },
  {
    'id': '1250',
    'nome': 'Montes Altos',
    'estado': 'MA'
  },
  {
    'id': '1251',
    'nome': 'Morros',
    'estado': 'MA'
  },
  {
    'id': '1252',
    'nome': 'Nina Rodrigues',
    'estado': 'MA'
  },
  {
    'id': '1253',
    'nome': 'Nova Colinas',
    'estado': 'MA'
  },
  {
    'id': '1254',
    'nome': 'Nova Iorque',
    'estado': 'MA'
  },
  {
    'id': '1255',
    'nome': 'Nova Olinda do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1256',
    'nome': 'Olho d`Água das Cunhãs',
    'estado': 'MA'
  },
  {
    'id': '1257',
    'nome': 'Olinda Nova do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1258',
    'nome': 'Paço do Lumiar',
    'estado': 'MA'
  },
  {
    'id': '1259',
    'nome': 'Palmeirândia',
    'estado': 'MA'
  },
  {
    'id': '1260',
    'nome': 'Paraibano',
    'estado': 'MA'
  },
  {
    'id': '1261',
    'nome': 'Parnarama',
    'estado': 'MA'
  },
  {
    'id': '1262',
    'nome': 'Passagem Franca',
    'estado': 'MA'
  },
  {
    'id': '1263',
    'nome': 'Pastos Bons',
    'estado': 'MA'
  },
  {
    'id': '1264',
    'nome': 'Paulino Neves',
    'estado': 'MA'
  },
  {
    'id': '1265',
    'nome': 'Paulo Ramos',
    'estado': 'MA'
  },
  {
    'id': '1266',
    'nome': 'Pedreiras',
    'estado': 'MA'
  },
  {
    'id': '1267',
    'nome': 'Pedro do Rosário',
    'estado': 'MA'
  },
  {
    'id': '1268',
    'nome': 'Penalva',
    'estado': 'MA'
  },
  {
    'id': '1269',
    'nome': 'Peri Mirim',
    'estado': 'MA'
  },
  {
    'id': '1270',
    'nome': 'Peritoró',
    'estado': 'MA'
  },
  {
    'id': '1271',
    'nome': 'Pindaré-Mirim',
    'estado': 'MA'
  },
  {
    'id': '1272',
    'nome': 'Pinheiro',
    'estado': 'MA'
  },
  {
    'id': '1273',
    'nome': 'Pio XII',
    'estado': 'MA'
  },
  {
    'id': '1274',
    'nome': 'Pirapemas',
    'estado': 'MA'
  },
  {
    'id': '1275',
    'nome': 'Poção de Pedras',
    'estado': 'MA'
  },
  {
    'id': '1276',
    'nome': 'Porto Franco',
    'estado': 'MA'
  },
  {
    'id': '1277',
    'nome': 'Porto Rico do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1278',
    'nome': 'Presidente Dutra',
    'estado': 'MA'
  },
  {
    'id': '1279',
    'nome': 'Presidente Juscelino',
    'estado': 'MA'
  },
  {
    'id': '1280',
    'nome': 'Presidente Médici',
    'estado': 'MA'
  },
  {
    'id': '1281',
    'nome': 'Presidente Sarney',
    'estado': 'MA'
  },
  {
    'id': '1282',
    'nome': 'Presidente Vargas',
    'estado': 'MA'
  },
  {
    'id': '1283',
    'nome': 'Primeira Cruz',
    'estado': 'MA'
  },
  {
    'id': '1284',
    'nome': 'Raposa',
    'estado': 'MA'
  },
  {
    'id': '1285',
    'nome': 'Riachão',
    'estado': 'MA'
  },
  {
    'id': '1286',
    'nome': 'Ribamar Fiquene',
    'estado': 'MA'
  },
  {
    'id': '1287',
    'nome': 'Rosário',
    'estado': 'MA'
  },
  {
    'id': '1288',
    'nome': 'Sambaíba',
    'estado': 'MA'
  },
  {
    'id': '1289',
    'nome': 'Santa Filomena do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1290',
    'nome': 'Santa Helena',
    'estado': 'MA'
  },
  {
    'id': '1291',
    'nome': 'Santa Inês',
    'estado': 'MA'
  },
  {
    'id': '1292',
    'nome': 'Santa Luzia',
    'estado': 'MA'
  },
  {
    'id': '1293',
    'nome': 'Santa Luzia do Paruá',
    'estado': 'MA'
  },
  {
    'id': '1294',
    'nome': 'Santa Quitéria do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1295',
    'nome': 'Santa Rita',
    'estado': 'MA'
  },
  {
    'id': '1296',
    'nome': 'Santana do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1297',
    'nome': 'Santo Amaro do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1298',
    'nome': 'Santo Antônio dos Lopes',
    'estado': 'MA'
  },
  {
    'id': '1299',
    'nome': 'São Benedito do Rio Preto',
    'estado': 'MA'
  },
  {
    'id': '1300',
    'nome': 'São Bento',
    'estado': 'MA'
  },
  {
    'id': '1301',
    'nome': 'São Bernardo',
    'estado': 'MA'
  },
  {
    'id': '1302',
    'nome': 'São Domingos do Azeitão',
    'estado': 'MA'
  },
  {
    'id': '1303',
    'nome': 'São Domingos do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1304',
    'nome': 'São Félix de Balsas',
    'estado': 'MA'
  },
  {
    'id': '1305',
    'nome': 'São Francisco do Brejão',
    'estado': 'MA'
  },
  {
    'id': '1306',
    'nome': 'São Francisco do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1307',
    'nome': 'São João Batista',
    'estado': 'MA'
  },
  {
    'id': '1308',
    'nome': 'São João do Carú',
    'estado': 'MA'
  },
  {
    'id': '1309',
    'nome': 'São João do Paraíso',
    'estado': 'MA'
  },
  {
    'id': '1310',
    'nome': 'São João do Soter',
    'estado': 'MA'
  },
  {
    'id': '1311',
    'nome': 'São João dos Patos',
    'estado': 'MA'
  },
  {
    'id': '1312',
    'nome': 'São José de Ribamar',
    'estado': 'MA'
  },
  {
    'id': '1313',
    'nome': 'São José dos Basílios',
    'estado': 'MA'
  },
  {
    'id': '1314',
    'nome': 'São Luís',
    'estado': 'MA'
  },
  {
    'id': '1315',
    'nome': 'São Luís Gonzaga do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1316',
    'nome': 'São Mateus do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1317',
    'nome': 'São Pedro da Água Branca',
    'estado': 'MA'
  },
  {
    'id': '1318',
    'nome': 'São Pedro dos Crentes',
    'estado': 'MA'
  },
  {
    'id': '1319',
    'nome': 'São Raimundo das Mangabeiras',
    'estado': 'MA'
  },
  {
    'id': '1320',
    'nome': 'São Raimundo do Doca Bezerra',
    'estado': 'MA'
  },
  {
    'id': '1321',
    'nome': 'São Roberto',
    'estado': 'MA'
  },
  {
    'id': '1322',
    'nome': 'São Vicente Ferrer',
    'estado': 'MA'
  },
  {
    'id': '1323',
    'nome': 'Satubinha',
    'estado': 'MA'
  },
  {
    'id': '1324',
    'nome': 'Senador Alexandre Costa',
    'estado': 'MA'
  },
  {
    'id': '1325',
    'nome': 'Senador La Rocque',
    'estado': 'MA'
  },
  {
    'id': '1326',
    'nome': 'Serrano do Maranhão',
    'estado': 'MA'
  },
  {
    'id': '1327',
    'nome': 'Sítio Novo',
    'estado': 'MA'
  },
  {
    'id': '1328',
    'nome': 'Sucupira do Norte',
    'estado': 'MA'
  },
  {
    'id': '1329',
    'nome': 'Sucupira do Riachão',
    'estado': 'MA'
  },
  {
    'id': '1330',
    'nome': 'Tasso Fragoso',
    'estado': 'MA'
  },
  {
    'id': '1331',
    'nome': 'Timbiras',
    'estado': 'MA'
  },
  {
    'id': '1332',
    'nome': 'Timon',
    'estado': 'MA'
  },
  {
    'id': '1333',
    'nome': 'Trizidela do Vale',
    'estado': 'MA'
  },
  {
    'id': '1334',
    'nome': 'Tufilândia',
    'estado': 'MA'
  },
  {
    'id': '1335',
    'nome': 'Tuntum',
    'estado': 'MA'
  },
  {
    'id': '1336',
    'nome': 'Turiaçu',
    'estado': 'MA'
  },
  {
    'id': '1337',
    'nome': 'Turilândia',
    'estado': 'MA'
  },
  {
    'id': '1338',
    'nome': 'Tutóia',
    'estado': 'MA'
  },
  {
    'id': '1339',
    'nome': 'Urbano Santos',
    'estado': 'MA'
  },
  {
    'id': '1340',
    'nome': 'Vargem Grande',
    'estado': 'MA'
  },
  {
    'id': '1341',
    'nome': 'Viana',
    'estado': 'MA'
  },
  {
    'id': '1342',
    'nome': 'Vila Nova dos Martírios',
    'estado': 'MA'
  },
  {
    'id': '1343',
    'nome': 'Vitória do Mearim',
    'estado': 'MA'
  },
  {
    'id': '1344',
    'nome': 'Vitorino Freire',
    'estado': 'MA'
  },
  {
    'id': '1345',
    'nome': 'Zé Doca',
    'estado': 'MA'
  },
  {
    'id': '1346',
    'nome': 'Acorizal',
    'estado': 'MT'
  },
  {
    'id': '1347',
    'nome': 'Água Boa',
    'estado': 'MT'
  },
  {
    'id': '1348',
    'nome': 'Alta Floresta',
    'estado': 'MT'
  },
  {
    'id': '1349',
    'nome': 'Alto Araguaia',
    'estado': 'MT'
  },
  {
    'id': '1350',
    'nome': 'Alto Boa Vista',
    'estado': 'MT'
  },
  {
    'id': '1351',
    'nome': 'Alto Garças',
    'estado': 'MT'
  },
  {
    'id': '1352',
    'nome': 'Alto Paraguai',
    'estado': 'MT'
  },
  {
    'id': '1353',
    'nome': 'Alto Taquari',
    'estado': 'MT'
  },
  {
    'id': '1354',
    'nome': 'Apiacás',
    'estado': 'MT'
  },
  {
    'id': '1355',
    'nome': 'Araguaiana',
    'estado': 'MT'
  },
  {
    'id': '1356',
    'nome': 'Araguainha',
    'estado': 'MT'
  },
  {
    'id': '1357',
    'nome': 'Araputanga',
    'estado': 'MT'
  },
  {
    'id': '1358',
    'nome': 'Arenápolis',
    'estado': 'MT'
  },
  {
    'id': '1359',
    'nome': 'Aripuanã',
    'estado': 'MT'
  },
  {
    'id': '1360',
    'nome': 'Barão de Melgaço',
    'estado': 'MT'
  },
  {
    'id': '1361',
    'nome': 'Barra do Bugres',
    'estado': 'MT'
  },
  {
    'id': '1362',
    'nome': 'Barra do Garças',
    'estado': 'MT'
  },
  {
    'id': '1363',
    'nome': 'Bom Jesus do Araguaia',
    'estado': 'MT'
  },
  {
    'id': '1364',
    'nome': 'Brasnorte',
    'estado': 'MT'
  },
  {
    'id': '1365',
    'nome': 'Cáceres',
    'estado': 'MT'
  },
  {
    'id': '1366',
    'nome': 'Campinápolis',
    'estado': 'MT'
  },
  {
    'id': '1367',
    'nome': 'Campo Novo do Parecis',
    'estado': 'MT'
  },
  {
    'id': '1368',
    'nome': 'Campo Verde',
    'estado': 'MT'
  },
  {
    'id': '1369',
    'nome': 'Campos de Júlio',
    'estado': 'MT'
  },
  {
    'id': '1370',
    'nome': 'Canabrava do Norte',
    'estado': 'MT'
  },
  {
    'id': '1371',
    'nome': 'Canarana',
    'estado': 'MT'
  },
  {
    'id': '1372',
    'nome': 'Carlinda',
    'estado': 'MT'
  },
  {
    'id': '1373',
    'nome': 'Castanheira',
    'estado': 'MT'
  },
  {
    'id': '1374',
    'nome': 'Chapada dos Guimarães',
    'estado': 'MT'
  },
  {
    'id': '1375',
    'nome': 'Cláudia',
    'estado': 'MT'
  },
  {
    'id': '1376',
    'nome': 'Cocalinho',
    'estado': 'MT'
  },
  {
    'id': '1377',
    'nome': 'Colíder',
    'estado': 'MT'
  },
  {
    'id': '1378',
    'nome': 'Colniza',
    'estado': 'MT'
  },
  {
    'id': '1379',
    'nome': 'Comodoro',
    'estado': 'MT'
  },
  {
    'id': '1380',
    'nome': 'Confresa',
    'estado': 'MT'
  },
  {
    'id': '1381',
    'nome': 'Conquista d`Oeste',
    'estado': 'MT'
  },
  {
    'id': '1382',
    'nome': 'Cotriguaçu',
    'estado': 'MT'
  },
  {
    'id': '1383',
    'nome': 'Cuiabá',
    'estado': 'MT'
  },
  {
    'id': '1384',
    'nome': 'Curvelândia',
    'estado': 'MT'
  },
  {
    'id': '1385',
    'nome': 'Curvelândia',
    'estado': 'MT'
  },
  {
    'id': '1386',
    'nome': 'Denise',
    'estado': 'MT'
  },
  {
    'id': '1387',
    'nome': 'Diamantino',
    'estado': 'MT'
  },
  {
    'id': '1388',
    'nome': 'Dom Aquino',
    'estado': 'MT'
  },
  {
    'id': '1389',
    'nome': 'Feliz Natal',
    'estado': 'MT'
  },
  {
    'id': '1390',
    'nome': 'Figueirópolis d`Oeste',
    'estado': 'MT'
  },
  {
    'id': '1391',
    'nome': 'Gaúcha do Norte',
    'estado': 'MT'
  },
  {
    'id': '1392',
    'nome': 'General Carneiro',
    'estado': 'MT'
  },
  {
    'id': '1393',
    'nome': 'Glória d`Oeste',
    'estado': 'MT'
  },
  {
    'id': '1394',
    'nome': 'Guarantã do Norte',
    'estado': 'MT'
  },
  {
    'id': '1395',
    'nome': 'Guiratinga',
    'estado': 'MT'
  },
  {
    'id': '1396',
    'nome': 'Indiavaí',
    'estado': 'MT'
  },
  {
    'id': '1397',
    'nome': 'Ipiranga do Norte',
    'estado': 'MT'
  },
  {
    'id': '1398',
    'nome': 'Itanhangá',
    'estado': 'MT'
  },
  {
    'id': '1399',
    'nome': 'Itaúba',
    'estado': 'MT'
  },
  {
    'id': '1400',
    'nome': 'Itiquira',
    'estado': 'MT'
  },
  {
    'id': '1401',
    'nome': 'Jaciara',
    'estado': 'MT'
  },
  {
    'id': '1402',
    'nome': 'Jangada',
    'estado': 'MT'
  },
  {
    'id': '1403',
    'nome': 'Jauru',
    'estado': 'MT'
  },
  {
    'id': '1404',
    'nome': 'Juara',
    'estado': 'MT'
  },
  {
    'id': '1405',
    'nome': 'Juína',
    'estado': 'MT'
  },
  {
    'id': '1406',
    'nome': 'Juruena',
    'estado': 'MT'
  },
  {
    'id': '1407',
    'nome': 'Juscimeira',
    'estado': 'MT'
  },
  {
    'id': '1408',
    'nome': 'Lambari d`Oeste',
    'estado': 'MT'
  },
  {
    'id': '1409',
    'nome': 'Lucas do Rio Verde',
    'estado': 'MT'
  },
  {
    'id': '1410',
    'nome': 'Luciára',
    'estado': 'MT'
  },
  {
    'id': '1411',
    'nome': 'Marcelândia',
    'estado': 'MT'
  },
  {
    'id': '1412',
    'nome': 'Matupá',
    'estado': 'MT'
  },
  {
    'id': '1413',
    'nome': 'Mirassol d`Oeste',
    'estado': 'MT'
  },
  {
    'id': '1414',
    'nome': 'Nobres',
    'estado': 'MT'
  },
  {
    'id': '1415',
    'nome': 'Nortelândia',
    'estado': 'MT'
  },
  {
    'id': '1416',
    'nome': 'Nossa Senhora do Livramento',
    'estado': 'MT'
  },
  {
    'id': '1417',
    'nome': 'Nova Bandeirantes',
    'estado': 'MT'
  },
  {
    'id': '1418',
    'nome': 'Nova Brasilândia',
    'estado': 'MT'
  },
  {
    'id': '1419',
    'nome': 'Nova Canaã do Norte',
    'estado': 'MT'
  },
  {
    'id': '1420',
    'nome': 'Nova Guarita',
    'estado': 'MT'
  },
  {
    'id': '1421',
    'nome': 'Nova Lacerda',
    'estado': 'MT'
  },
  {
    'id': '1422',
    'nome': 'Nova Marilândia',
    'estado': 'MT'
  },
  {
    'id': '1423',
    'nome': 'Nova Maringá',
    'estado': 'MT'
  },
  {
    'id': '1424',
    'nome': 'Nova Monte verde',
    'estado': 'MT'
  },
  {
    'id': '1425',
    'nome': 'Nova Mutum',
    'estado': 'MT'
  },
  {
    'id': '1426',
    'nome': 'Nova Olímpia',
    'estado': 'MT'
  },
  {
    'id': '1427',
    'nome': 'Nova Santa Helena',
    'estado': 'MT'
  },
  {
    'id': '1428',
    'nome': 'Nova Ubiratã',
    'estado': 'MT'
  },
  {
    'id': '1429',
    'nome': 'Nova Xavantina',
    'estado': 'MT'
  },
  {
    'id': '1430',
    'nome': 'Novo Horizonte do Norte',
    'estado': 'MT'
  },
  {
    'id': '1431',
    'nome': 'Novo Mundo',
    'estado': 'MT'
  },
  {
    'id': '1432',
    'nome': 'Novo Santo Antônio',
    'estado': 'MT'
  },
  {
    'id': '1433',
    'nome': 'Novo São Joaquim',
    'estado': 'MT'
  },
  {
    'id': '1434',
    'nome': 'Paranaíta',
    'estado': 'MT'
  },
  {
    'id': '1435',
    'nome': 'Paranatinga',
    'estado': 'MT'
  },
  {
    'id': '1436',
    'nome': 'Pedra Preta',
    'estado': 'MT'
  },
  {
    'id': '1437',
    'nome': 'Peixoto de Azevedo',
    'estado': 'MT'
  },
  {
    'id': '1438',
    'nome': 'Planalto da Serra',
    'estado': 'MT'
  },
  {
    'id': '1439',
    'nome': 'Poconé',
    'estado': 'MT'
  },
  {
    'id': '1440',
    'nome': 'Pontal do Araguaia',
    'estado': 'MT'
  },
  {
    'id': '1441',
    'nome': 'Ponte Branca',
    'estado': 'MT'
  },
  {
    'id': '1442',
    'nome': 'Pontes e Lacerda',
    'estado': 'MT'
  },
  {
    'id': '1443',
    'nome': 'Porto Alegre do Norte',
    'estado': 'MT'
  },
  {
    'id': '1444',
    'nome': 'Porto dos Gaúchos',
    'estado': 'MT'
  },
  {
    'id': '1445',
    'nome': 'Porto Esperidião',
    'estado': 'MT'
  },
  {
    'id': '1446',
    'nome': 'Porto Estrela',
    'estado': 'MT'
  },
  {
    'id': '1447',
    'nome': 'Poxoréo',
    'estado': 'MT'
  },
  {
    'id': '1448',
    'nome': 'Primavera do Leste',
    'estado': 'MT'
  },
  {
    'id': '1449',
    'nome': 'Querência',
    'estado': 'MT'
  },
  {
    'id': '1450',
    'nome': 'Reserva do Cabaçal',
    'estado': 'MT'
  },
  {
    'id': '1451',
    'nome': 'Ribeirão Cascalheira',
    'estado': 'MT'
  },
  {
    'id': '1452',
    'nome': 'Ribeirãozinho',
    'estado': 'MT'
  },
  {
    'id': '1453',
    'nome': 'Rio Branco',
    'estado': 'MT'
  },
  {
    'id': '1454',
    'nome': 'Rondolândia',
    'estado': 'MT'
  },
  {
    'id': '1455',
    'nome': 'Rondonópolis',
    'estado': 'MT'
  },
  {
    'id': '1456',
    'nome': 'Rosário Oeste',
    'estado': 'MT'
  },
  {
    'id': '1457',
    'nome': 'Salto do Céu',
    'estado': 'MT'
  },
  {
    'id': '1458',
    'nome': 'Santa Carmem',
    'estado': 'MT'
  },
  {
    'id': '1459',
    'nome': 'Santa Cruz do Xingu',
    'estado': 'MT'
  },
  {
    'id': '1460',
    'nome': 'Santa Rita do Trivelato',
    'estado': 'MT'
  },
  {
    'id': '1461',
    'nome': 'Santa Terezinha',
    'estado': 'MT'
  },
  {
    'id': '1462',
    'nome': 'Santo Afonso',
    'estado': 'MT'
  },
  {
    'id': '1463',
    'nome': 'Santo Antônio do Leste',
    'estado': 'MT'
  },
  {
    'id': '1464',
    'nome': 'Santo Antônio do Leverger',
    'estado': 'MT'
  },
  {
    'id': '1465',
    'nome': 'São Félix do Araguaia',
    'estado': 'MT'
  },
  {
    'id': '1466',
    'nome': 'São José do Povo',
    'estado': 'MT'
  },
  {
    'id': '1467',
    'nome': 'São José do Rio Claro',
    'estado': 'MT'
  },
  {
    'id': '1468',
    'nome': 'São José do Xingu',
    'estado': 'MT'
  },
  {
    'id': '1469',
    'nome': 'São José dos Quatro Marcos',
    'estado': 'MT'
  },
  {
    'id': '1470',
    'nome': 'São Pedro da Cipa',
    'estado': 'MT'
  },
  {
    'id': '1471',
    'nome': 'Sapezal',
    'estado': 'MT'
  },
  {
    'id': '1472',
    'nome': 'Serra Nova Dourada',
    'estado': 'MT'
  },
  {
    'id': '1473',
    'nome': 'Sinop',
    'estado': 'MT'
  },
  {
    'id': '1474',
    'nome': 'Sorriso',
    'estado': 'MT'
  },
  {
    'id': '1475',
    'nome': 'Tabaporã',
    'estado': 'MT'
  },
  {
    'id': '1476',
    'nome': 'Tangará da Serra',
    'estado': 'MT'
  },
  {
    'id': '1477',
    'nome': 'Tapurah',
    'estado': 'MT'
  },
  {
    'id': '1478',
    'nome': 'Terra Nova do Norte',
    'estado': 'MT'
  },
  {
    'id': '1479',
    'nome': 'Tesouro',
    'estado': 'MT'
  },
  {
    'id': '1480',
    'nome': 'Torixoréu',
    'estado': 'MT'
  },
  {
    'id': '1481',
    'nome': 'União do Sul',
    'estado': 'MT'
  },
  {
    'id': '1482',
    'nome': 'Vale de São Domingos',
    'estado': 'MT'
  },
  {
    'id': '1483',
    'nome': 'Várzea Grande',
    'estado': 'MT'
  },
  {
    'id': '1484',
    'nome': 'Vera',
    'estado': 'MT'
  },
  {
    'id': '1485',
    'nome': 'Vila Bela da Santíssima Trindade',
    'estado': 'MT'
  },
  {
    'id': '1486',
    'nome': 'Vila Rica',
    'estado': 'MT'
  },
  {
    'id': '1487',
    'nome': 'Água Clara',
    'estado': 'MS'
  },
  {
    'id': '1488',
    'nome': 'Alcinópolis',
    'estado': 'MS'
  },
  {
    'id': '1489',
    'nome': 'Amambaí',
    'estado': 'MS'
  },
  {
    'id': '1490',
    'nome': 'Anastácio',
    'estado': 'MS'
  },
  {
    'id': '1491',
    'nome': 'Anaurilândia',
    'estado': 'MS'
  },
  {
    'id': '1492',
    'nome': 'Angélica',
    'estado': 'MS'
  },
  {
    'id': '1493',
    'nome': 'Antônio João',
    'estado': 'MS'
  },
  {
    'id': '1494',
    'nome': 'Aparecida do Taboado',
    'estado': 'MS'
  },
  {
    'id': '1495',
    'nome': 'Aquidauana',
    'estado': 'MS'
  },
  {
    'id': '1496',
    'nome': 'Aral Moreira',
    'estado': 'MS'
  },
  {
    'id': '1497',
    'nome': 'Bandeirantes',
    'estado': 'MS'
  },
  {
    'id': '1498',
    'nome': 'Bataguassu',
    'estado': 'MS'
  },
  {
    'id': '1499',
    'nome': 'Bataiporã',
    'estado': 'MS'
  },
  {
    'id': '1500',
    'nome': 'Bela Vista',
    'estado': 'MS'
  },
  {
    'id': '1501',
    'nome': 'Bodoquena',
    'estado': 'MS'
  },
  {
    'id': '1502',
    'nome': 'Bonito',
    'estado': 'MS'
  },
  {
    'id': '1503',
    'nome': 'Brasilândia',
    'estado': 'MS'
  },
  {
    'id': '1504',
    'nome': 'Caarapó',
    'estado': 'MS'
  },
  {
    'id': '1505',
    'nome': 'Camapuã',
    'estado': 'MS'
  },
  {
    'id': '1506',
    'nome': 'Campo Grande',
    'estado': 'MS'
  },
  {
    'id': '1507',
    'nome': 'Caracol',
    'estado': 'MS'
  },
  {
    'id': '1508',
    'nome': 'Cassilândia',
    'estado': 'MS'
  },
  {
    'id': '1509',
    'nome': 'Chapadão do Sul',
    'estado': 'MS'
  },
  {
    'id': '1510',
    'nome': 'Corguinho',
    'estado': 'MS'
  },
  {
    'id': '1511',
    'nome': 'Coronel Sapucaia',
    'estado': 'MS'
  },
  {
    'id': '1512',
    'nome': 'Corumbá',
    'estado': 'MS'
  },
  {
    'id': '1513',
    'nome': 'Costa Rica',
    'estado': 'MS'
  },
  {
    'id': '1514',
    'nome': 'Coxim',
    'estado': 'MS'
  },
  {
    'id': '1515',
    'nome': 'Deodápolis',
    'estado': 'MS'
  },
  {
    'id': '1516',
    'nome': 'Dois Irmãos do Buriti',
    'estado': 'MS'
  },
  {
    'id': '1517',
    'nome': 'Douradina',
    'estado': 'MS'
  },
  {
    'id': '1518',
    'nome': 'Dourados',
    'estado': 'MS'
  },
  {
    'id': '1519',
    'nome': 'Eldorado',
    'estado': 'MS'
  },
  {
    'id': '1520',
    'nome': 'Fátima do Sul',
    'estado': 'MS'
  },
  {
    'id': '1521',
    'nome': 'Figueirão',
    'estado': 'MS'
  },
  {
    'id': '1522',
    'nome': 'Glória de Dourados',
    'estado': 'MS'
  },
  {
    'id': '1523',
    'nome': 'Guia Lopes da Laguna',
    'estado': 'MS'
  },
  {
    'id': '1524',
    'nome': 'Iguatemi',
    'estado': 'MS'
  },
  {
    'id': '1525',
    'nome': 'Inocência',
    'estado': 'MS'
  },
  {
    'id': '1526',
    'nome': 'Itaporã',
    'estado': 'MS'
  },
  {
    'id': '1527',
    'nome': 'Itaquiraí',
    'estado': 'MS'
  },
  {
    'id': '1528',
    'nome': 'Ivinhema',
    'estado': 'MS'
  },
  {
    'id': '1529',
    'nome': 'Japorã',
    'estado': 'MS'
  },
  {
    'id': '1530',
    'nome': 'Jaraguari',
    'estado': 'MS'
  },
  {
    'id': '1531',
    'nome': 'Jardim',
    'estado': 'MS'
  },
  {
    'id': '1532',
    'nome': 'Jateí',
    'estado': 'MS'
  },
  {
    'id': '1533',
    'nome': 'Juti',
    'estado': 'MS'
  },
  {
    'id': '1534',
    'nome': 'Ladário',
    'estado': 'MS'
  },
  {
    'id': '1535',
    'nome': 'Laguna Carapã',
    'estado': 'MS'
  },
  {
    'id': '1536',
    'nome': 'Maracaju',
    'estado': 'MS'
  },
  {
    'id': '1537',
    'nome': 'Miranda',
    'estado': 'MS'
  },
  {
    'id': '1538',
    'nome': 'Mundo Novo',
    'estado': 'MS'
  },
  {
    'id': '1539',
    'nome': 'Naviraí',
    'estado': 'MS'
  },
  {
    'id': '1540',
    'nome': 'Nioaque',
    'estado': 'MS'
  },
  {
    'id': '1541',
    'nome': 'Nova Alvorada do Sul',
    'estado': 'MS'
  },
  {
    'id': '1542',
    'nome': 'Nova Andradina',
    'estado': 'MS'
  },
  {
    'id': '1543',
    'nome': 'Novo Horizonte do Sul',
    'estado': 'MS'
  },
  {
    'id': '1544',
    'nome': 'Paranaíba',
    'estado': 'MS'
  },
  {
    'id': '1545',
    'nome': 'Paranhos',
    'estado': 'MS'
  },
  {
    'id': '1546',
    'nome': 'Pedro Gomes',
    'estado': 'MS'
  },
  {
    'id': '1547',
    'nome': 'Ponta Porã',
    'estado': 'MS'
  },
  {
    'id': '1548',
    'nome': 'Porto Murtinho',
    'estado': 'MS'
  },
  {
    'id': '1549',
    'nome': 'Ribas do Rio Pardo',
    'estado': 'MS'
  },
  {
    'id': '1550',
    'nome': 'Rio Brilhante',
    'estado': 'MS'
  },
  {
    'id': '1551',
    'nome': 'Rio Negro',
    'estado': 'MS'
  },
  {
    'id': '1552',
    'nome': 'Rio Verde de Mato Grosso',
    'estado': 'MS'
  },
  {
    'id': '1553',
    'nome': 'Rochedo',
    'estado': 'MS'
  },
  {
    'id': '1554',
    'nome': 'Santa Rita do Pardo',
    'estado': 'MS'
  },
  {
    'id': '1555',
    'nome': 'São Gabriel do Oeste',
    'estado': 'MS'
  },
  {
    'id': '1556',
    'nome': 'Selvíria',
    'estado': 'MS'
  },
  {
    'id': '1557',
    'nome': 'Sete Quedas',
    'estado': 'MS'
  },
  {
    'id': '1558',
    'nome': 'Sidrolândia',
    'estado': 'MS'
  },
  {
    'id': '1559',
    'nome': 'Sonora',
    'estado': 'MS'
  },
  {
    'id': '1560',
    'nome': 'Tacuru',
    'estado': 'MS'
  },
  {
    'id': '1561',
    'nome': 'Taquarussu',
    'estado': 'MS'
  },
  {
    'id': '1562',
    'nome': 'Terenos',
    'estado': 'MS'
  },
  {
    'id': '1563',
    'nome': 'Três Lagoas',
    'estado': 'MS'
  },
  {
    'id': '1564',
    'nome': 'Vicentina',
    'estado': 'MS'
  },
  {
    'id': '1565',
    'nome': 'Abadia dos Dourados',
    'estado': 'MG'
  },
  {
    'id': '1566',
    'nome': 'Abaeté',
    'estado': 'MG'
  },
  {
    'id': '1567',
    'nome': 'Abre Campo',
    'estado': 'MG'
  },
  {
    'id': '1568',
    'nome': 'Acaiaca',
    'estado': 'MG'
  },
  {
    'id': '1569',
    'nome': 'Açucena',
    'estado': 'MG'
  },
  {
    'id': '1570',
    'nome': 'Água Boa',
    'estado': 'MG'
  },
  {
    'id': '1571',
    'nome': 'Água Comprida',
    'estado': 'MG'
  },
  {
    'id': '1572',
    'nome': 'Aguanil',
    'estado': 'MG'
  },
  {
    'id': '1573',
    'nome': 'Águas Formosas',
    'estado': 'MG'
  },
  {
    'id': '1574',
    'nome': 'Águas Vermelhas',
    'estado': 'MG'
  },
  {
    'id': '1575',
    'nome': 'Aimorés',
    'estado': 'MG'
  },
  {
    'id': '1576',
    'nome': 'Aiuruoca',
    'estado': 'MG'
  },
  {
    'id': '1577',
    'nome': 'Alagoa',
    'estado': 'MG'
  },
  {
    'id': '1578',
    'nome': 'Albertina',
    'estado': 'MG'
  },
  {
    'id': '1579',
    'nome': 'Além Paraíba',
    'estado': 'MG'
  },
  {
    'id': '1580',
    'nome': 'Alfenas',
    'estado': 'MG'
  },
  {
    'id': '1581',
    'nome': 'Alfredo Vasconcelos',
    'estado': 'MG'
  },
  {
    'id': '1582',
    'nome': 'Almenara',
    'estado': 'MG'
  },
  {
    'id': '1583',
    'nome': 'Alpercata',
    'estado': 'MG'
  },
  {
    'id': '1584',
    'nome': 'Alpinópolis',
    'estado': 'MG'
  },
  {
    'id': '1585',
    'nome': 'Alterosa',
    'estado': 'MG'
  },
  {
    'id': '1586',
    'nome': 'Alto Caparaó',
    'estado': 'MG'
  },
  {
    'id': '1587',
    'nome': 'Alto Jequitibá',
    'estado': 'MG'
  },
  {
    'id': '1588',
    'nome': 'Alto Rio Doce',
    'estado': 'MG'
  },
  {
    'id': '1589',
    'nome': 'Alvarenga',
    'estado': 'MG'
  },
  {
    'id': '1590',
    'nome': 'Alvinópolis',
    'estado': 'MG'
  },
  {
    'id': '1591',
    'nome': 'Alvorada de Minas',
    'estado': 'MG'
  },
  {
    'id': '1592',
    'nome': 'Amparo do Serra',
    'estado': 'MG'
  },
  {
    'id': '1593',
    'nome': 'Andradas',
    'estado': 'MG'
  },
  {
    'id': '1594',
    'nome': 'Andrelândia',
    'estado': 'MG'
  },
  {
    'id': '1595',
    'nome': 'Angelândia',
    'estado': 'MG'
  },
  {
    'id': '1596',
    'nome': 'Antônio Carlos',
    'estado': 'MG'
  },
  {
    'id': '1597',
    'nome': 'Antônio Dias',
    'estado': 'MG'
  },
  {
    'id': '1598',
    'nome': 'Antônio Prado de Minas',
    'estado': 'MG'
  },
  {
    'id': '1599',
    'nome': 'Araçaí',
    'estado': 'MG'
  },
  {
    'id': '1600',
    'nome': 'Aracitaba',
    'estado': 'MG'
  },
  {
    'id': '1601',
    'nome': 'Araçuaí',
    'estado': 'MG'
  },
  {
    'id': '1602',
    'nome': 'Araguari',
    'estado': 'MG'
  },
  {
    'id': '1603',
    'nome': 'Arantina',
    'estado': 'MG'
  },
  {
    'id': '1604',
    'nome': 'Araponga',
    'estado': 'MG'
  },
  {
    'id': '1605',
    'nome': 'Araporã',
    'estado': 'MG'
  },
  {
    'id': '1606',
    'nome': 'Arapuá',
    'estado': 'MG'
  },
  {
    'id': '1607',
    'nome': 'Araújos',
    'estado': 'MG'
  },
  {
    'id': '1608',
    'nome': 'Araxá',
    'estado': 'MG'
  },
  {
    'id': '1609',
    'nome': 'Arceburgo',
    'estado': 'MG'
  },
  {
    'id': '1610',
    'nome': 'Arcos',
    'estado': 'MG'
  },
  {
    'id': '1611',
    'nome': 'Areado',
    'estado': 'MG'
  },
  {
    'id': '1612',
    'nome': 'Argirita',
    'estado': 'MG'
  },
  {
    'id': '1613',
    'nome': 'Aricanduva',
    'estado': 'MG'
  },
  {
    'id': '1614',
    'nome': 'Arinos',
    'estado': 'MG'
  },
  {
    'id': '1615',
    'nome': 'Astolfo Dutra',
    'estado': 'MG'
  },
  {
    'id': '1616',
    'nome': 'Ataléia',
    'estado': 'MG'
  },
  {
    'id': '1617',
    'nome': 'Augusto de Lima',
    'estado': 'MG'
  },
  {
    'id': '1618',
    'nome': 'Baependi',
    'estado': 'MG'
  },
  {
    'id': '1619',
    'nome': 'Baldim',
    'estado': 'MG'
  },
  {
    'id': '1620',
    'nome': 'Bambuí',
    'estado': 'MG'
  },
  {
    'id': '1621',
    'nome': 'Bandeira',
    'estado': 'MG'
  },
  {
    'id': '1622',
    'nome': 'Bandeira do Sul',
    'estado': 'MG'
  },
  {
    'id': '1623',
    'nome': 'Barão de Cocais',
    'estado': 'MG'
  },
  {
    'id': '1624',
    'nome': 'Barão de Monte Alto',
    'estado': 'MG'
  },
  {
    'id': '1625',
    'nome': 'Barbacena',
    'estado': 'MG'
  },
  {
    'id': '1626',
    'nome': 'Barra Longa',
    'estado': 'MG'
  },
  {
    'id': '1627',
    'nome': 'Barroso',
    'estado': 'MG'
  },
  {
    'id': '1628',
    'nome': 'Bela Vista de Minas',
    'estado': 'MG'
  },
  {
    'id': '1629',
    'nome': 'Belmiro Braga',
    'estado': 'MG'
  },
  {
    'id': '1630',
    'nome': 'Belo Horizonte',
    'estado': 'MG'
  },
  {
    'id': '1631',
    'nome': 'Belo Oriente',
    'estado': 'MG'
  },
  {
    'id': '1632',
    'nome': 'Belo Vale',
    'estado': 'MG'
  },
  {
    'id': '1633',
    'nome': 'Berilo',
    'estado': 'MG'
  },
  {
    'id': '1634',
    'nome': 'Berizal',
    'estado': 'MG'
  },
  {
    'id': '1635',
    'nome': 'Bertópolis',
    'estado': 'MG'
  },
  {
    'id': '1636',
    'nome': 'Betim',
    'estado': 'MG'
  },
  {
    'id': '1637',
    'nome': 'Bias Fortes',
    'estado': 'MG'
  },
  {
    'id': '1638',
    'nome': 'Bicas',
    'estado': 'MG'
  },
  {
    'id': '1639',
    'nome': 'Biquinhas',
    'estado': 'MG'
  },
  {
    'id': '1640',
    'nome': 'Boa Esperança',
    'estado': 'MG'
  },
  {
    'id': '1641',
    'nome': 'Bocaina de Minas',
    'estado': 'MG'
  },
  {
    'id': '1642',
    'nome': 'Bocaiúva',
    'estado': 'MG'
  },
  {
    'id': '1643',
    'nome': 'Bom Despacho',
    'estado': 'MG'
  },
  {
    'id': '1644',
    'nome': 'Bom Jardim de Minas',
    'estado': 'MG'
  },
  {
    'id': '1645',
    'nome': 'Bom Jesus da Penha',
    'estado': 'MG'
  },
  {
    'id': '1646',
    'nome': 'Bom Jesus do Amparo',
    'estado': 'MG'
  },
  {
    'id': '1647',
    'nome': 'Bom Jesus do Galho',
    'estado': 'MG'
  },
  {
    'id': '1648',
    'nome': 'Bom Repouso',
    'estado': 'MG'
  },
  {
    'id': '1649',
    'nome': 'Bom Sucesso',
    'estado': 'MG'
  },
  {
    'id': '1650',
    'nome': 'Bonfim',
    'estado': 'MG'
  },
  {
    'id': '1651',
    'nome': 'Bonfinópolis de Minas',
    'estado': 'MG'
  },
  {
    'id': '1652',
    'nome': 'Bonito de Minas',
    'estado': 'MG'
  },
  {
    'id': '1653',
    'nome': 'Borda da Mata',
    'estado': 'MG'
  },
  {
    'id': '1654',
    'nome': 'Botelhos',
    'estado': 'MG'
  },
  {
    'id': '1655',
    'nome': 'Botumirim',
    'estado': 'MG'
  },
  {
    'id': '1656',
    'nome': 'Brás Pires',
    'estado': 'MG'
  },
  {
    'id': '1657',
    'nome': 'Brasilândia de Minas',
    'estado': 'MG'
  },
  {
    'id': '1658',
    'nome': 'Brasília de Minas',
    'estado': 'MG'
  },
  {
    'id': '1659',
    'nome': 'Brasópolis',
    'estado': 'MG'
  },
  {
    'id': '1660',
    'nome': 'Braúnas',
    'estado': 'MG'
  },
  {
    'id': '1661',
    'nome': 'Brumadinho',
    'estado': 'MG'
  },
  {
    'id': '1662',
    'nome': 'Bueno Brandão',
    'estado': 'MG'
  },
  {
    'id': '1663',
    'nome': 'Buenópolis',
    'estado': 'MG'
  },
  {
    'id': '1664',
    'nome': 'Bugre',
    'estado': 'MG'
  },
  {
    'id': '1665',
    'nome': 'Buritis',
    'estado': 'MG'
  },
  {
    'id': '1666',
    'nome': 'Buritizeiro',
    'estado': 'MG'
  },
  {
    'id': '1667',
    'nome': 'Cabeceira Grande',
    'estado': 'MG'
  },
  {
    'id': '1668',
    'nome': 'Cabo Verde',
    'estado': 'MG'
  },
  {
    'id': '1669',
    'nome': 'Cachoeira da Prata',
    'estado': 'MG'
  },
  {
    'id': '1670',
    'nome': 'Cachoeira de Minas',
    'estado': 'MG'
  },
  {
    'id': '1671',
    'nome': 'Cachoeira de Pajeú',
    'estado': 'MG'
  },
  {
    'id': '1672',
    'nome': 'Cachoeira Dourada',
    'estado': 'MG'
  },
  {
    'id': '1673',
    'nome': 'Caetanópolis',
    'estado': 'MG'
  },
  {
    'id': '1674',
    'nome': 'Caeté',
    'estado': 'MG'
  },
  {
    'id': '1675',
    'nome': 'Caiana',
    'estado': 'MG'
  },
  {
    'id': '1676',
    'nome': 'Cajuri',
    'estado': 'MG'
  },
  {
    'id': '1677',
    'nome': 'Caldas',
    'estado': 'MG'
  },
  {
    'id': '1678',
    'nome': 'Camacho',
    'estado': 'MG'
  },
  {
    'id': '1679',
    'nome': 'Camanducaia',
    'estado': 'MG'
  },
  {
    'id': '1680',
    'nome': 'Cambuí',
    'estado': 'MG'
  },
  {
    'id': '1681',
    'nome': 'Cambuquira',
    'estado': 'MG'
  },
  {
    'id': '1682',
    'nome': 'Campanário',
    'estado': 'MG'
  },
  {
    'id': '1683',
    'nome': 'Campanha',
    'estado': 'MG'
  },
  {
    'id': '1684',
    'nome': 'Campestre',
    'estado': 'MG'
  },
  {
    'id': '1685',
    'nome': 'Campina Verde',
    'estado': 'MG'
  },
  {
    'id': '1686',
    'nome': 'Campo Azul',
    'estado': 'MG'
  },
  {
    'id': '1687',
    'nome': 'Campo Belo',
    'estado': 'MG'
  },
  {
    'id': '1688',
    'nome': 'Campo do Meio',
    'estado': 'MG'
  },
  {
    'id': '1689',
    'nome': 'Campo Florido',
    'estado': 'MG'
  },
  {
    'id': '1690',
    'nome': 'Campos Altos',
    'estado': 'MG'
  },
  {
    'id': '1691',
    'nome': 'Campos Gerais',
    'estado': 'MG'
  },
  {
    'id': '1692',
    'nome': 'Cana Verde',
    'estado': 'MG'
  },
  {
    'id': '1693',
    'nome': 'Canaã',
    'estado': 'MG'
  },
  {
    'id': '1694',
    'nome': 'Canápolis',
    'estado': 'MG'
  },
  {
    'id': '1695',
    'nome': 'Candeias',
    'estado': 'MG'
  },
  {
    'id': '1696',
    'nome': 'Cantagalo',
    'estado': 'MG'
  },
  {
    'id': '1697',
    'nome': 'Caparaó',
    'estado': 'MG'
  },
  {
    'id': '1698',
    'nome': 'Capela Nova',
    'estado': 'MG'
  },
  {
    'id': '1699',
    'nome': 'Capelinha',
    'estado': 'MG'
  },
  {
    'id': '1700',
    'nome': 'Capetinga',
    'estado': 'MG'
  },
  {
    'id': '1701',
    'nome': 'Capim Branco',
    'estado': 'MG'
  },
  {
    'id': '1702',
    'nome': 'Capinópolis',
    'estado': 'MG'
  },
  {
    'id': '1703',
    'nome': 'Capitão Andrade',
    'estado': 'MG'
  },
  {
    'id': '1704',
    'nome': 'Capitão Enéas',
    'estado': 'MG'
  },
  {
    'id': '1705',
    'nome': 'Capitólio',
    'estado': 'MG'
  },
  {
    'id': '1706',
    'nome': 'Caputira',
    'estado': 'MG'
  },
  {
    'id': '1707',
    'nome': 'Caraí',
    'estado': 'MG'
  },
  {
    'id': '1708',
    'nome': 'Caranaíba',
    'estado': 'MG'
  },
  {
    'id': '1709',
    'nome': 'Carandaí',
    'estado': 'MG'
  },
  {
    'id': '1710',
    'nome': 'Carangola',
    'estado': 'MG'
  },
  {
    'id': '1711',
    'nome': 'Caratinga',
    'estado': 'MG'
  },
  {
    'id': '1712',
    'nome': 'Carbonita',
    'estado': 'MG'
  },
  {
    'id': '1713',
    'nome': 'Careaçu',
    'estado': 'MG'
  },
  {
    'id': '1714',
    'nome': 'Carlos Chagas',
    'estado': 'MG'
  },
  {
    'id': '1715',
    'nome': 'Carmésia',
    'estado': 'MG'
  },
  {
    'id': '1716',
    'nome': 'Carmo da Cachoeira',
    'estado': 'MG'
  },
  {
    'id': '1717',
    'nome': 'Carmo da Mata',
    'estado': 'MG'
  },
  {
    'id': '1718',
    'nome': 'Carmo de Minas',
    'estado': 'MG'
  },
  {
    'id': '1719',
    'nome': 'Carmo do Cajuru',
    'estado': 'MG'
  },
  {
    'id': '1720',
    'nome': 'Carmo do Paranaíba',
    'estado': 'MG'
  },
  {
    'id': '1721',
    'nome': 'Carmo do Rio Claro',
    'estado': 'MG'
  },
  {
    'id': '1722',
    'nome': 'Carmópolis de Minas',
    'estado': 'MG'
  },
  {
    'id': '1723',
    'nome': 'Carneirinho',
    'estado': 'MG'
  },
  {
    'id': '1724',
    'nome': 'Carrancas',
    'estado': 'MG'
  },
  {
    'id': '1725',
    'nome': 'Carvalhópolis',
    'estado': 'MG'
  },
  {
    'id': '1726',
    'nome': 'Carvalhos',
    'estado': 'MG'
  },
  {
    'id': '1727',
    'nome': 'Casa Grande',
    'estado': 'MG'
  },
  {
    'id': '1728',
    'nome': 'Cascalho Rico',
    'estado': 'MG'
  },
  {
    'id': '1729',
    'nome': 'Cássia',
    'estado': 'MG'
  },
  {
    'id': '1730',
    'nome': 'Cataguases',
    'estado': 'MG'
  },
  {
    'id': '1731',
    'nome': 'Catas Altas',
    'estado': 'MG'
  },
  {
    'id': '1732',
    'nome': 'Catas Altas da Noruega',
    'estado': 'MG'
  },
  {
    'id': '1733',
    'nome': 'Catuji',
    'estado': 'MG'
  },
  {
    'id': '1734',
    'nome': 'Catuti',
    'estado': 'MG'
  },
  {
    'id': '1735',
    'nome': 'Caxambu',
    'estado': 'MG'
  },
  {
    'id': '1736',
    'nome': 'Cedro do Abaeté',
    'estado': 'MG'
  },
  {
    'id': '1737',
    'nome': 'Central de Minas',
    'estado': 'MG'
  },
  {
    'id': '1738',
    'nome': 'Centralina',
    'estado': 'MG'
  },
  {
    'id': '1739',
    'nome': 'Chácara',
    'estado': 'MG'
  },
  {
    'id': '1740',
    'nome': 'Chalé',
    'estado': 'MG'
  },
  {
    'id': '1741',
    'nome': 'Chapada do Norte',
    'estado': 'MG'
  },
  {
    'id': '1742',
    'nome': 'Chapada Gaúcha',
    'estado': 'MG'
  },
  {
    'id': '1743',
    'nome': 'Chiador',
    'estado': 'MG'
  },
  {
    'id': '1744',
    'nome': 'Cipotânea',
    'estado': 'MG'
  },
  {
    'id': '1745',
    'nome': 'Claraval',
    'estado': 'MG'
  },
  {
    'id': '1746',
    'nome': 'Claro dos Poções',
    'estado': 'MG'
  },
  {
    'id': '1747',
    'nome': 'Cláudio',
    'estado': 'MG'
  },
  {
    'id': '1748',
    'nome': 'Coimbra',
    'estado': 'MG'
  },
  {
    'id': '1749',
    'nome': 'Coluna',
    'estado': 'MG'
  },
  {
    'id': '1750',
    'nome': 'Comendador Gomes',
    'estado': 'MG'
  },
  {
    'id': '1751',
    'nome': 'Comercinho',
    'estado': 'MG'
  },
  {
    'id': '1752',
    'nome': 'Conceição da Aparecida',
    'estado': 'MG'
  },
  {
    'id': '1753',
    'nome': 'Conceição da Barra de Minas',
    'estado': 'MG'
  },
  {
    'id': '1754',
    'nome': 'Conceição das Alagoas',
    'estado': 'MG'
  },
  {
    'id': '1755',
    'nome': 'Conceição das Pedras',
    'estado': 'MG'
  },
  {
    'id': '1756',
    'nome': 'Conceição de Ipanema',
    'estado': 'MG'
  },
  {
    'id': '1757',
    'nome': 'Conceição do Mato Dentro',
    'estado': 'MG'
  },
  {
    'id': '1758',
    'nome': 'Conceição do Pará',
    'estado': 'MG'
  },
  {
    'id': '1759',
    'nome': 'Conceição do Rio Verde',
    'estado': 'MG'
  },
  {
    'id': '1760',
    'nome': 'Conceição dos Ouros',
    'estado': 'MG'
  },
  {
    'id': '1761',
    'nome': 'Cônego Marinho',
    'estado': 'MG'
  },
  {
    'id': '1762',
    'nome': 'Confins',
    'estado': 'MG'
  },
  {
    'id': '1763',
    'nome': 'Congonhal',
    'estado': 'MG'
  },
  {
    'id': '1764',
    'nome': 'Congonhas',
    'estado': 'MG'
  },
  {
    'id': '1765',
    'nome': 'Congonhas do Norte',
    'estado': 'MG'
  },
  {
    'id': '1766',
    'nome': 'Conquista',
    'estado': 'MG'
  },
  {
    'id': '1767',
    'nome': 'Conselheiro Lafaiete',
    'estado': 'MG'
  },
  {
    'id': '1768',
    'nome': 'Conselheiro Pena',
    'estado': 'MG'
  },
  {
    'id': '1769',
    'nome': 'Consolação',
    'estado': 'MG'
  },
  {
    'id': '1770',
    'nome': 'Contagem',
    'estado': 'MG'
  },
  {
    'id': '1771',
    'nome': 'Coqueiral',
    'estado': 'MG'
  },
  {
    'id': '1772',
    'nome': 'Coração de Jesus',
    'estado': 'MG'
  },
  {
    'id': '1773',
    'nome': 'Cordisburgo',
    'estado': 'MG'
  },
  {
    'id': '1774',
    'nome': 'Cordislândia',
    'estado': 'MG'
  },
  {
    'id': '1775',
    'nome': 'Corinto',
    'estado': 'MG'
  },
  {
    'id': '1776',
    'nome': 'Coroaci',
    'estado': 'MG'
  },
  {
    'id': '1777',
    'nome': 'Coromandel',
    'estado': 'MG'
  },
  {
    'id': '1778',
    'nome': 'Coronel Fabriciano',
    'estado': 'MG'
  },
  {
    'id': '1779',
    'nome': 'Coronel Murta',
    'estado': 'MG'
  },
  {
    'id': '1780',
    'nome': 'Coronel Pacheco',
    'estado': 'MG'
  },
  {
    'id': '1781',
    'nome': 'Coronel Xavier Chaves',
    'estado': 'MG'
  },
  {
    'id': '1782',
    'nome': 'Córrego Danta',
    'estado': 'MG'
  },
  {
    'id': '1783',
    'nome': 'Córrego do Bom Jesus',
    'estado': 'MG'
  },
  {
    'id': '1784',
    'nome': 'Córrego Fundo',
    'estado': 'MG'
  },
  {
    'id': '1785',
    'nome': 'Córrego Novo',
    'estado': 'MG'
  },
  {
    'id': '1786',
    'nome': 'Couto de Magalhães de Minas',
    'estado': 'MG'
  },
  {
    'id': '1787',
    'nome': 'Crisólita',
    'estado': 'MG'
  },
  {
    'id': '1788',
    'nome': 'Cristais',
    'estado': 'MG'
  },
  {
    'id': '1789',
    'nome': 'Cristália',
    'estado': 'MG'
  },
  {
    'id': '1790',
    'nome': 'Cristiano Otoni',
    'estado': 'MG'
  },
  {
    'id': '1791',
    'nome': 'Cristina',
    'estado': 'MG'
  },
  {
    'id': '1792',
    'nome': 'Crucilândia',
    'estado': 'MG'
  },
  {
    'id': '1793',
    'nome': 'Cruzeiro da Fortaleza',
    'estado': 'MG'
  },
  {
    'id': '1794',
    'nome': 'Cruzília',
    'estado': 'MG'
  },
  {
    'id': '1795',
    'nome': 'Cuparaque',
    'estado': 'MG'
  },
  {
    'id': '1796',
    'nome': 'Curral de Dentro',
    'estado': 'MG'
  },
  {
    'id': '1797',
    'nome': 'Curvelo',
    'estado': 'MG'
  },
  {
    'id': '1798',
    'nome': 'Datas',
    'estado': 'MG'
  },
  {
    'id': '1799',
    'nome': 'Delfim Moreira',
    'estado': 'MG'
  },
  {
    'id': '1800',
    'nome': 'Delfinópolis',
    'estado': 'MG'
  },
  {
    'id': '1801',
    'nome': 'Delta',
    'estado': 'MG'
  },
  {
    'id': '1802',
    'nome': 'Descoberto',
    'estado': 'MG'
  },
  {
    'id': '1803',
    'nome': 'Desterro de Entre Rios',
    'estado': 'MG'
  },
  {
    'id': '1804',
    'nome': 'Desterro do Melo',
    'estado': 'MG'
  },
  {
    'id': '1805',
    'nome': 'Diamantina',
    'estado': 'MG'
  },
  {
    'id': '1806',
    'nome': 'Diogo de Vasconcelos',
    'estado': 'MG'
  },
  {
    'id': '1807',
    'nome': 'Dionísio',
    'estado': 'MG'
  },
  {
    'id': '1808',
    'nome': 'Divinésia',
    'estado': 'MG'
  },
  {
    'id': '1809',
    'nome': 'Divino',
    'estado': 'MG'
  },
  {
    'id': '1810',
    'nome': 'Divino das Laranjeiras',
    'estado': 'MG'
  },
  {
    'id': '1811',
    'nome': 'Divinolândia de Minas',
    'estado': 'MG'
  },
  {
    'id': '1812',
    'nome': 'Divinópolis',
    'estado': 'MG'
  },
  {
    'id': '1813',
    'nome': 'Divisa Alegre',
    'estado': 'MG'
  },
  {
    'id': '1814',
    'nome': 'Divisa Nova',
    'estado': 'MG'
  },
  {
    'id': '1815',
    'nome': 'Divisópolis',
    'estado': 'MG'
  },
  {
    'id': '1816',
    'nome': 'Dom Bosco',
    'estado': 'MG'
  },
  {
    'id': '1817',
    'nome': 'Dom Cavati',
    'estado': 'MG'
  },
  {
    'id': '1818',
    'nome': 'Dom Joaquim',
    'estado': 'MG'
  },
  {
    'id': '1819',
    'nome': 'Dom Silvério',
    'estado': 'MG'
  },
  {
    'id': '1820',
    'nome': 'Dom Viçoso',
    'estado': 'MG'
  },
  {
    'id': '1821',
    'nome': 'Dona Eusébia',
    'estado': 'MG'
  },
  {
    'id': '1822',
    'nome': 'Dores de Campos',
    'estado': 'MG'
  },
  {
    'id': '1823',
    'nome': 'Dores de Guanhães',
    'estado': 'MG'
  },
  {
    'id': '1824',
    'nome': 'Dores do Indaiá',
    'estado': 'MG'
  },
  {
    'id': '1825',
    'nome': 'Dores do Turvo',
    'estado': 'MG'
  },
  {
    'id': '1826',
    'nome': 'Doresópolis',
    'estado': 'MG'
  },
  {
    'id': '1827',
    'nome': 'Douradoquara',
    'estado': 'MG'
  },
  {
    'id': '1828',
    'nome': 'Durandé',
    'estado': 'MG'
  },
  {
    'id': '1829',
    'nome': 'Elói Mendes',
    'estado': 'MG'
  },
  {
    'id': '1830',
    'nome': 'Engenheiro Caldas',
    'estado': 'MG'
  },
  {
    'id': '1831',
    'nome': 'Engenheiro Navarro',
    'estado': 'MG'
  },
  {
    'id': '1832',
    'nome': 'Entre Folhas',
    'estado': 'MG'
  },
  {
    'id': '1833',
    'nome': 'Entre Rios de Minas',
    'estado': 'MG'
  },
  {
    'id': '1834',
    'nome': 'Ervália',
    'estado': 'MG'
  },
  {
    'id': '1835',
    'nome': 'Esmeraldas',
    'estado': 'MG'
  },
  {
    'id': '1836',
    'nome': 'Espera Feliz',
    'estado': 'MG'
  },
  {
    'id': '1837',
    'nome': 'Espinosa',
    'estado': 'MG'
  },
  {
    'id': '1838',
    'nome': 'Espírito Santo do Dourado',
    'estado': 'MG'
  },
  {
    'id': '1839',
    'nome': 'Estiva',
    'estado': 'MG'
  },
  {
    'id': '1840',
    'nome': 'Estrela Dalva',
    'estado': 'MG'
  },
  {
    'id': '1841',
    'nome': 'Estrela do Indaiá',
    'estado': 'MG'
  },
  {
    'id': '1842',
    'nome': 'Estrela do Sul',
    'estado': 'MG'
  },
  {
    'id': '1843',
    'nome': 'Eugenópolis',
    'estado': 'MG'
  },
  {
    'id': '1844',
    'nome': 'Ewbank da Câmara',
    'estado': 'MG'
  },
  {
    'id': '1845',
    'nome': 'Extrema',
    'estado': 'MG'
  },
  {
    'id': '1846',
    'nome': 'Fama',
    'estado': 'MG'
  },
  {
    'id': '1847',
    'nome': 'Faria Lemos',
    'estado': 'MG'
  },
  {
    'id': '1848',
    'nome': 'Felício dos Santos',
    'estado': 'MG'
  },
  {
    'id': '1849',
    'nome': 'Felisburgo',
    'estado': 'MG'
  },
  {
    'id': '1850',
    'nome': 'Felixlândia',
    'estado': 'MG'
  },
  {
    'id': '1851',
    'nome': 'Fernandes Tourinho',
    'estado': 'MG'
  },
  {
    'id': '1852',
    'nome': 'Ferros',
    'estado': 'MG'
  },
  {
    'id': '1853',
    'nome': 'Fervedouro',
    'estado': 'MG'
  },
  {
    'id': '1854',
    'nome': 'Florestal',
    'estado': 'MG'
  },
  {
    'id': '1855',
    'nome': 'Formiga',
    'estado': 'MG'
  },
  {
    'id': '1856',
    'nome': 'Formoso',
    'estado': 'MG'
  },
  {
    'id': '1857',
    'nome': 'Fortaleza de Minas',
    'estado': 'MG'
  },
  {
    'id': '1858',
    'nome': 'Fortuna de Minas',
    'estado': 'MG'
  },
  {
    'id': '1859',
    'nome': 'Francisco Badaró',
    'estado': 'MG'
  },
  {
    'id': '1860',
    'nome': 'Francisco Dumont',
    'estado': 'MG'
  },
  {
    'id': '1861',
    'nome': 'Francisco Sá',
    'estado': 'MG'
  },
  {
    'id': '1862',
    'nome': 'Franciscópolis',
    'estado': 'MG'
  },
  {
    'id': '1863',
    'nome': 'Frei Gaspar',
    'estado': 'MG'
  },
  {
    'id': '1864',
    'nome': 'Frei Inocêncio',
    'estado': 'MG'
  },
  {
    'id': '1865',
    'nome': 'Frei Lagonegro',
    'estado': 'MG'
  },
  {
    'id': '1866',
    'nome': 'Fronteira',
    'estado': 'MG'
  },
  {
    'id': '1867',
    'nome': 'Fronteira dos Vales',
    'estado': 'MG'
  },
  {
    'id': '1868',
    'nome': 'Fruta de Leite',
    'estado': 'MG'
  },
  {
    'id': '1869',
    'nome': 'Frutal',
    'estado': 'MG'
  },
  {
    'id': '1870',
    'nome': 'Funilândia',
    'estado': 'MG'
  },
  {
    'id': '1871',
    'nome': 'Galiléia',
    'estado': 'MG'
  },
  {
    'id': '1872',
    'nome': 'Gameleiras',
    'estado': 'MG'
  },
  {
    'id': '1873',
    'nome': 'Glaucilândia',
    'estado': 'MG'
  },
  {
    'id': '1874',
    'nome': 'Goiabeira',
    'estado': 'MG'
  },
  {
    'id': '1875',
    'nome': 'Goianá',
    'estado': 'MG'
  },
  {
    'id': '1876',
    'nome': 'Gonçalves',
    'estado': 'MG'
  },
  {
    'id': '1877',
    'nome': 'Gonzaga',
    'estado': 'MG'
  },
  {
    'id': '1878',
    'nome': 'Gouveia',
    'estado': 'MG'
  },
  {
    'id': '1879',
    'nome': 'Governador Valadares',
    'estado': 'MG'
  },
  {
    'id': '1880',
    'nome': 'Grão Mogol',
    'estado': 'MG'
  },
  {
    'id': '1881',
    'nome': 'Grupiara',
    'estado': 'MG'
  },
  {
    'id': '1882',
    'nome': 'Guanhães',
    'estado': 'MG'
  },
  {
    'id': '1883',
    'nome': 'Guapé',
    'estado': 'MG'
  },
  {
    'id': '1884',
    'nome': 'Guaraciaba',
    'estado': 'MG'
  },
  {
    'id': '1885',
    'nome': 'Guaraciama',
    'estado': 'MG'
  },
  {
    'id': '1886',
    'nome': 'Guaranésia',
    'estado': 'MG'
  },
  {
    'id': '1887',
    'nome': 'Guarani',
    'estado': 'MG'
  },
  {
    'id': '1888',
    'nome': 'Guarará',
    'estado': 'MG'
  },
  {
    'id': '1889',
    'nome': 'Guarda-Mor',
    'estado': 'MG'
  },
  {
    'id': '1890',
    'nome': 'Guaxupé',
    'estado': 'MG'
  },
  {
    'id': '1891',
    'nome': 'Guidoval',
    'estado': 'MG'
  },
  {
    'id': '1892',
    'nome': 'Guimarânia',
    'estado': 'MG'
  },
  {
    'id': '1893',
    'nome': 'Guiricema',
    'estado': 'MG'
  },
  {
    'id': '1894',
    'nome': 'Gurinhatã',
    'estado': 'MG'
  },
  {
    'id': '1895',
    'nome': 'Heliodora',
    'estado': 'MG'
  },
  {
    'id': '1896',
    'nome': 'Iapu',
    'estado': 'MG'
  },
  {
    'id': '1897',
    'nome': 'Ibertioga',
    'estado': 'MG'
  },
  {
    'id': '1898',
    'nome': 'Ibiá',
    'estado': 'MG'
  },
  {
    'id': '1899',
    'nome': 'Ibiaí',
    'estado': 'MG'
  },
  {
    'id': '1900',
    'nome': 'Ibiracatu',
    'estado': 'MG'
  },
  {
    'id': '1901',
    'nome': 'Ibiraci',
    'estado': 'MG'
  },
  {
    'id': '1902',
    'nome': 'Ibirité',
    'estado': 'MG'
  },
  {
    'id': '1903',
    'nome': 'Ibitiúra de Minas',
    'estado': 'MG'
  },
  {
    'id': '1904',
    'nome': 'Ibituruna',
    'estado': 'MG'
  },
  {
    'id': '1905',
    'nome': 'Icaraí de Minas',
    'estado': 'MG'
  },
  {
    'id': '1906',
    'nome': 'Igarapé',
    'estado': 'MG'
  },
  {
    'id': '1907',
    'nome': 'Igaratinga',
    'estado': 'MG'
  },
  {
    'id': '1908',
    'nome': 'Iguatama',
    'estado': 'MG'
  },
  {
    'id': '1909',
    'nome': 'Ijaci',
    'estado': 'MG'
  },
  {
    'id': '1910',
    'nome': 'Ilicínea',
    'estado': 'MG'
  },
  {
    'id': '1911',
    'nome': 'Imbé de Minas',
    'estado': 'MG'
  },
  {
    'id': '1912',
    'nome': 'Inconfidentes',
    'estado': 'MG'
  },
  {
    'id': '1913',
    'nome': 'Indaiabira',
    'estado': 'MG'
  },
  {
    'id': '1914',
    'nome': 'Indianópolis',
    'estado': 'MG'
  },
  {
    'id': '1915',
    'nome': 'Ingaí',
    'estado': 'MG'
  },
  {
    'id': '1916',
    'nome': 'Inhapim',
    'estado': 'MG'
  },
  {
    'id': '1917',
    'nome': 'Inhaúma',
    'estado': 'MG'
  },
  {
    'id': '1918',
    'nome': 'Inimutaba',
    'estado': 'MG'
  },
  {
    'id': '1919',
    'nome': 'Ipaba',
    'estado': 'MG'
  },
  {
    'id': '1920',
    'nome': 'Ipanema',
    'estado': 'MG'
  },
  {
    'id': '1921',
    'nome': 'Ipatinga',
    'estado': 'MG'
  },
  {
    'id': '1922',
    'nome': 'Ipiaçu',
    'estado': 'MG'
  },
  {
    'id': '1923',
    'nome': 'Ipuiúna',
    'estado': 'MG'
  },
  {
    'id': '1924',
    'nome': 'Iraí de Minas',
    'estado': 'MG'
  },
  {
    'id': '1925',
    'nome': 'Itabira',
    'estado': 'MG'
  },
  {
    'id': '1926',
    'nome': 'Itabirinha de Mantena',
    'estado': 'MG'
  },
  {
    'id': '1927',
    'nome': 'Itabirito',
    'estado': 'MG'
  },
  {
    'id': '1928',
    'nome': 'Itacambira',
    'estado': 'MG'
  },
  {
    'id': '1929',
    'nome': 'Itacarambi',
    'estado': 'MG'
  },
  {
    'id': '1930',
    'nome': 'Itaguara',
    'estado': 'MG'
  },
  {
    'id': '1931',
    'nome': 'Itaipé',
    'estado': 'MG'
  },
  {
    'id': '1932',
    'nome': 'Itajubá',
    'estado': 'MG'
  },
  {
    'id': '1933',
    'nome': 'Itamarandiba',
    'estado': 'MG'
  },
  {
    'id': '1934',
    'nome': 'Itamarati de Minas',
    'estado': 'MG'
  },
  {
    'id': '1935',
    'nome': 'Itambacuri',
    'estado': 'MG'
  },
  {
    'id': '1936',
    'nome': 'Itambé do Mato Dentro',
    'estado': 'MG'
  },
  {
    'id': '1937',
    'nome': 'Itamogi',
    'estado': 'MG'
  },
  {
    'id': '1938',
    'nome': 'Itamonte',
    'estado': 'MG'
  },
  {
    'id': '1939',
    'nome': 'Itanhandu',
    'estado': 'MG'
  },
  {
    'id': '1940',
    'nome': 'Itanhomi',
    'estado': 'MG'
  },
  {
    'id': '1941',
    'nome': 'Itaobim',
    'estado': 'MG'
  },
  {
    'id': '1942',
    'nome': 'Itapagipe',
    'estado': 'MG'
  },
  {
    'id': '1943',
    'nome': 'Itapecerica',
    'estado': 'MG'
  },
  {
    'id': '1944',
    'nome': 'Itapeva',
    'estado': 'MG'
  },
  {
    'id': '1945',
    'nome': 'Itatiaiuçu',
    'estado': 'MG'
  },
  {
    'id': '1946',
    'nome': 'Itaú de Minas',
    'estado': 'MG'
  },
  {
    'id': '1947',
    'nome': 'Itaúna',
    'estado': 'MG'
  },
  {
    'id': '1948',
    'nome': 'Itaverava',
    'estado': 'MG'
  },
  {
    'id': '1949',
    'nome': 'Itinga',
    'estado': 'MG'
  },
  {
    'id': '1950',
    'nome': 'Itueta',
    'estado': 'MG'
  },
  {
    'id': '1951',
    'nome': 'Ituiutaba',
    'estado': 'MG'
  },
  {
    'id': '1952',
    'nome': 'Itumirim',
    'estado': 'MG'
  },
  {
    'id': '1953',
    'nome': 'Iturama',
    'estado': 'MG'
  },
  {
    'id': '1954',
    'nome': 'Itutinga',
    'estado': 'MG'
  },
  {
    'id': '1955',
    'nome': 'Jaboticatubas',
    'estado': 'MG'
  },
  {
    'id': '1956',
    'nome': 'Jacinto',
    'estado': 'MG'
  },
  {
    'id': '1957',
    'nome': 'Jacuí',
    'estado': 'MG'
  },
  {
    'id': '1958',
    'nome': 'Jacutinga',
    'estado': 'MG'
  },
  {
    'id': '1959',
    'nome': 'Jaguaraçu',
    'estado': 'MG'
  },
  {
    'id': '1960',
    'nome': 'Jaíba',
    'estado': 'MG'
  },
  {
    'id': '1961',
    'nome': 'Jampruca',
    'estado': 'MG'
  },
  {
    'id': '1962',
    'nome': 'Janaúba',
    'estado': 'MG'
  },
  {
    'id': '1963',
    'nome': 'Januária',
    'estado': 'MG'
  },
  {
    'id': '1964',
    'nome': 'Japaraíba',
    'estado': 'MG'
  },
  {
    'id': '1965',
    'nome': 'Japonvar',
    'estado': 'MG'
  },
  {
    'id': '1966',
    'nome': 'Jeceaba',
    'estado': 'MG'
  },
  {
    'id': '1967',
    'nome': 'Jenipapo de Minas',
    'estado': 'MG'
  },
  {
    'id': '1968',
    'nome': 'Jequeri',
    'estado': 'MG'
  },
  {
    'id': '1969',
    'nome': 'Jequitaí',
    'estado': 'MG'
  },
  {
    'id': '1970',
    'nome': 'Jequitibá',
    'estado': 'MG'
  },
  {
    'id': '1971',
    'nome': 'Jequitinhonha',
    'estado': 'MG'
  },
  {
    'id': '1972',
    'nome': 'Jesuânia',
    'estado': 'MG'
  },
  {
    'id': '1973',
    'nome': 'Joaíma',
    'estado': 'MG'
  },
  {
    'id': '1974',
    'nome': 'Joanésia',
    'estado': 'MG'
  },
  {
    'id': '1975',
    'nome': 'João Monlevade',
    'estado': 'MG'
  },
  {
    'id': '1976',
    'nome': 'João Pinheiro',
    'estado': 'MG'
  },
  {
    'id': '1977',
    'nome': 'Joaquim Felício',
    'estado': 'MG'
  },
  {
    'id': '1978',
    'nome': 'Jordânia',
    'estado': 'MG'
  },
  {
    'id': '1979',
    'nome': 'José Gonçalves de Minas',
    'estado': 'MG'
  },
  {
    'id': '1980',
    'nome': 'José Raydan',
    'estado': 'MG'
  },
  {
    'id': '1981',
    'nome': 'Josenópolis',
    'estado': 'MG'
  },
  {
    'id': '1982',
    'nome': 'Juatuba',
    'estado': 'MG'
  },
  {
    'id': '1983',
    'nome': 'Juiz de Fora',
    'estado': 'MG'
  },
  {
    'id': '1984',
    'nome': 'Juramento',
    'estado': 'MG'
  },
  {
    'id': '1985',
    'nome': 'Juruaia',
    'estado': 'MG'
  },
  {
    'id': '1986',
    'nome': 'Juvenília',
    'estado': 'MG'
  },
  {
    'id': '1987',
    'nome': 'Ladainha',
    'estado': 'MG'
  },
  {
    'id': '1988',
    'nome': 'Lagamar',
    'estado': 'MG'
  },
  {
    'id': '1989',
    'nome': 'Lagoa da Prata',
    'estado': 'MG'
  },
  {
    'id': '1990',
    'nome': 'Lagoa dos Patos',
    'estado': 'MG'
  },
  {
    'id': '1991',
    'nome': 'Lagoa Dourada',
    'estado': 'MG'
  },
  {
    'id': '1992',
    'nome': 'Lagoa Formosa',
    'estado': 'MG'
  },
  {
    'id': '1993',
    'nome': 'Lagoa Grande',
    'estado': 'MG'
  },
  {
    'id': '1994',
    'nome': 'Lagoa Santa',
    'estado': 'MG'
  },
  {
    'id': '1995',
    'nome': 'Lajinha',
    'estado': 'MG'
  },
  {
    'id': '1996',
    'nome': 'Lambari',
    'estado': 'MG'
  },
  {
    'id': '1997',
    'nome': 'Lamim',
    'estado': 'MG'
  },
  {
    'id': '1998',
    'nome': 'Laranjal',
    'estado': 'MG'
  },
  {
    'id': '1999',
    'nome': 'Lassance',
    'estado': 'MG'
  },
  {
    'id': '2000',
    'nome': 'Lavras',
    'estado': 'MG'
  },
  {
    'id': '2001',
    'nome': 'Leandro Ferreira',
    'estado': 'MG'
  },
  {
    'id': '2002',
    'nome': 'Leme do Prado',
    'estado': 'MG'
  },
  {
    'id': '2003',
    'nome': 'Leopoldina',
    'estado': 'MG'
  },
  {
    'id': '2004',
    'nome': 'Liberdade',
    'estado': 'MG'
  },
  {
    'id': '2005',
    'nome': 'Lima Duarte',
    'estado': 'MG'
  },
  {
    'id': '2006',
    'nome': 'Limeira do Oeste',
    'estado': 'MG'
  },
  {
    'id': '2007',
    'nome': 'Lontra',
    'estado': 'MG'
  },
  {
    'id': '2008',
    'nome': 'Luisburgo',
    'estado': 'MG'
  },
  {
    'id': '2009',
    'nome': 'Luislândia',
    'estado': 'MG'
  },
  {
    'id': '2010',
    'nome': 'Luminárias',
    'estado': 'MG'
  },
  {
    'id': '2011',
    'nome': 'Luz',
    'estado': 'MG'
  },
  {
    'id': '2012',
    'nome': 'Machacalis',
    'estado': 'MG'
  },
  {
    'id': '2013',
    'nome': 'Machado',
    'estado': 'MG'
  },
  {
    'id': '2014',
    'nome': 'Madre de Deus de Minas',
    'estado': 'MG'
  },
  {
    'id': '2015',
    'nome': 'Malacacheta',
    'estado': 'MG'
  },
  {
    'id': '2016',
    'nome': 'Mamonas',
    'estado': 'MG'
  },
  {
    'id': '2017',
    'nome': 'Manga',
    'estado': 'MG'
  },
  {
    'id': '2018',
    'nome': 'Manhuaçu',
    'estado': 'MG'
  },
  {
    'id': '2019',
    'nome': 'Manhumirim',
    'estado': 'MG'
  },
  {
    'id': '2020',
    'nome': 'Mantena',
    'estado': 'MG'
  },
  {
    'id': '2021',
    'nome': 'Mar de Espanha',
    'estado': 'MG'
  },
  {
    'id': '2022',
    'nome': 'Maravilhas',
    'estado': 'MG'
  },
  {
    'id': '2023',
    'nome': 'Maria da Fé',
    'estado': 'MG'
  },
  {
    'id': '2024',
    'nome': 'Mariana',
    'estado': 'MG'
  },
  {
    'id': '2025',
    'nome': 'Marilac',
    'estado': 'MG'
  },
  {
    'id': '2026',
    'nome': 'Mário Campos',
    'estado': 'MG'
  },
  {
    'id': '2027',
    'nome': 'Maripá de Minas',
    'estado': 'MG'
  },
  {
    'id': '2028',
    'nome': 'Marliéria',
    'estado': 'MG'
  },
  {
    'id': '2029',
    'nome': 'Marmelópolis',
    'estado': 'MG'
  },
  {
    'id': '2030',
    'nome': 'Martinho Campos',
    'estado': 'MG'
  },
  {
    'id': '2031',
    'nome': 'Martins Soares',
    'estado': 'MG'
  },
  {
    'id': '2032',
    'nome': 'Mata Verde',
    'estado': 'MG'
  },
  {
    'id': '2033',
    'nome': 'Materlândia',
    'estado': 'MG'
  },
  {
    'id': '2034',
    'nome': 'Mateus Leme',
    'estado': 'MG'
  },
  {
    'id': '2035',
    'nome': 'Mathias Lobato',
    'estado': 'MG'
  },
  {
    'id': '2036',
    'nome': 'Matias Barbosa',
    'estado': 'MG'
  },
  {
    'id': '2037',
    'nome': 'Matias Cardoso',
    'estado': 'MG'
  },
  {
    'id': '2038',
    'nome': 'Matipó',
    'estado': 'MG'
  },
  {
    'id': '2039',
    'nome': 'Mato Verde',
    'estado': 'MG'
  },
  {
    'id': '2040',
    'nome': 'Matozinhos',
    'estado': 'MG'
  },
  {
    'id': '2041',
    'nome': 'Matutina',
    'estado': 'MG'
  },
  {
    'id': '2042',
    'nome': 'Medeiros',
    'estado': 'MG'
  },
  {
    'id': '2043',
    'nome': 'Medina',
    'estado': 'MG'
  },
  {
    'id': '2044',
    'nome': 'Mendes Pimentel',
    'estado': 'MG'
  },
  {
    'id': '2045',
    'nome': 'Mercês',
    'estado': 'MG'
  },
  {
    'id': '2046',
    'nome': 'Mesquita',
    'estado': 'MG'
  },
  {
    'id': '2047',
    'nome': 'Minas Novas',
    'estado': 'MG'
  },
  {
    'id': '2048',
    'nome': 'Minduri',
    'estado': 'MG'
  },
  {
    'id': '2049',
    'nome': 'Mirabela',
    'estado': 'MG'
  },
  {
    'id': '2050',
    'nome': 'Miradouro',
    'estado': 'MG'
  },
  {
    'id': '2051',
    'nome': 'Miraí',
    'estado': 'MG'
  },
  {
    'id': '2052',
    'nome': 'Miravânia',
    'estado': 'MG'
  },
  {
    'id': '2053',
    'nome': 'Moeda',
    'estado': 'MG'
  },
  {
    'id': '2054',
    'nome': 'Moema',
    'estado': 'MG'
  },
  {
    'id': '2055',
    'nome': 'Monjolos',
    'estado': 'MG'
  },
  {
    'id': '2056',
    'nome': 'Monsenhor Paulo',
    'estado': 'MG'
  },
  {
    'id': '2057',
    'nome': 'Montalvânia',
    'estado': 'MG'
  },
  {
    'id': '2058',
    'nome': 'Monte Alegre de Minas',
    'estado': 'MG'
  },
  {
    'id': '2059',
    'nome': 'Monte Azul',
    'estado': 'MG'
  },
  {
    'id': '2060',
    'nome': 'Monte Belo',
    'estado': 'MG'
  },
  {
    'id': '2061',
    'nome': 'Monte Carmelo',
    'estado': 'MG'
  },
  {
    'id': '2062',
    'nome': 'Monte Formoso',
    'estado': 'MG'
  },
  {
    'id': '2063',
    'nome': 'Monte Santo de Minas',
    'estado': 'MG'
  },
  {
    'id': '2064',
    'nome': 'Monte Sião',
    'estado': 'MG'
  },
  {
    'id': '2065',
    'nome': 'Montes Claros',
    'estado': 'MG'
  },
  {
    'id': '2066',
    'nome': 'Montezuma',
    'estado': 'MG'
  },
  {
    'id': '2067',
    'nome': 'Morada Nova de Minas',
    'estado': 'MG'
  },
  {
    'id': '2068',
    'nome': 'Morro da Garça',
    'estado': 'MG'
  },
  {
    'id': '2069',
    'nome': 'Morro do Pilar',
    'estado': 'MG'
  },
  {
    'id': '2070',
    'nome': 'Munhoz',
    'estado': 'MG'
  },
  {
    'id': '2071',
    'nome': 'Muriaé',
    'estado': 'MG'
  },
  {
    'id': '2072',
    'nome': 'Mutum',
    'estado': 'MG'
  },
  {
    'id': '2073',
    'nome': 'Muzambinho',
    'estado': 'MG'
  },
  {
    'id': '2074',
    'nome': 'Nacip Raydan',
    'estado': 'MG'
  },
  {
    'id': '2075',
    'nome': 'Nanuque',
    'estado': 'MG'
  },
  {
    'id': '2076',
    'nome': 'Naque',
    'estado': 'MG'
  },
  {
    'id': '2077',
    'nome': 'Natalândia',
    'estado': 'MG'
  },
  {
    'id': '2078',
    'nome': 'Natércia',
    'estado': 'MG'
  },
  {
    'id': '2079',
    'nome': 'Nazareno',
    'estado': 'MG'
  },
  {
    'id': '2080',
    'nome': 'Nepomuceno',
    'estado': 'MG'
  },
  {
    'id': '2081',
    'nome': 'Ninheira',
    'estado': 'MG'
  },
  {
    'id': '2082',
    'nome': 'Nova Belém',
    'estado': 'MG'
  },
  {
    'id': '2083',
    'nome': 'Nova Era',
    'estado': 'MG'
  },
  {
    'id': '2084',
    'nome': 'Nova Lima',
    'estado': 'MG'
  },
  {
    'id': '2085',
    'nome': 'Nova Módica',
    'estado': 'MG'
  },
  {
    'id': '2086',
    'nome': 'Nova Ponte',
    'estado': 'MG'
  },
  {
    'id': '2087',
    'nome': 'Nova Porteirinha',
    'estado': 'MG'
  },
  {
    'id': '2088',
    'nome': 'Nova Resende',
    'estado': 'MG'
  },
  {
    'id': '2089',
    'nome': 'Nova Serrana',
    'estado': 'MG'
  },
  {
    'id': '2090',
    'nome': 'Nova União',
    'estado': 'MG'
  },
  {
    'id': '2091',
    'nome': 'Novo Cruzeiro',
    'estado': 'MG'
  },
  {
    'id': '2092',
    'nome': 'Novo Oriente de Minas',
    'estado': 'MG'
  },
  {
    'id': '2093',
    'nome': 'Novorizonte',
    'estado': 'MG'
  },
  {
    'id': '2094',
    'nome': 'Olaria',
    'estado': 'MG'
  },
  {
    'id': '2095',
    'nome': 'Olhos-d`Água',
    'estado': 'MG'
  },
  {
    'id': '2096',
    'nome': 'Olímpio Noronha',
    'estado': 'MG'
  },
  {
    'id': '2097',
    'nome': 'Oliveira',
    'estado': 'MG'
  },
  {
    'id': '2098',
    'nome': 'Oliveira Fortes',
    'estado': 'MG'
  },
  {
    'id': '2099',
    'nome': 'Onça de Pitangui',
    'estado': 'MG'
  },
  {
    'id': '2100',
    'nome': 'Oratórios',
    'estado': 'MG'
  },
  {
    'id': '2101',
    'nome': 'Orizânia',
    'estado': 'MG'
  },
  {
    'id': '2102',
    'nome': 'Ouro Branco',
    'estado': 'MG'
  },
  {
    'id': '2103',
    'nome': 'Ouro Fino',
    'estado': 'MG'
  },
  {
    'id': '2104',
    'nome': 'Ouro Preto',
    'estado': 'MG'
  },
  {
    'id': '2105',
    'nome': 'Ouro Verde de Minas',
    'estado': 'MG'
  },
  {
    'id': '2106',
    'nome': 'Padre Carvalho',
    'estado': 'MG'
  },
  {
    'id': '2107',
    'nome': 'Padre Paraíso',
    'estado': 'MG'
  },
  {
    'id': '2108',
    'nome': 'Pai Pedro',
    'estado': 'MG'
  },
  {
    'id': '2109',
    'nome': 'Paineiras',
    'estado': 'MG'
  },
  {
    'id': '2110',
    'nome': 'Pains',
    'estado': 'MG'
  },
  {
    'id': '2111',
    'nome': 'Paiva',
    'estado': 'MG'
  },
  {
    'id': '2112',
    'nome': 'Palma',
    'estado': 'MG'
  },
  {
    'id': '2113',
    'nome': 'Palmópolis',
    'estado': 'MG'
  },
  {
    'id': '2114',
    'nome': 'Papagaios',
    'estado': 'MG'
  },
  {
    'id': '2115',
    'nome': 'Pará de Minas',
    'estado': 'MG'
  },
  {
    'id': '2116',
    'nome': 'Paracatu',
    'estado': 'MG'
  },
  {
    'id': '2117',
    'nome': 'Paraguaçu',
    'estado': 'MG'
  },
  {
    'id': '2118',
    'nome': 'Paraisópolis',
    'estado': 'MG'
  },
  {
    'id': '2119',
    'nome': 'Paraopeba',
    'estado': 'MG'
  },
  {
    'id': '2120',
    'nome': 'Passa Quatro',
    'estado': 'MG'
  },
  {
    'id': '2121',
    'nome': 'Passa Tempo',
    'estado': 'MG'
  },
  {
    'id': '2122',
    'nome': 'Passabém',
    'estado': 'MG'
  },
  {
    'id': '2123',
    'nome': 'Passa-Vinte',
    'estado': 'MG'
  },
  {
    'id': '2124',
    'nome': 'Passos',
    'estado': 'MG'
  },
  {
    'id': '2125',
    'nome': 'Patis',
    'estado': 'MG'
  },
  {
    'id': '2126',
    'nome': 'Patos de Minas',
    'estado': 'MG'
  },
  {
    'id': '2127',
    'nome': 'Patrocínio',
    'estado': 'MG'
  },
  {
    'id': '2128',
    'nome': 'Patrocínio do Muriaé',
    'estado': 'MG'
  },
  {
    'id': '2129',
    'nome': 'Paula Cândido',
    'estado': 'MG'
  },
  {
    'id': '2130',
    'nome': 'Paulistas',
    'estado': 'MG'
  },
  {
    'id': '2131',
    'nome': 'Pavão',
    'estado': 'MG'
  },
  {
    'id': '2132',
    'nome': 'Peçanha',
    'estado': 'MG'
  },
  {
    'id': '2133',
    'nome': 'Pedra Azul',
    'estado': 'MG'
  },
  {
    'id': '2134',
    'nome': 'Pedra Bonita',
    'estado': 'MG'
  },
  {
    'id': '2135',
    'nome': 'Pedra do Anta',
    'estado': 'MG'
  },
  {
    'id': '2136',
    'nome': 'Pedra do Indaiá',
    'estado': 'MG'
  },
  {
    'id': '2137',
    'nome': 'Pedra Dourada',
    'estado': 'MG'
  },
  {
    'id': '2138',
    'nome': 'Pedralva',
    'estado': 'MG'
  },
  {
    'id': '2139',
    'nome': 'Pedras de Maria da Cruz',
    'estado': 'MG'
  },
  {
    'id': '2140',
    'nome': 'Pedrinópolis',
    'estado': 'MG'
  },
  {
    'id': '2141',
    'nome': 'Pedro Leopoldo',
    'estado': 'MG'
  },
  {
    'id': '2142',
    'nome': 'Pedro Teixeira',
    'estado': 'MG'
  },
  {
    'id': '2143',
    'nome': 'Pequeri',
    'estado': 'MG'
  },
  {
    'id': '2144',
    'nome': 'Pequi',
    'estado': 'MG'
  },
  {
    'id': '2145',
    'nome': 'Perdigão',
    'estado': 'MG'
  },
  {
    'id': '2146',
    'nome': 'Perdizes',
    'estado': 'MG'
  },
  {
    'id': '2147',
    'nome': 'Perdões',
    'estado': 'MG'
  },
  {
    'id': '2148',
    'nome': 'Periquito',
    'estado': 'MG'
  },
  {
    'id': '2149',
    'nome': 'Pescador',
    'estado': 'MG'
  },
  {
    'id': '2150',
    'nome': 'Piau',
    'estado': 'MG'
  },
  {
    'id': '2151',
    'nome': 'Piedade de Caratinga',
    'estado': 'MG'
  },
  {
    'id': '2152',
    'nome': 'Piedade de Ponte Nova',
    'estado': 'MG'
  },
  {
    'id': '2153',
    'nome': 'Piedade do Rio Grande',
    'estado': 'MG'
  },
  {
    'id': '2154',
    'nome': 'Piedade dos Gerais',
    'estado': 'MG'
  },
  {
    'id': '2155',
    'nome': 'Pimenta',
    'estado': 'MG'
  },
  {
    'id': '2156',
    'nome': 'Pingo-d`Água',
    'estado': 'MG'
  },
  {
    'id': '2157',
    'nome': 'Pintópolis',
    'estado': 'MG'
  },
  {
    'id': '2158',
    'nome': 'Piracema',
    'estado': 'MG'
  },
  {
    'id': '2159',
    'nome': 'Pirajuba',
    'estado': 'MG'
  },
  {
    'id': '2160',
    'nome': 'Piranga',
    'estado': 'MG'
  },
  {
    'id': '2161',
    'nome': 'Piranguçu',
    'estado': 'MG'
  },
  {
    'id': '2162',
    'nome': 'Piranguinho',
    'estado': 'MG'
  },
  {
    'id': '2163',
    'nome': 'Pirapetinga',
    'estado': 'MG'
  },
  {
    'id': '2164',
    'nome': 'Pirapora',
    'estado': 'MG'
  },
  {
    'id': '2165',
    'nome': 'Piraúba',
    'estado': 'MG'
  },
  {
    'id': '2166',
    'nome': 'Pitangui',
    'estado': 'MG'
  },
  {
    'id': '2167',
    'nome': 'Piumhi',
    'estado': 'MG'
  },
  {
    'id': '2168',
    'nome': 'Planura',
    'estado': 'MG'
  },
  {
    'id': '2169',
    'nome': 'Poço Fundo',
    'estado': 'MG'
  },
  {
    'id': '2170',
    'nome': 'Poços de Caldas',
    'estado': 'MG'
  },
  {
    'id': '2171',
    'nome': 'Pocrane',
    'estado': 'MG'
  },
  {
    'id': '2172',
    'nome': 'Pompéu',
    'estado': 'MG'
  },
  {
    'id': '2173',
    'nome': 'Ponte Nova',
    'estado': 'MG'
  },
  {
    'id': '2174',
    'nome': 'Ponto Chique',
    'estado': 'MG'
  },
  {
    'id': '2175',
    'nome': 'Ponto dos Volantes',
    'estado': 'MG'
  },
  {
    'id': '2176',
    'nome': 'Porteirinha',
    'estado': 'MG'
  },
  {
    'id': '2177',
    'nome': 'Porto Firme',
    'estado': 'MG'
  },
  {
    'id': '2178',
    'nome': 'Poté',
    'estado': 'MG'
  },
  {
    'id': '2179',
    'nome': 'Pouso Alegre',
    'estado': 'MG'
  },
  {
    'id': '2180',
    'nome': 'Pouso Alto',
    'estado': 'MG'
  },
  {
    'id': '2181',
    'nome': 'Prados',
    'estado': 'MG'
  },
  {
    'id': '2182',
    'nome': 'Prata',
    'estado': 'MG'
  },
  {
    'id': '2183',
    'nome': 'Pratápolis',
    'estado': 'MG'
  },
  {
    'id': '2184',
    'nome': 'Pratinha',
    'estado': 'MG'
  },
  {
    'id': '2185',
    'nome': 'Presidente Bernardes',
    'estado': 'MG'
  },
  {
    'id': '2186',
    'nome': 'Presidente Juscelino',
    'estado': 'MG'
  },
  {
    'id': '2187',
    'nome': 'Presidente Kubitschek',
    'estado': 'MG'
  },
  {
    'id': '2188',
    'nome': 'Presidente Olegário',
    'estado': 'MG'
  },
  {
    'id': '2189',
    'nome': 'Prudente de Morais',
    'estado': 'MG'
  },
  {
    'id': '2190',
    'nome': 'Quartel Geral',
    'estado': 'MG'
  },
  {
    'id': '2191',
    'nome': 'Queluzito',
    'estado': 'MG'
  },
  {
    'id': '2192',
    'nome': 'Raposos',
    'estado': 'MG'
  },
  {
    'id': '2193',
    'nome': 'Raul Soares',
    'estado': 'MG'
  },
  {
    'id': '2194',
    'nome': 'Recreio',
    'estado': 'MG'
  },
  {
    'id': '2195',
    'nome': 'Reduto',
    'estado': 'MG'
  },
  {
    'id': '2196',
    'nome': 'Resende Costa',
    'estado': 'MG'
  },
  {
    'id': '2197',
    'nome': 'Resplendor',
    'estado': 'MG'
  },
  {
    'id': '2198',
    'nome': 'Ressaquinha',
    'estado': 'MG'
  },
  {
    'id': '2199',
    'nome': 'Riachinho',
    'estado': 'MG'
  },
  {
    'id': '2200',
    'nome': 'Riacho dos Machados',
    'estado': 'MG'
  },
  {
    'id': '2201',
    'nome': 'Ribeirão das Neves',
    'estado': 'MG'
  },
  {
    'id': '2202',
    'nome': 'Ribeirão Vermelho',
    'estado': 'MG'
  },
  {
    'id': '2203',
    'nome': 'Rio Acima',
    'estado': 'MG'
  },
  {
    'id': '2204',
    'nome': 'Rio Casca',
    'estado': 'MG'
  },
  {
    'id': '2205',
    'nome': 'Rio do Prado',
    'estado': 'MG'
  },
  {
    'id': '2206',
    'nome': 'Rio Doce',
    'estado': 'MG'
  },
  {
    'id': '2207',
    'nome': 'Rio Espera',
    'estado': 'MG'
  },
  {
    'id': '2208',
    'nome': 'Rio Manso',
    'estado': 'MG'
  },
  {
    'id': '2209',
    'nome': 'Rio Novo',
    'estado': 'MG'
  },
  {
    'id': '2210',
    'nome': 'Rio Paranaíba',
    'estado': 'MG'
  },
  {
    'id': '2211',
    'nome': 'Rio Pardo de Minas',
    'estado': 'MG'
  },
  {
    'id': '2212',
    'nome': 'Rio Piracicaba',
    'estado': 'MG'
  },
  {
    'id': '2213',
    'nome': 'Rio Pomba',
    'estado': 'MG'
  },
  {
    'id': '2214',
    'nome': 'Rio Preto',
    'estado': 'MG'
  },
  {
    'id': '2215',
    'nome': 'Rio Vermelho',
    'estado': 'MG'
  },
  {
    'id': '2216',
    'nome': 'Ritápolis',
    'estado': 'MG'
  },
  {
    'id': '2217',
    'nome': 'Rochedo de Minas',
    'estado': 'MG'
  },
  {
    'id': '2218',
    'nome': 'Rodeiro',
    'estado': 'MG'
  },
  {
    'id': '2219',
    'nome': 'Romaria',
    'estado': 'MG'
  },
  {
    'id': '2220',
    'nome': 'Rosário da Limeira',
    'estado': 'MG'
  },
  {
    'id': '2221',
    'nome': 'Rubelita',
    'estado': 'MG'
  },
  {
    'id': '2222',
    'nome': 'Rubim',
    'estado': 'MG'
  },
  {
    'id': '2223',
    'nome': 'Sabará',
    'estado': 'MG'
  },
  {
    'id': '2224',
    'nome': 'Sabinópolis',
    'estado': 'MG'
  },
  {
    'id': '2225',
    'nome': 'Sacramento',
    'estado': 'MG'
  },
  {
    'id': '2226',
    'nome': 'Salinas',
    'estado': 'MG'
  },
  {
    'id': '2227',
    'nome': 'Salto da Divisa',
    'estado': 'MG'
  },
  {
    'id': '2228',
    'nome': 'Santa Bárbara',
    'estado': 'MG'
  },
  {
    'id': '2229',
    'nome': 'Santa Bárbara do Leste',
    'estado': 'MG'
  },
  {
    'id': '2230',
    'nome': 'Santa Bárbara do Monte Verde',
    'estado': 'MG'
  },
  {
    'id': '2231',
    'nome': 'Santa Bárbara do Tugúrio',
    'estado': 'MG'
  },
  {
    'id': '2232',
    'nome': 'Santa Cruz de Minas',
    'estado': 'MG'
  },
  {
    'id': '2233',
    'nome': 'Santa Cruz de Salinas',
    'estado': 'MG'
  },
  {
    'id': '2234',
    'nome': 'Santa Cruz do Escalvado',
    'estado': 'MG'
  },
  {
    'id': '2235',
    'nome': 'Santa Efigênia de Minas',
    'estado': 'MG'
  },
  {
    'id': '2236',
    'nome': 'Santa Fé de Minas',
    'estado': 'MG'
  },
  {
    'id': '2237',
    'nome': 'Santa Helena de Minas',
    'estado': 'MG'
  },
  {
    'id': '2238',
    'nome': 'Santa Juliana',
    'estado': 'MG'
  },
  {
    'id': '2239',
    'nome': 'Santa Luzia',
    'estado': 'MG'
  },
  {
    'id': '2240',
    'nome': 'Santa Margarida',
    'estado': 'MG'
  },
  {
    'id': '2241',
    'nome': 'Santa Maria de Itabira',
    'estado': 'MG'
  },
  {
    'id': '2242',
    'nome': 'Santa Maria do Salto',
    'estado': 'MG'
  },
  {
    'id': '2243',
    'nome': 'Santa Maria do Suaçuí',
    'estado': 'MG'
  },
  {
    'id': '2244',
    'nome': 'Santa Rita de Caldas',
    'estado': 'MG'
  },
  {
    'id': '2245',
    'nome': 'Santa Rita de Ibitipoca',
    'estado': 'MG'
  },
  {
    'id': '2246',
    'nome': 'Santa Rita de Jacutinga',
    'estado': 'MG'
  },
  {
    'id': '2247',
    'nome': 'Santa Rita de Minas',
    'estado': 'MG'
  },
  {
    'id': '2248',
    'nome': 'Santa Rita do Itueto',
    'estado': 'MG'
  },
  {
    'id': '2249',
    'nome': 'Santa Rita do Sapucaí',
    'estado': 'MG'
  },
  {
    'id': '2250',
    'nome': 'Santa Rosa da Serra',
    'estado': 'MG'
  },
  {
    'id': '2251',
    'nome': 'Santa Vitória',
    'estado': 'MG'
  },
  {
    'id': '2252',
    'nome': 'Santana da Vargem',
    'estado': 'MG'
  },
  {
    'id': '2253',
    'nome': 'Santana de Cataguases',
    'estado': 'MG'
  },
  {
    'id': '2254',
    'nome': 'Santana de Pirapama',
    'estado': 'MG'
  },
  {
    'id': '2255',
    'nome': 'Santana do Deserto',
    'estado': 'MG'
  },
  {
    'id': '2256',
    'nome': 'Santana do Garambéu',
    'estado': 'MG'
  },
  {
    'id': '2257',
    'nome': 'Santana do Jacaré',
    'estado': 'MG'
  },
  {
    'id': '2258',
    'nome': 'Santana do Manhuaçu',
    'estado': 'MG'
  },
  {
    'id': '2259',
    'nome': 'Santana do Paraíso',
    'estado': 'MG'
  },
  {
    'id': '2260',
    'nome': 'Santana do Riacho',
    'estado': 'MG'
  },
  {
    'id': '2261',
    'nome': 'Santana dos Montes',
    'estado': 'MG'
  },
  {
    'id': '2262',
    'nome': 'Santo Antônio do Amparo',
    'estado': 'MG'
  },
  {
    'id': '2263',
    'nome': 'Santo Antônio do Aventureiro',
    'estado': 'MG'
  },
  {
    'id': '2264',
    'nome': 'Santo Antônio do Grama',
    'estado': 'MG'
  },
  {
    'id': '2265',
    'nome': 'Santo Antônio do Itambé',
    'estado': 'MG'
  },
  {
    'id': '2266',
    'nome': 'Santo Antônio do Jacinto',
    'estado': 'MG'
  },
  {
    'id': '2267',
    'nome': 'Santo Antônio do Monte',
    'estado': 'MG'
  },
  {
    'id': '2268',
    'nome': 'Santo Antônio do Retiro',
    'estado': 'MG'
  },
  {
    'id': '2269',
    'nome': 'Santo Antônio do Rio Abaixo',
    'estado': 'MG'
  },
  {
    'id': '2270',
    'nome': 'Santo Hipólito',
    'estado': 'MG'
  },
  {
    'id': '2271',
    'nome': 'Santos Dumont',
    'estado': 'MG'
  },
  {
    'id': '2272',
    'nome': 'São Bento Abade',
    'estado': 'MG'
  },
  {
    'id': '2273',
    'nome': 'São Brás do Suaçuí',
    'estado': 'MG'
  },
  {
    'id': '2274',
    'nome': 'São Domingos das Dores',
    'estado': 'MG'
  },
  {
    'id': '2275',
    'nome': 'São Domingos do Prata',
    'estado': 'MG'
  },
  {
    'id': '2276',
    'nome': 'São Félix de Minas',
    'estado': 'MG'
  },
  {
    'id': '2277',
    'nome': 'São Francisco',
    'estado': 'MG'
  },
  {
    'id': '2278',
    'nome': 'São Francisco de Paula',
    'estado': 'MG'
  },
  {
    'id': '2279',
    'nome': 'São Francisco de Sales',
    'estado': 'MG'
  },
  {
    'id': '2280',
    'nome': 'São Francisco do Glória',
    'estado': 'MG'
  },
  {
    'id': '2281',
    'nome': 'São Geraldo',
    'estado': 'MG'
  },
  {
    'id': '2282',
    'nome': 'São Geraldo da Piedade',
    'estado': 'MG'
  },
  {
    'id': '2283',
    'nome': 'São Geraldo do Baixio',
    'estado': 'MG'
  },
  {
    'id': '2284',
    'nome': 'São Gonçalo do Abaeté',
    'estado': 'MG'
  },
  {
    'id': '2285',
    'nome': 'São Gonçalo do Pará',
    'estado': 'MG'
  },
  {
    'id': '2286',
    'nome': 'São Gonçalo do Rio Abaixo',
    'estado': 'MG'
  },
  {
    'id': '2287',
    'nome': 'São Gonçalo do Rio Preto',
    'estado': 'MG'
  },
  {
    'id': '2288',
    'nome': 'São Gonçalo do Sapucaí',
    'estado': 'MG'
  },
  {
    'id': '2289',
    'nome': 'São Gotardo',
    'estado': 'MG'
  },
  {
    'id': '2290',
    'nome': 'São João Batista do Glória',
    'estado': 'MG'
  },
  {
    'id': '2291',
    'nome': 'São João da Lagoa',
    'estado': 'MG'
  },
  {
    'id': '2292',
    'nome': 'São João da Mata',
    'estado': 'MG'
  },
  {
    'id': '2293',
    'nome': 'São João da Ponte',
    'estado': 'MG'
  },
  {
    'id': '2294',
    'nome': 'São João das Missões',
    'estado': 'MG'
  },
  {
    'id': '2295',
    'nome': 'São João del Rei',
    'estado': 'MG'
  },
  {
    'id': '2296',
    'nome': 'São João do Manhuaçu',
    'estado': 'MG'
  },
  {
    'id': '2297',
    'nome': 'São João do Manteninha',
    'estado': 'MG'
  },
  {
    'id': '2298',
    'nome': 'São João do Oriente',
    'estado': 'MG'
  },
  {
    'id': '2299',
    'nome': 'São João do Pacuí',
    'estado': 'MG'
  },
  {
    'id': '2300',
    'nome': 'São João do Paraíso',
    'estado': 'MG'
  },
  {
    'id': '2301',
    'nome': 'São João Evangelista',
    'estado': 'MG'
  },
  {
    'id': '2302',
    'nome': 'São João Nepomuceno',
    'estado': 'MG'
  },
  {
    'id': '2303',
    'nome': 'São Joaquim de Bicas',
    'estado': 'MG'
  },
  {
    'id': '2304',
    'nome': 'São José da Barra',
    'estado': 'MG'
  },
  {
    'id': '2305',
    'nome': 'São José da Lapa',
    'estado': 'MG'
  },
  {
    'id': '2306',
    'nome': 'São José da Safira',
    'estado': 'MG'
  },
  {
    'id': '2307',
    'nome': 'São José da Varginha',
    'estado': 'MG'
  },
  {
    'id': '2308',
    'nome': 'São José do Alegre',
    'estado': 'MG'
  },
  {
    'id': '2309',
    'nome': 'São José do Divino',
    'estado': 'MG'
  },
  {
    'id': '2310',
    'nome': 'São José do Goiabal',
    'estado': 'MG'
  },
  {
    'id': '2311',
    'nome': 'São José do Jacuri',
    'estado': 'MG'
  },
  {
    'id': '2312',
    'nome': 'São José do Mantimento',
    'estado': 'MG'
  },
  {
    'id': '2313',
    'nome': 'São Lourenço',
    'estado': 'MG'
  },
  {
    'id': '2314',
    'nome': 'São Miguel do Anta',
    'estado': 'MG'
  },
  {
    'id': '2315',
    'nome': 'São Pedro da União',
    'estado': 'MG'
  },
  {
    'id': '2316',
    'nome': 'São Pedro do Suaçuí',
    'estado': 'MG'
  },
  {
    'id': '2317',
    'nome': 'São Pedro dos Ferros',
    'estado': 'MG'
  },
  {
    'id': '2318',
    'nome': 'São Romão',
    'estado': 'MG'
  },
  {
    'id': '2319',
    'nome': 'São Roque de Minas',
    'estado': 'MG'
  },
  {
    'id': '2320',
    'nome': 'São Sebastião da Bela Vista',
    'estado': 'MG'
  },
  {
    'id': '2321',
    'nome': 'São Sebastião da Vargem Alegre',
    'estado': 'MG'
  },
  {
    'id': '2322',
    'nome': 'São Sebastião do Anta',
    'estado': 'MG'
  },
  {
    'id': '2323',
    'nome': 'São Sebastião do Maranhão',
    'estado': 'MG'
  },
  {
    'id': '2324',
    'nome': 'São Sebastião do Oeste',
    'estado': 'MG'
  },
  {
    'id': '2325',
    'nome': 'São Sebastião do Paraíso',
    'estado': 'MG'
  },
  {
    'id': '2326',
    'nome': 'São Sebastião do Rio Preto',
    'estado': 'MG'
  },
  {
    'id': '2327',
    'nome': 'São Sebastião do Rio Verde',
    'estado': 'MG'
  },
  {
    'id': '2328',
    'nome': 'São Thomé das Letras',
    'estado': 'MG'
  },
  {
    'id': '2329',
    'nome': 'São Tiago',
    'estado': 'MG'
  },
  {
    'id': '2330',
    'nome': 'São Tomás de Aquino',
    'estado': 'MG'
  },
  {
    'id': '2331',
    'nome': 'São Vicente de Minas',
    'estado': 'MG'
  },
  {
    'id': '2332',
    'nome': 'Sapucaí-Mirim',
    'estado': 'MG'
  },
  {
    'id': '2333',
    'nome': 'Sardoá',
    'estado': 'MG'
  },
  {
    'id': '2334',
    'nome': 'Sarzedo',
    'estado': 'MG'
  },
  {
    'id': '2335',
    'nome': 'Sem-Peixe',
    'estado': 'MG'
  },
  {
    'id': '2336',
    'nome': 'Senador Amaral',
    'estado': 'MG'
  },
  {
    'id': '2337',
    'nome': 'Senador Cortes',
    'estado': 'MG'
  },
  {
    'id': '2338',
    'nome': 'Senador Firmino',
    'estado': 'MG'
  },
  {
    'id': '2339',
    'nome': 'Senador José Bento',
    'estado': 'MG'
  },
  {
    'id': '2340',
    'nome': 'Senador Modestino Gonçalves',
    'estado': 'MG'
  },
  {
    'id': '2341',
    'nome': 'Senhora de Oliveira',
    'estado': 'MG'
  },
  {
    'id': '2342',
    'nome': 'Senhora do Porto',
    'estado': 'MG'
  },
  {
    'id': '2343',
    'nome': 'Senhora dos Remédios',
    'estado': 'MG'
  },
  {
    'id': '2344',
    'nome': 'Sericita',
    'estado': 'MG'
  },
  {
    'id': '2345',
    'nome': 'Seritinga',
    'estado': 'MG'
  },
  {
    'id': '2346',
    'nome': 'Serra Azul de Minas',
    'estado': 'MG'
  },
  {
    'id': '2347',
    'nome': 'Serra da Saudade',
    'estado': 'MG'
  },
  {
    'id': '2348',
    'nome': 'Serra do Salitre',
    'estado': 'MG'
  },
  {
    'id': '2349',
    'nome': 'Serra dos Aimorés',
    'estado': 'MG'
  },
  {
    'id': '2350',
    'nome': 'Serrania',
    'estado': 'MG'
  },
  {
    'id': '2351',
    'nome': 'Serranópolis de Minas',
    'estado': 'MG'
  },
  {
    'id': '2352',
    'nome': 'Serranos',
    'estado': 'MG'
  },
  {
    'id': '2353',
    'nome': 'Serro',
    'estado': 'MG'
  },
  {
    'id': '2354',
    'nome': 'Sete Lagoas',
    'estado': 'MG'
  },
  {
    'id': '2355',
    'nome': 'Setubinha',
    'estado': 'MG'
  },
  {
    'id': '2356',
    'nome': 'Silveirânia',
    'estado': 'MG'
  },
  {
    'id': '2357',
    'nome': 'Silvianópolis',
    'estado': 'MG'
  },
  {
    'id': '2358',
    'nome': 'Simão Pereira',
    'estado': 'MG'
  },
  {
    'id': '2359',
    'nome': 'Simonésia',
    'estado': 'MG'
  },
  {
    'id': '2360',
    'nome': 'Sobrália',
    'estado': 'MG'
  },
  {
    'id': '2361',
    'nome': 'Soledade de Minas',
    'estado': 'MG'
  },
  {
    'id': '2362',
    'nome': 'Tabuleiro',
    'estado': 'MG'
  },
  {
    'id': '2363',
    'nome': 'Taiobeiras',
    'estado': 'MG'
  },
  {
    'id': '2364',
    'nome': 'Taparuba',
    'estado': 'MG'
  },
  {
    'id': '2365',
    'nome': 'Tapira',
    'estado': 'MG'
  },
  {
    'id': '2366',
    'nome': 'Tapiraí',
    'estado': 'MG'
  },
  {
    'id': '2367',
    'nome': 'Taquaraçu de Minas',
    'estado': 'MG'
  },
  {
    'id': '2368',
    'nome': 'Tarumirim',
    'estado': 'MG'
  },
  {
    'id': '2369',
    'nome': 'Teixeiras',
    'estado': 'MG'
  },
  {
    'id': '2370',
    'nome': 'Teófilo Otoni',
    'estado': 'MG'
  },
  {
    'id': '2371',
    'nome': 'Timóteo',
    'estado': 'MG'
  },
  {
    'id': '2372',
    'nome': 'Tiradentes',
    'estado': 'MG'
  },
  {
    'id': '2373',
    'nome': 'Tiros',
    'estado': 'MG'
  },
  {
    'id': '2374',
    'nome': 'Tocantins',
    'estado': 'MG'
  },
  {
    'id': '2375',
    'nome': 'Tocos do Moji',
    'estado': 'MG'
  },
  {
    'id': '2376',
    'nome': 'Toledo',
    'estado': 'MG'
  },
  {
    'id': '2377',
    'nome': 'Tombos',
    'estado': 'MG'
  },
  {
    'id': '2378',
    'nome': 'Três Corações',
    'estado': 'MG'
  },
  {
    'id': '2379',
    'nome': 'Três Marias',
    'estado': 'MG'
  },
  {
    'id': '2380',
    'nome': 'Três Pontas',
    'estado': 'MG'
  },
  {
    'id': '2381',
    'nome': 'Tumiritinga',
    'estado': 'MG'
  },
  {
    'id': '2382',
    'nome': 'Tupaciguara',
    'estado': 'MG'
  },
  {
    'id': '2383',
    'nome': 'Turmalina',
    'estado': 'MG'
  },
  {
    'id': '2384',
    'nome': 'Turvolândia',
    'estado': 'MG'
  },
  {
    'id': '2385',
    'nome': 'Ubá',
    'estado': 'MG'
  },
  {
    'id': '2386',
    'nome': 'Ubaí',
    'estado': 'MG'
  },
  {
    'id': '2387',
    'nome': 'Ubaporanga',
    'estado': 'MG'
  },
  {
    'id': '2388',
    'nome': 'Uberaba',
    'estado': 'MG'
  },
  {
    'id': '2389',
    'nome': 'Uberlândia',
    'estado': 'MG'
  },
  {
    'id': '2390',
    'nome': 'Umburatiba',
    'estado': 'MG'
  },
  {
    'id': '2391',
    'nome': 'Unaí',
    'estado': 'MG'
  },
  {
    'id': '2392',
    'nome': 'União de Minas',
    'estado': 'MG'
  },
  {
    'id': '2393',
    'nome': 'Uruana de Minas',
    'estado': 'MG'
  },
  {
    'id': '2394',
    'nome': 'Urucânia',
    'estado': 'MG'
  },
  {
    'id': '2395',
    'nome': 'Urucuia',
    'estado': 'MG'
  },
  {
    'id': '2396',
    'nome': 'Vargem Alegre',
    'estado': 'MG'
  },
  {
    'id': '2397',
    'nome': 'Vargem Bonita',
    'estado': 'MG'
  },
  {
    'id': '2398',
    'nome': 'Vargem Grande do Rio Pardo',
    'estado': 'MG'
  },
  {
    'id': '2399',
    'nome': 'Varginha',
    'estado': 'MG'
  },
  {
    'id': '2400',
    'nome': 'Varjão de Minas',
    'estado': 'MG'
  },
  {
    'id': '2401',
    'nome': 'Várzea da Palma',
    'estado': 'MG'
  },
  {
    'id': '2402',
    'nome': 'Varzelândia',
    'estado': 'MG'
  },
  {
    'id': '2403',
    'nome': 'Vazante',
    'estado': 'MG'
  },
  {
    'id': '2404',
    'nome': 'Verdelândia',
    'estado': 'MG'
  },
  {
    'id': '2405',
    'nome': 'Veredinha',
    'estado': 'MG'
  },
  {
    'id': '2406',
    'nome': 'Veríssimo',
    'estado': 'MG'
  },
  {
    'id': '2407',
    'nome': 'Vermelho Novo',
    'estado': 'MG'
  },
  {
    'id': '2408',
    'nome': 'Vespasiano',
    'estado': 'MG'
  },
  {
    'id': '2409',
    'nome': 'Viçosa',
    'estado': 'MG'
  },
  {
    'id': '2410',
    'nome': 'Vieiras',
    'estado': 'MG'
  },
  {
    'id': '2411',
    'nome': 'Virgem da Lapa',
    'estado': 'MG'
  },
  {
    'id': '2412',
    'nome': 'Virgínia',
    'estado': 'MG'
  },
  {
    'id': '2413',
    'nome': 'Virginópolis',
    'estado': 'MG'
  },
  {
    'id': '2414',
    'nome': 'Virgolândia',
    'estado': 'MG'
  },
  {
    'id': '2415',
    'nome': 'Visconde do Rio Branco',
    'estado': 'MG'
  },
  {
    'id': '2416',
    'nome': 'Volta Grande',
    'estado': 'MG'
  },
  {
    'id': '2417',
    'nome': 'Wenceslau Braz',
    'estado': 'MG'
  },
  {
    'id': '2418',
    'nome': 'Abaetetuba',
    'estado': 'PA'
  },
  {
    'id': '2419',
    'nome': 'Abel Figueiredo',
    'estado': 'PA'
  },
  {
    'id': '2420',
    'nome': 'Acará',
    'estado': 'PA'
  },
  {
    'id': '2421',
    'nome': 'Afuá',
    'estado': 'PA'
  },
  {
    'id': '2422',
    'nome': 'Água Azul do Norte',
    'estado': 'PA'
  },
  {
    'id': '2423',
    'nome': 'Alenquer',
    'estado': 'PA'
  },
  {
    'id': '2424',
    'nome': 'Almeirim',
    'estado': 'PA'
  },
  {
    'id': '2425',
    'nome': 'Altamira',
    'estado': 'PA'
  },
  {
    'id': '2426',
    'nome': 'Anajás',
    'estado': 'PA'
  },
  {
    'id': '2427',
    'nome': 'Ananindeua',
    'estado': 'PA'
  },
  {
    'id': '2428',
    'nome': 'Anapu',
    'estado': 'PA'
  },
  {
    'id': '2429',
    'nome': 'Augusto Corrêa',
    'estado': 'PA'
  },
  {
    'id': '2430',
    'nome': 'Aurora do Pará',
    'estado': 'PA'
  },
  {
    'id': '2431',
    'nome': 'Aveiro',
    'estado': 'PA'
  },
  {
    'id': '2432',
    'nome': 'Bagre',
    'estado': 'PA'
  },
  {
    'id': '2433',
    'nome': 'Baião',
    'estado': 'PA'
  },
  {
    'id': '2434',
    'nome': 'Bannach',
    'estado': 'PA'
  },
  {
    'id': '2435',
    'nome': 'Barcarena',
    'estado': 'PA'
  },
  {
    'id': '2436',
    'nome': 'Belém',
    'estado': 'PA'
  },
  {
    'id': '2437',
    'nome': 'Belterra',
    'estado': 'PA'
  },
  {
    'id': '2438',
    'nome': 'Benevides',
    'estado': 'PA'
  },
  {
    'id': '2439',
    'nome': 'Bom Jesus do Tocantins',
    'estado': 'PA'
  },
  {
    'id': '2440',
    'nome': 'Bonito',
    'estado': 'PA'
  },
  {
    'id': '2441',
    'nome': 'Bragança',
    'estado': 'PA'
  },
  {
    'id': '2442',
    'nome': 'Brasil Novo',
    'estado': 'PA'
  },
  {
    'id': '2443',
    'nome': 'Brejo Grande do Araguaia',
    'estado': 'PA'
  },
  {
    'id': '2444',
    'nome': 'Breu Branco',
    'estado': 'PA'
  },
  {
    'id': '2445',
    'nome': 'Breves',
    'estado': 'PA'
  },
  {
    'id': '2446',
    'nome': 'Bujaru',
    'estado': 'PA'
  },
  {
    'id': '2447',
    'nome': 'Cachoeira do Arari',
    'estado': 'PA'
  },
  {
    'id': '2448',
    'nome': 'Cachoeira do Piriá',
    'estado': 'PA'
  },
  {
    'id': '2449',
    'nome': 'Cametá',
    'estado': 'PA'
  },
  {
    'id': '2450',
    'nome': 'Canaã dos Carajás',
    'estado': 'PA'
  },
  {
    'id': '2451',
    'nome': 'Capanema',
    'estado': 'PA'
  },
  {
    'id': '2452',
    'nome': 'Capitão Poço',
    'estado': 'PA'
  },
  {
    'id': '2453',
    'nome': 'Castanhal',
    'estado': 'PA'
  },
  {
    'id': '2454',
    'nome': 'Chaves',
    'estado': 'PA'
  },
  {
    'id': '2455',
    'nome': 'Colares',
    'estado': 'PA'
  },
  {
    'id': '2456',
    'nome': 'Conceição do Araguaia',
    'estado': 'PA'
  },
  {
    'id': '2457',
    'nome': 'Concórdia do Pará',
    'estado': 'PA'
  },
  {
    'id': '2458',
    'nome': 'Cumaru do Norte',
    'estado': 'PA'
  },
  {
    'id': '2459',
    'nome': 'Curionópolis',
    'estado': 'PA'
  },
  {
    'id': '2460',
    'nome': 'Curralinho',
    'estado': 'PA'
  },
  {
    'id': '2461',
    'nome': 'Curuá',
    'estado': 'PA'
  },
  {
    'id': '2462',
    'nome': 'Curuçá',
    'estado': 'PA'
  },
  {
    'id': '2463',
    'nome': 'Dom Eliseu',
    'estado': 'PA'
  },
  {
    'id': '2464',
    'nome': 'Eldorado dos Carajás',
    'estado': 'PA'
  },
  {
    'id': '2465',
    'nome': 'Faro',
    'estado': 'PA'
  },
  {
    'id': '2466',
    'nome': 'Floresta do Araguaia',
    'estado': 'PA'
  },
  {
    'id': '2467',
    'nome': 'Garrafão do Norte',
    'estado': 'PA'
  },
  {
    'id': '2468',
    'nome': 'Goianésia do Pará',
    'estado': 'PA'
  },
  {
    'id': '2469',
    'nome': 'Gurupá',
    'estado': 'PA'
  },
  {
    'id': '2470',
    'nome': 'Igarapé-Açu',
    'estado': 'PA'
  },
  {
    'id': '2471',
    'nome': 'Igarapé-Miri',
    'estado': 'PA'
  },
  {
    'id': '2472',
    'nome': 'Inhangapi',
    'estado': 'PA'
  },
  {
    'id': '2473',
    'nome': 'Ipixuna do Pará',
    'estado': 'PA'
  },
  {
    'id': '2474',
    'nome': 'Irituia',
    'estado': 'PA'
  },
  {
    'id': '2475',
    'nome': 'Itaituba',
    'estado': 'PA'
  },
  {
    'id': '2476',
    'nome': 'Itupiranga',
    'estado': 'PA'
  },
  {
    'id': '2477',
    'nome': 'Jacareacanga',
    'estado': 'PA'
  },
  {
    'id': '2478',
    'nome': 'Jacundá',
    'estado': 'PA'
  },
  {
    'id': '2479',
    'nome': 'Juruti',
    'estado': 'PA'
  },
  {
    'id': '2480',
    'nome': 'Limoeiro do Ajuru',
    'estado': 'PA'
  },
  {
    'id': '2481',
    'nome': 'Mãe do Rio',
    'estado': 'PA'
  },
  {
    'id': '2482',
    'nome': 'Magalhães Barata',
    'estado': 'PA'
  },
  {
    'id': '2483',
    'nome': 'Marabá',
    'estado': 'PA'
  },
  {
    'id': '2484',
    'nome': 'Maracanã',
    'estado': 'PA'
  },
  {
    'id': '2485',
    'nome': 'Marapanim',
    'estado': 'PA'
  },
  {
    'id': '2486',
    'nome': 'Marituba',
    'estado': 'PA'
  },
  {
    'id': '2487',
    'nome': 'Medicilândia',
    'estado': 'PA'
  },
  {
    'id': '2488',
    'nome': 'Melgaço',
    'estado': 'PA'
  },
  {
    'id': '2489',
    'nome': 'Mocajuba',
    'estado': 'PA'
  },
  {
    'id': '2490',
    'nome': 'Moju',
    'estado': 'PA'
  },
  {
    'id': '2491',
    'nome': 'Monte Alegre',
    'estado': 'PA'
  },
  {
    'id': '2492',
    'nome': 'Muaná',
    'estado': 'PA'
  },
  {
    'id': '2493',
    'nome': 'Nova Esperança do Piriá',
    'estado': 'PA'
  },
  {
    'id': '2494',
    'nome': 'Nova Ipixuna',
    'estado': 'PA'
  },
  {
    'id': '2495',
    'nome': 'Nova Timboteua',
    'estado': 'PA'
  },
  {
    'id': '2496',
    'nome': 'Novo Progresso',
    'estado': 'PA'
  },
  {
    'id': '2497',
    'nome': 'Novo Repartimento',
    'estado': 'PA'
  },
  {
    'id': '2498',
    'nome': 'Óbidos',
    'estado': 'PA'
  },
  {
    'id': '2499',
    'nome': 'Oeiras do Pará',
    'estado': 'PA'
  },
  {
    'id': '2500',
    'nome': 'Oriximiná',
    'estado': 'PA'
  },
  {
    'id': '2501',
    'nome': 'Ourém',
    'estado': 'PA'
  },
  {
    'id': '2502',
    'nome': 'Ourilândia do Norte',
    'estado': 'PA'
  },
  {
    'id': '2503',
    'nome': 'Pacajá',
    'estado': 'PA'
  },
  {
    'id': '2504',
    'nome': 'Palestina do Pará',
    'estado': 'PA'
  },
  {
    'id': '2505',
    'nome': 'Paragominas',
    'estado': 'PA'
  },
  {
    'id': '2506',
    'nome': 'Parauapebas',
    'estado': 'PA'
  },
  {
    'id': '2507',
    'nome': 'Pau d`Arco',
    'estado': 'PA'
  },
  {
    'id': '2508',
    'nome': 'Peixe-Boi',
    'estado': 'PA'
  },
  {
    'id': '2509',
    'nome': 'Piçarra',
    'estado': 'PA'
  },
  {
    'id': '2510',
    'nome': 'Placas',
    'estado': 'PA'
  },
  {
    'id': '2511',
    'nome': 'Ponta de Pedras',
    'estado': 'PA'
  },
  {
    'id': '2512',
    'nome': 'Portel',
    'estado': 'PA'
  },
  {
    'id': '2513',
    'nome': 'Porto de Moz',
    'estado': 'PA'
  },
  {
    'id': '2514',
    'nome': 'Prainha',
    'estado': 'PA'
  },
  {
    'id': '2515',
    'nome': 'Primavera',
    'estado': 'PA'
  },
  {
    'id': '2516',
    'nome': 'Quatipuru',
    'estado': 'PA'
  },
  {
    'id': '2517',
    'nome': 'Redenção',
    'estado': 'PA'
  },
  {
    'id': '2518',
    'nome': 'Rio Maria',
    'estado': 'PA'
  },
  {
    'id': '2519',
    'nome': 'Rondon do Pará',
    'estado': 'PA'
  },
  {
    'id': '2520',
    'nome': 'Rurópolis',
    'estado': 'PA'
  },
  {
    'id': '2521',
    'nome': 'Salinópolis',
    'estado': 'PA'
  },
  {
    'id': '2522',
    'nome': 'Salvaterra',
    'estado': 'PA'
  },
  {
    'id': '2523',
    'nome': 'Santa Bárbara do Pará',
    'estado': 'PA'
  },
  {
    'id': '2524',
    'nome': 'Santa Cruz do Arari',
    'estado': 'PA'
  },
  {
    'id': '2525',
    'nome': 'Santa Isabel do Pará',
    'estado': 'PA'
  },
  {
    'id': '2526',
    'nome': 'Santa Luzia do Pará',
    'estado': 'PA'
  },
  {
    'id': '2527',
    'nome': 'Santa Maria das Barreiras',
    'estado': 'PA'
  },
  {
    'id': '2528',
    'nome': 'Santa Maria do Pará',
    'estado': 'PA'
  },
  {
    'id': '2529',
    'nome': 'Santana do Araguaia',
    'estado': 'PA'
  },
  {
    'id': '2530',
    'nome': 'Santarém',
    'estado': 'PA'
  },
  {
    'id': '2531',
    'nome': 'Santarém Novo',
    'estado': 'PA'
  },
  {
    'id': '2532',
    'nome': 'Santo Antônio do Tauá',
    'estado': 'PA'
  },
  {
    'id': '2533',
    'nome': 'São Caetano de Odivelas',
    'estado': 'PA'
  },
  {
    'id': '2534',
    'nome': 'São Domingos do Araguaia',
    'estado': 'PA'
  },
  {
    'id': '2535',
    'nome': 'São Domingos do Capim',
    'estado': 'PA'
  },
  {
    'id': '2536',
    'nome': 'São Félix do Xingu',
    'estado': 'PA'
  },
  {
    'id': '2537',
    'nome': 'São Francisco do Pará',
    'estado': 'PA'
  },
  {
    'id': '2538',
    'nome': 'São Geraldo do Araguaia',
    'estado': 'PA'
  },
  {
    'id': '2539',
    'nome': 'São João da Ponta',
    'estado': 'PA'
  },
  {
    'id': '2540',
    'nome': 'São João de Pirabas',
    'estado': 'PA'
  },
  {
    'id': '2541',
    'nome': 'São João do Araguaia',
    'estado': 'PA'
  },
  {
    'id': '2542',
    'nome': 'São Miguel do Guamá',
    'estado': 'PA'
  },
  {
    'id': '2543',
    'nome': 'São Sebastião da Boa Vista',
    'estado': 'PA'
  },
  {
    'id': '2544',
    'nome': 'Sapucaia',
    'estado': 'PA'
  },
  {
    'id': '2545',
    'nome': 'Senador José Porfírio',
    'estado': 'PA'
  },
  {
    'id': '2546',
    'nome': 'Soure',
    'estado': 'PA'
  },
  {
    'id': '2547',
    'nome': 'Tailândia',
    'estado': 'PA'
  },
  {
    'id': '2548',
    'nome': 'Terra Alta',
    'estado': 'PA'
  },
  {
    'id': '2549',
    'nome': 'Terra Santa',
    'estado': 'PA'
  },
  {
    'id': '2550',
    'nome': 'Tomé-Açu',
    'estado': 'PA'
  },
  {
    'id': '2551',
    'nome': 'Tracuateua',
    'estado': 'PA'
  },
  {
    'id': '2552',
    'nome': 'Trairão',
    'estado': 'PA'
  },
  {
    'id': '2553',
    'nome': 'Tucumã',
    'estado': 'PA'
  },
  {
    'id': '2554',
    'nome': 'Tucuruí',
    'estado': 'PA'
  },
  {
    'id': '2555',
    'nome': 'Ulianópolis',
    'estado': 'PA'
  },
  {
    'id': '2556',
    'nome': 'Uruará',
    'estado': 'PA'
  },
  {
    'id': '2557',
    'nome': 'Vigia',
    'estado': 'PA'
  },
  {
    'id': '2558',
    'nome': 'Viseu',
    'estado': 'PA'
  },
  {
    'id': '2559',
    'nome': 'Vitória do Xingu',
    'estado': 'PA'
  },
  {
    'id': '2560',
    'nome': 'Xinguara',
    'estado': 'PA'
  },
  {
    'id': '2561',
    'nome': 'Água Branca',
    'estado': 'PB'
  },
  {
    'id': '2562',
    'nome': 'Aguiar',
    'estado': 'PB'
  },
  {
    'id': '2563',
    'nome': 'Alagoa Grande',
    'estado': 'PB'
  },
  {
    'id': '2564',
    'nome': 'Alagoa Nova',
    'estado': 'PB'
  },
  {
    'id': '2565',
    'nome': 'Alagoinha',
    'estado': 'PB'
  },
  {
    'id': '2566',
    'nome': 'Alcantil',
    'estado': 'PB'
  },
  {
    'id': '2567',
    'nome': 'Algodão de Jandaíra',
    'estado': 'PB'
  },
  {
    'id': '2568',
    'nome': 'Alhandra',
    'estado': 'PB'
  },
  {
    'id': '2569',
    'nome': 'Amparo',
    'estado': 'PB'
  },
  {
    'id': '2570',
    'nome': 'Aparecida',
    'estado': 'PB'
  },
  {
    'id': '2571',
    'nome': 'Araçagi',
    'estado': 'PB'
  },
  {
    'id': '2572',
    'nome': 'Arara',
    'estado': 'PB'
  },
  {
    'id': '2573',
    'nome': 'Araruna',
    'estado': 'PB'
  },
  {
    'id': '2574',
    'nome': 'Areia',
    'estado': 'PB'
  },
  {
    'id': '2575',
    'nome': 'Areia de Baraúnas',
    'estado': 'PB'
  },
  {
    'id': '2576',
    'nome': 'Areial',
    'estado': 'PB'
  },
  {
    'id': '2577',
    'nome': 'Aroeiras',
    'estado': 'PB'
  },
  {
    'id': '2578',
    'nome': 'Assunção',
    'estado': 'PB'
  },
  {
    'id': '2579',
    'nome': 'Baía da Traição',
    'estado': 'PB'
  },
  {
    'id': '2580',
    'nome': 'Bananeiras',
    'estado': 'PB'
  },
  {
    'id': '2581',
    'nome': 'Baraúna',
    'estado': 'PB'
  },
  {
    'id': '2582',
    'nome': 'Barra de Santa Rosa',
    'estado': 'PB'
  },
  {
    'id': '2583',
    'nome': 'Barra de Santana',
    'estado': 'PB'
  },
  {
    'id': '2584',
    'nome': 'Barra de São Miguel',
    'estado': 'PB'
  },
  {
    'id': '2585',
    'nome': 'Bayeux',
    'estado': 'PB'
  },
  {
    'id': '2586',
    'nome': 'Belém',
    'estado': 'PB'
  },
  {
    'id': '2587',
    'nome': 'Belém do Brejo do Cruz',
    'estado': 'PB'
  },
  {
    'id': '2588',
    'nome': 'Bernardino Batista',
    'estado': 'PB'
  },
  {
    'id': '2589',
    'nome': 'Boa Ventura',
    'estado': 'PB'
  },
  {
    'id': '2590',
    'nome': 'Boa Vista',
    'estado': 'PB'
  },
  {
    'id': '2591',
    'nome': 'Bom Jesus',
    'estado': 'PB'
  },
  {
    'id': '2592',
    'nome': 'Bom Sucesso',
    'estado': 'PB'
  },
  {
    'id': '2593',
    'nome': 'Bonito de Santa Fé',
    'estado': 'PB'
  },
  {
    'id': '2594',
    'nome': 'Boqueirão',
    'estado': 'PB'
  },
  {
    'id': '2595',
    'nome': 'Borborema',
    'estado': 'PB'
  },
  {
    'id': '2596',
    'nome': 'Brejo do Cruz',
    'estado': 'PB'
  },
  {
    'id': '2597',
    'nome': 'Brejo dos Santos',
    'estado': 'PB'
  },
  {
    'id': '2598',
    'nome': 'Caaporã',
    'estado': 'PB'
  },
  {
    'id': '2599',
    'nome': 'Cabaceiras',
    'estado': 'PB'
  },
  {
    'id': '2600',
    'nome': 'Cabedelo',
    'estado': 'PB'
  },
  {
    'id': '2601',
    'nome': 'Cachoeira dos Índios',
    'estado': 'PB'
  },
  {
    'id': '2602',
    'nome': 'Cacimba de Areia',
    'estado': 'PB'
  },
  {
    'id': '2603',
    'nome': 'Cacimba de Dentro',
    'estado': 'PB'
  },
  {
    'id': '2604',
    'nome': 'Cacimbas',
    'estado': 'PB'
  },
  {
    'id': '2605',
    'nome': 'Caiçara',
    'estado': 'PB'
  },
  {
    'id': '2606',
    'nome': 'Cajazeiras',
    'estado': 'PB'
  },
  {
    'id': '2607',
    'nome': 'Cajazeirinhas',
    'estado': 'PB'
  },
  {
    'id': '2608',
    'nome': 'Caldas Brandão',
    'estado': 'PB'
  },
  {
    'id': '2609',
    'nome': 'Camalaú',
    'estado': 'PB'
  },
  {
    'id': '2610',
    'nome': 'Campina Grande',
    'estado': 'PB'
  },
  {
    'id': '2611',
    'nome': 'Campo de Santana',
    'estado': 'PB'
  },
  {
    'id': '2612',
    'nome': 'Capim',
    'estado': 'PB'
  },
  {
    'id': '2613',
    'nome': 'Caraúbas',
    'estado': 'PB'
  },
  {
    'id': '2614',
    'nome': 'Carrapateira',
    'estado': 'PB'
  },
  {
    'id': '2615',
    'nome': 'Casserengue',
    'estado': 'PB'
  },
  {
    'id': '2616',
    'nome': 'Catingueira',
    'estado': 'PB'
  },
  {
    'id': '2617',
    'nome': 'Catolé do Rocha',
    'estado': 'PB'
  },
  {
    'id': '2618',
    'nome': 'Caturité',
    'estado': 'PB'
  },
  {
    'id': '2619',
    'nome': 'Conceição',
    'estado': 'PB'
  },
  {
    'id': '2620',
    'nome': 'Condado',
    'estado': 'PB'
  },
  {
    'id': '2621',
    'nome': 'Conde',
    'estado': 'PB'
  },
  {
    'id': '2622',
    'nome': 'Congo',
    'estado': 'PB'
  },
  {
    'id': '2623',
    'nome': 'Coremas',
    'estado': 'PB'
  },
  {
    'id': '2624',
    'nome': 'Coxixola',
    'estado': 'PB'
  },
  {
    'id': '2625',
    'nome': 'Cruz do Espírito Santo',
    'estado': 'PB'
  },
  {
    'id': '2626',
    'nome': 'Cubati',
    'estado': 'PB'
  },
  {
    'id': '2627',
    'nome': 'Cuité',
    'estado': 'PB'
  },
  {
    'id': '2628',
    'nome': 'Cuité de Mamanguape',
    'estado': 'PB'
  },
  {
    'id': '2629',
    'nome': 'Cuitegi',
    'estado': 'PB'
  },
  {
    'id': '2630',
    'nome': 'Curral de Cima',
    'estado': 'PB'
  },
  {
    'id': '2631',
    'nome': 'Curral Velho',
    'estado': 'PB'
  },
  {
    'id': '2632',
    'nome': 'Damião',
    'estado': 'PB'
  },
  {
    'id': '2633',
    'nome': 'Desterro',
    'estado': 'PB'
  },
  {
    'id': '2634',
    'nome': 'Diamante',
    'estado': 'PB'
  },
  {
    'id': '2635',
    'nome': 'Dona Inês',
    'estado': 'PB'
  },
  {
    'id': '2636',
    'nome': 'Duas Estradas',
    'estado': 'PB'
  },
  {
    'id': '2637',
    'nome': 'Emas',
    'estado': 'PB'
  },
  {
    'id': '2638',
    'nome': 'Esperança',
    'estado': 'PB'
  },
  {
    'id': '2639',
    'nome': 'Fagundes',
    'estado': 'PB'
  },
  {
    'id': '2640',
    'nome': 'Frei Martinho',
    'estado': 'PB'
  },
  {
    'id': '2641',
    'nome': 'Gado Bravo',
    'estado': 'PB'
  },
  {
    'id': '2642',
    'nome': 'Guarabira',
    'estado': 'PB'
  },
  {
    'id': '2643',
    'nome': 'Gurinhém',
    'estado': 'PB'
  },
  {
    'id': '2644',
    'nome': 'Gurjão',
    'estado': 'PB'
  },
  {
    'id': '2645',
    'nome': 'Ibiara',
    'estado': 'PB'
  },
  {
    'id': '2646',
    'nome': 'Igaracy',
    'estado': 'PB'
  },
  {
    'id': '2647',
    'nome': 'Imaculada',
    'estado': 'PB'
  },
  {
    'id': '2648',
    'nome': 'Ingá',
    'estado': 'PB'
  },
  {
    'id': '2649',
    'nome': 'Itabaiana',
    'estado': 'PB'
  },
  {
    'id': '2650',
    'nome': 'Itaporanga',
    'estado': 'PB'
  },
  {
    'id': '2651',
    'nome': 'Itapororoca',
    'estado': 'PB'
  },
  {
    'id': '2652',
    'nome': 'Itatuba',
    'estado': 'PB'
  },
  {
    'id': '2653',
    'nome': 'Jacaraú',
    'estado': 'PB'
  },
  {
    'id': '2654',
    'nome': 'Jericó',
    'estado': 'PB'
  },
  {
    'id': '2655',
    'nome': 'João Pessoa',
    'estado': 'PB'
  },
  {
    'id': '2656',
    'nome': 'Juarez Távora',
    'estado': 'PB'
  },
  {
    'id': '2657',
    'nome': 'Juazeirinho',
    'estado': 'PB'
  },
  {
    'id': '2658',
    'nome': 'Junco do Seridó',
    'estado': 'PB'
  },
  {
    'id': '2659',
    'nome': 'Juripiranga',
    'estado': 'PB'
  },
  {
    'id': '2660',
    'nome': 'Juru',
    'estado': 'PB'
  },
  {
    'id': '2661',
    'nome': 'Lagoa',
    'estado': 'PB'
  },
  {
    'id': '2662',
    'nome': 'Lagoa de Dentro',
    'estado': 'PB'
  },
  {
    'id': '2663',
    'nome': 'Lagoa Seca',
    'estado': 'PB'
  },
  {
    'id': '2664',
    'nome': 'Lastro',
    'estado': 'PB'
  },
  {
    'id': '2665',
    'nome': 'Livramento',
    'estado': 'PB'
  },
  {
    'id': '2666',
    'nome': 'Logradouro',
    'estado': 'PB'
  },
  {
    'id': '2667',
    'nome': 'Lucena',
    'estado': 'PB'
  },
  {
    'id': '2668',
    'nome': 'Mãe d`Água',
    'estado': 'PB'
  },
  {
    'id': '2669',
    'nome': 'Malta',
    'estado': 'PB'
  },
  {
    'id': '2670',
    'nome': 'Mamanguape',
    'estado': 'PB'
  },
  {
    'id': '2671',
    'nome': 'Manaíra',
    'estado': 'PB'
  },
  {
    'id': '2672',
    'nome': 'Marcação',
    'estado': 'PB'
  },
  {
    'id': '2673',
    'nome': 'Mari',
    'estado': 'PB'
  },
  {
    'id': '2674',
    'nome': 'Marizópolis',
    'estado': 'PB'
  },
  {
    'id': '2675',
    'nome': 'Massaranduba',
    'estado': 'PB'
  },
  {
    'id': '2676',
    'nome': 'Mataraca',
    'estado': 'PB'
  },
  {
    'id': '2677',
    'nome': 'Matinhas',
    'estado': 'PB'
  },
  {
    'id': '2678',
    'nome': 'Mato Grosso',
    'estado': 'PB'
  },
  {
    'id': '2679',
    'nome': 'Maturéia',
    'estado': 'PB'
  },
  {
    'id': '2680',
    'nome': 'Mogeiro',
    'estado': 'PB'
  },
  {
    'id': '2681',
    'nome': 'Montadas',
    'estado': 'PB'
  },
  {
    'id': '2682',
    'nome': 'Monte Horebe',
    'estado': 'PB'
  },
  {
    'id': '2683',
    'nome': 'Monteiro',
    'estado': 'PB'
  },
  {
    'id': '2684',
    'nome': 'Mulungu',
    'estado': 'PB'
  },
  {
    'id': '2685',
    'nome': 'Natuba',
    'estado': 'PB'
  },
  {
    'id': '2686',
    'nome': 'Nazarezinho',
    'estado': 'PB'
  },
  {
    'id': '2687',
    'nome': 'Nova Floresta',
    'estado': 'PB'
  },
  {
    'id': '2688',
    'nome': 'Nova Olinda',
    'estado': 'PB'
  },
  {
    'id': '2689',
    'nome': 'Nova Palmeira',
    'estado': 'PB'
  },
  {
    'id': '2690',
    'nome': 'Olho d`Água',
    'estado': 'PB'
  },
  {
    'id': '2691',
    'nome': 'Olivedos',
    'estado': 'PB'
  },
  {
    'id': '2692',
    'nome': 'Ouro Velho',
    'estado': 'PB'
  },
  {
    'id': '2693',
    'nome': 'Parari',
    'estado': 'PB'
  },
  {
    'id': '2694',
    'nome': 'Passagem',
    'estado': 'PB'
  },
  {
    'id': '2695',
    'nome': 'Patos',
    'estado': 'PB'
  },
  {
    'id': '2696',
    'nome': 'Paulista',
    'estado': 'PB'
  },
  {
    'id': '2697',
    'nome': 'Pedra Branca',
    'estado': 'PB'
  },
  {
    'id': '2698',
    'nome': 'Pedra Lavrada',
    'estado': 'PB'
  },
  {
    'id': '2699',
    'nome': 'Pedras de Fogo',
    'estado': 'PB'
  },
  {
    'id': '2700',
    'nome': 'Pedro Régis',
    'estado': 'PB'
  },
  {
    'id': '2701',
    'nome': 'Piancó',
    'estado': 'PB'
  },
  {
    'id': '2702',
    'nome': 'Picuí',
    'estado': 'PB'
  },
  {
    'id': '2703',
    'nome': 'Pilar',
    'estado': 'PB'
  },
  {
    'id': '2704',
    'nome': 'Pilões',
    'estado': 'PB'
  },
  {
    'id': '2705',
    'nome': 'Pilõezinhos',
    'estado': 'PB'
  },
  {
    'id': '2706',
    'nome': 'Pirpirituba',
    'estado': 'PB'
  },
  {
    'id': '2707',
    'nome': 'Pitimbu',
    'estado': 'PB'
  },
  {
    'id': '2708',
    'nome': 'Pocinhos',
    'estado': 'PB'
  },
  {
    'id': '2709',
    'nome': 'Poço Dantas',
    'estado': 'PB'
  },
  {
    'id': '2710',
    'nome': 'Poço de José de Moura',
    'estado': 'PB'
  },
  {
    'id': '2711',
    'nome': 'Pombal',
    'estado': 'PB'
  },
  {
    'id': '2712',
    'nome': 'Prata',
    'estado': 'PB'
  },
  {
    'id': '2713',
    'nome': 'Princesa Isabel',
    'estado': 'PB'
  },
  {
    'id': '2714',
    'nome': 'Puxinanã',
    'estado': 'PB'
  },
  {
    'id': '2715',
    'nome': 'Queimadas',
    'estado': 'PB'
  },
  {
    'id': '2716',
    'nome': 'Quixabá',
    'estado': 'PB'
  },
  {
    'id': '2717',
    'nome': 'Remígio',
    'estado': 'PB'
  },
  {
    'id': '2718',
    'nome': 'Riachão',
    'estado': 'PB'
  },
  {
    'id': '2719',
    'nome': 'Riachão do Bacamarte',
    'estado': 'PB'
  },
  {
    'id': '2720',
    'nome': 'Riachão do Poço',
    'estado': 'PB'
  },
  {
    'id': '2721',
    'nome': 'Riacho de Santo Antônio',
    'estado': 'PB'
  },
  {
    'id': '2722',
    'nome': 'Riacho dos Cavalos',
    'estado': 'PB'
  },
  {
    'id': '2723',
    'nome': 'Rio Tinto',
    'estado': 'PB'
  },
  {
    'id': '2724',
    'nome': 'Salgadinho',
    'estado': 'PB'
  },
  {
    'id': '2725',
    'nome': 'Salgado de São Félix',
    'estado': 'PB'
  },
  {
    'id': '2726',
    'nome': 'Santa Cecília',
    'estado': 'PB'
  },
  {
    'id': '2727',
    'nome': 'Santa Cruz',
    'estado': 'PB'
  },
  {
    'id': '2728',
    'nome': 'Santa Helena',
    'estado': 'PB'
  },
  {
    'id': '2729',
    'nome': 'Santa Inês',
    'estado': 'PB'
  },
  {
    'id': '2730',
    'nome': 'Santa Luzia',
    'estado': 'PB'
  },
  {
    'id': '2731',
    'nome': 'Santa Rita',
    'estado': 'PB'
  },
  {
    'id': '2732',
    'nome': 'Santa Teresinha',
    'estado': 'PB'
  },
  {
    'id': '2733',
    'nome': 'Santana de Mangueira',
    'estado': 'PB'
  },
  {
    'id': '2734',
    'nome': 'Santana dos Garrotes',
    'estado': 'PB'
  },
  {
    'id': '2735',
    'nome': 'Santarém',
    'estado': 'PB'
  },
  {
    'id': '2736',
    'nome': 'Santo André',
    'estado': 'PB'
  },
  {
    'id': '2737',
    'nome': 'São Bentinho',
    'estado': 'PB'
  },
  {
    'id': '2738',
    'nome': 'São Bento',
    'estado': 'PB'
  },
  {
    'id': '2739',
    'nome': 'São Domingos de Pombal',
    'estado': 'PB'
  },
  {
    'id': '2740',
    'nome': 'São Domingos do Cariri',
    'estado': 'PB'
  },
  {
    'id': '2741',
    'nome': 'São Francisco',
    'estado': 'PB'
  },
  {
    'id': '2742',
    'nome': 'São João do Cariri',
    'estado': 'PB'
  },
  {
    'id': '2743',
    'nome': 'São João do Rio do Peixe',
    'estado': 'PB'
  },
  {
    'id': '2744',
    'nome': 'São João do Tigre',
    'estado': 'PB'
  },
  {
    'id': '2745',
    'nome': 'São José da Lagoa Tapada',
    'estado': 'PB'
  },
  {
    'id': '2746',
    'nome': 'São José de Caiana',
    'estado': 'PB'
  },
  {
    'id': '2747',
    'nome': 'São José de Espinharas',
    'estado': 'PB'
  },
  {
    'id': '2748',
    'nome': 'São José de Piranhas',
    'estado': 'PB'
  },
  {
    'id': '2749',
    'nome': 'São José de Princesa',
    'estado': 'PB'
  },
  {
    'id': '2750',
    'nome': 'São José do Bonfim',
    'estado': 'PB'
  },
  {
    'id': '2751',
    'nome': 'São José do Brejo do Cruz',
    'estado': 'PB'
  },
  {
    'id': '2752',
    'nome': 'São José do Sabugi',
    'estado': 'PB'
  },
  {
    'id': '2753',
    'nome': 'São José dos Cordeiros',
    'estado': 'PB'
  },
  {
    'id': '2754',
    'nome': 'São José dos Ramos',
    'estado': 'PB'
  },
  {
    'id': '2755',
    'nome': 'São Mamede',
    'estado': 'PB'
  },
  {
    'id': '2756',
    'nome': 'São Miguel de Taipu',
    'estado': 'PB'
  },
  {
    'id': '2757',
    'nome': 'São Sebastião de Lagoa de Roça',
    'estado': 'PB'
  },
  {
    'id': '2758',
    'nome': 'São Sebastião do Umbuzeiro',
    'estado': 'PB'
  },
  {
    'id': '2759',
    'nome': 'Sapé',
    'estado': 'PB'
  },
  {
    'id': '2760',
    'nome': 'Seridó',
    'estado': 'PB'
  },
  {
    'id': '2761',
    'nome': 'Serra Branca',
    'estado': 'PB'
  },
  {
    'id': '2762',
    'nome': 'Serra da Raiz',
    'estado': 'PB'
  },
  {
    'id': '2763',
    'nome': 'Serra Grande',
    'estado': 'PB'
  },
  {
    'id': '2764',
    'nome': 'Serra Redonda',
    'estado': 'PB'
  },
  {
    'id': '2765',
    'nome': 'Serraria',
    'estado': 'PB'
  },
  {
    'id': '2766',
    'nome': 'Sertãozinho',
    'estado': 'PB'
  },
  {
    'id': '2767',
    'nome': 'Sobrado',
    'estado': 'PB'
  },
  {
    'id': '2768',
    'nome': 'Solânea',
    'estado': 'PB'
  },
  {
    'id': '2769',
    'nome': 'Soledade',
    'estado': 'PB'
  },
  {
    'id': '2770',
    'nome': 'Sossêgo',
    'estado': 'PB'
  },
  {
    'id': '2771',
    'nome': 'Sousa',
    'estado': 'PB'
  },
  {
    'id': '2772',
    'nome': 'Sumé',
    'estado': 'PB'
  },
  {
    'id': '2773',
    'nome': 'Taperoá',
    'estado': 'PB'
  },
  {
    'id': '2774',
    'nome': 'Tavares',
    'estado': 'PB'
  },
  {
    'id': '2775',
    'nome': 'Teixeira',
    'estado': 'PB'
  },
  {
    'id': '2776',
    'nome': 'Tenório',
    'estado': 'PB'
  },
  {
    'id': '2777',
    'nome': 'Triunfo',
    'estado': 'PB'
  },
  {
    'id': '2778',
    'nome': 'Uiraúna',
    'estado': 'PB'
  },
  {
    'id': '2779',
    'nome': 'Umbuzeiro',
    'estado': 'PB'
  },
  {
    'id': '2780',
    'nome': 'Várzea',
    'estado': 'PB'
  },
  {
    'id': '2781',
    'nome': 'Vieirópolis',
    'estado': 'PB'
  },
  {
    'id': '2782',
    'nome': 'Vista Serrana',
    'estado': 'PB'
  },
  {
    'id': '2783',
    'nome': 'Zabelê',
    'estado': 'PB'
  },
  {
    'id': '2784',
    'nome': 'Abatiá',
    'estado': 'PR'
  },
  {
    'id': '2785',
    'nome': 'Adrianópolis',
    'estado': 'PR'
  },
  {
    'id': '2786',
    'nome': 'Agudos do Sul',
    'estado': 'PR'
  },
  {
    'id': '2787',
    'nome': 'Almirante Tamandaré',
    'estado': 'PR'
  },
  {
    'id': '2788',
    'nome': 'Altamira do Paraná',
    'estado': 'PR'
  },
  {
    'id': '2789',
    'nome': 'Alto Paraíso',
    'estado': 'PR'
  },
  {
    'id': '2790',
    'nome': 'Alto Paraná',
    'estado': 'PR'
  },
  {
    'id': '2791',
    'nome': 'Alto Piquiri',
    'estado': 'PR'
  },
  {
    'id': '2792',
    'nome': 'Altônia',
    'estado': 'PR'
  },
  {
    'id': '2793',
    'nome': 'Alvorada do Sul',
    'estado': 'PR'
  },
  {
    'id': '2794',
    'nome': 'Amaporã',
    'estado': 'PR'
  },
  {
    'id': '2795',
    'nome': 'Ampére',
    'estado': 'PR'
  },
  {
    'id': '2796',
    'nome': 'Anahy',
    'estado': 'PR'
  },
  {
    'id': '2797',
    'nome': 'Andirá',
    'estado': 'PR'
  },
  {
    'id': '2798',
    'nome': 'Ângulo',
    'estado': 'PR'
  },
  {
    'id': '2799',
    'nome': 'Antonina',
    'estado': 'PR'
  },
  {
    'id': '2800',
    'nome': 'Antônio Olinto',
    'estado': 'PR'
  },
  {
    'id': '2801',
    'nome': 'Apucarana',
    'estado': 'PR'
  },
  {
    'id': '2802',
    'nome': 'Arapongas',
    'estado': 'PR'
  },
  {
    'id': '2803',
    'nome': 'Arapoti',
    'estado': 'PR'
  },
  {
    'id': '2804',
    'nome': 'Arapuã',
    'estado': 'PR'
  },
  {
    'id': '2805',
    'nome': 'Araruna',
    'estado': 'PR'
  },
  {
    'id': '2806',
    'nome': 'Araucária',
    'estado': 'PR'
  },
  {
    'id': '2807',
    'nome': 'Ariranha do Ivaí',
    'estado': 'PR'
  },
  {
    'id': '2808',
    'nome': 'Assaí',
    'estado': 'PR'
  },
  {
    'id': '2809',
    'nome': 'Assis Chateaubriand',
    'estado': 'PR'
  },
  {
    'id': '2810',
    'nome': 'Astorga',
    'estado': 'PR'
  },
  {
    'id': '2811',
    'nome': 'Atalaia',
    'estado': 'PR'
  },
  {
    'id': '2812',
    'nome': 'Balsa Nova',
    'estado': 'PR'
  },
  {
    'id': '2813',
    'nome': 'Bandeirantes',
    'estado': 'PR'
  },
  {
    'id': '2814',
    'nome': 'Barbosa Ferraz',
    'estado': 'PR'
  },
  {
    'id': '2815',
    'nome': 'Barra do Jacaré',
    'estado': 'PR'
  },
  {
    'id': '2816',
    'nome': 'Barracão',
    'estado': 'PR'
  },
  {
    'id': '2817',
    'nome': 'Bela Vista da Caroba',
    'estado': 'PR'
  },
  {
    'id': '2818',
    'nome': 'Bela Vista do Paraíso',
    'estado': 'PR'
  },
  {
    'id': '2819',
    'nome': 'Bituruna',
    'estado': 'PR'
  },
  {
    'id': '2820',
    'nome': 'Boa Esperança',
    'estado': 'PR'
  },
  {
    'id': '2821',
    'nome': 'Boa Esperança do Iguaçu',
    'estado': 'PR'
  },
  {
    'id': '2822',
    'nome': 'Boa Ventura de São Roque',
    'estado': 'PR'
  },
  {
    'id': '2823',
    'nome': 'Boa Vista da Aparecida',
    'estado': 'PR'
  },
  {
    'id': '2824',
    'nome': 'Bocaiúva do Sul',
    'estado': 'PR'
  },
  {
    'id': '2825',
    'nome': 'Bom Jesus do Sul',
    'estado': 'PR'
  },
  {
    'id': '2826',
    'nome': 'Bom Sucesso',
    'estado': 'PR'
  },
  {
    'id': '2827',
    'nome': 'Bom Sucesso do Sul',
    'estado': 'PR'
  },
  {
    'id': '2828',
    'nome': 'Borrazópolis',
    'estado': 'PR'
  },
  {
    'id': '2829',
    'nome': 'Braganey',
    'estado': 'PR'
  },
  {
    'id': '2830',
    'nome': 'Brasilândia do Sul',
    'estado': 'PR'
  },
  {
    'id': '2831',
    'nome': 'Cafeara',
    'estado': 'PR'
  },
  {
    'id': '2832',
    'nome': 'Cafelândia',
    'estado': 'PR'
  },
  {
    'id': '2833',
    'nome': 'Cafezal do Sul',
    'estado': 'PR'
  },
  {
    'id': '2834',
    'nome': 'Califórnia',
    'estado': 'PR'
  },
  {
    'id': '2835',
    'nome': 'Cambará',
    'estado': 'PR'
  },
  {
    'id': '2836',
    'nome': 'Cambé',
    'estado': 'PR'
  },
  {
    'id': '2837',
    'nome': 'Cambira',
    'estado': 'PR'
  },
  {
    'id': '2838',
    'nome': 'Campina da Lagoa',
    'estado': 'PR'
  },
  {
    'id': '2839',
    'nome': 'Campina do Simão',
    'estado': 'PR'
  },
  {
    'id': '2840',
    'nome': 'Campina Grande do Sul',
    'estado': 'PR'
  },
  {
    'id': '2841',
    'nome': 'Campo Bonito',
    'estado': 'PR'
  },
  {
    'id': '2842',
    'nome': 'Campo do Tenente',
    'estado': 'PR'
  },
  {
    'id': '2843',
    'nome': 'Campo Largo',
    'estado': 'PR'
  },
  {
    'id': '2844',
    'nome': 'Campo Magro',
    'estado': 'PR'
  },
  {
    'id': '2845',
    'nome': 'Campo Mourão',
    'estado': 'PR'
  },
  {
    'id': '2846',
    'nome': 'Cândido de Abreu',
    'estado': 'PR'
  },
  {
    'id': '2847',
    'nome': 'Candói',
    'estado': 'PR'
  },
  {
    'id': '2848',
    'nome': 'Cantagalo',
    'estado': 'PR'
  },
  {
    'id': '2849',
    'nome': 'Capanema',
    'estado': 'PR'
  },
  {
    'id': '2850',
    'nome': 'Capitão Leônidas Marques',
    'estado': 'PR'
  },
  {
    'id': '2851',
    'nome': 'Carambeí',
    'estado': 'PR'
  },
  {
    'id': '2852',
    'nome': 'Carlópolis',
    'estado': 'PR'
  },
  {
    'id': '2853',
    'nome': 'Cascavel',
    'estado': 'PR'
  },
  {
    'id': '2854',
    'nome': 'Castro',
    'estado': 'PR'
  },
  {
    'id': '2855',
    'nome': 'Catanduvas',
    'estado': 'PR'
  },
  {
    'id': '2856',
    'nome': 'Centenário do Sul',
    'estado': 'PR'
  },
  {
    'id': '2857',
    'nome': 'Cerro Azul',
    'estado': 'PR'
  },
  {
    'id': '2858',
    'nome': 'Céu Azul',
    'estado': 'PR'
  },
  {
    'id': '2859',
    'nome': 'Chopinzinho',
    'estado': 'PR'
  },
  {
    'id': '2860',
    'nome': 'Cianorte',
    'estado': 'PR'
  },
  {
    'id': '2861',
    'nome': 'Cidade Gaúcha',
    'estado': 'PR'
  },
  {
    'id': '2862',
    'nome': 'Clevelândia',
    'estado': 'PR'
  },
  {
    'id': '2863',
    'nome': 'Colombo',
    'estado': 'PR'
  },
  {
    'id': '2864',
    'nome': 'Colorado',
    'estado': 'PR'
  },
  {
    'id': '2865',
    'nome': 'Congonhinhas',
    'estado': 'PR'
  },
  {
    'id': '2866',
    'nome': 'Conselheiro Mairinck',
    'estado': 'PR'
  },
  {
    'id': '2867',
    'nome': 'Contenda',
    'estado': 'PR'
  },
  {
    'id': '2868',
    'nome': 'Corbélia',
    'estado': 'PR'
  },
  {
    'id': '2869',
    'nome': 'Cornélio Procópio',
    'estado': 'PR'
  },
  {
    'id': '2870',
    'nome': 'Coronel Domingos Soares',
    'estado': 'PR'
  },
  {
    'id': '2871',
    'nome': 'Coronel Vivida',
    'estado': 'PR'
  },
  {
    'id': '2872',
    'nome': 'Corumbataí do Sul',
    'estado': 'PR'
  },
  {
    'id': '2873',
    'nome': 'Cruz Machado',
    'estado': 'PR'
  },
  {
    'id': '2874',
    'nome': 'Cruzeiro do Iguaçu',
    'estado': 'PR'
  },
  {
    'id': '2875',
    'nome': 'Cruzeiro do Oeste',
    'estado': 'PR'
  },
  {
    'id': '2876',
    'nome': 'Cruzeiro do Sul',
    'estado': 'PR'
  },
  {
    'id': '2877',
    'nome': 'Cruzmaltina',
    'estado': 'PR'
  },
  {
    'id': '2878',
    'nome': 'Curitiba',
    'estado': 'PR'
  },
  {
    'id': '2879',
    'nome': 'Curiúva',
    'estado': 'PR'
  },
  {
    'id': '2880',
    'nome': 'Diamante d`Oeste',
    'estado': 'PR'
  },
  {
    'id': '2881',
    'nome': 'Diamante do Norte',
    'estado': 'PR'
  },
  {
    'id': '2882',
    'nome': 'Diamante do Sul',
    'estado': 'PR'
  },
  {
    'id': '2883',
    'nome': 'Dois Vizinhos',
    'estado': 'PR'
  },
  {
    'id': '2884',
    'nome': 'Douradina',
    'estado': 'PR'
  },
  {
    'id': '2885',
    'nome': 'Doutor Camargo',
    'estado': 'PR'
  },
  {
    'id': '2886',
    'nome': 'Doutor Ulysses',
    'estado': 'PR'
  },
  {
    'id': '2887',
    'nome': 'Enéas Marques',
    'estado': 'PR'
  },
  {
    'id': '2888',
    'nome': 'Engenheiro Beltrão',
    'estado': 'PR'
  },
  {
    'id': '2889',
    'nome': 'Entre Rios do Oeste',
    'estado': 'PR'
  },
  {
    'id': '2890',
    'nome': 'Esperança Nova',
    'estado': 'PR'
  },
  {
    'id': '2891',
    'nome': 'Espigão Alto do Iguaçu',
    'estado': 'PR'
  },
  {
    'id': '2892',
    'nome': 'Farol',
    'estado': 'PR'
  },
  {
    'id': '2893',
    'nome': 'Faxinal',
    'estado': 'PR'
  },
  {
    'id': '2894',
    'nome': 'Fazenda Rio Grande',
    'estado': 'PR'
  },
  {
    'id': '2895',
    'nome': 'Fênix',
    'estado': 'PR'
  },
  {
    'id': '2896',
    'nome': 'Fernandes Pinheiro',
    'estado': 'PR'
  },
  {
    'id': '2897',
    'nome': 'Figueira',
    'estado': 'PR'
  },
  {
    'id': '2898',
    'nome': 'Flor da Serra do Sul',
    'estado': 'PR'
  },
  {
    'id': '2899',
    'nome': 'Floraí',
    'estado': 'PR'
  },
  {
    'id': '2900',
    'nome': 'Floresta',
    'estado': 'PR'
  },
  {
    'id': '2901',
    'nome': 'Florestópolis',
    'estado': 'PR'
  },
  {
    'id': '2902',
    'nome': 'Flórida',
    'estado': 'PR'
  },
  {
    'id': '2903',
    'nome': 'Formosa do Oeste',
    'estado': 'PR'
  },
  {
    'id': '2904',
    'nome': 'Foz do Iguaçu',
    'estado': 'PR'
  },
  {
    'id': '2905',
    'nome': 'Foz do Jordão',
    'estado': 'PR'
  },
  {
    'id': '2906',
    'nome': 'Francisco Alves',
    'estado': 'PR'
  },
  {
    'id': '2907',
    'nome': 'Francisco Beltrão',
    'estado': 'PR'
  },
  {
    'id': '2908',
    'nome': 'General Carneiro',
    'estado': 'PR'
  },
  {
    'id': '2909',
    'nome': 'Godoy Moreira',
    'estado': 'PR'
  },
  {
    'id': '2910',
    'nome': 'Goioerê',
    'estado': 'PR'
  },
  {
    'id': '2911',
    'nome': 'Goioxim',
    'estado': 'PR'
  },
  {
    'id': '2912',
    'nome': 'Grandes Rios',
    'estado': 'PR'
  },
  {
    'id': '2913',
    'nome': 'Guaíra',
    'estado': 'PR'
  },
  {
    'id': '2914',
    'nome': 'Guairaçá',
    'estado': 'PR'
  },
  {
    'id': '2915',
    'nome': 'Guamiranga',
    'estado': 'PR'
  },
  {
    'id': '2916',
    'nome': 'Guapirama',
    'estado': 'PR'
  },
  {
    'id': '2917',
    'nome': 'Guaporema',
    'estado': 'PR'
  },
  {
    'id': '2918',
    'nome': 'Guaraci',
    'estado': 'PR'
  },
  {
    'id': '2919',
    'nome': 'Guaraniaçu',
    'estado': 'PR'
  },
  {
    'id': '2920',
    'nome': 'Guarapuava',
    'estado': 'PR'
  },
  {
    'id': '2921',
    'nome': 'Guaraqueçaba',
    'estado': 'PR'
  },
  {
    'id': '2922',
    'nome': 'Guaratuba',
    'estado': 'PR'
  },
  {
    'id': '2923',
    'nome': 'Honório Serpa',
    'estado': 'PR'
  },
  {
    'id': '2924',
    'nome': 'Ibaiti',
    'estado': 'PR'
  },
  {
    'id': '2925',
    'nome': 'Ibema',
    'estado': 'PR'
  },
  {
    'id': '2926',
    'nome': 'Ibiporã',
    'estado': 'PR'
  },
  {
    'id': '2927',
    'nome': 'Icaraíma',
    'estado': 'PR'
  },
  {
    'id': '2928',
    'nome': 'Iguaraçu',
    'estado': 'PR'
  },
  {
    'id': '2929',
    'nome': 'Iguatu',
    'estado': 'PR'
  },
  {
    'id': '2930',
    'nome': 'Imbaú',
    'estado': 'PR'
  },
  {
    'id': '2931',
    'nome': 'Imbituva',
    'estado': 'PR'
  },
  {
    'id': '2932',
    'nome': 'Inácio Martins',
    'estado': 'PR'
  },
  {
    'id': '2933',
    'nome': 'Inajá',
    'estado': 'PR'
  },
  {
    'id': '2934',
    'nome': 'Indianópolis',
    'estado': 'PR'
  },
  {
    'id': '2935',
    'nome': 'Ipiranga',
    'estado': 'PR'
  },
  {
    'id': '2936',
    'nome': 'Iporã',
    'estado': 'PR'
  },
  {
    'id': '2937',
    'nome': 'Iracema do Oeste',
    'estado': 'PR'
  },
  {
    'id': '2938',
    'nome': 'Irati',
    'estado': 'PR'
  },
  {
    'id': '2939',
    'nome': 'Iretama',
    'estado': 'PR'
  },
  {
    'id': '2940',
    'nome': 'Itaguajé',
    'estado': 'PR'
  },
  {
    'id': '2941',
    'nome': 'Itaipulândia',
    'estado': 'PR'
  },
  {
    'id': '2942',
    'nome': 'Itambaracá',
    'estado': 'PR'
  },
  {
    'id': '2943',
    'nome': 'Itambé',
    'estado': 'PR'
  },
  {
    'id': '2944',
    'nome': 'Itapejara d`Oeste',
    'estado': 'PR'
  },
  {
    'id': '2945',
    'nome': 'Itaperuçu',
    'estado': 'PR'
  },
  {
    'id': '2946',
    'nome': 'Itaúna do Sul',
    'estado': 'PR'
  },
  {
    'id': '2947',
    'nome': 'Ivaí',
    'estado': 'PR'
  },
  {
    'id': '2948',
    'nome': 'Ivaiporã',
    'estado': 'PR'
  },
  {
    'id': '2949',
    'nome': 'Ivaté',
    'estado': 'PR'
  },
  {
    'id': '2950',
    'nome': 'Ivatuba',
    'estado': 'PR'
  },
  {
    'id': '2951',
    'nome': 'Jaboti',
    'estado': 'PR'
  },
  {
    'id': '2952',
    'nome': 'Jacarezinho',
    'estado': 'PR'
  },
  {
    'id': '2953',
    'nome': 'Jaguapitã',
    'estado': 'PR'
  },
  {
    'id': '2954',
    'nome': 'Jaguariaíva',
    'estado': 'PR'
  },
  {
    'id': '2955',
    'nome': 'Jandaia do Sul',
    'estado': 'PR'
  },
  {
    'id': '2956',
    'nome': 'Janiópolis',
    'estado': 'PR'
  },
  {
    'id': '2957',
    'nome': 'Japira',
    'estado': 'PR'
  },
  {
    'id': '2958',
    'nome': 'Japurá',
    'estado': 'PR'
  },
  {
    'id': '2959',
    'nome': 'Jardim Alegre',
    'estado': 'PR'
  },
  {
    'id': '2960',
    'nome': 'Jardim Olinda',
    'estado': 'PR'
  },
  {
    'id': '2961',
    'nome': 'Jataizinho',
    'estado': 'PR'
  },
  {
    'id': '2962',
    'nome': 'Jesuítas',
    'estado': 'PR'
  },
  {
    'id': '2963',
    'nome': 'Joaquim Távora',
    'estado': 'PR'
  },
  {
    'id': '2964',
    'nome': 'Jundiaí do Sul',
    'estado': 'PR'
  },
  {
    'id': '2965',
    'nome': 'Juranda',
    'estado': 'PR'
  },
  {
    'id': '2966',
    'nome': 'Jussara',
    'estado': 'PR'
  },
  {
    'id': '2967',
    'nome': 'Kaloré',
    'estado': 'PR'
  },
  {
    'id': '2968',
    'nome': 'Lapa',
    'estado': 'PR'
  },
  {
    'id': '2969',
    'nome': 'Laranjal',
    'estado': 'PR'
  },
  {
    'id': '2970',
    'nome': 'Laranjeiras do Sul',
    'estado': 'PR'
  },
  {
    'id': '2971',
    'nome': 'Leópolis',
    'estado': 'PR'
  },
  {
    'id': '2972',
    'nome': 'Lidianópolis',
    'estado': 'PR'
  },
  {
    'id': '2973',
    'nome': 'Lindoeste',
    'estado': 'PR'
  },
  {
    'id': '2974',
    'nome': 'Loanda',
    'estado': 'PR'
  },
  {
    'id': '2975',
    'nome': 'Lobato',
    'estado': 'PR'
  },
  {
    'id': '2976',
    'nome': 'Londrina',
    'estado': 'PR'
  },
  {
    'id': '2977',
    'nome': 'Luiziana',
    'estado': 'PR'
  },
  {
    'id': '2978',
    'nome': 'Lunardelli',
    'estado': 'PR'
  },
  {
    'id': '2979',
    'nome': 'Lupionópolis',
    'estado': 'PR'
  },
  {
    'id': '2980',
    'nome': 'Mallet',
    'estado': 'PR'
  },
  {
    'id': '2981',
    'nome': 'Mamborê',
    'estado': 'PR'
  },
  {
    'id': '2982',
    'nome': 'Mandaguaçu',
    'estado': 'PR'
  },
  {
    'id': '2983',
    'nome': 'Mandaguari',
    'estado': 'PR'
  },
  {
    'id': '2984',
    'nome': 'Mandirituba',
    'estado': 'PR'
  },
  {
    'id': '2985',
    'nome': 'Manfrinópolis',
    'estado': 'PR'
  },
  {
    'id': '2986',
    'nome': 'Mangueirinha',
    'estado': 'PR'
  },
  {
    'id': '2987',
    'nome': 'Manoel Ribas',
    'estado': 'PR'
  },
  {
    'id': '2988',
    'nome': 'Marechal Cândido Rondon',
    'estado': 'PR'
  },
  {
    'id': '2989',
    'nome': 'Maria Helena',
    'estado': 'PR'
  },
  {
    'id': '2990',
    'nome': 'Marialva',
    'estado': 'PR'
  },
  {
    'id': '2991',
    'nome': 'Marilândia do Sul',
    'estado': 'PR'
  },
  {
    'id': '2992',
    'nome': 'Marilena',
    'estado': 'PR'
  },
  {
    'id': '2993',
    'nome': 'Mariluz',
    'estado': 'PR'
  },
  {
    'id': '2994',
    'nome': 'Maringá',
    'estado': 'PR'
  },
  {
    'id': '2995',
    'nome': 'Mariópolis',
    'estado': 'PR'
  },
  {
    'id': '2996',
    'nome': 'Maripá',
    'estado': 'PR'
  },
  {
    'id': '2997',
    'nome': 'Marmeleiro',
    'estado': 'PR'
  },
  {
    'id': '2998',
    'nome': 'Marquinho',
    'estado': 'PR'
  },
  {
    'id': '2999',
    'nome': 'Marumbi',
    'estado': 'PR'
  },
  {
    'id': '3000',
    'nome': 'Matelândia',
    'estado': 'PR'
  },
  {
    'id': '3001',
    'nome': 'Matinhos',
    'estado': 'PR'
  },
  {
    'id': '3002',
    'nome': 'Mato Rico',
    'estado': 'PR'
  },
  {
    'id': '3003',
    'nome': 'Mauá da Serra',
    'estado': 'PR'
  },
  {
    'id': '3004',
    'nome': 'Medianeira',
    'estado': 'PR'
  },
  {
    'id': '3005',
    'nome': 'Mercedes',
    'estado': 'PR'
  },
  {
    'id': '3006',
    'nome': 'Mirador',
    'estado': 'PR'
  },
  {
    'id': '3007',
    'nome': 'Miraselva',
    'estado': 'PR'
  },
  {
    'id': '3008',
    'nome': 'Missal',
    'estado': 'PR'
  },
  {
    'id': '3009',
    'nome': 'Moreira Sales',
    'estado': 'PR'
  },
  {
    'id': '3010',
    'nome': 'Morretes',
    'estado': 'PR'
  },
  {
    'id': '3011',
    'nome': 'Munhoz de Melo',
    'estado': 'PR'
  },
  {
    'id': '3012',
    'nome': 'Nossa Senhora das Graças',
    'estado': 'PR'
  },
  {
    'id': '3013',
    'nome': 'Nova Aliança do Ivaí',
    'estado': 'PR'
  },
  {
    'id': '3014',
    'nome': 'Nova América da Colina',
    'estado': 'PR'
  },
  {
    'id': '3015',
    'nome': 'Nova Aurora',
    'estado': 'PR'
  },
  {
    'id': '3016',
    'nome': 'Nova Cantu',
    'estado': 'PR'
  },
  {
    'id': '3017',
    'nome': 'Nova Esperança',
    'estado': 'PR'
  },
  {
    'id': '3018',
    'nome': 'Nova Esperança do Sudoeste',
    'estado': 'PR'
  },
  {
    'id': '3019',
    'nome': 'Nova Fátima',
    'estado': 'PR'
  },
  {
    'id': '3020',
    'nome': 'Nova Laranjeiras',
    'estado': 'PR'
  },
  {
    'id': '3021',
    'nome': 'Nova Londrina',
    'estado': 'PR'
  },
  {
    'id': '3022',
    'nome': 'Nova Olímpia',
    'estado': 'PR'
  },
  {
    'id': '3023',
    'nome': 'Nova Prata do Iguaçu',
    'estado': 'PR'
  },
  {
    'id': '3024',
    'nome': 'Nova Santa Bárbara',
    'estado': 'PR'
  },
  {
    'id': '3025',
    'nome': 'Nova Santa Rosa',
    'estado': 'PR'
  },
  {
    'id': '3026',
    'nome': 'Nova Tebas',
    'estado': 'PR'
  },
  {
    'id': '3027',
    'nome': 'Novo Itacolomi',
    'estado': 'PR'
  },
  {
    'id': '3028',
    'nome': 'Ortigueira',
    'estado': 'PR'
  },
  {
    'id': '3029',
    'nome': 'Ourizona',
    'estado': 'PR'
  },
  {
    'id': '3030',
    'nome': 'Ouro Verde do Oeste',
    'estado': 'PR'
  },
  {
    'id': '3031',
    'nome': 'Paiçandu',
    'estado': 'PR'
  },
  {
    'id': '3032',
    'nome': 'Palmas',
    'estado': 'PR'
  },
  {
    'id': '3033',
    'nome': 'Palmeira',
    'estado': 'PR'
  },
  {
    'id': '3034',
    'nome': 'Palmital',
    'estado': 'PR'
  },
  {
    'id': '3035',
    'nome': 'Palotina',
    'estado': 'PR'
  },
  {
    'id': '3036',
    'nome': 'Paraíso do Norte',
    'estado': 'PR'
  },
  {
    'id': '3037',
    'nome': 'Paranacity',
    'estado': 'PR'
  },
  {
    'id': '3038',
    'nome': 'Paranaguá',
    'estado': 'PR'
  },
  {
    'id': '3039',
    'nome': 'Paranapoema',
    'estado': 'PR'
  },
  {
    'id': '3040',
    'nome': 'Paranavaí',
    'estado': 'PR'
  },
  {
    'id': '3041',
    'nome': 'Pato Bragado',
    'estado': 'PR'
  },
  {
    'id': '3042',
    'nome': 'Pato Branco',
    'estado': 'PR'
  },
  {
    'id': '3043',
    'nome': 'Paula Freitas',
    'estado': 'PR'
  },
  {
    'id': '3044',
    'nome': 'Paulo Frontin',
    'estado': 'PR'
  },
  {
    'id': '3045',
    'nome': 'Peabiru',
    'estado': 'PR'
  },
  {
    'id': '3046',
    'nome': 'Perobal',
    'estado': 'PR'
  },
  {
    'id': '3047',
    'nome': 'Pérola',
    'estado': 'PR'
  },
  {
    'id': '3048',
    'nome': 'Pérola d`Oeste',
    'estado': 'PR'
  },
  {
    'id': '3049',
    'nome': 'Piên',
    'estado': 'PR'
  },
  {
    'id': '3050',
    'nome': 'Pinhais',
    'estado': 'PR'
  },
  {
    'id': '3051',
    'nome': 'Pinhal de São Bento',
    'estado': 'PR'
  },
  {
    'id': '3052',
    'nome': 'Pinhalão',
    'estado': 'PR'
  },
  {
    'id': '3053',
    'nome': 'Pinhão',
    'estado': 'PR'
  },
  {
    'id': '3054',
    'nome': 'Piraí do Sul',
    'estado': 'PR'
  },
  {
    'id': '3055',
    'nome': 'Piraquara',
    'estado': 'PR'
  },
  {
    'id': '3056',
    'nome': 'Pitanga',
    'estado': 'PR'
  },
  {
    'id': '3057',
    'nome': 'Pitangueiras',
    'estado': 'PR'
  },
  {
    'id': '3058',
    'nome': 'Planaltina do Paraná',
    'estado': 'PR'
  },
  {
    'id': '3059',
    'nome': 'Planalto',
    'estado': 'PR'
  },
  {
    'id': '3060',
    'nome': 'Ponta Grossa',
    'estado': 'PR'
  },
  {
    'id': '3061',
    'nome': 'Pontal do Paraná',
    'estado': 'PR'
  },
  {
    'id': '3062',
    'nome': 'Porecatu',
    'estado': 'PR'
  },
  {
    'id': '3063',
    'nome': 'Porto Amazonas',
    'estado': 'PR'
  },
  {
    'id': '3064',
    'nome': 'Porto Barreiro',
    'estado': 'PR'
  },
  {
    'id': '3065',
    'nome': 'Porto Rico',
    'estado': 'PR'
  },
  {
    'id': '3066',
    'nome': 'Porto Vitória',
    'estado': 'PR'
  },
  {
    'id': '3067',
    'nome': 'Prado Ferreira',
    'estado': 'PR'
  },
  {
    'id': '3068',
    'nome': 'Pranchita',
    'estado': 'PR'
  },
  {
    'id': '3069',
    'nome': 'Presidente Castelo Branco',
    'estado': 'PR'
  },
  {
    'id': '3070',
    'nome': 'Primeiro de Maio',
    'estado': 'PR'
  },
  {
    'id': '3071',
    'nome': 'Prudentópolis',
    'estado': 'PR'
  },
  {
    'id': '3072',
    'nome': 'Quarto Centenário',
    'estado': 'PR'
  },
  {
    'id': '3073',
    'nome': 'Quatiguá',
    'estado': 'PR'
  },
  {
    'id': '3074',
    'nome': 'Quatro Barras',
    'estado': 'PR'
  },
  {
    'id': '3075',
    'nome': 'Quatro Pontes',
    'estado': 'PR'
  },
  {
    'id': '3076',
    'nome': 'Quedas do Iguaçu',
    'estado': 'PR'
  },
  {
    'id': '3077',
    'nome': 'Querência do Norte',
    'estado': 'PR'
  },
  {
    'id': '3078',
    'nome': 'Quinta do Sol',
    'estado': 'PR'
  },
  {
    'id': '3079',
    'nome': 'Quitandinha',
    'estado': 'PR'
  },
  {
    'id': '3080',
    'nome': 'Ramilândia',
    'estado': 'PR'
  },
  {
    'id': '3081',
    'nome': 'Rancho Alegre',
    'estado': 'PR'
  },
  {
    'id': '3082',
    'nome': 'Rancho Alegre d`Oeste',
    'estado': 'PR'
  },
  {
    'id': '3083',
    'nome': 'Realeza',
    'estado': 'PR'
  },
  {
    'id': '3084',
    'nome': 'Rebouças',
    'estado': 'PR'
  },
  {
    'id': '3085',
    'nome': 'Renascença',
    'estado': 'PR'
  },
  {
    'id': '3086',
    'nome': 'Reserva',
    'estado': 'PR'
  },
  {
    'id': '3087',
    'nome': 'Reserva do Iguaçu',
    'estado': 'PR'
  },
  {
    'id': '3088',
    'nome': 'Ribeirão Claro',
    'estado': 'PR'
  },
  {
    'id': '3089',
    'nome': 'Ribeirão do Pinhal',
    'estado': 'PR'
  },
  {
    'id': '3090',
    'nome': 'Rio Azul',
    'estado': 'PR'
  },
  {
    'id': '3091',
    'nome': 'Rio Bom',
    'estado': 'PR'
  },
  {
    'id': '3092',
    'nome': 'Rio Bonito do Iguaçu',
    'estado': 'PR'
  },
  {
    'id': '3093',
    'nome': 'Rio Branco do Ivaí',
    'estado': 'PR'
  },
  {
    'id': '3094',
    'nome': 'Rio Branco do Sul',
    'estado': 'PR'
  },
  {
    'id': '3095',
    'nome': 'Rio Negro',
    'estado': 'PR'
  },
  {
    'id': '3096',
    'nome': 'Rolândia',
    'estado': 'PR'
  },
  {
    'id': '3097',
    'nome': 'Roncador',
    'estado': 'PR'
  },
  {
    'id': '3098',
    'nome': 'Rondon',
    'estado': 'PR'
  },
  {
    'id': '3099',
    'nome': 'Rosário do Ivaí',
    'estado': 'PR'
  },
  {
    'id': '3100',
    'nome': 'Sabáudia',
    'estado': 'PR'
  },
  {
    'id': '3101',
    'nome': 'Salgado Filho',
    'estado': 'PR'
  },
  {
    'id': '3102',
    'nome': 'Salto do Itararé',
    'estado': 'PR'
  },
  {
    'id': '3103',
    'nome': 'Salto do Lontra',
    'estado': 'PR'
  },
  {
    'id': '3104',
    'nome': 'Santa Amélia',
    'estado': 'PR'
  },
  {
    'id': '3105',
    'nome': 'Santa Cecília do Pavão',
    'estado': 'PR'
  },
  {
    'id': '3106',
    'nome': 'Santa Cruz de Monte Castelo',
    'estado': 'PR'
  },
  {
    'id': '3107',
    'nome': 'Santa Fé',
    'estado': 'PR'
  },
  {
    'id': '3108',
    'nome': 'Santa Helena',
    'estado': 'PR'
  },
  {
    'id': '3109',
    'nome': 'Santa Inês',
    'estado': 'PR'
  },
  {
    'id': '3110',
    'nome': 'Santa Isabel do Ivaí',
    'estado': 'PR'
  },
  {
    'id': '3111',
    'nome': 'Santa Izabel do Oeste',
    'estado': 'PR'
  },
  {
    'id': '3112',
    'nome': 'Santa Lúcia',
    'estado': 'PR'
  },
  {
    'id': '3113',
    'nome': 'Santa Maria do Oeste',
    'estado': 'PR'
  },
  {
    'id': '3114',
    'nome': 'Santa Mariana',
    'estado': 'PR'
  },
  {
    'id': '3115',
    'nome': 'Santa Mônica',
    'estado': 'PR'
  },
  {
    'id': '3116',
    'nome': 'Santa Tereza do Oeste',
    'estado': 'PR'
  },
  {
    'id': '3117',
    'nome': 'Santa Terezinha de Itaipu',
    'estado': 'PR'
  },
  {
    'id': '3118',
    'nome': 'Santana do Itararé',
    'estado': 'PR'
  },
  {
    'id': '3119',
    'nome': 'Santo Antônio da Platina',
    'estado': 'PR'
  },
  {
    'id': '3120',
    'nome': 'Santo Antônio do Caiuá',
    'estado': 'PR'
  },
  {
    'id': '3121',
    'nome': 'Santo Antônio do Paraíso',
    'estado': 'PR'
  },
  {
    'id': '3122',
    'nome': 'Santo Antônio do Sudoeste',
    'estado': 'PR'
  },
  {
    'id': '3123',
    'nome': 'Santo Inácio',
    'estado': 'PR'
  },
  {
    'id': '3124',
    'nome': 'São Carlos do Ivaí',
    'estado': 'PR'
  },
  {
    'id': '3125',
    'nome': 'São Jerônimo da Serra',
    'estado': 'PR'
  },
  {
    'id': '3126',
    'nome': 'São João',
    'estado': 'PR'
  },
  {
    'id': '3127',
    'nome': 'São João do Caiuá',
    'estado': 'PR'
  },
  {
    'id': '3128',
    'nome': 'São João do Ivaí',
    'estado': 'PR'
  },
  {
    'id': '3129',
    'nome': 'São João do Triunfo',
    'estado': 'PR'
  },
  {
    'id': '3130',
    'nome': 'São Jorge d`Oeste',
    'estado': 'PR'
  },
  {
    'id': '3131',
    'nome': 'São Jorge do Ivaí',
    'estado': 'PR'
  },
  {
    'id': '3132',
    'nome': 'São Jorge do Patrocínio',
    'estado': 'PR'
  },
  {
    'id': '3133',
    'nome': 'São José da Boa Vista',
    'estado': 'PR'
  },
  {
    'id': '3134',
    'nome': 'São José das Palmeiras',
    'estado': 'PR'
  },
  {
    'id': '3135',
    'nome': 'São José dos Pinhais',
    'estado': 'PR'
  },
  {
    'id': '3136',
    'nome': 'São Manoel do Paraná',
    'estado': 'PR'
  },
  {
    'id': '3137',
    'nome': 'São Mateus do Sul',
    'estado': 'PR'
  },
  {
    'id': '3138',
    'nome': 'São Miguel do Iguaçu',
    'estado': 'PR'
  },
  {
    'id': '3139',
    'nome': 'São Pedro do Iguaçu',
    'estado': 'PR'
  },
  {
    'id': '3140',
    'nome': 'São Pedro do Ivaí',
    'estado': 'PR'
  },
  {
    'id': '3141',
    'nome': 'São Pedro do Paraná',
    'estado': 'PR'
  },
  {
    'id': '3142',
    'nome': 'São Sebastião da Amoreira',
    'estado': 'PR'
  },
  {
    'id': '3143',
    'nome': 'São Tomé',
    'estado': 'PR'
  },
  {
    'id': '3144',
    'nome': 'Sapopema',
    'estado': 'PR'
  },
  {
    'id': '3145',
    'nome': 'Sarandi',
    'estado': 'PR'
  },
  {
    'id': '3146',
    'nome': 'Saudade do Iguaçu',
    'estado': 'PR'
  },
  {
    'id': '3147',
    'nome': 'Sengés',
    'estado': 'PR'
  },
  {
    'id': '3148',
    'nome': 'Serranópolis do Iguaçu',
    'estado': 'PR'
  },
  {
    'id': '3149',
    'nome': 'Sertaneja',
    'estado': 'PR'
  },
  {
    'id': '3150',
    'nome': 'Sertanópolis',
    'estado': 'PR'
  },
  {
    'id': '3151',
    'nome': 'Siqueira Campos',
    'estado': 'PR'
  },
  {
    'id': '3152',
    'nome': 'Sulina',
    'estado': 'PR'
  },
  {
    'id': '3153',
    'nome': 'Tamarana',
    'estado': 'PR'
  },
  {
    'id': '3154',
    'nome': 'Tamboara',
    'estado': 'PR'
  },
  {
    'id': '3155',
    'nome': 'Tapejara',
    'estado': 'PR'
  },
  {
    'id': '3156',
    'nome': 'Tapira',
    'estado': 'PR'
  },
  {
    'id': '3157',
    'nome': 'Teixeira Soares',
    'estado': 'PR'
  },
  {
    'id': '3158',
    'nome': 'Telêmaco Borba',
    'estado': 'PR'
  },
  {
    'id': '3159',
    'nome': 'Terra Boa',
    'estado': 'PR'
  },
  {
    'id': '3160',
    'nome': 'Terra Rica',
    'estado': 'PR'
  },
  {
    'id': '3161',
    'nome': 'Terra Roxa',
    'estado': 'PR'
  },
  {
    'id': '3162',
    'nome': 'Tibagi',
    'estado': 'PR'
  },
  {
    'id': '3163',
    'nome': 'Tijucas do Sul',
    'estado': 'PR'
  },
  {
    'id': '3164',
    'nome': 'Toledo',
    'estado': 'PR'
  },
  {
    'id': '3165',
    'nome': 'Tomazina',
    'estado': 'PR'
  },
  {
    'id': '3166',
    'nome': 'Três Barras do Paraná',
    'estado': 'PR'
  },
  {
    'id': '3167',
    'nome': 'Tunas do Paraná',
    'estado': 'PR'
  },
  {
    'id': '3168',
    'nome': 'Tuneiras do Oeste',
    'estado': 'PR'
  },
  {
    'id': '3169',
    'nome': 'Tupãssi',
    'estado': 'PR'
  },
  {
    'id': '3170',
    'nome': 'Turvo',
    'estado': 'PR'
  },
  {
    'id': '3171',
    'nome': 'Ubiratã',
    'estado': 'PR'
  },
  {
    'id': '3172',
    'nome': 'Umuarama',
    'estado': 'PR'
  },
  {
    'id': '3173',
    'nome': 'União da Vitória',
    'estado': 'PR'
  },
  {
    'id': '3174',
    'nome': 'Uniflor',
    'estado': 'PR'
  },
  {
    'id': '3175',
    'nome': 'Uraí',
    'estado': 'PR'
  },
  {
    'id': '3176',
    'nome': 'Ventania',
    'estado': 'PR'
  },
  {
    'id': '3177',
    'nome': 'Vera Cruz do Oeste',
    'estado': 'PR'
  },
  {
    'id': '3178',
    'nome': 'Verê',
    'estado': 'PR'
  },
  {
    'id': '3179',
    'nome': 'Virmond',
    'estado': 'PR'
  },
  {
    'id': '3180',
    'nome': 'Vitorino',
    'estado': 'PR'
  },
  {
    'id': '3181',
    'nome': 'Wenceslau Braz',
    'estado': 'PR'
  },
  {
    'id': '3182',
    'nome': 'Xambrê',
    'estado': 'PR'
  },
  {
    'id': '3183',
    'nome': 'Abreu e Lima',
    'estado': 'PE'
  },
  {
    'id': '3184',
    'nome': 'Afogados da Ingazeira',
    'estado': 'PE'
  },
  {
    'id': '3185',
    'nome': 'Afrânio',
    'estado': 'PE'
  },
  {
    'id': '3186',
    'nome': 'Agrestina',
    'estado': 'PE'
  },
  {
    'id': '3187',
    'nome': 'Água Preta',
    'estado': 'PE'
  },
  {
    'id': '3188',
    'nome': 'Águas Belas',
    'estado': 'PE'
  },
  {
    'id': '3189',
    'nome': 'Alagoinha',
    'estado': 'PE'
  },
  {
    'id': '3190',
    'nome': 'Aliança',
    'estado': 'PE'
  },
  {
    'id': '3191',
    'nome': 'Altinho',
    'estado': 'PE'
  },
  {
    'id': '3192',
    'nome': 'Amaraji',
    'estado': 'PE'
  },
  {
    'id': '3193',
    'nome': 'Angelim',
    'estado': 'PE'
  },
  {
    'id': '3194',
    'nome': 'Araçoiaba',
    'estado': 'PE'
  },
  {
    'id': '3195',
    'nome': 'Araripina',
    'estado': 'PE'
  },
  {
    'id': '3196',
    'nome': 'Arcoverde',
    'estado': 'PE'
  },
  {
    'id': '3197',
    'nome': 'Barra de Guabiraba',
    'estado': 'PE'
  },
  {
    'id': '3198',
    'nome': 'Barreiros',
    'estado': 'PE'
  },
  {
    'id': '3199',
    'nome': 'Belém de Maria',
    'estado': 'PE'
  },
  {
    'id': '3200',
    'nome': 'Belém de São Francisco',
    'estado': 'PE'
  },
  {
    'id': '3201',
    'nome': 'Belo Jardim',
    'estado': 'PE'
  },
  {
    'id': '3202',
    'nome': 'Betânia',
    'estado': 'PE'
  },
  {
    'id': '3203',
    'nome': 'Bezerros',
    'estado': 'PE'
  },
  {
    'id': '3204',
    'nome': 'Bodocó',
    'estado': 'PE'
  },
  {
    'id': '3205',
    'nome': 'Bom Conselho',
    'estado': 'PE'
  },
  {
    'id': '3206',
    'nome': 'Bom Jardim',
    'estado': 'PE'
  },
  {
    'id': '3207',
    'nome': 'Bonito',
    'estado': 'PE'
  },
  {
    'id': '3208',
    'nome': 'Brejão',
    'estado': 'PE'
  },
  {
    'id': '3209',
    'nome': 'Brejinho',
    'estado': 'PE'
  },
  {
    'id': '3210',
    'nome': 'Brejo da Madre de Deus',
    'estado': 'PE'
  },
  {
    'id': '3211',
    'nome': 'Buenos Aires',
    'estado': 'PE'
  },
  {
    'id': '3212',
    'nome': 'Buíque',
    'estado': 'PE'
  },
  {
    'id': '3213',
    'nome': 'Cabo de Santo Agostinho',
    'estado': 'PE'
  },
  {
    'id': '3214',
    'nome': 'Cabrobó',
    'estado': 'PE'
  },
  {
    'id': '3215',
    'nome': 'Cachoeirinha',
    'estado': 'PE'
  },
  {
    'id': '3216',
    'nome': 'Caetés',
    'estado': 'PE'
  },
  {
    'id': '3217',
    'nome': 'Calçado',
    'estado': 'PE'
  },
  {
    'id': '3218',
    'nome': 'Calumbi',
    'estado': 'PE'
  },
  {
    'id': '3219',
    'nome': 'Camaragibe',
    'estado': 'PE'
  },
  {
    'id': '3220',
    'nome': 'Camocim de São Félix',
    'estado': 'PE'
  },
  {
    'id': '3221',
    'nome': 'Camutanga',
    'estado': 'PE'
  },
  {
    'id': '3222',
    'nome': 'Canhotinho',
    'estado': 'PE'
  },
  {
    'id': '3223',
    'nome': 'Capoeiras',
    'estado': 'PE'
  },
  {
    'id': '3224',
    'nome': 'Carnaíba',
    'estado': 'PE'
  },
  {
    'id': '3225',
    'nome': 'Carnaubeira da Penha',
    'estado': 'PE'
  },
  {
    'id': '3226',
    'nome': 'Carpina',
    'estado': 'PE'
  },
  {
    'id': '3227',
    'nome': 'Caruaru',
    'estado': 'PE'
  },
  {
    'id': '3228',
    'nome': 'Casinhas',
    'estado': 'PE'
  },
  {
    'id': '3229',
    'nome': 'Catende',
    'estado': 'PE'
  },
  {
    'id': '3230',
    'nome': 'Cedro',
    'estado': 'PE'
  },
  {
    'id': '3231',
    'nome': 'Chã de Alegria',
    'estado': 'PE'
  },
  {
    'id': '3232',
    'nome': 'Chã Grande',
    'estado': 'PE'
  },
  {
    'id': '3233',
    'nome': 'Condado',
    'estado': 'PE'
  },
  {
    'id': '3234',
    'nome': 'Correntes',
    'estado': 'PE'
  },
  {
    'id': '3235',
    'nome': 'Cortês',
    'estado': 'PE'
  },
  {
    'id': '3236',
    'nome': 'Cumaru',
    'estado': 'PE'
  },
  {
    'id': '3237',
    'nome': 'Cupira',
    'estado': 'PE'
  },
  {
    'id': '3238',
    'nome': 'Custódia',
    'estado': 'PE'
  },
  {
    'id': '3239',
    'nome': 'Dormentes',
    'estado': 'PE'
  },
  {
    'id': '3240',
    'nome': 'Escada',
    'estado': 'PE'
  },
  {
    'id': '3241',
    'nome': 'Exu',
    'estado': 'PE'
  },
  {
    'id': '3242',
    'nome': 'Feira Nova',
    'estado': 'PE'
  },
  {
    'id': '3243',
    'nome': 'Fernando de Noronha',
    'estado': 'PE'
  },
  {
    'id': '3244',
    'nome': 'Ferreiros',
    'estado': 'PE'
  },
  {
    'id': '3245',
    'nome': 'Flores',
    'estado': 'PE'
  },
  {
    'id': '3246',
    'nome': 'Floresta',
    'estado': 'PE'
  },
  {
    'id': '3247',
    'nome': 'Frei Miguelinho',
    'estado': 'PE'
  },
  {
    'id': '3248',
    'nome': 'Gameleira',
    'estado': 'PE'
  },
  {
    'id': '3249',
    'nome': 'Garanhuns',
    'estado': 'PE'
  },
  {
    'id': '3250',
    'nome': 'Glória do Goitá',
    'estado': 'PE'
  },
  {
    'id': '3251',
    'nome': 'Goiana',
    'estado': 'PE'
  },
  {
    'id': '3252',
    'nome': 'Granito',
    'estado': 'PE'
  },
  {
    'id': '3253',
    'nome': 'Gravatá',
    'estado': 'PE'
  },
  {
    'id': '3254',
    'nome': 'Iati',
    'estado': 'PE'
  },
  {
    'id': '3255',
    'nome': 'Ibimirim',
    'estado': 'PE'
  },
  {
    'id': '3256',
    'nome': 'Ibirajuba',
    'estado': 'PE'
  },
  {
    'id': '3257',
    'nome': 'Igarassu',
    'estado': 'PE'
  },
  {
    'id': '3258',
    'nome': 'Iguaraci',
    'estado': 'PE'
  },
  {
    'id': '3259',
    'nome': 'Ilha de Itamaracá',
    'estado': 'PE'
  },
  {
    'id': '3260',
    'nome': 'Inajá',
    'estado': 'PE'
  },
  {
    'id': '3261',
    'nome': 'Ingazeira',
    'estado': 'PE'
  },
  {
    'id': '3262',
    'nome': 'Ipojuca',
    'estado': 'PE'
  },
  {
    'id': '3263',
    'nome': 'Ipubi',
    'estado': 'PE'
  },
  {
    'id': '3264',
    'nome': 'Itacuruba',
    'estado': 'PE'
  },
  {
    'id': '3265',
    'nome': 'Itaíba',
    'estado': 'PE'
  },
  {
    'id': '3266',
    'nome': 'Itambé',
    'estado': 'PE'
  },
  {
    'id': '3267',
    'nome': 'Itapetim',
    'estado': 'PE'
  },
  {
    'id': '3268',
    'nome': 'Itapissuma',
    'estado': 'PE'
  },
  {
    'id': '3269',
    'nome': 'Itaquitinga',
    'estado': 'PE'
  },
  {
    'id': '3270',
    'nome': 'Jaboatão dos Guararapes',
    'estado': 'PE'
  },
  {
    'id': '3271',
    'nome': 'Jaqueira',
    'estado': 'PE'
  },
  {
    'id': '3272',
    'nome': 'Jataúba',
    'estado': 'PE'
  },
  {
    'id': '3273',
    'nome': 'Jatobá',
    'estado': 'PE'
  },
  {
    'id': '3274',
    'nome': 'João Alfredo',
    'estado': 'PE'
  },
  {
    'id': '3275',
    'nome': 'Joaquim Nabuco',
    'estado': 'PE'
  },
  {
    'id': '3276',
    'nome': 'Jucati',
    'estado': 'PE'
  },
  {
    'id': '3277',
    'nome': 'Jupi',
    'estado': 'PE'
  },
  {
    'id': '3278',
    'nome': 'Jurema',
    'estado': 'PE'
  },
  {
    'id': '3279',
    'nome': 'Lagoa do Carro',
    'estado': 'PE'
  },
  {
    'id': '3280',
    'nome': 'Lagoa do Itaenga',
    'estado': 'PE'
  },
  {
    'id': '3281',
    'nome': 'Lagoa do Ouro',
    'estado': 'PE'
  },
  {
    'id': '3282',
    'nome': 'Lagoa dos Gatos',
    'estado': 'PE'
  },
  {
    'id': '3283',
    'nome': 'Lagoa Grande',
    'estado': 'PE'
  },
  {
    'id': '3284',
    'nome': 'Lajedo',
    'estado': 'PE'
  },
  {
    'id': '3285',
    'nome': 'Limoeiro',
    'estado': 'PE'
  },
  {
    'id': '3286',
    'nome': 'Macaparana',
    'estado': 'PE'
  },
  {
    'id': '3287',
    'nome': 'Machados',
    'estado': 'PE'
  },
  {
    'id': '3288',
    'nome': 'Manari',
    'estado': 'PE'
  },
  {
    'id': '3289',
    'nome': 'Maraial',
    'estado': 'PE'
  },
  {
    'id': '3290',
    'nome': 'Mirandiba',
    'estado': 'PE'
  },
  {
    'id': '3291',
    'nome': 'Moreilândia',
    'estado': 'PE'
  },
  {
    'id': '3292',
    'nome': 'Moreno',
    'estado': 'PE'
  },
  {
    'id': '3293',
    'nome': 'Nazaré da Mata',
    'estado': 'PE'
  },
  {
    'id': '3294',
    'nome': 'Olinda',
    'estado': 'PE'
  },
  {
    'id': '3295',
    'nome': 'Orobó',
    'estado': 'PE'
  },
  {
    'id': '3296',
    'nome': 'Orocó',
    'estado': 'PE'
  },
  {
    'id': '3297',
    'nome': 'Ouricuri',
    'estado': 'PE'
  },
  {
    'id': '3298',
    'nome': 'Palmares',
    'estado': 'PE'
  },
  {
    'id': '3299',
    'nome': 'Palmeirina',
    'estado': 'PE'
  },
  {
    'id': '3300',
    'nome': 'Panelas',
    'estado': 'PE'
  },
  {
    'id': '3301',
    'nome': 'Paranatama',
    'estado': 'PE'
  },
  {
    'id': '3302',
    'nome': 'Parnamirim',
    'estado': 'PE'
  },
  {
    'id': '3303',
    'nome': 'Passira',
    'estado': 'PE'
  },
  {
    'id': '3304',
    'nome': 'Paudalho',
    'estado': 'PE'
  },
  {
    'id': '3305',
    'nome': 'Paulista',
    'estado': 'PE'
  },
  {
    'id': '3306',
    'nome': 'Pedra',
    'estado': 'PE'
  },
  {
    'id': '3307',
    'nome': 'Pesqueira',
    'estado': 'PE'
  },
  {
    'id': '3308',
    'nome': 'Petrolândia',
    'estado': 'PE'
  },
  {
    'id': '3309',
    'nome': 'Petrolina',
    'estado': 'PE'
  },
  {
    'id': '3310',
    'nome': 'Poção',
    'estado': 'PE'
  },
  {
    'id': '3311',
    'nome': 'Pombos',
    'estado': 'PE'
  },
  {
    'id': '3312',
    'nome': 'Primavera',
    'estado': 'PE'
  },
  {
    'id': '3313',
    'nome': 'Quipapá',
    'estado': 'PE'
  },
  {
    'id': '3314',
    'nome': 'Quixaba',
    'estado': 'PE'
  },
  {
    'id': '3315',
    'nome': 'Recife',
    'estado': 'PE'
  },
  {
    'id': '3316',
    'nome': 'Riacho das Almas',
    'estado': 'PE'
  },
  {
    'id': '3317',
    'nome': 'Ribeirão',
    'estado': 'PE'
  },
  {
    'id': '3318',
    'nome': 'Rio Formoso',
    'estado': 'PE'
  },
  {
    'id': '3319',
    'nome': 'Sairé',
    'estado': 'PE'
  },
  {
    'id': '3320',
    'nome': 'Salgadinho',
    'estado': 'PE'
  },
  {
    'id': '3321',
    'nome': 'Salgueiro',
    'estado': 'PE'
  },
  {
    'id': '3322',
    'nome': 'Saloá',
    'estado': 'PE'
  },
  {
    'id': '3323',
    'nome': 'Sanharó',
    'estado': 'PE'
  },
  {
    'id': '3324',
    'nome': 'Santa Cruz',
    'estado': 'PE'
  },
  {
    'id': '3325',
    'nome': 'Santa Cruz da Baixa Verde',
    'estado': 'PE'
  },
  {
    'id': '3326',
    'nome': 'Santa Cruz do Capibaribe',
    'estado': 'PE'
  },
  {
    'id': '3327',
    'nome': 'Santa Filomena',
    'estado': 'PE'
  },
  {
    'id': '3328',
    'nome': 'Santa Maria da Boa Vista',
    'estado': 'PE'
  },
  {
    'id': '3329',
    'nome': 'Santa Maria do Cambucá',
    'estado': 'PE'
  },
  {
    'id': '3330',
    'nome': 'Santa Terezinha',
    'estado': 'PE'
  },
  {
    'id': '3331',
    'nome': 'São Benedito do Sul',
    'estado': 'PE'
  },
  {
    'id': '3332',
    'nome': 'São Bento do Una',
    'estado': 'PE'
  },
  {
    'id': '3333',
    'nome': 'São Caitano',
    'estado': 'PE'
  },
  {
    'id': '3334',
    'nome': 'São João',
    'estado': 'PE'
  },
  {
    'id': '3335',
    'nome': 'São Joaquim do Monte',
    'estado': 'PE'
  },
  {
    'id': '3336',
    'nome': 'São José da Coroa Grande',
    'estado': 'PE'
  },
  {
    'id': '3337',
    'nome': 'São José do Belmonte',
    'estado': 'PE'
  },
  {
    'id': '3338',
    'nome': 'São José do Egito',
    'estado': 'PE'
  },
  {
    'id': '3339',
    'nome': 'São Lourenço da Mata',
    'estado': 'PE'
  },
  {
    'id': '3340',
    'nome': 'São Vicente Ferrer',
    'estado': 'PE'
  },
  {
    'id': '3341',
    'nome': 'Serra Talhada',
    'estado': 'PE'
  },
  {
    'id': '3342',
    'nome': 'Serrita',
    'estado': 'PE'
  },
  {
    'id': '3343',
    'nome': 'Sertânia',
    'estado': 'PE'
  },
  {
    'id': '3344',
    'nome': 'Sirinhaém',
    'estado': 'PE'
  },
  {
    'id': '3345',
    'nome': 'Solidão',
    'estado': 'PE'
  },
  {
    'id': '3346',
    'nome': 'Surubim',
    'estado': 'PE'
  },
  {
    'id': '3347',
    'nome': 'Tabira',
    'estado': 'PE'
  },
  {
    'id': '3348',
    'nome': 'Tacaimbó',
    'estado': 'PE'
  },
  {
    'id': '3349',
    'nome': 'Tacaratu',
    'estado': 'PE'
  },
  {
    'id': '3350',
    'nome': 'Tamandaré',
    'estado': 'PE'
  },
  {
    'id': '3351',
    'nome': 'Taquaritinga do Norte',
    'estado': 'PE'
  },
  {
    'id': '3352',
    'nome': 'Terezinha',
    'estado': 'PE'
  },
  {
    'id': '3353',
    'nome': 'Terra Nova',
    'estado': 'PE'
  },
  {
    'id': '3354',
    'nome': 'Timbaúba',
    'estado': 'PE'
  },
  {
    'id': '3355',
    'nome': 'Toritama',
    'estado': 'PE'
  },
  {
    'id': '3356',
    'nome': 'Tracunhaém',
    'estado': 'PE'
  },
  {
    'id': '3357',
    'nome': 'Trindade',
    'estado': 'PE'
  },
  {
    'id': '3358',
    'nome': 'Triunfo',
    'estado': 'PE'
  },
  {
    'id': '3359',
    'nome': 'Tupanatinga',
    'estado': 'PE'
  },
  {
    'id': '3360',
    'nome': 'Tuparetama',
    'estado': 'PE'
  },
  {
    'id': '3361',
    'nome': 'Venturosa',
    'estado': 'PE'
  },
  {
    'id': '3362',
    'nome': 'Verdejante',
    'estado': 'PE'
  },
  {
    'id': '3363',
    'nome': 'Vertente do Lério',
    'estado': 'PE'
  },
  {
    'id': '3364',
    'nome': 'Vertentes',
    'estado': 'PE'
  },
  {
    'id': '3365',
    'nome': 'Vicência',
    'estado': 'PE'
  },
  {
    'id': '3366',
    'nome': 'Vitória de Santo Antão',
    'estado': 'PE'
  },
  {
    'id': '3367',
    'nome': 'Xexéu',
    'estado': 'PE'
  },
  {
    'id': '3368',
    'nome': 'Acauã',
    'estado': 'PI'
  },
  {
    'id': '3369',
    'nome': 'Agricolândia',
    'estado': 'PI'
  },
  {
    'id': '3370',
    'nome': 'Água Branca',
    'estado': 'PI'
  },
  {
    'id': '3371',
    'nome': 'Alagoinha do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3372',
    'nome': 'Alegrete do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3373',
    'nome': 'Alto Longá',
    'estado': 'PI'
  },
  {
    'id': '3374',
    'nome': 'Altos',
    'estado': 'PI'
  },
  {
    'id': '3375',
    'nome': 'Alvorada do Gurguéia',
    'estado': 'PI'
  },
  {
    'id': '3376',
    'nome': 'Amarante',
    'estado': 'PI'
  },
  {
    'id': '3377',
    'nome': 'Angical do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3378',
    'nome': 'Anísio de Abreu',
    'estado': 'PI'
  },
  {
    'id': '3379',
    'nome': 'Antônio Almeida',
    'estado': 'PI'
  },
  {
    'id': '3380',
    'nome': 'Aroazes',
    'estado': 'PI'
  },
  {
    'id': '3381',
    'nome': 'Aroeiras do Itaim',
    'estado': 'PI'
  },
  {
    'id': '3382',
    'nome': 'Arraial',
    'estado': 'PI'
  },
  {
    'id': '3383',
    'nome': 'Assunção do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3384',
    'nome': 'Avelino Lopes',
    'estado': 'PI'
  },
  {
    'id': '3385',
    'nome': 'Baixa Grande do Ribeiro',
    'estado': 'PI'
  },
  {
    'id': '3386',
    'nome': 'Barra d`Alcântara',
    'estado': 'PI'
  },
  {
    'id': '3387',
    'nome': 'Barras',
    'estado': 'PI'
  },
  {
    'id': '3388',
    'nome': 'Barreiras do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3389',
    'nome': 'Barro Duro',
    'estado': 'PI'
  },
  {
    'id': '3390',
    'nome': 'Batalha',
    'estado': 'PI'
  },
  {
    'id': '3391',
    'nome': 'Bela Vista do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3392',
    'nome': 'Belém do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3393',
    'nome': 'Beneditinos',
    'estado': 'PI'
  },
  {
    'id': '3394',
    'nome': 'Bertolínia',
    'estado': 'PI'
  },
  {
    'id': '3395',
    'nome': 'Betânia do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3396',
    'nome': 'Boa Hora',
    'estado': 'PI'
  },
  {
    'id': '3397',
    'nome': 'Bocaina',
    'estado': 'PI'
  },
  {
    'id': '3398',
    'nome': 'Bom Jesus',
    'estado': 'PI'
  },
  {
    'id': '3399',
    'nome': 'Bom Princípio do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3400',
    'nome': 'Bonfim do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3401',
    'nome': 'Boqueirão do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3402',
    'nome': 'Brasileira',
    'estado': 'PI'
  },
  {
    'id': '3403',
    'nome': 'Brejo do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3404',
    'nome': 'Buriti dos Lopes',
    'estado': 'PI'
  },
  {
    'id': '3405',
    'nome': 'Buriti dos Montes',
    'estado': 'PI'
  },
  {
    'id': '3406',
    'nome': 'Cabeceiras do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3407',
    'nome': 'Cajazeiras do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3408',
    'nome': 'Cajueiro da Praia',
    'estado': 'PI'
  },
  {
    'id': '3409',
    'nome': 'Caldeirão Grande do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3410',
    'nome': 'Campinas do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3411',
    'nome': 'Campo Alegre do Fidalgo',
    'estado': 'PI'
  },
  {
    'id': '3412',
    'nome': 'Campo Grande do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3413',
    'nome': 'Campo Largo do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3414',
    'nome': 'Campo Maior',
    'estado': 'PI'
  },
  {
    'id': '3415',
    'nome': 'Canavieira',
    'estado': 'PI'
  },
  {
    'id': '3416',
    'nome': 'Canto do Buriti',
    'estado': 'PI'
  },
  {
    'id': '3417',
    'nome': 'Capitão de Campos',
    'estado': 'PI'
  },
  {
    'id': '3418',
    'nome': 'Capitão Gervásio Oliveira',
    'estado': 'PI'
  },
  {
    'id': '3419',
    'nome': 'Caracol',
    'estado': 'PI'
  },
  {
    'id': '3420',
    'nome': 'Caraúbas do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3421',
    'nome': 'Caridade do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3422',
    'nome': 'Castelo do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3423',
    'nome': 'Caxingó',
    'estado': 'PI'
  },
  {
    'id': '3424',
    'nome': 'Cocal',
    'estado': 'PI'
  },
  {
    'id': '3425',
    'nome': 'Cocal de Telha',
    'estado': 'PI'
  },
  {
    'id': '3426',
    'nome': 'Cocal dos Alves',
    'estado': 'PI'
  },
  {
    'id': '3427',
    'nome': 'Coivaras',
    'estado': 'PI'
  },
  {
    'id': '3428',
    'nome': 'Colônia do Gurguéia',
    'estado': 'PI'
  },
  {
    'id': '3429',
    'nome': 'Colônia do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3430',
    'nome': 'Conceição do Canindé',
    'estado': 'PI'
  },
  {
    'id': '3431',
    'nome': 'Coronel José Dias',
    'estado': 'PI'
  },
  {
    'id': '3432',
    'nome': 'Corrente',
    'estado': 'PI'
  },
  {
    'id': '3433',
    'nome': 'Cristalândia do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3434',
    'nome': 'Cristino Castro',
    'estado': 'PI'
  },
  {
    'id': '3435',
    'nome': 'Curimatá',
    'estado': 'PI'
  },
  {
    'id': '3436',
    'nome': 'Currais',
    'estado': 'PI'
  },
  {
    'id': '3437',
    'nome': 'Curral Novo do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3438',
    'nome': 'Curralinhos',
    'estado': 'PI'
  },
  {
    'id': '3439',
    'nome': 'Demerval Lobão',
    'estado': 'PI'
  },
  {
    'id': '3440',
    'nome': 'Dirceu Arcoverde',
    'estado': 'PI'
  },
  {
    'id': '3441',
    'nome': 'Dom Expedito Lopes',
    'estado': 'PI'
  },
  {
    'id': '3442',
    'nome': 'Dom Inocêncio',
    'estado': 'PI'
  },
  {
    'id': '3443',
    'nome': 'Domingos Mourão',
    'estado': 'PI'
  },
  {
    'id': '3444',
    'nome': 'Elesbão Veloso',
    'estado': 'PI'
  },
  {
    'id': '3445',
    'nome': 'Eliseu Martins',
    'estado': 'PI'
  },
  {
    'id': '3446',
    'nome': 'Esperantina',
    'estado': 'PI'
  },
  {
    'id': '3447',
    'nome': 'Fartura do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3448',
    'nome': 'Flores do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3449',
    'nome': 'Floresta do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3450',
    'nome': 'Floriano',
    'estado': 'PI'
  },
  {
    'id': '3451',
    'nome': 'Francinópolis',
    'estado': 'PI'
  },
  {
    'id': '3452',
    'nome': 'Francisco Ayres',
    'estado': 'PI'
  },
  {
    'id': '3453',
    'nome': 'Francisco Macedo',
    'estado': 'PI'
  },
  {
    'id': '3454',
    'nome': 'Francisco Santos',
    'estado': 'PI'
  },
  {
    'id': '3455',
    'nome': 'Fronteiras',
    'estado': 'PI'
  },
  {
    'id': '3456',
    'nome': 'Geminiano',
    'estado': 'PI'
  },
  {
    'id': '3457',
    'nome': 'Gilbués',
    'estado': 'PI'
  },
  {
    'id': '3458',
    'nome': 'Guadalupe',
    'estado': 'PI'
  },
  {
    'id': '3459',
    'nome': 'Guaribas',
    'estado': 'PI'
  },
  {
    'id': '3460',
    'nome': 'Hugo Napoleão',
    'estado': 'PI'
  },
  {
    'id': '3461',
    'nome': 'Ilha Grande',
    'estado': 'PI'
  },
  {
    'id': '3462',
    'nome': 'Inhuma',
    'estado': 'PI'
  },
  {
    'id': '3463',
    'nome': 'Ipiranga do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3464',
    'nome': 'Isaías Coelho',
    'estado': 'PI'
  },
  {
    'id': '3465',
    'nome': 'Itainópolis',
    'estado': 'PI'
  },
  {
    'id': '3466',
    'nome': 'Itaueira',
    'estado': 'PI'
  },
  {
    'id': '3467',
    'nome': 'Jacobina do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3468',
    'nome': 'Jaicós',
    'estado': 'PI'
  },
  {
    'id': '3469',
    'nome': 'Jardim do Mulato',
    'estado': 'PI'
  },
  {
    'id': '3470',
    'nome': 'Jatobá do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3471',
    'nome': 'Jerumenha',
    'estado': 'PI'
  },
  {
    'id': '3472',
    'nome': 'João Costa',
    'estado': 'PI'
  },
  {
    'id': '3473',
    'nome': 'Joaquim Pires',
    'estado': 'PI'
  },
  {
    'id': '3474',
    'nome': 'Joca Marques',
    'estado': 'PI'
  },
  {
    'id': '3475',
    'nome': 'José de Freitas',
    'estado': 'PI'
  },
  {
    'id': '3476',
    'nome': 'Juazeiro do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3477',
    'nome': 'Júlio Borges',
    'estado': 'PI'
  },
  {
    'id': '3478',
    'nome': 'Jurema',
    'estado': 'PI'
  },
  {
    'id': '3479',
    'nome': 'Lagoa Alegre',
    'estado': 'PI'
  },
  {
    'id': '3480',
    'nome': 'Lagoa de São Francisco',
    'estado': 'PI'
  },
  {
    'id': '3481',
    'nome': 'Lagoa do Barro do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3482',
    'nome': 'Lagoa do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3483',
    'nome': 'Lagoa do Sítio',
    'estado': 'PI'
  },
  {
    'id': '3484',
    'nome': 'Lagoinha do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3485',
    'nome': 'Landri Sales',
    'estado': 'PI'
  },
  {
    'id': '3486',
    'nome': 'Luís Correia',
    'estado': 'PI'
  },
  {
    'id': '3487',
    'nome': 'Luzilândia',
    'estado': 'PI'
  },
  {
    'id': '3488',
    'nome': 'Madeiro',
    'estado': 'PI'
  },
  {
    'id': '3489',
    'nome': 'Manoel Emídio',
    'estado': 'PI'
  },
  {
    'id': '3490',
    'nome': 'Marcolândia',
    'estado': 'PI'
  },
  {
    'id': '3491',
    'nome': 'Marcos Parente',
    'estado': 'PI'
  },
  {
    'id': '3492',
    'nome': 'Massapê do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3493',
    'nome': 'Matias Olímpio',
    'estado': 'PI'
  },
  {
    'id': '3494',
    'nome': 'Miguel Alves',
    'estado': 'PI'
  },
  {
    'id': '3495',
    'nome': 'Miguel Leão',
    'estado': 'PI'
  },
  {
    'id': '3496',
    'nome': 'Milton Brandão',
    'estado': 'PI'
  },
  {
    'id': '3497',
    'nome': 'Monsenhor Gil',
    'estado': 'PI'
  },
  {
    'id': '3498',
    'nome': 'Monsenhor Hipólito',
    'estado': 'PI'
  },
  {
    'id': '3499',
    'nome': 'Monte Alegre do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3500',
    'nome': 'Morro Cabeça no Tempo',
    'estado': 'PI'
  },
  {
    'id': '3501',
    'nome': 'Morro do Chapéu do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3502',
    'nome': 'Murici dos Portelas',
    'estado': 'PI'
  },
  {
    'id': '3503',
    'nome': 'Nazaré do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3504',
    'nome': 'Nossa Senhora de Nazaré',
    'estado': 'PI'
  },
  {
    'id': '3505',
    'nome': 'Nossa Senhora dos Remédios',
    'estado': 'PI'
  },
  {
    'id': '3506',
    'nome': 'Nova Santa Rita',
    'estado': 'PI'
  },
  {
    'id': '3507',
    'nome': 'Novo Oriente do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3508',
    'nome': 'Novo Santo Antônio',
    'estado': 'PI'
  },
  {
    'id': '3509',
    'nome': 'Oeiras',
    'estado': 'PI'
  },
  {
    'id': '3510',
    'nome': 'Olho d`Água do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3511',
    'nome': 'Padre Marcos',
    'estado': 'PI'
  },
  {
    'id': '3512',
    'nome': 'Paes Landim',
    'estado': 'PI'
  },
  {
    'id': '3513',
    'nome': 'Pajeú do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3514',
    'nome': 'Palmeira do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3515',
    'nome': 'Palmeirais',
    'estado': 'PI'
  },
  {
    'id': '3516',
    'nome': 'Paquetá',
    'estado': 'PI'
  },
  {
    'id': '3517',
    'nome': 'Parnaguá',
    'estado': 'PI'
  },
  {
    'id': '3518',
    'nome': 'Parnaíba',
    'estado': 'PI'
  },
  {
    'id': '3519',
    'nome': 'Passagem Franca do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3520',
    'nome': 'Patos do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3521',
    'nome': 'Pau d`Arco do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3522',
    'nome': 'Paulistana',
    'estado': 'PI'
  },
  {
    'id': '3523',
    'nome': 'Pavussu',
    'estado': 'PI'
  },
  {
    'id': '3524',
    'nome': 'Pedro II',
    'estado': 'PI'
  },
  {
    'id': '3525',
    'nome': 'Pedro Laurentino',
    'estado': 'PI'
  },
  {
    'id': '3526',
    'nome': 'Picos',
    'estado': 'PI'
  },
  {
    'id': '3527',
    'nome': 'Pimenteiras',
    'estado': 'PI'
  },
  {
    'id': '3528',
    'nome': 'Pio IX',
    'estado': 'PI'
  },
  {
    'id': '3529',
    'nome': 'Piracuruca',
    'estado': 'PI'
  },
  {
    'id': '3530',
    'nome': 'Piripiri',
    'estado': 'PI'
  },
  {
    'id': '3531',
    'nome': 'Porto',
    'estado': 'PI'
  },
  {
    'id': '3532',
    'nome': 'Porto Alegre do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3533',
    'nome': 'Prata do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3534',
    'nome': 'Queimada Nova',
    'estado': 'PI'
  },
  {
    'id': '3535',
    'nome': 'Redenção do Gurguéia',
    'estado': 'PI'
  },
  {
    'id': '3536',
    'nome': 'Regeneração',
    'estado': 'PI'
  },
  {
    'id': '3537',
    'nome': 'Riacho Frio',
    'estado': 'PI'
  },
  {
    'id': '3538',
    'nome': 'Ribeira do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3539',
    'nome': 'Ribeiro Gonçalves',
    'estado': 'PI'
  },
  {
    'id': '3540',
    'nome': 'Rio Grande do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3541',
    'nome': 'Santa Cruz do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3542',
    'nome': 'Santa Cruz dos Milagres',
    'estado': 'PI'
  },
  {
    'id': '3543',
    'nome': 'Santa Filomena',
    'estado': 'PI'
  },
  {
    'id': '3544',
    'nome': 'Santa Luz',
    'estado': 'PI'
  },
  {
    'id': '3545',
    'nome': 'Santa Rosa do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3546',
    'nome': 'Santana do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3547',
    'nome': 'Santo Antônio de Lisboa',
    'estado': 'PI'
  },
  {
    'id': '3548',
    'nome': 'Santo Antônio dos Milagres',
    'estado': 'PI'
  },
  {
    'id': '3549',
    'nome': 'Santo Inácio do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3550',
    'nome': 'São Braz do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3551',
    'nome': 'São Félix do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3552',
    'nome': 'São Francisco de Assis do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3553',
    'nome': 'São Francisco do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3554',
    'nome': 'São Gonçalo do Gurguéia',
    'estado': 'PI'
  },
  {
    'id': '3555',
    'nome': 'São Gonçalo do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3556',
    'nome': 'São João da Canabrava',
    'estado': 'PI'
  },
  {
    'id': '3557',
    'nome': 'São João da Fronteira',
    'estado': 'PI'
  },
  {
    'id': '3558',
    'nome': 'São João da Serra',
    'estado': 'PI'
  },
  {
    'id': '3559',
    'nome': 'São João da Varjota',
    'estado': 'PI'
  },
  {
    'id': '3560',
    'nome': 'São João do Arraial',
    'estado': 'PI'
  },
  {
    'id': '3561',
    'nome': 'São João do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3562',
    'nome': 'São José do Divino',
    'estado': 'PI'
  },
  {
    'id': '3563',
    'nome': 'São José do Peixe',
    'estado': 'PI'
  },
  {
    'id': '3564',
    'nome': 'São José do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3565',
    'nome': 'São Julião',
    'estado': 'PI'
  },
  {
    'id': '3566',
    'nome': 'São Lourenço do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3567',
    'nome': 'São Luis do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3568',
    'nome': 'São Miguel da Baixa Grande',
    'estado': 'PI'
  },
  {
    'id': '3569',
    'nome': 'São Miguel do Fidalgo',
    'estado': 'PI'
  },
  {
    'id': '3570',
    'nome': 'São Miguel do Tapuio',
    'estado': 'PI'
  },
  {
    'id': '3571',
    'nome': 'São Pedro do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3572',
    'nome': 'São Raimundo Nonato',
    'estado': 'PI'
  },
  {
    'id': '3573',
    'nome': 'Sebastião Barros',
    'estado': 'PI'
  },
  {
    'id': '3574',
    'nome': 'Sebastião Leal',
    'estado': 'PI'
  },
  {
    'id': '3575',
    'nome': 'Sigefredo Pacheco',
    'estado': 'PI'
  },
  {
    'id': '3576',
    'nome': 'Simões',
    'estado': 'PI'
  },
  {
    'id': '3577',
    'nome': 'Simplício Mendes',
    'estado': 'PI'
  },
  {
    'id': '3578',
    'nome': 'Socorro do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3579',
    'nome': 'Sussuapara',
    'estado': 'PI'
  },
  {
    'id': '3580',
    'nome': 'Tamboril do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3581',
    'nome': 'Tanque do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3582',
    'nome': 'Teresina',
    'estado': 'PI'
  },
  {
    'id': '3583',
    'nome': 'União',
    'estado': 'PI'
  },
  {
    'id': '3584',
    'nome': 'Uruçuí',
    'estado': 'PI'
  },
  {
    'id': '3585',
    'nome': 'Valença do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3586',
    'nome': 'Várzea Branca',
    'estado': 'PI'
  },
  {
    'id': '3587',
    'nome': 'Várzea Grande',
    'estado': 'PI'
  },
  {
    'id': '3588',
    'nome': 'Vera Mendes',
    'estado': 'PI'
  },
  {
    'id': '3589',
    'nome': 'Vila Nova do Piauí',
    'estado': 'PI'
  },
  {
    'id': '3590',
    'nome': 'Wall Ferraz',
    'estado': 'PI'
  },
  {
    'id': '3591',
    'nome': 'Angra dos Reis',
    'estado': 'RJ'
  },
  {
    'id': '3592',
    'nome': 'Aperibé',
    'estado': 'RJ'
  },
  {
    'id': '3593',
    'nome': 'Araruama',
    'estado': 'RJ'
  },
  {
    'id': '3594',
    'nome': 'Areal',
    'estado': 'RJ'
  },
  {
    'id': '3595',
    'nome': 'Armação dos Búzios',
    'estado': 'RJ'
  },
  {
    'id': '3596',
    'nome': 'Arraial do Cabo',
    'estado': 'RJ'
  },
  {
    'id': '3597',
    'nome': 'Barra do Piraí',
    'estado': 'RJ'
  },
  {
    'id': '3598',
    'nome': 'Barra Mansa',
    'estado': 'RJ'
  },
  {
    'id': '3599',
    'nome': 'Belford Roxo',
    'estado': 'RJ'
  },
  {
    'id': '3600',
    'nome': 'Bom Jardim',
    'estado': 'RJ'
  },
  {
    'id': '3601',
    'nome': 'Bom Jesus do Itabapoana',
    'estado': 'RJ'
  },
  {
    'id': '3602',
    'nome': 'Cabo Frio',
    'estado': 'RJ'
  },
  {
    'id': '3603',
    'nome': 'Cachoeiras de Macacu',
    'estado': 'RJ'
  },
  {
    'id': '3604',
    'nome': 'Cambuci',
    'estado': 'RJ'
  },
  {
    'id': '3605',
    'nome': 'Campos dos Goytacazes',
    'estado': 'RJ'
  },
  {
    'id': '3606',
    'nome': 'Cantagalo',
    'estado': 'RJ'
  },
  {
    'id': '3607',
    'nome': 'Carapebus',
    'estado': 'RJ'
  },
  {
    'id': '3608',
    'nome': 'Cardoso Moreira',
    'estado': 'RJ'
  },
  {
    'id': '3609',
    'nome': 'Carmo',
    'estado': 'RJ'
  },
  {
    'id': '3610',
    'nome': 'Casimiro de Abreu',
    'estado': 'RJ'
  },
  {
    'id': '3611',
    'nome': 'Comendador Levy Gasparian',
    'estado': 'RJ'
  },
  {
    'id': '3612',
    'nome': 'Conceição de Macabu',
    'estado': 'RJ'
  },
  {
    'id': '3613',
    'nome': 'Cordeiro',
    'estado': 'RJ'
  },
  {
    'id': '3614',
    'nome': 'Duas Barras',
    'estado': 'RJ'
  },
  {
    'id': '3615',
    'nome': 'Duque de Caxias',
    'estado': 'RJ'
  },
  {
    'id': '3616',
    'nome': 'Engenheiro Paulo de Frontin',
    'estado': 'RJ'
  },
  {
    'id': '3617',
    'nome': 'Guapimirim',
    'estado': 'RJ'
  },
  {
    'id': '3618',
    'nome': 'Iguaba Grande',
    'estado': 'RJ'
  },
  {
    'id': '3619',
    'nome': 'Itaboraí',
    'estado': 'RJ'
  },
  {
    'id': '3620',
    'nome': 'Itaguaí',
    'estado': 'RJ'
  },
  {
    'id': '3621',
    'nome': 'Italva',
    'estado': 'RJ'
  },
  {
    'id': '3622',
    'nome': 'Itaocara',
    'estado': 'RJ'
  },
  {
    'id': '3623',
    'nome': 'Itaperuna',
    'estado': 'RJ'
  },
  {
    'id': '3624',
    'nome': 'Itatiaia',
    'estado': 'RJ'
  },
  {
    'id': '3625',
    'nome': 'Japeri',
    'estado': 'RJ'
  },
  {
    'id': '3626',
    'nome': 'Laje do Muriaé',
    'estado': 'RJ'
  },
  {
    'id': '3627',
    'nome': 'Macaé',
    'estado': 'RJ'
  },
  {
    'id': '3628',
    'nome': 'Macuco',
    'estado': 'RJ'
  },
  {
    'id': '3629',
    'nome': 'Magé',
    'estado': 'RJ'
  },
  {
    'id': '3630',
    'nome': 'Mangaratiba',
    'estado': 'RJ'
  },
  {
    'id': '3631',
    'nome': 'Maricá',
    'estado': 'RJ'
  },
  {
    'id': '3632',
    'nome': 'Mendes',
    'estado': 'RJ'
  },
  {
    'id': '3633',
    'nome': 'Mesquita',
    'estado': 'RJ'
  },
  {
    'id': '3634',
    'nome': 'Miguel Pereira',
    'estado': 'RJ'
  },
  {
    'id': '3635',
    'nome': 'Miracema',
    'estado': 'RJ'
  },
  {
    'id': '3636',
    'nome': 'Natividade',
    'estado': 'RJ'
  },
  {
    'id': '3637',
    'nome': 'Nilópolis',
    'estado': 'RJ'
  },
  {
    'id': '3638',
    'nome': 'Niterói',
    'estado': 'RJ'
  },
  {
    'id': '3639',
    'nome': 'Nova Friburgo',
    'estado': 'RJ'
  },
  {
    'id': '3640',
    'nome': 'Nova Iguaçu',
    'estado': 'RJ'
  },
  {
    'id': '3641',
    'nome': 'Paracambi',
    'estado': 'RJ'
  },
  {
    'id': '3642',
    'nome': 'Paraíba do Sul',
    'estado': 'RJ'
  },
  {
    'id': '3643',
    'nome': 'Parati',
    'estado': 'RJ'
  },
  {
    'id': '3644',
    'nome': 'Paty do Alferes',
    'estado': 'RJ'
  },
  {
    'id': '3645',
    'nome': 'Petrópolis',
    'estado': 'RJ'
  },
  {
    'id': '3646',
    'nome': 'Pinheiral',
    'estado': 'RJ'
  },
  {
    'id': '3647',
    'nome': 'Piraí',
    'estado': 'RJ'
  },
  {
    'id': '3648',
    'nome': 'Porciúncula',
    'estado': 'RJ'
  },
  {
    'id': '3649',
    'nome': 'Porto Real',
    'estado': 'RJ'
  },
  {
    'id': '3650',
    'nome': 'Quatis',
    'estado': 'RJ'
  },
  {
    'id': '3651',
    'nome': 'Queimados',
    'estado': 'RJ'
  },
  {
    'id': '3652',
    'nome': 'Quissamã',
    'estado': 'RJ'
  },
  {
    'id': '3653',
    'nome': 'Resende',
    'estado': 'RJ'
  },
  {
    'id': '3654',
    'nome': 'Rio Bonito',
    'estado': 'RJ'
  },
  {
    'id': '3655',
    'nome': 'Rio Claro',
    'estado': 'RJ'
  },
  {
    'id': '3656',
    'nome': 'Rio das Flores',
    'estado': 'RJ'
  },
  {
    'id': '3657',
    'nome': 'Rio das Ostras',
    'estado': 'RJ'
  },
  {
    'id': '3658',
    'nome': 'Rio de Janeiro',
    'estado': 'RJ'
  },
  {
    'id': '3659',
    'nome': 'Santa Maria Madalena',
    'estado': 'RJ'
  },
  {
    'id': '3660',
    'nome': 'Santo Antônio de Pádua',
    'estado': 'RJ'
  },
  {
    'id': '3661',
    'nome': 'São Fidélis',
    'estado': 'RJ'
  },
  {
    'id': '3662',
    'nome': 'São Francisco de Itabapoana',
    'estado': 'RJ'
  },
  {
    'id': '3663',
    'nome': 'São Gonçalo',
    'estado': 'RJ'
  },
  {
    'id': '3664',
    'nome': 'São João da Barra',
    'estado': 'RJ'
  },
  {
    'id': '3665',
    'nome': 'São João de Meriti',
    'estado': 'RJ'
  },
  {
    'id': '3666',
    'nome': 'São José de Ubá',
    'estado': 'RJ'
  },
  {
    'id': '3667',
    'nome': 'São José do Vale do Rio Pret',
    'estado': 'RJ'
  },
  {
    'id': '3668',
    'nome': 'São Pedro da Aldeia',
    'estado': 'RJ'
  },
  {
    'id': '3669',
    'nome': 'São Sebastião do Alto',
    'estado': 'RJ'
  },
  {
    'id': '3670',
    'nome': 'Sapucaia',
    'estado': 'RJ'
  },
  {
    'id': '3671',
    'nome': 'Saquarema',
    'estado': 'RJ'
  },
  {
    'id': '3672',
    'nome': 'Seropédica',
    'estado': 'RJ'
  },
  {
    'id': '3673',
    'nome': 'Silva Jardim',
    'estado': 'RJ'
  },
  {
    'id': '3674',
    'nome': 'Sumidouro',
    'estado': 'RJ'
  },
  {
    'id': '3675',
    'nome': 'Tanguá',
    'estado': 'RJ'
  },
  {
    'id': '3676',
    'nome': 'Teresópolis',
    'estado': 'RJ'
  },
  {
    'id': '3677',
    'nome': 'Trajano de Morais',
    'estado': 'RJ'
  },
  {
    'id': '3678',
    'nome': 'Três Rios',
    'estado': 'RJ'
  },
  {
    'id': '3679',
    'nome': 'Valença',
    'estado': 'RJ'
  },
  {
    'id': '3680',
    'nome': 'Varre-Sai',
    'estado': 'RJ'
  },
  {
    'id': '3681',
    'nome': 'Vassouras',
    'estado': 'RJ'
  },
  {
    'id': '3682',
    'nome': 'Volta Redonda',
    'estado': 'RJ'
  },
  {
    'id': '3683',
    'nome': 'Acari',
    'estado': 'RN'
  },
  {
    'id': '3684',
    'nome': 'Açu',
    'estado': 'RN'
  },
  {
    'id': '3685',
    'nome': 'Afonso Bezerra',
    'estado': 'RN'
  },
  {
    'id': '3686',
    'nome': 'Água Nova',
    'estado': 'RN'
  },
  {
    'id': '3687',
    'nome': 'Alexandria',
    'estado': 'RN'
  },
  {
    'id': '3688',
    'nome': 'Almino Afonso',
    'estado': 'RN'
  },
  {
    'id': '3689',
    'nome': 'Alto do Rodrigues',
    'estado': 'RN'
  },
  {
    'id': '3690',
    'nome': 'Angicos',
    'estado': 'RN'
  },
  {
    'id': '3691',
    'nome': 'Antônio Martins',
    'estado': 'RN'
  },
  {
    'id': '3692',
    'nome': 'Apodi',
    'estado': 'RN'
  },
  {
    'id': '3693',
    'nome': 'Areia Branca',
    'estado': 'RN'
  },
  {
    'id': '3694',
    'nome': 'Arês',
    'estado': 'RN'
  },
  {
    'id': '3695',
    'nome': 'Augusto Severo',
    'estado': 'RN'
  },
  {
    'id': '3696',
    'nome': 'Baía Formosa',
    'estado': 'RN'
  },
  {
    'id': '3697',
    'nome': 'Baraúna',
    'estado': 'RN'
  },
  {
    'id': '3698',
    'nome': 'Barcelona',
    'estado': 'RN'
  },
  {
    'id': '3699',
    'nome': 'Bento Fernandes',
    'estado': 'RN'
  },
  {
    'id': '3700',
    'nome': 'Bodó',
    'estado': 'RN'
  },
  {
    'id': '3701',
    'nome': 'Bom Jesus',
    'estado': 'RN'
  },
  {
    'id': '3702',
    'nome': 'Brejinho',
    'estado': 'RN'
  },
  {
    'id': '3703',
    'nome': 'Caiçara do Norte',
    'estado': 'RN'
  },
  {
    'id': '3704',
    'nome': 'Caiçara do Rio do Vento',
    'estado': 'RN'
  },
  {
    'id': '3705',
    'nome': 'Caicó',
    'estado': 'RN'
  },
  {
    'id': '3706',
    'nome': 'Campo Redondo',
    'estado': 'RN'
  },
  {
    'id': '3707',
    'nome': 'Canguaretama',
    'estado': 'RN'
  },
  {
    'id': '3708',
    'nome': 'Caraúbas',
    'estado': 'RN'
  },
  {
    'id': '3709',
    'nome': 'Carnaúba dos Dantas',
    'estado': 'RN'
  },
  {
    'id': '3710',
    'nome': 'Carnaubais',
    'estado': 'RN'
  },
  {
    'id': '3711',
    'nome': 'Ceará-Mirim',
    'estado': 'RN'
  },
  {
    'id': '3712',
    'nome': 'Cerro Corá',
    'estado': 'RN'
  },
  {
    'id': '3713',
    'nome': 'Coronel Ezequiel',
    'estado': 'RN'
  },
  {
    'id': '3714',
    'nome': 'Coronel João Pessoa',
    'estado': 'RN'
  },
  {
    'id': '3715',
    'nome': 'Cruzeta',
    'estado': 'RN'
  },
  {
    'id': '3716',
    'nome': 'Currais Novos',
    'estado': 'RN'
  },
  {
    'id': '3717',
    'nome': 'Doutor Severiano',
    'estado': 'RN'
  },
  {
    'id': '3718',
    'nome': 'Encanto',
    'estado': 'RN'
  },
  {
    'id': '3719',
    'nome': 'Equador',
    'estado': 'RN'
  },
  {
    'id': '3720',
    'nome': 'Espírito Santo',
    'estado': 'RN'
  },
  {
    'id': '3721',
    'nome': 'Extremoz',
    'estado': 'RN'
  },
  {
    'id': '3722',
    'nome': 'Felipe Guerra',
    'estado': 'RN'
  },
  {
    'id': '3723',
    'nome': 'Fernando Pedroza',
    'estado': 'RN'
  },
  {
    'id': '3724',
    'nome': 'Florânia',
    'estado': 'RN'
  },
  {
    'id': '3725',
    'nome': 'Francisco Dantas',
    'estado': 'RN'
  },
  {
    'id': '3726',
    'nome': 'Frutuoso Gomes',
    'estado': 'RN'
  },
  {
    'id': '3727',
    'nome': 'Galinhos',
    'estado': 'RN'
  },
  {
    'id': '3728',
    'nome': 'Goianinha',
    'estado': 'RN'
  },
  {
    'id': '3729',
    'nome': 'Governador Dix-Sept Rosado',
    'estado': 'RN'
  },
  {
    'id': '3730',
    'nome': 'Grossos',
    'estado': 'RN'
  },
  {
    'id': '3731',
    'nome': 'Guamaré',
    'estado': 'RN'
  },
  {
    'id': '3732',
    'nome': 'Ielmo Marinho',
    'estado': 'RN'
  },
  {
    'id': '3733',
    'nome': 'Ipanguaçu',
    'estado': 'RN'
  },
  {
    'id': '3734',
    'nome': 'Ipueira',
    'estado': 'RN'
  },
  {
    'id': '3735',
    'nome': 'Itajá',
    'estado': 'RN'
  },
  {
    'id': '3736',
    'nome': 'Itaú',
    'estado': 'RN'
  },
  {
    'id': '3737',
    'nome': 'Jaçanã',
    'estado': 'RN'
  },
  {
    'id': '3738',
    'nome': 'Jandaíra',
    'estado': 'RN'
  },
  {
    'id': '3739',
    'nome': 'Janduís',
    'estado': 'RN'
  },
  {
    'id': '3740',
    'nome': 'Januário Cicco',
    'estado': 'RN'
  },
  {
    'id': '3741',
    'nome': 'Japi',
    'estado': 'RN'
  },
  {
    'id': '3742',
    'nome': 'Jardim de Angicos',
    'estado': 'RN'
  },
  {
    'id': '3743',
    'nome': 'Jardim de Piranhas',
    'estado': 'RN'
  },
  {
    'id': '3744',
    'nome': 'Jardim do Seridó',
    'estado': 'RN'
  },
  {
    'id': '3745',
    'nome': 'João Câmara',
    'estado': 'RN'
  },
  {
    'id': '3746',
    'nome': 'João Dias',
    'estado': 'RN'
  },
  {
    'id': '3747',
    'nome': 'José da Penha',
    'estado': 'RN'
  },
  {
    'id': '3748',
    'nome': 'Jucurutu',
    'estado': 'RN'
  },
  {
    'id': '3749',
    'nome': 'Jundiá',
    'estado': 'RN'
  },
  {
    'id': '3750',
    'nome': 'Lagoa d`Anta',
    'estado': 'RN'
  },
  {
    'id': '3751',
    'nome': 'Lagoa de Pedras',
    'estado': 'RN'
  },
  {
    'id': '3752',
    'nome': 'Lagoa de Velhos',
    'estado': 'RN'
  },
  {
    'id': '3753',
    'nome': 'Lagoa Nova',
    'estado': 'RN'
  },
  {
    'id': '3754',
    'nome': 'Lagoa Salgada',
    'estado': 'RN'
  },
  {
    'id': '3755',
    'nome': 'Lajes',
    'estado': 'RN'
  },
  {
    'id': '3756',
    'nome': 'Lajes Pintadas',
    'estado': 'RN'
  },
  {
    'id': '3757',
    'nome': 'Lucrécia',
    'estado': 'RN'
  },
  {
    'id': '3758',
    'nome': 'Luís Gomes',
    'estado': 'RN'
  },
  {
    'id': '3759',
    'nome': 'Macaíba',
    'estado': 'RN'
  },
  {
    'id': '3760',
    'nome': 'Macau',
    'estado': 'RN'
  },
  {
    'id': '3761',
    'nome': 'Major Sales',
    'estado': 'RN'
  },
  {
    'id': '3762',
    'nome': 'Marcelino Vieira',
    'estado': 'RN'
  },
  {
    'id': '3763',
    'nome': 'Martins',
    'estado': 'RN'
  },
  {
    'id': '3764',
    'nome': 'Maxaranguape',
    'estado': 'RN'
  },
  {
    'id': '3765',
    'nome': 'Messias Targino',
    'estado': 'RN'
  },
  {
    'id': '3766',
    'nome': 'Montanhas',
    'estado': 'RN'
  },
  {
    'id': '3767',
    'nome': 'Monte Alegre',
    'estado': 'RN'
  },
  {
    'id': '3768',
    'nome': 'Monte das Gameleiras',
    'estado': 'RN'
  },
  {
    'id': '3769',
    'nome': 'Mossoró',
    'estado': 'RN'
  },
  {
    'id': '3770',
    'nome': 'Natal',
    'estado': 'RN'
  },
  {
    'id': '3771',
    'nome': 'Nísia Floresta',
    'estado': 'RN'
  },
  {
    'id': '3772',
    'nome': 'Nova Cruz',
    'estado': 'RN'
  },
  {
    'id': '3773',
    'nome': 'Olho-d`Água do Borges',
    'estado': 'RN'
  },
  {
    'id': '3774',
    'nome': 'Ouro Branco',
    'estado': 'RN'
  },
  {
    'id': '3775',
    'nome': 'Paraná',
    'estado': 'RN'
  },
  {
    'id': '3776',
    'nome': 'Paraú',
    'estado': 'RN'
  },
  {
    'id': '3777',
    'nome': 'Parazinho',
    'estado': 'RN'
  },
  {
    'id': '3778',
    'nome': 'Parelhas',
    'estado': 'RN'
  },
  {
    'id': '3779',
    'nome': 'Parnamirim',
    'estado': 'RN'
  },
  {
    'id': '3780',
    'nome': 'Passa e Fica',
    'estado': 'RN'
  },
  {
    'id': '3781',
    'nome': 'Passagem',
    'estado': 'RN'
  },
  {
    'id': '3782',
    'nome': 'Patu',
    'estado': 'RN'
  },
  {
    'id': '3783',
    'nome': 'Pau dos Ferros',
    'estado': 'RN'
  },
  {
    'id': '3784',
    'nome': 'Pedra Grande',
    'estado': 'RN'
  },
  {
    'id': '3785',
    'nome': 'Pedra Preta',
    'estado': 'RN'
  },
  {
    'id': '3786',
    'nome': 'Pedro Avelino',
    'estado': 'RN'
  },
  {
    'id': '3787',
    'nome': 'Pedro Velho',
    'estado': 'RN'
  },
  {
    'id': '3788',
    'nome': 'Pendências',
    'estado': 'RN'
  },
  {
    'id': '3789',
    'nome': 'Pilões',
    'estado': 'RN'
  },
  {
    'id': '3790',
    'nome': 'Poço Branco',
    'estado': 'RN'
  },
  {
    'id': '3791',
    'nome': 'Portalegre',
    'estado': 'RN'
  },
  {
    'id': '3792',
    'nome': 'Porto do Mangue',
    'estado': 'RN'
  },
  {
    'id': '3793',
    'nome': 'Presidente Juscelino',
    'estado': 'RN'
  },
  {
    'id': '3794',
    'nome': 'Pureza',
    'estado': 'RN'
  },
  {
    'id': '3795',
    'nome': 'Rafael Fernandes',
    'estado': 'RN'
  },
  {
    'id': '3796',
    'nome': 'Rafael Godeiro',
    'estado': 'RN'
  },
  {
    'id': '3797',
    'nome': 'Riacho da Cruz',
    'estado': 'RN'
  },
  {
    'id': '3798',
    'nome': 'Riacho de Santana',
    'estado': 'RN'
  },
  {
    'id': '3799',
    'nome': 'Riachuelo',
    'estado': 'RN'
  },
  {
    'id': '3800',
    'nome': 'Rio do Fogo',
    'estado': 'RN'
  },
  {
    'id': '3801',
    'nome': 'Rodolfo Fernandes',
    'estado': 'RN'
  },
  {
    'id': '3802',
    'nome': 'Ruy Barbosa',
    'estado': 'RN'
  },
  {
    'id': '3803',
    'nome': 'Santa Cruz',
    'estado': 'RN'
  },
  {
    'id': '3804',
    'nome': 'Santa Maria',
    'estado': 'RN'
  },
  {
    'id': '3805',
    'nome': 'Santana do Matos',
    'estado': 'RN'
  },
  {
    'id': '3806',
    'nome': 'Santana do Seridó',
    'estado': 'RN'
  },
  {
    'id': '3807',
    'nome': 'Santo Antônio',
    'estado': 'RN'
  },
  {
    'id': '3808',
    'nome': 'São Bento do Norte',
    'estado': 'RN'
  },
  {
    'id': '3809',
    'nome': 'São Bento do Trairí',
    'estado': 'RN'
  },
  {
    'id': '3810',
    'nome': 'São Fernando',
    'estado': 'RN'
  },
  {
    'id': '3811',
    'nome': 'São Francisco do Oeste',
    'estado': 'RN'
  },
  {
    'id': '3812',
    'nome': 'São Gonçalo do Amarante',
    'estado': 'RN'
  },
  {
    'id': '3813',
    'nome': 'São João do Sabugi',
    'estado': 'RN'
  },
  {
    'id': '3814',
    'nome': 'São José de Mipibu',
    'estado': 'RN'
  },
  {
    'id': '3815',
    'nome': 'São José do Campestre',
    'estado': 'RN'
  },
  {
    'id': '3816',
    'nome': 'São José do Seridó',
    'estado': 'RN'
  },
  {
    'id': '3817',
    'nome': 'São Miguel',
    'estado': 'RN'
  },
  {
    'id': '3818',
    'nome': 'São Miguel do Gostoso',
    'estado': 'RN'
  },
  {
    'id': '3819',
    'nome': 'São Paulo do Potengi',
    'estado': 'RN'
  },
  {
    'id': '3820',
    'nome': 'São Pedro',
    'estado': 'RN'
  },
  {
    'id': '3821',
    'nome': 'São Rafael',
    'estado': 'RN'
  },
  {
    'id': '3822',
    'nome': 'São Tomé',
    'estado': 'RN'
  },
  {
    'id': '3823',
    'nome': 'São Vicente',
    'estado': 'RN'
  },
  {
    'id': '3824',
    'nome': 'Senador Elói de Souza',
    'estado': 'RN'
  },
  {
    'id': '3825',
    'nome': 'Senador Georgino Avelino',
    'estado': 'RN'
  },
  {
    'id': '3826',
    'nome': 'Serra de São Bento',
    'estado': 'RN'
  },
  {
    'id': '3827',
    'nome': 'Serra do Mel',
    'estado': 'RN'
  },
  {
    'id': '3828',
    'nome': 'Serra Negra do Norte',
    'estado': 'RN'
  },
  {
    'id': '3829',
    'nome': 'Serrinha',
    'estado': 'RN'
  },
  {
    'id': '3830',
    'nome': 'Serrinha dos Pintos',
    'estado': 'RN'
  },
  {
    'id': '3831',
    'nome': 'Severiano Melo',
    'estado': 'RN'
  },
  {
    'id': '3832',
    'nome': 'Sítio Novo',
    'estado': 'RN'
  },
  {
    'id': '3833',
    'nome': 'Taboleiro Grande',
    'estado': 'RN'
  },
  {
    'id': '3834',
    'nome': 'Taipu',
    'estado': 'RN'
  },
  {
    'id': '3835',
    'nome': 'Tangará',
    'estado': 'RN'
  },
  {
    'id': '3836',
    'nome': 'Tenente Ananias',
    'estado': 'RN'
  },
  {
    'id': '3837',
    'nome': 'Tenente Laurentino Cruz',
    'estado': 'RN'
  },
  {
    'id': '3838',
    'nome': 'Tibau',
    'estado': 'RN'
  },
  {
    'id': '3839',
    'nome': 'Tibau do Sul',
    'estado': 'RN'
  },
  {
    'id': '3840',
    'nome': 'Timbaúba dos Batistas',
    'estado': 'RN'
  },
  {
    'id': '3841',
    'nome': 'Touros',
    'estado': 'RN'
  },
  {
    'id': '3842',
    'nome': 'Triunfo Potiguar',
    'estado': 'RN'
  },
  {
    'id': '3843',
    'nome': 'Umarizal',
    'estado': 'RN'
  },
  {
    'id': '3844',
    'nome': 'Upanema',
    'estado': 'RN'
  },
  {
    'id': '3845',
    'nome': 'Várzea',
    'estado': 'RN'
  },
  {
    'id': '3846',
    'nome': 'Venha-Ver',
    'estado': 'RN'
  },
  {
    'id': '3847',
    'nome': 'Vera Cruz',
    'estado': 'RN'
  },
  {
    'id': '3848',
    'nome': 'Viçosa',
    'estado': 'RN'
  },
  {
    'id': '3849',
    'nome': 'Vila Flor',
    'estado': 'RN'
  },
  {
    'id': '3850',
    'nome': 'Aceguá',
    'estado': 'RS'
  },
  {
    'id': '3851',
    'nome': 'Água Santa',
    'estado': 'RS'
  },
  {
    'id': '3852',
    'nome': 'Agudo',
    'estado': 'RS'
  },
  {
    'id': '3853',
    'nome': 'Ajuricaba',
    'estado': 'RS'
  },
  {
    'id': '3854',
    'nome': 'Alecrim',
    'estado': 'RS'
  },
  {
    'id': '3855',
    'nome': 'Alegrete',
    'estado': 'RS'
  },
  {
    'id': '3856',
    'nome': 'Alegria',
    'estado': 'RS'
  },
  {
    'id': '3857',
    'nome': 'Almirante Tamandaré do Sul',
    'estado': 'RS'
  },
  {
    'id': '3858',
    'nome': 'Alpestre',
    'estado': 'RS'
  },
  {
    'id': '3859',
    'nome': 'Alto Alegre',
    'estado': 'RS'
  },
  {
    'id': '3860',
    'nome': 'Alto Feliz',
    'estado': 'RS'
  },
  {
    'id': '3861',
    'nome': 'Alvorada',
    'estado': 'RS'
  },
  {
    'id': '3862',
    'nome': 'Amaral Ferrador',
    'estado': 'RS'
  },
  {
    'id': '3863',
    'nome': 'Ametista do Sul',
    'estado': 'RS'
  },
  {
    'id': '3864',
    'nome': 'André da Rocha',
    'estado': 'RS'
  },
  {
    'id': '3865',
    'nome': 'Anta Gorda',
    'estado': 'RS'
  },
  {
    'id': '3866',
    'nome': 'Antônio Prado',
    'estado': 'RS'
  },
  {
    'id': '3867',
    'nome': 'Arambaré',
    'estado': 'RS'
  },
  {
    'id': '3868',
    'nome': 'Araricá',
    'estado': 'RS'
  },
  {
    'id': '3869',
    'nome': 'Aratiba',
    'estado': 'RS'
  },
  {
    'id': '3870',
    'nome': 'Arroio do Meio',
    'estado': 'RS'
  },
  {
    'id': '3871',
    'nome': 'Arroio do Padre',
    'estado': 'RS'
  },
  {
    'id': '3872',
    'nome': 'Arroio do Sal',
    'estado': 'RS'
  },
  {
    'id': '3873',
    'nome': 'Arroio do Tigre',
    'estado': 'RS'
  },
  {
    'id': '3874',
    'nome': 'Arroio dos Ratos',
    'estado': 'RS'
  },
  {
    'id': '3875',
    'nome': 'Arroio Grande',
    'estado': 'RS'
  },
  {
    'id': '3876',
    'nome': 'Arvorezinha',
    'estado': 'RS'
  },
  {
    'id': '3877',
    'nome': 'Augusto Pestana',
    'estado': 'RS'
  },
  {
    'id': '3878',
    'nome': 'Áurea',
    'estado': 'RS'
  },
  {
    'id': '3879',
    'nome': 'Bagé',
    'estado': 'RS'
  },
  {
    'id': '3880',
    'nome': 'Balneário Pinhal',
    'estado': 'RS'
  },
  {
    'id': '3881',
    'nome': 'Barão',
    'estado': 'RS'
  },
  {
    'id': '3882',
    'nome': 'Barão de Cotegipe',
    'estado': 'RS'
  },
  {
    'id': '3883',
    'nome': 'Barão do Triunfo',
    'estado': 'RS'
  },
  {
    'id': '3884',
    'nome': 'Barra do Guarita',
    'estado': 'RS'
  },
  {
    'id': '3885',
    'nome': 'Barra do Quaraí',
    'estado': 'RS'
  },
  {
    'id': '3886',
    'nome': 'Barra do Ribeiro',
    'estado': 'RS'
  },
  {
    'id': '3887',
    'nome': 'Barra do Rio Azul',
    'estado': 'RS'
  },
  {
    'id': '3888',
    'nome': 'Barra Funda',
    'estado': 'RS'
  },
  {
    'id': '3889',
    'nome': 'Barracão',
    'estado': 'RS'
  },
  {
    'id': '3890',
    'nome': 'Barros Cassal',
    'estado': 'RS'
  },
  {
    'id': '3891',
    'nome': 'Benjamin Constant do Sul',
    'estado': 'RS'
  },
  {
    'id': '3892',
    'nome': 'Bento Gonçalves',
    'estado': 'RS'
  },
  {
    'id': '3893',
    'nome': 'Boa Vista das Missões',
    'estado': 'RS'
  },
  {
    'id': '3894',
    'nome': 'Boa Vista do Buricá',
    'estado': 'RS'
  },
  {
    'id': '3895',
    'nome': 'Boa Vista do Cadeado',
    'estado': 'RS'
  },
  {
    'id': '3896',
    'nome': 'Boa Vista do Incra',
    'estado': 'RS'
  },
  {
    'id': '3897',
    'nome': 'Boa Vista do Sul',
    'estado': 'RS'
  },
  {
    'id': '3898',
    'nome': 'Bom Jesus',
    'estado': 'RS'
  },
  {
    'id': '3899',
    'nome': 'Bom Princípio',
    'estado': 'RS'
  },
  {
    'id': '3900',
    'nome': 'Bom Progresso',
    'estado': 'RS'
  },
  {
    'id': '3901',
    'nome': 'Bom Retiro do Sul',
    'estado': 'RS'
  },
  {
    'id': '3902',
    'nome': 'Boqueirão do Leão',
    'estado': 'RS'
  },
  {
    'id': '3903',
    'nome': 'Bossoroca',
    'estado': 'RS'
  },
  {
    'id': '3904',
    'nome': 'Bozano',
    'estado': 'RS'
  },
  {
    'id': '3905',
    'nome': 'Braga',
    'estado': 'RS'
  },
  {
    'id': '3906',
    'nome': 'Brochier',
    'estado': 'RS'
  },
  {
    'id': '3907',
    'nome': 'Butiá',
    'estado': 'RS'
  },
  {
    'id': '3908',
    'nome': 'Caçapava do Sul',
    'estado': 'RS'
  },
  {
    'id': '3909',
    'nome': 'Cacequi',
    'estado': 'RS'
  },
  {
    'id': '3910',
    'nome': 'Cachoeira do Sul',
    'estado': 'RS'
  },
  {
    'id': '3911',
    'nome': 'Cachoeirinha',
    'estado': 'RS'
  },
  {
    'id': '3912',
    'nome': 'Cacique Doble',
    'estado': 'RS'
  },
  {
    'id': '3913',
    'nome': 'Caibaté',
    'estado': 'RS'
  },
  {
    'id': '3914',
    'nome': 'Caiçara',
    'estado': 'RS'
  },
  {
    'id': '3915',
    'nome': 'Camaquã',
    'estado': 'RS'
  },
  {
    'id': '3916',
    'nome': 'Camargo',
    'estado': 'RS'
  },
  {
    'id': '3917',
    'nome': 'Cambará do Sul',
    'estado': 'RS'
  },
  {
    'id': '3918',
    'nome': 'Campestre da Serra',
    'estado': 'RS'
  },
  {
    'id': '3919',
    'nome': 'Campina das Missões',
    'estado': 'RS'
  },
  {
    'id': '3920',
    'nome': 'Campinas do Sul',
    'estado': 'RS'
  },
  {
    'id': '3921',
    'nome': 'Campo Bom',
    'estado': 'RS'
  },
  {
    'id': '3922',
    'nome': 'Campo Novo',
    'estado': 'RS'
  },
  {
    'id': '3923',
    'nome': 'Campos Borges',
    'estado': 'RS'
  },
  {
    'id': '3924',
    'nome': 'Candelária',
    'estado': 'RS'
  },
  {
    'id': '3925',
    'nome': 'Cândido Godói',
    'estado': 'RS'
  },
  {
    'id': '3926',
    'nome': 'Candiota',
    'estado': 'RS'
  },
  {
    'id': '3927',
    'nome': 'Canela',
    'estado': 'RS'
  },
  {
    'id': '3928',
    'nome': 'Canguçu',
    'estado': 'RS'
  },
  {
    'id': '3929',
    'nome': 'Canoas',
    'estado': 'RS'
  },
  {
    'id': '3930',
    'nome': 'Canudos do Vale',
    'estado': 'RS'
  },
  {
    'id': '3931',
    'nome': 'Capão Bonito do Sul',
    'estado': 'RS'
  },
  {
    'id': '3932',
    'nome': 'Capão da Canoa',
    'estado': 'RS'
  },
  {
    'id': '3933',
    'nome': 'Capão do Cipó',
    'estado': 'RS'
  },
  {
    'id': '3934',
    'nome': 'Capão do Leão',
    'estado': 'RS'
  },
  {
    'id': '3935',
    'nome': 'Capela de Santana',
    'estado': 'RS'
  },
  {
    'id': '3936',
    'nome': 'Capitão',
    'estado': 'RS'
  },
  {
    'id': '3937',
    'nome': 'Capivari do Sul',
    'estado': 'RS'
  },
  {
    'id': '3938',
    'nome': 'Caraá',
    'estado': 'RS'
  },
  {
    'id': '3939',
    'nome': 'Carazinho',
    'estado': 'RS'
  },
  {
    'id': '3940',
    'nome': 'Carlos Barbosa',
    'estado': 'RS'
  },
  {
    'id': '3941',
    'nome': 'Carlos Gomes',
    'estado': 'RS'
  },
  {
    'id': '3942',
    'nome': 'Casca',
    'estado': 'RS'
  },
  {
    'id': '3943',
    'nome': 'Caseiros',
    'estado': 'RS'
  },
  {
    'id': '3944',
    'nome': 'Catuípe',
    'estado': 'RS'
  },
  {
    'id': '3945',
    'nome': 'Caxias do Sul',
    'estado': 'RS'
  },
  {
    'id': '3946',
    'nome': 'Centenário',
    'estado': 'RS'
  },
  {
    'id': '3947',
    'nome': 'Cerrito',
    'estado': 'RS'
  },
  {
    'id': '3948',
    'nome': 'Cerro Branco',
    'estado': 'RS'
  },
  {
    'id': '3949',
    'nome': 'Cerro Grande',
    'estado': 'RS'
  },
  {
    'id': '3950',
    'nome': 'Cerro Grande do Sul',
    'estado': 'RS'
  },
  {
    'id': '3951',
    'nome': 'Cerro Largo',
    'estado': 'RS'
  },
  {
    'id': '3952',
    'nome': 'Chapada',
    'estado': 'RS'
  },
  {
    'id': '3953',
    'nome': 'Charqueadas',
    'estado': 'RS'
  },
  {
    'id': '3954',
    'nome': 'Charrua',
    'estado': 'RS'
  },
  {
    'id': '3955',
    'nome': 'Chiapeta',
    'estado': 'RS'
  },
  {
    'id': '3956',
    'nome': 'Chuí',
    'estado': 'RS'
  },
  {
    'id': '3957',
    'nome': 'Chuvisca',
    'estado': 'RS'
  },
  {
    'id': '3958',
    'nome': 'Cidreira',
    'estado': 'RS'
  },
  {
    'id': '3959',
    'nome': 'Ciríaco',
    'estado': 'RS'
  },
  {
    'id': '3960',
    'nome': 'Colinas',
    'estado': 'RS'
  },
  {
    'id': '3961',
    'nome': 'Colorado',
    'estado': 'RS'
  },
  {
    'id': '3962',
    'nome': 'Condor',
    'estado': 'RS'
  },
  {
    'id': '3963',
    'nome': 'Constantina',
    'estado': 'RS'
  },
  {
    'id': '3964',
    'nome': 'Coqueiro Baixo',
    'estado': 'RS'
  },
  {
    'id': '3965',
    'nome': 'Coqueiros do Sul',
    'estado': 'RS'
  },
  {
    'id': '3966',
    'nome': 'Coronel Barros',
    'estado': 'RS'
  },
  {
    'id': '3967',
    'nome': 'Coronel Bicaco',
    'estado': 'RS'
  },
  {
    'id': '3968',
    'nome': 'Coronel Pilar',
    'estado': 'RS'
  },
  {
    'id': '3969',
    'nome': 'Cotiporã',
    'estado': 'RS'
  },
  {
    'id': '3970',
    'nome': 'Coxilha',
    'estado': 'RS'
  },
  {
    'id': '3971',
    'nome': 'Crissiumal',
    'estado': 'RS'
  },
  {
    'id': '3972',
    'nome': 'Cristal',
    'estado': 'RS'
  },
  {
    'id': '3973',
    'nome': 'Cristal do Sul',
    'estado': 'RS'
  },
  {
    'id': '3974',
    'nome': 'Cruz Alta',
    'estado': 'RS'
  },
  {
    'id': '3975',
    'nome': 'Cruzaltense',
    'estado': 'RS'
  },
  {
    'id': '3976',
    'nome': 'Cruzeiro do Sul',
    'estado': 'RS'
  },
  {
    'id': '3977',
    'nome': 'David Canabarro',
    'estado': 'RS'
  },
  {
    'id': '3978',
    'nome': 'Derrubadas',
    'estado': 'RS'
  },
  {
    'id': '3979',
    'nome': 'Dezesseis de Novembro',
    'estado': 'RS'
  },
  {
    'id': '3980',
    'nome': 'Dilermando de Aguiar',
    'estado': 'RS'
  },
  {
    'id': '3981',
    'nome': 'Dois Irmãos',
    'estado': 'RS'
  },
  {
    'id': '3982',
    'nome': 'Dois Irmãos das Missões',
    'estado': 'RS'
  },
  {
    'id': '3983',
    'nome': 'Dois Lajeados',
    'estado': 'RS'
  },
  {
    'id': '3984',
    'nome': 'Dom Feliciano',
    'estado': 'RS'
  },
  {
    'id': '3985',
    'nome': 'Dom Pedrito',
    'estado': 'RS'
  },
  {
    'id': '3986',
    'nome': 'Dom Pedro de Alcântara',
    'estado': 'RS'
  },
  {
    'id': '3987',
    'nome': 'Dona Francisca',
    'estado': 'RS'
  },
  {
    'id': '3988',
    'nome': 'Doutor Maurício Cardoso',
    'estado': 'RS'
  },
  {
    'id': '3989',
    'nome': 'Doutor Ricardo',
    'estado': 'RS'
  },
  {
    'id': '3990',
    'nome': 'Eldorado do Sul',
    'estado': 'RS'
  },
  {
    'id': '3991',
    'nome': 'Encantado',
    'estado': 'RS'
  },
  {
    'id': '3992',
    'nome': 'Encruzilhada do Sul',
    'estado': 'RS'
  },
  {
    'id': '3993',
    'nome': 'Engenho Velho',
    'estado': 'RS'
  },
  {
    'id': '3994',
    'nome': 'Entre Rios do Sul',
    'estado': 'RS'
  },
  {
    'id': '3995',
    'nome': 'Entre-Ijuís',
    'estado': 'RS'
  },
  {
    'id': '3996',
    'nome': 'Erebango',
    'estado': 'RS'
  },
  {
    'id': '3997',
    'nome': 'Erechim',
    'estado': 'RS'
  },
  {
    'id': '3998',
    'nome': 'Ernestina',
    'estado': 'RS'
  },
  {
    'id': '3999',
    'nome': 'Erval Grande',
    'estado': 'RS'
  },
  {
    'id': '4000',
    'nome': 'Erval Seco',
    'estado': 'RS'
  },
  {
    'id': '4001',
    'nome': 'Esmeralda',
    'estado': 'RS'
  },
  {
    'id': '4002',
    'nome': 'Esperança do Sul',
    'estado': 'RS'
  },
  {
    'id': '4003',
    'nome': 'Espumoso',
    'estado': 'RS'
  },
  {
    'id': '4004',
    'nome': 'Estação',
    'estado': 'RS'
  },
  {
    'id': '4005',
    'nome': 'Estância Velha',
    'estado': 'RS'
  },
  {
    'id': '4006',
    'nome': 'Esteio',
    'estado': 'RS'
  },
  {
    'id': '4007',
    'nome': 'Estrela',
    'estado': 'RS'
  },
  {
    'id': '4008',
    'nome': 'Estrela Velha',
    'estado': 'RS'
  },
  {
    'id': '4009',
    'nome': 'Eugênio de Castro',
    'estado': 'RS'
  },
  {
    'id': '4010',
    'nome': 'Fagundes Varela',
    'estado': 'RS'
  },
  {
    'id': '4011',
    'nome': 'Farroupilha',
    'estado': 'RS'
  },
  {
    'id': '4012',
    'nome': 'Faxinal do Soturno',
    'estado': 'RS'
  },
  {
    'id': '4013',
    'nome': 'Faxinalzinho',
    'estado': 'RS'
  },
  {
    'id': '4014',
    'nome': 'Fazenda Vilanova',
    'estado': 'RS'
  },
  {
    'id': '4015',
    'nome': 'Feliz',
    'estado': 'RS'
  },
  {
    'id': '4016',
    'nome': 'Flores da Cunha',
    'estado': 'RS'
  },
  {
    'id': '4017',
    'nome': 'Floriano Peixoto',
    'estado': 'RS'
  },
  {
    'id': '4018',
    'nome': 'Fontoura Xavier',
    'estado': 'RS'
  },
  {
    'id': '4019',
    'nome': 'Formigueiro',
    'estado': 'RS'
  },
  {
    'id': '4020',
    'nome': 'Forquetinha',
    'estado': 'RS'
  },
  {
    'id': '4021',
    'nome': 'Fortaleza dos Valos',
    'estado': 'RS'
  },
  {
    'id': '4022',
    'nome': 'Frederico Westphalen',
    'estado': 'RS'
  },
  {
    'id': '4023',
    'nome': 'Garibaldi',
    'estado': 'RS'
  },
  {
    'id': '4024',
    'nome': 'Garruchos',
    'estado': 'RS'
  },
  {
    'id': '4025',
    'nome': 'Gaurama',
    'estado': 'RS'
  },
  {
    'id': '4026',
    'nome': 'General Câmara',
    'estado': 'RS'
  },
  {
    'id': '4027',
    'nome': 'Gentil',
    'estado': 'RS'
  },
  {
    'id': '4028',
    'nome': 'Getúlio Vargas',
    'estado': 'RS'
  },
  {
    'id': '4029',
    'nome': 'Giruá',
    'estado': 'RS'
  },
  {
    'id': '4030',
    'nome': 'Glorinha',
    'estado': 'RS'
  },
  {
    'id': '4031',
    'nome': 'Gramado',
    'estado': 'RS'
  },
  {
    'id': '4032',
    'nome': 'Gramado dos Loureiros',
    'estado': 'RS'
  },
  {
    'id': '4033',
    'nome': 'Gramado Xavier',
    'estado': 'RS'
  },
  {
    'id': '4034',
    'nome': 'Gravataí',
    'estado': 'RS'
  },
  {
    'id': '4035',
    'nome': 'Guabiju',
    'estado': 'RS'
  },
  {
    'id': '4036',
    'nome': 'Guaíba',
    'estado': 'RS'
  },
  {
    'id': '4037',
    'nome': 'Guaporé',
    'estado': 'RS'
  },
  {
    'id': '4038',
    'nome': 'Guarani das Missões',
    'estado': 'RS'
  },
  {
    'id': '4039',
    'nome': 'Harmonia',
    'estado': 'RS'
  },
  {
    'id': '4040',
    'nome': 'Herval',
    'estado': 'RS'
  },
  {
    'id': '4041',
    'nome': 'Herveiras',
    'estado': 'RS'
  },
  {
    'id': '4042',
    'nome': 'Horizontina',
    'estado': 'RS'
  },
  {
    'id': '4043',
    'nome': 'Hulha Negra',
    'estado': 'RS'
  },
  {
    'id': '4044',
    'nome': 'Humaitá',
    'estado': 'RS'
  },
  {
    'id': '4045',
    'nome': 'Ibarama',
    'estado': 'RS'
  },
  {
    'id': '4046',
    'nome': 'Ibiaçá',
    'estado': 'RS'
  },
  {
    'id': '4047',
    'nome': 'Ibiraiaras',
    'estado': 'RS'
  },
  {
    'id': '4048',
    'nome': 'Ibirapuitã',
    'estado': 'RS'
  },
  {
    'id': '4049',
    'nome': 'Ibirubá',
    'estado': 'RS'
  },
  {
    'id': '4050',
    'nome': 'Igrejinha',
    'estado': 'RS'
  },
  {
    'id': '4051',
    'nome': 'Ijuí',
    'estado': 'RS'
  },
  {
    'id': '4052',
    'nome': 'Ilópolis',
    'estado': 'RS'
  },
  {
    'id': '4053',
    'nome': 'Imbé',
    'estado': 'RS'
  },
  {
    'id': '4054',
    'nome': 'Imigrante',
    'estado': 'RS'
  },
  {
    'id': '4055',
    'nome': 'Independência',
    'estado': 'RS'
  },
  {
    'id': '4056',
    'nome': 'Inhacorá',
    'estado': 'RS'
  },
  {
    'id': '4057',
    'nome': 'Ipê',
    'estado': 'RS'
  },
  {
    'id': '4058',
    'nome': 'Ipiranga do Sul',
    'estado': 'RS'
  },
  {
    'id': '4059',
    'nome': 'Iraí',
    'estado': 'RS'
  },
  {
    'id': '4060',
    'nome': 'Itaara',
    'estado': 'RS'
  },
  {
    'id': '4061',
    'nome': 'Itacurubi',
    'estado': 'RS'
  },
  {
    'id': '4062',
    'nome': 'Itapuca',
    'estado': 'RS'
  },
  {
    'id': '4063',
    'nome': 'Itaqui',
    'estado': 'RS'
  },
  {
    'id': '4064',
    'nome': 'Itati',
    'estado': 'RS'
  },
  {
    'id': '4065',
    'nome': 'Itatiba do Sul',
    'estado': 'RS'
  },
  {
    'id': '4066',
    'nome': 'Ivorá',
    'estado': 'RS'
  },
  {
    'id': '4067',
    'nome': 'Ivoti',
    'estado': 'RS'
  },
  {
    'id': '4068',
    'nome': 'Jaboticaba',
    'estado': 'RS'
  },
  {
    'id': '4069',
    'nome': 'Jacuizinho',
    'estado': 'RS'
  },
  {
    'id': '4070',
    'nome': 'Jacutinga',
    'estado': 'RS'
  },
  {
    'id': '4071',
    'nome': 'Jaguarão',
    'estado': 'RS'
  },
  {
    'id': '4072',
    'nome': 'Jaguari',
    'estado': 'RS'
  },
  {
    'id': '4073',
    'nome': 'Jaquirana',
    'estado': 'RS'
  },
  {
    'id': '4074',
    'nome': 'Jari',
    'estado': 'RS'
  },
  {
    'id': '4075',
    'nome': 'Jóia',
    'estado': 'RS'
  },
  {
    'id': '4076',
    'nome': 'Júlio de Castilhos',
    'estado': 'RS'
  },
  {
    'id': '4077',
    'nome': 'Lagoa Bonita do Sul',
    'estado': 'RS'
  },
  {
    'id': '4078',
    'nome': 'Lagoa dos Três Cantos',
    'estado': 'RS'
  },
  {
    'id': '4079',
    'nome': 'Lagoa Vermelha',
    'estado': 'RS'
  },
  {
    'id': '4080',
    'nome': 'Lagoão',
    'estado': 'RS'
  },
  {
    'id': '4081',
    'nome': 'Lajeado',
    'estado': 'RS'
  },
  {
    'id': '4082',
    'nome': 'Lajeado do Bugre',
    'estado': 'RS'
  },
  {
    'id': '4083',
    'nome': 'Lavras do Sul',
    'estado': 'RS'
  },
  {
    'id': '4084',
    'nome': 'Liberato Salzano',
    'estado': 'RS'
  },
  {
    'id': '4085',
    'nome': 'Lindolfo Collor',
    'estado': 'RS'
  },
  {
    'id': '4086',
    'nome': 'Linha Nova',
    'estado': 'RS'
  },
  {
    'id': '4087',
    'nome': 'Maçambara',
    'estado': 'RS'
  },
  {
    'id': '4088',
    'nome': 'Machadinho',
    'estado': 'RS'
  },
  {
    'id': '4089',
    'nome': 'Mampituba',
    'estado': 'RS'
  },
  {
    'id': '4090',
    'nome': 'Manoel Viana',
    'estado': 'RS'
  },
  {
    'id': '4091',
    'nome': 'Maquiné',
    'estado': 'RS'
  },
  {
    'id': '4092',
    'nome': 'Maratá',
    'estado': 'RS'
  },
  {
    'id': '4093',
    'nome': 'Marau',
    'estado': 'RS'
  },
  {
    'id': '4094',
    'nome': 'Marcelino Ramos',
    'estado': 'RS'
  },
  {
    'id': '4095',
    'nome': 'Mariana Pimentel',
    'estado': 'RS'
  },
  {
    'id': '4096',
    'nome': 'Mariano Moro',
    'estado': 'RS'
  },
  {
    'id': '4097',
    'nome': 'Marques de Souza',
    'estado': 'RS'
  },
  {
    'id': '4098',
    'nome': 'Mata',
    'estado': 'RS'
  },
  {
    'id': '4099',
    'nome': 'Mato Castelhano',
    'estado': 'RS'
  },
  {
    'id': '4100',
    'nome': 'Mato Leitão',
    'estado': 'RS'
  },
  {
    'id': '4101',
    'nome': 'Mato Queimado',
    'estado': 'RS'
  },
  {
    'id': '4102',
    'nome': 'Maximiliano de Almeida',
    'estado': 'RS'
  },
  {
    'id': '4103',
    'nome': 'Minas do Leão',
    'estado': 'RS'
  },
  {
    'id': '4104',
    'nome': 'Miraguaí',
    'estado': 'RS'
  },
  {
    'id': '4105',
    'nome': 'Montauri',
    'estado': 'RS'
  },
  {
    'id': '4106',
    'nome': 'Monte Alegre dos Campos',
    'estado': 'RS'
  },
  {
    'id': '4107',
    'nome': 'Monte Belo do Sul',
    'estado': 'RS'
  },
  {
    'id': '4108',
    'nome': 'Montenegro',
    'estado': 'RS'
  },
  {
    'id': '4109',
    'nome': 'Mormaço',
    'estado': 'RS'
  },
  {
    'id': '4110',
    'nome': 'Morrinhos do Sul',
    'estado': 'RS'
  },
  {
    'id': '4111',
    'nome': 'Morro Redondo',
    'estado': 'RS'
  },
  {
    'id': '4112',
    'nome': 'Morro Reuter',
    'estado': 'RS'
  },
  {
    'id': '4113',
    'nome': 'Mostardas',
    'estado': 'RS'
  },
  {
    'id': '4114',
    'nome': 'Muçum',
    'estado': 'RS'
  },
  {
    'id': '4115',
    'nome': 'Muitos Capões',
    'estado': 'RS'
  },
  {
    'id': '4116',
    'nome': 'Muliterno',
    'estado': 'RS'
  },
  {
    'id': '4117',
    'nome': 'Não-Me-Toque',
    'estado': 'RS'
  },
  {
    'id': '4118',
    'nome': 'Nicolau Vergueiro',
    'estado': 'RS'
  },
  {
    'id': '4119',
    'nome': 'Nonoai',
    'estado': 'RS'
  },
  {
    'id': '4120',
    'nome': 'Nova Alvorada',
    'estado': 'RS'
  },
  {
    'id': '4121',
    'nome': 'Nova Araçá',
    'estado': 'RS'
  },
  {
    'id': '4122',
    'nome': 'Nova Bassano',
    'estado': 'RS'
  },
  {
    'id': '4123',
    'nome': 'Nova Boa Vista',
    'estado': 'RS'
  },
  {
    'id': '4124',
    'nome': 'Nova Bréscia',
    'estado': 'RS'
  },
  {
    'id': '4125',
    'nome': 'Nova Candelária',
    'estado': 'RS'
  },
  {
    'id': '4126',
    'nome': 'Nova Esperança do Sul',
    'estado': 'RS'
  },
  {
    'id': '4127',
    'nome': 'Nova Hartz',
    'estado': 'RS'
  },
  {
    'id': '4128',
    'nome': 'Nova Pádua',
    'estado': 'RS'
  },
  {
    'id': '4129',
    'nome': 'Nova Palma',
    'estado': 'RS'
  },
  {
    'id': '4130',
    'nome': 'Nova Petrópolis',
    'estado': 'RS'
  },
  {
    'id': '4131',
    'nome': 'Nova Prata',
    'estado': 'RS'
  },
  {
    'id': '4132',
    'nome': 'Nova Ramada',
    'estado': 'RS'
  },
  {
    'id': '4133',
    'nome': 'Nova Roma do Sul',
    'estado': 'RS'
  },
  {
    'id': '4134',
    'nome': 'Nova Santa Rita',
    'estado': 'RS'
  },
  {
    'id': '4135',
    'nome': 'Novo Barreiro',
    'estado': 'RS'
  },
  {
    'id': '4136',
    'nome': 'Novo Cabrais',
    'estado': 'RS'
  },
  {
    'id': '4137',
    'nome': 'Novo Hamburgo',
    'estado': 'RS'
  },
  {
    'id': '4138',
    'nome': 'Novo Machado',
    'estado': 'RS'
  },
  {
    'id': '4139',
    'nome': 'Novo Tiradentes',
    'estado': 'RS'
  },
  {
    'id': '4140',
    'nome': 'Novo Xingu',
    'estado': 'RS'
  },
  {
    'id': '4141',
    'nome': 'Osório',
    'estado': 'RS'
  },
  {
    'id': '4142',
    'nome': 'Paim Filho',
    'estado': 'RS'
  },
  {
    'id': '4143',
    'nome': 'Palmares do Sul',
    'estado': 'RS'
  },
  {
    'id': '4144',
    'nome': 'Palmeira das Missões',
    'estado': 'RS'
  },
  {
    'id': '4145',
    'nome': 'Palmitinho',
    'estado': 'RS'
  },
  {
    'id': '4146',
    'nome': 'Panambi',
    'estado': 'RS'
  },
  {
    'id': '4147',
    'nome': 'Pantano Grande',
    'estado': 'RS'
  },
  {
    'id': '4148',
    'nome': 'Paraí',
    'estado': 'RS'
  },
  {
    'id': '4149',
    'nome': 'Paraíso do Sul',
    'estado': 'RS'
  },
  {
    'id': '4150',
    'nome': 'Pareci Novo',
    'estado': 'RS'
  },
  {
    'id': '4151',
    'nome': 'Parobé',
    'estado': 'RS'
  },
  {
    'id': '4152',
    'nome': 'Passa Sete',
    'estado': 'RS'
  },
  {
    'id': '4153',
    'nome': 'Passo do Sobrado',
    'estado': 'RS'
  },
  {
    'id': '4154',
    'nome': 'Passo Fundo',
    'estado': 'RS'
  },
  {
    'id': '4155',
    'nome': 'Paulo Bento',
    'estado': 'RS'
  },
  {
    'id': '4156',
    'nome': 'Paverama',
    'estado': 'RS'
  },
  {
    'id': '4157',
    'nome': 'Pedras Altas',
    'estado': 'RS'
  },
  {
    'id': '4158',
    'nome': 'Pedro Osório',
    'estado': 'RS'
  },
  {
    'id': '4159',
    'nome': 'Pejuçara',
    'estado': 'RS'
  },
  {
    'id': '4160',
    'nome': 'Pelotas',
    'estado': 'RS'
  },
  {
    'id': '4161',
    'nome': 'Picada Café',
    'estado': 'RS'
  },
  {
    'id': '4162',
    'nome': 'Pinhal',
    'estado': 'RS'
  },
  {
    'id': '4163',
    'nome': 'Pinhal da Serra',
    'estado': 'RS'
  },
  {
    'id': '4164',
    'nome': 'Pinhal Grande',
    'estado': 'RS'
  },
  {
    'id': '4165',
    'nome': 'Pinheirinho do Vale',
    'estado': 'RS'
  },
  {
    'id': '4166',
    'nome': 'Pinheiro Machado',
    'estado': 'RS'
  },
  {
    'id': '4167',
    'nome': 'Pirapó',
    'estado': 'RS'
  },
  {
    'id': '4168',
    'nome': 'Piratini',
    'estado': 'RS'
  },
  {
    'id': '4169',
    'nome': 'Planalto',
    'estado': 'RS'
  },
  {
    'id': '4170',
    'nome': 'Poço das Antas',
    'estado': 'RS'
  },
  {
    'id': '4171',
    'nome': 'Pontão',
    'estado': 'RS'
  },
  {
    'id': '4172',
    'nome': 'Ponte Preta',
    'estado': 'RS'
  },
  {
    'id': '4173',
    'nome': 'Portão',
    'estado': 'RS'
  },
  {
    'id': '4174',
    'nome': 'Porto Alegre',
    'estado': 'RS'
  },
  {
    'id': '4175',
    'nome': 'Porto Lucena',
    'estado': 'RS'
  },
  {
    'id': '4176',
    'nome': 'Porto Mauá',
    'estado': 'RS'
  },
  {
    'id': '4177',
    'nome': 'Porto Vera Cruz',
    'estado': 'RS'
  },
  {
    'id': '4178',
    'nome': 'Porto Xavier',
    'estado': 'RS'
  },
  {
    'id': '4179',
    'nome': 'Pouso Novo',
    'estado': 'RS'
  },
  {
    'id': '4180',
    'nome': 'Presidente Lucena',
    'estado': 'RS'
  },
  {
    'id': '4181',
    'nome': 'Progresso',
    'estado': 'RS'
  },
  {
    'id': '4182',
    'nome': 'Protásio Alves',
    'estado': 'RS'
  },
  {
    'id': '4183',
    'nome': 'Putinga',
    'estado': 'RS'
  },
  {
    'id': '4184',
    'nome': 'Quaraí',
    'estado': 'RS'
  },
  {
    'id': '4185',
    'nome': 'Quatro Irmãos',
    'estado': 'RS'
  },
  {
    'id': '4186',
    'nome': 'Quevedos',
    'estado': 'RS'
  },
  {
    'id': '4187',
    'nome': 'Quinze de Novembro',
    'estado': 'RS'
  },
  {
    'id': '4188',
    'nome': 'Redentora',
    'estado': 'RS'
  },
  {
    'id': '4189',
    'nome': 'Relvado',
    'estado': 'RS'
  },
  {
    'id': '4190',
    'nome': 'Restinga Seca',
    'estado': 'RS'
  },
  {
    'id': '4191',
    'nome': 'Rio dos Índios',
    'estado': 'RS'
  },
  {
    'id': '4192',
    'nome': 'Rio Grande',
    'estado': 'RS'
  },
  {
    'id': '4193',
    'nome': 'Rio Pardo',
    'estado': 'RS'
  },
  {
    'id': '4194',
    'nome': 'Riozinho',
    'estado': 'RS'
  },
  {
    'id': '4195',
    'nome': 'Roca Sales',
    'estado': 'RS'
  },
  {
    'id': '4196',
    'nome': 'Rodeio Bonito',
    'estado': 'RS'
  },
  {
    'id': '4197',
    'nome': 'Rolador',
    'estado': 'RS'
  },
  {
    'id': '4198',
    'nome': 'Rolante',
    'estado': 'RS'
  },
  {
    'id': '4199',
    'nome': 'Ronda Alta',
    'estado': 'RS'
  },
  {
    'id': '4200',
    'nome': 'Rondinha',
    'estado': 'RS'
  },
  {
    'id': '4201',
    'nome': 'Roque Gonzales',
    'estado': 'RS'
  },
  {
    'id': '4202',
    'nome': 'Rosário do Sul',
    'estado': 'RS'
  },
  {
    'id': '4203',
    'nome': 'Sagrada Família',
    'estado': 'RS'
  },
  {
    'id': '4204',
    'nome': 'Saldanha Marinho',
    'estado': 'RS'
  },
  {
    'id': '4205',
    'nome': 'Salto do Jacuí',
    'estado': 'RS'
  },
  {
    'id': '4206',
    'nome': 'Salvador das Missões',
    'estado': 'RS'
  },
  {
    'id': '4207',
    'nome': 'Salvador do Sul',
    'estado': 'RS'
  },
  {
    'id': '4208',
    'nome': 'Sananduva',
    'estado': 'RS'
  },
  {
    'id': '4209',
    'nome': 'Santa Bárbara do Sul',
    'estado': 'RS'
  },
  {
    'id': '4210',
    'nome': 'Santa Cecília do Sul',
    'estado': 'RS'
  },
  {
    'id': '4211',
    'nome': 'Santa Clara do Sul',
    'estado': 'RS'
  },
  {
    'id': '4212',
    'nome': 'Santa Cruz do Sul',
    'estado': 'RS'
  },
  {
    'id': '4213',
    'nome': 'Santa Margarida do Sul',
    'estado': 'RS'
  },
  {
    'id': '4214',
    'nome': 'Santa Maria',
    'estado': 'RS'
  },
  {
    'id': '4215',
    'nome': 'Santa Maria do Herval',
    'estado': 'RS'
  },
  {
    'id': '4216',
    'nome': 'Santa Rosa',
    'estado': 'RS'
  },
  {
    'id': '4217',
    'nome': 'Santa Tereza',
    'estado': 'RS'
  },
  {
    'id': '4218',
    'nome': 'Santa Vitória do Palmar',
    'estado': 'RS'
  },
  {
    'id': '4219',
    'nome': 'Santana da Boa Vista',
    'estado': 'RS'
  },
  {
    'id': '4220',
    'nome': 'Santana do Livramento',
    'estado': 'RS'
  },
  {
    'id': '4221',
    'nome': 'Santiago',
    'estado': 'RS'
  },
  {
    'id': '4222',
    'nome': 'Santo Ângelo',
    'estado': 'RS'
  },
  {
    'id': '4223',
    'nome': 'Santo Antônio da Patrulha',
    'estado': 'RS'
  },
  {
    'id': '4224',
    'nome': 'Santo Antônio das Missões',
    'estado': 'RS'
  },
  {
    'id': '4225',
    'nome': 'Santo Antônio do Palma',
    'estado': 'RS'
  },
  {
    'id': '4226',
    'nome': 'Santo Antônio do Planalto',
    'estado': 'RS'
  },
  {
    'id': '4227',
    'nome': 'Santo Augusto',
    'estado': 'RS'
  },
  {
    'id': '4228',
    'nome': 'Santo Cristo',
    'estado': 'RS'
  },
  {
    'id': '4229',
    'nome': 'Santo Expedito do Sul',
    'estado': 'RS'
  },
  {
    'id': '4230',
    'nome': 'São Borja',
    'estado': 'RS'
  },
  {
    'id': '4231',
    'nome': 'São Domingos do Sul',
    'estado': 'RS'
  },
  {
    'id': '4232',
    'nome': 'São Francisco de Assis',
    'estado': 'RS'
  },
  {
    'id': '4233',
    'nome': 'São Francisco de Paula',
    'estado': 'RS'
  },
  {
    'id': '4234',
    'nome': 'São Gabriel',
    'estado': 'RS'
  },
  {
    'id': '4235',
    'nome': 'São Jerônimo',
    'estado': 'RS'
  },
  {
    'id': '4236',
    'nome': 'São João da Urtiga',
    'estado': 'RS'
  },
  {
    'id': '4237',
    'nome': 'São João do Polêsine',
    'estado': 'RS'
  },
  {
    'id': '4238',
    'nome': 'São Jorge',
    'estado': 'RS'
  },
  {
    'id': '4239',
    'nome': 'São José das Missões',
    'estado': 'RS'
  },
  {
    'id': '4240',
    'nome': 'São José do Herval',
    'estado': 'RS'
  },
  {
    'id': '4241',
    'nome': 'São José do Hortêncio',
    'estado': 'RS'
  },
  {
    'id': '4242',
    'nome': 'São José do Inhacorá',
    'estado': 'RS'
  },
  {
    'id': '4243',
    'nome': 'São José do Norte',
    'estado': 'RS'
  },
  {
    'id': '4244',
    'nome': 'São José do Ouro',
    'estado': 'RS'
  },
  {
    'id': '4245',
    'nome': 'São José do Sul',
    'estado': 'RS'
  },
  {
    'id': '4246',
    'nome': 'São José dos Ausentes',
    'estado': 'RS'
  },
  {
    'id': '4247',
    'nome': 'São Leopoldo',
    'estado': 'RS'
  },
  {
    'id': '4248',
    'nome': 'São Lourenço do Sul',
    'estado': 'RS'
  },
  {
    'id': '4249',
    'nome': 'São Luiz Gonzaga',
    'estado': 'RS'
  },
  {
    'id': '4250',
    'nome': 'São Marcos',
    'estado': 'RS'
  },
  {
    'id': '4251',
    'nome': 'São Martinho',
    'estado': 'RS'
  },
  {
    'id': '4252',
    'nome': 'São Martinho da Serra',
    'estado': 'RS'
  },
  {
    'id': '4253',
    'nome': 'São Miguel das Missões',
    'estado': 'RS'
  },
  {
    'id': '4254',
    'nome': 'São Nicolau',
    'estado': 'RS'
  },
  {
    'id': '4255',
    'nome': 'São Paulo das Missões',
    'estado': 'RS'
  },
  {
    'id': '4256',
    'nome': 'São Pedro da Serra',
    'estado': 'RS'
  },
  {
    'id': '4257',
    'nome': 'São Pedro das Missões',
    'estado': 'RS'
  },
  {
    'id': '4258',
    'nome': 'São Pedro do Butiá',
    'estado': 'RS'
  },
  {
    'id': '4259',
    'nome': 'São Pedro do Sul',
    'estado': 'RS'
  },
  {
    'id': '4260',
    'nome': 'São Sebastião do Caí',
    'estado': 'RS'
  },
  {
    'id': '4261',
    'nome': 'São Sepé',
    'estado': 'RS'
  },
  {
    'id': '4262',
    'nome': 'São Valentim',
    'estado': 'RS'
  },
  {
    'id': '4263',
    'nome': 'São Valentim do Sul',
    'estado': 'RS'
  },
  {
    'id': '4264',
    'nome': 'São Valério do Sul',
    'estado': 'RS'
  },
  {
    'id': '4265',
    'nome': 'São Vendelino',
    'estado': 'RS'
  },
  {
    'id': '4266',
    'nome': 'São Vicente do Sul',
    'estado': 'RS'
  },
  {
    'id': '4267',
    'nome': 'Sapiranga',
    'estado': 'RS'
  },
  {
    'id': '4268',
    'nome': 'Sapucaia do Sul',
    'estado': 'RS'
  },
  {
    'id': '4269',
    'nome': 'Sarandi',
    'estado': 'RS'
  },
  {
    'id': '4270',
    'nome': 'Seberi',
    'estado': 'RS'
  },
  {
    'id': '4271',
    'nome': 'Sede Nova',
    'estado': 'RS'
  },
  {
    'id': '4272',
    'nome': 'Segredo',
    'estado': 'RS'
  },
  {
    'id': '4273',
    'nome': 'Selbach',
    'estado': 'RS'
  },
  {
    'id': '4274',
    'nome': 'Senador Salgado Filho',
    'estado': 'RS'
  },
  {
    'id': '4275',
    'nome': 'Sentinela do Sul',
    'estado': 'RS'
  },
  {
    'id': '4276',
    'nome': 'Serafina Corrêa',
    'estado': 'RS'
  },
  {
    'id': '4277',
    'nome': 'Sério',
    'estado': 'RS'
  },
  {
    'id': '4278',
    'nome': 'Sertão',
    'estado': 'RS'
  },
  {
    'id': '4279',
    'nome': 'Sertão Santana',
    'estado': 'RS'
  },
  {
    'id': '4280',
    'nome': 'Sete de Setembro',
    'estado': 'RS'
  },
  {
    'id': '4281',
    'nome': 'Severiano de Almeida',
    'estado': 'RS'
  },
  {
    'id': '4282',
    'nome': 'Silveira Martins',
    'estado': 'RS'
  },
  {
    'id': '4283',
    'nome': 'Sinimbu',
    'estado': 'RS'
  },
  {
    'id': '4284',
    'nome': 'Sobradinho',
    'estado': 'RS'
  },
  {
    'id': '4285',
    'nome': 'Soledade',
    'estado': 'RS'
  },
  {
    'id': '4286',
    'nome': 'Tabaí',
    'estado': 'RS'
  },
  {
    'id': '4287',
    'nome': 'Tapejara',
    'estado': 'RS'
  },
  {
    'id': '4288',
    'nome': 'Tapera',
    'estado': 'RS'
  },
  {
    'id': '4289',
    'nome': 'Tapes',
    'estado': 'RS'
  },
  {
    'id': '4290',
    'nome': 'Taquara',
    'estado': 'RS'
  },
  {
    'id': '4291',
    'nome': 'Taquari',
    'estado': 'RS'
  },
  {
    'id': '4292',
    'nome': 'Taquaruçu do Sul',
    'estado': 'RS'
  },
  {
    'id': '4293',
    'nome': 'Tavares',
    'estado': 'RS'
  },
  {
    'id': '4294',
    'nome': 'Tenente Portela',
    'estado': 'RS'
  },
  {
    'id': '4295',
    'nome': 'Terra de Areia',
    'estado': 'RS'
  },
  {
    'id': '4296',
    'nome': 'Teutônia',
    'estado': 'RS'
  },
  {
    'id': '4297',
    'nome': 'Tio Hugo',
    'estado': 'RS'
  },
  {
    'id': '4298',
    'nome': 'Tiradentes do Sul',
    'estado': 'RS'
  },
  {
    'id': '4299',
    'nome': 'Toropi',
    'estado': 'RS'
  },
  {
    'id': '4300',
    'nome': 'Torres',
    'estado': 'RS'
  },
  {
    'id': '4301',
    'nome': 'Tramandaí',
    'estado': 'RS'
  },
  {
    'id': '4302',
    'nome': 'Travesseiro',
    'estado': 'RS'
  },
  {
    'id': '4303',
    'nome': 'Três Arroios',
    'estado': 'RS'
  },
  {
    'id': '4304',
    'nome': 'Três Cachoeiras',
    'estado': 'RS'
  },
  {
    'id': '4305',
    'nome': 'Três Coroas',
    'estado': 'RS'
  },
  {
    'id': '4306',
    'nome': 'Três de Maio',
    'estado': 'RS'
  },
  {
    'id': '4307',
    'nome': 'Três Forquilhas',
    'estado': 'RS'
  },
  {
    'id': '4308',
    'nome': 'Três Palmeiras',
    'estado': 'RS'
  },
  {
    'id': '4309',
    'nome': 'Três Passos',
    'estado': 'RS'
  },
  {
    'id': '4310',
    'nome': 'Trindade do Sul',
    'estado': 'RS'
  },
  {
    'id': '4311',
    'nome': 'Triunfo',
    'estado': 'RS'
  },
  {
    'id': '4312',
    'nome': 'Tucunduva',
    'estado': 'RS'
  },
  {
    'id': '4313',
    'nome': 'Tunas',
    'estado': 'RS'
  },
  {
    'id': '4314',
    'nome': 'Tupanci do Sul',
    'estado': 'RS'
  },
  {
    'id': '4315',
    'nome': 'Tupanciretã',
    'estado': 'RS'
  },
  {
    'id': '4316',
    'nome': 'Tupandi',
    'estado': 'RS'
  },
  {
    'id': '4317',
    'nome': 'Tuparendi',
    'estado': 'RS'
  },
  {
    'id': '4318',
    'nome': 'Turuçu',
    'estado': 'RS'
  },
  {
    'id': '4319',
    'nome': 'Ubiretama',
    'estado': 'RS'
  },
  {
    'id': '4320',
    'nome': 'União da Serra',
    'estado': 'RS'
  },
  {
    'id': '4321',
    'nome': 'Unistalda',
    'estado': 'RS'
  },
  {
    'id': '4322',
    'nome': 'Uruguaiana',
    'estado': 'RS'
  },
  {
    'id': '4323',
    'nome': 'Vacaria',
    'estado': 'RS'
  },
  {
    'id': '4324',
    'nome': 'Vale do Sol',
    'estado': 'RS'
  },
  {
    'id': '4325',
    'nome': 'Vale Real',
    'estado': 'RS'
  },
  {
    'id': '4326',
    'nome': 'Vale Verde',
    'estado': 'RS'
  },
  {
    'id': '4327',
    'nome': 'Vanini',
    'estado': 'RS'
  },
  {
    'id': '4328',
    'nome': 'Venâncio Aires',
    'estado': 'RS'
  },
  {
    'id': '4329',
    'nome': 'Vera Cruz',
    'estado': 'RS'
  },
  {
    'id': '4330',
    'nome': 'Veranópolis',
    'estado': 'RS'
  },
  {
    'id': '4331',
    'nome': 'Vespasiano Correa',
    'estado': 'RS'
  },
  {
    'id': '4332',
    'nome': 'Viadutos',
    'estado': 'RS'
  },
  {
    'id': '4333',
    'nome': 'Viamão',
    'estado': 'RS'
  },
  {
    'id': '4334',
    'nome': 'Vicente Dutra',
    'estado': 'RS'
  },
  {
    'id': '4335',
    'nome': 'Victor Graeff',
    'estado': 'RS'
  },
  {
    'id': '4336',
    'nome': 'Vila Flores',
    'estado': 'RS'
  },
  {
    'id': '4337',
    'nome': 'Vila Lângaro',
    'estado': 'RS'
  },
  {
    'id': '4338',
    'nome': 'Vila Maria',
    'estado': 'RS'
  },
  {
    'id': '4339',
    'nome': 'Vila Nova do Sul',
    'estado': 'RS'
  },
  {
    'id': '4340',
    'nome': 'Vista Alegre',
    'estado': 'RS'
  },
  {
    'id': '4341',
    'nome': 'Vista Alegre do Prata',
    'estado': 'RS'
  },
  {
    'id': '4342',
    'nome': 'Vista Gaúcha',
    'estado': 'RS'
  },
  {
    'id': '4343',
    'nome': 'Vitória das Missões',
    'estado': 'RS'
  },
  {
    'id': '4344',
    'nome': 'Westfália',
    'estado': 'RS'
  },
  {
    'id': '4345',
    'nome': 'Xangri-lá',
    'estado': 'RS'
  },
  {
    'id': '4346',
    'nome': 'Alta Floresta d`Oeste',
    'estado': 'RO'
  },
  {
    'id': '4347',
    'nome': 'Alto Alegre dos Parecis',
    'estado': 'RO'
  },
  {
    'id': '4348',
    'nome': 'Alto Paraíso',
    'estado': 'RO'
  },
  {
    'id': '4349',
    'nome': 'Alvorada d`Oeste',
    'estado': 'RO'
  },
  {
    'id': '4350',
    'nome': 'Ariquemes',
    'estado': 'RO'
  },
  {
    'id': '4351',
    'nome': 'Buritis',
    'estado': 'RO'
  },
  {
    'id': '4352',
    'nome': 'Cabixi',
    'estado': 'RO'
  },
  {
    'id': '4353',
    'nome': 'Cacaulândia',
    'estado': 'RO'
  },
  {
    'id': '4354',
    'nome': 'Cacoal',
    'estado': 'RO'
  },
  {
    'id': '4355',
    'nome': 'Campo Novo de Rondônia',
    'estado': 'RO'
  },
  {
    'id': '4356',
    'nome': 'Candeias do Jamari',
    'estado': 'RO'
  },
  {
    'id': '4357',
    'nome': 'Castanheiras',
    'estado': 'RO'
  },
  {
    'id': '4358',
    'nome': 'Cerejeiras',
    'estado': 'RO'
  },
  {
    'id': '4359',
    'nome': 'Chupinguaia',
    'estado': 'RO'
  },
  {
    'id': '4360',
    'nome': 'Colorado do Oeste',
    'estado': 'RO'
  },
  {
    'id': '4361',
    'nome': 'Corumbiara',
    'estado': 'RO'
  },
  {
    'id': '4362',
    'nome': 'Costa Marques',
    'estado': 'RO'
  },
  {
    'id': '4363',
    'nome': 'Cujubim',
    'estado': 'RO'
  },
  {
    'id': '4364',
    'nome': 'Espigão d`Oeste',
    'estado': 'RO'
  },
  {
    'id': '4365',
    'nome': 'Governador Jorge Teixeira',
    'estado': 'RO'
  },
  {
    'id': '4366',
    'nome': 'Guajará-Mirim',
    'estado': 'RO'
  },
  {
    'id': '4367',
    'nome': 'Itapuã do Oeste',
    'estado': 'RO'
  },
  {
    'id': '4368',
    'nome': 'Jaru',
    'estado': 'RO'
  },
  {
    'id': '4369',
    'nome': 'Ji-Paraná',
    'estado': 'RO'
  },
  {
    'id': '4370',
    'nome': 'Machadinho d`Oeste',
    'estado': 'RO'
  },
  {
    'id': '4371',
    'nome': 'Ministro Andreazza',
    'estado': 'RO'
  },
  {
    'id': '4372',
    'nome': 'Mirante da Serra',
    'estado': 'RO'
  },
  {
    'id': '4373',
    'nome': 'Monte Negro',
    'estado': 'RO'
  },
  {
    'id': '4374',
    'nome': 'Nova Brasilândia d`Oeste',
    'estado': 'RO'
  },
  {
    'id': '4375',
    'nome': 'Nova Mamoré',
    'estado': 'RO'
  },
  {
    'id': '4376',
    'nome': 'Nova União',
    'estado': 'RO'
  },
  {
    'id': '4377',
    'nome': 'Novo Horizonte do Oeste',
    'estado': 'RO'
  },
  {
    'id': '4378',
    'nome': 'Ouro Preto do Oeste',
    'estado': 'RO'
  },
  {
    'id': '4379',
    'nome': 'Parecis',
    'estado': 'RO'
  },
  {
    'id': '4380',
    'nome': 'Pimenta Bueno',
    'estado': 'RO'
  },
  {
    'id': '4381',
    'nome': 'Pimenteiras do Oeste',
    'estado': 'RO'
  },
  {
    'id': '4382',
    'nome': 'Porto Velho',
    'estado': 'RO'
  },
  {
    'id': '4383',
    'nome': 'Presidente Médici',
    'estado': 'RO'
  },
  {
    'id': '4384',
    'nome': 'Primavera de Rondônia',
    'estado': 'RO'
  },
  {
    'id': '4385',
    'nome': 'Rio Crespo',
    'estado': 'RO'
  },
  {
    'id': '4386',
    'nome': 'Rolim de Moura',
    'estado': 'RO'
  },
  {
    'id': '4387',
    'nome': 'Santa Luzia d`Oeste',
    'estado': 'RO'
  },
  {
    'id': '4388',
    'nome': 'São Felipe d`Oeste',
    'estado': 'RO'
  },
  {
    'id': '4389',
    'nome': 'São Francisco do Guaporé',
    'estado': 'RO'
  },
  {
    'id': '4390',
    'nome': 'São Miguel do Guaporé',
    'estado': 'RO'
  },
  {
    'id': '4391',
    'nome': 'Seringueiras',
    'estado': 'RO'
  },
  {
    'id': '4392',
    'nome': 'Teixeirópolis',
    'estado': 'RO'
  },
  {
    'id': '4393',
    'nome': 'Theobroma',
    'estado': 'RO'
  },
  {
    'id': '4394',
    'nome': 'Urupá',
    'estado': 'RO'
  },
  {
    'id': '4395',
    'nome': 'Vale do Anari',
    'estado': 'RO'
  },
  {
    'id': '4396',
    'nome': 'Vale do Paraíso',
    'estado': 'RO'
  },
  {
    'id': '4397',
    'nome': 'Vilhena',
    'estado': 'RO'
  },
  {
    'id': '4398',
    'nome': 'Alto Alegre',
    'estado': 'RR'
  },
  {
    'id': '4399',
    'nome': 'Amajari',
    'estado': 'RR'
  },
  {
    'id': '4400',
    'nome': 'Boa Vista',
    'estado': 'RR'
  },
  {
    'id': '4401',
    'nome': 'Bonfim',
    'estado': 'RR'
  },
  {
    'id': '4402',
    'nome': 'Cantá',
    'estado': 'RR'
  },
  {
    'id': '4403',
    'nome': 'Caracaraí',
    'estado': 'RR'
  },
  {
    'id': '4404',
    'nome': 'Caroebe',
    'estado': 'RR'
  },
  {
    'id': '4405',
    'nome': 'Iracema',
    'estado': 'RR'
  },
  {
    'id': '4406',
    'nome': 'Mucajaí',
    'estado': 'RR'
  },
  {
    'id': '4407',
    'nome': 'Normandia',
    'estado': 'RR'
  },
  {
    'id': '4408',
    'nome': 'Pacaraima',
    'estado': 'RR'
  },
  {
    'id': '4409',
    'nome': 'Rorainópolis',
    'estado': 'RR'
  },
  {
    'id': '4410',
    'nome': 'São João da Baliza',
    'estado': 'RR'
  },
  {
    'id': '4411',
    'nome': 'São Luiz',
    'estado': 'RR'
  },
  {
    'id': '4412',
    'nome': 'Uiramutã',
    'estado': 'RR'
  },
  {
    'id': '4413',
    'nome': 'Abdon Batista',
    'estado': 'SC'
  },
  {
    'id': '4414',
    'nome': 'Abelardo Luz',
    'estado': 'SC'
  },
  {
    'id': '4415',
    'nome': 'Agrolândia',
    'estado': 'SC'
  },
  {
    'id': '4416',
    'nome': 'Agronômica',
    'estado': 'SC'
  },
  {
    'id': '4417',
    'nome': 'Água Doce',
    'estado': 'SC'
  },
  {
    'id': '4418',
    'nome': 'Águas de Chapecó',
    'estado': 'SC'
  },
  {
    'id': '4419',
    'nome': 'Águas Frias',
    'estado': 'SC'
  },
  {
    'id': '4420',
    'nome': 'Águas Mornas',
    'estado': 'SC'
  },
  {
    'id': '4421',
    'nome': 'Alfredo Wagner',
    'estado': 'SC'
  },
  {
    'id': '4422',
    'nome': 'Alto Bela Vista',
    'estado': 'SC'
  },
  {
    'id': '4423',
    'nome': 'Anchieta',
    'estado': 'SC'
  },
  {
    'id': '4424',
    'nome': 'Angelina',
    'estado': 'SC'
  },
  {
    'id': '4425',
    'nome': 'Anita Garibaldi',
    'estado': 'SC'
  },
  {
    'id': '4426',
    'nome': 'Anitápolis',
    'estado': 'SC'
  },
  {
    'id': '4427',
    'nome': 'Antônio Carlos',
    'estado': 'SC'
  },
  {
    'id': '4428',
    'nome': 'Apiúna',
    'estado': 'SC'
  },
  {
    'id': '4429',
    'nome': 'Arabutã',
    'estado': 'SC'
  },
  {
    'id': '4430',
    'nome': 'Araquari',
    'estado': 'SC'
  },
  {
    'id': '4431',
    'nome': 'Araranguá',
    'estado': 'SC'
  },
  {
    'id': '4432',
    'nome': 'Armazém',
    'estado': 'SC'
  },
  {
    'id': '4433',
    'nome': 'Arroio Trinta',
    'estado': 'SC'
  },
  {
    'id': '4434',
    'nome': 'Arvoredo',
    'estado': 'SC'
  },
  {
    'id': '4435',
    'nome': 'Ascurra',
    'estado': 'SC'
  },
  {
    'id': '4436',
    'nome': 'Atalanta',
    'estado': 'SC'
  },
  {
    'id': '4437',
    'nome': 'Aurora',
    'estado': 'SC'
  },
  {
    'id': '4438',
    'nome': 'Balneário Arroio do Silva',
    'estado': 'SC'
  },
  {
    'id': '4439',
    'nome': 'Balneário Barra do Sul',
    'estado': 'SC'
  },
  {
    'id': '4440',
    'nome': 'Balneário Camboriú',
    'estado': 'SC'
  },
  {
    'id': '4441',
    'nome': 'Balneário Gaivota',
    'estado': 'SC'
  },
  {
    'id': '4442',
    'nome': 'Bandeirante',
    'estado': 'SC'
  },
  {
    'id': '4443',
    'nome': 'Barra Bonita',
    'estado': 'SC'
  },
  {
    'id': '4444',
    'nome': 'Barra Velha',
    'estado': 'SC'
  },
  {
    'id': '4445',
    'nome': 'Bela Vista do Toldo',
    'estado': 'SC'
  },
  {
    'id': '4446',
    'nome': 'Belmonte',
    'estado': 'SC'
  },
  {
    'id': '4447',
    'nome': 'Benedito Novo',
    'estado': 'SC'
  },
  {
    'id': '4448',
    'nome': 'Biguaçu',
    'estado': 'SC'
  },
  {
    'id': '4449',
    'nome': 'Blumenau',
    'estado': 'SC'
  },
  {
    'id': '4450',
    'nome': 'Bocaina do Sul',
    'estado': 'SC'
  },
  {
    'id': '4451',
    'nome': 'Bom Jardim da Serra',
    'estado': 'SC'
  },
  {
    'id': '4452',
    'nome': 'Bom Jesus',
    'estado': 'SC'
  },
  {
    'id': '4453',
    'nome': 'Bom Jesus do Oeste',
    'estado': 'SC'
  },
  {
    'id': '4454',
    'nome': 'Bom Retiro',
    'estado': 'SC'
  },
  {
    'id': '4455',
    'nome': 'Bombinhas',
    'estado': 'SC'
  },
  {
    'id': '4456',
    'nome': 'Botuverá',
    'estado': 'SC'
  },
  {
    'id': '4457',
    'nome': 'Braço do Norte',
    'estado': 'SC'
  },
  {
    'id': '4458',
    'nome': 'Braço do Trombudo',
    'estado': 'SC'
  },
  {
    'id': '4459',
    'nome': 'Brunópolis',
    'estado': 'SC'
  },
  {
    'id': '4460',
    'nome': 'Brusque',
    'estado': 'SC'
  },
  {
    'id': '4461',
    'nome': 'Caçador',
    'estado': 'SC'
  },
  {
    'id': '4462',
    'nome': 'Caibi',
    'estado': 'SC'
  },
  {
    'id': '4463',
    'nome': 'Calmon',
    'estado': 'SC'
  },
  {
    'id': '4464',
    'nome': 'Camboriú',
    'estado': 'SC'
  },
  {
    'id': '4465',
    'nome': 'Campo Alegre',
    'estado': 'SC'
  },
  {
    'id': '4466',
    'nome': 'Campo Belo do Sul',
    'estado': 'SC'
  },
  {
    'id': '4467',
    'nome': 'Campo Erê',
    'estado': 'SC'
  },
  {
    'id': '4468',
    'nome': 'Campos Novos',
    'estado': 'SC'
  },
  {
    'id': '4469',
    'nome': 'Canelinha',
    'estado': 'SC'
  },
  {
    'id': '4470',
    'nome': 'Canoinhas',
    'estado': 'SC'
  },
  {
    'id': '4471',
    'nome': 'Capão Alto',
    'estado': 'SC'
  },
  {
    'id': '4472',
    'nome': 'Capinzal',
    'estado': 'SC'
  },
  {
    'id': '4473',
    'nome': 'Capivari de Baixo',
    'estado': 'SC'
  },
  {
    'id': '4474',
    'nome': 'Catanduvas',
    'estado': 'SC'
  },
  {
    'id': '4475',
    'nome': 'Caxambu do Sul',
    'estado': 'SC'
  },
  {
    'id': '4476',
    'nome': 'Celso Ramos',
    'estado': 'SC'
  },
  {
    'id': '4477',
    'nome': 'Cerro Negro',
    'estado': 'SC'
  },
  {
    'id': '4478',
    'nome': 'Chapadão do Lageado',
    'estado': 'SC'
  },
  {
    'id': '4479',
    'nome': 'Chapecó',
    'estado': 'SC'
  },
  {
    'id': '4480',
    'nome': 'Cocal do Sul',
    'estado': 'SC'
  },
  {
    'id': '4481',
    'nome': 'Concórdia',
    'estado': 'SC'
  },
  {
    'id': '4482',
    'nome': 'Cordilheira Alta',
    'estado': 'SC'
  },
  {
    'id': '4483',
    'nome': 'Coronel Freitas',
    'estado': 'SC'
  },
  {
    'id': '4484',
    'nome': 'Coronel Martins',
    'estado': 'SC'
  },
  {
    'id': '4485',
    'nome': 'Correia Pinto',
    'estado': 'SC'
  },
  {
    'id': '4486',
    'nome': 'Corupá',
    'estado': 'SC'
  },
  {
    'id': '4487',
    'nome': 'Criciúma',
    'estado': 'SC'
  },
  {
    'id': '4488',
    'nome': 'Cunha Porã',
    'estado': 'SC'
  },
  {
    'id': '4489',
    'nome': 'Cunhataí',
    'estado': 'SC'
  },
  {
    'id': '4490',
    'nome': 'Curitibanos',
    'estado': 'SC'
  },
  {
    'id': '4491',
    'nome': 'Descanso',
    'estado': 'SC'
  },
  {
    'id': '4492',
    'nome': 'Dionísio Cerqueira',
    'estado': 'SC'
  },
  {
    'id': '4493',
    'nome': 'Dona Emma',
    'estado': 'SC'
  },
  {
    'id': '4494',
    'nome': 'Doutor Pedrinho',
    'estado': 'SC'
  },
  {
    'id': '4495',
    'nome': 'Entre Rios',
    'estado': 'SC'
  },
  {
    'id': '4496',
    'nome': 'Ermo',
    'estado': 'SC'
  },
  {
    'id': '4497',
    'nome': 'Erval Velho',
    'estado': 'SC'
  },
  {
    'id': '4498',
    'nome': 'Faxinal dos Guedes',
    'estado': 'SC'
  },
  {
    'id': '4499',
    'nome': 'Flor do Sertão',
    'estado': 'SC'
  },
  {
    'id': '4500',
    'nome': 'Florianópolis',
    'estado': 'SC'
  },
  {
    'id': '4501',
    'nome': 'Formosa do Sul',
    'estado': 'SC'
  },
  {
    'id': '4502',
    'nome': 'Forquilhinha',
    'estado': 'SC'
  },
  {
    'id': '4503',
    'nome': 'Fraiburgo',
    'estado': 'SC'
  },
  {
    'id': '4504',
    'nome': 'Frei Rogério',
    'estado': 'SC'
  },
  {
    'id': '4505',
    'nome': 'Galvão',
    'estado': 'SC'
  },
  {
    'id': '4506',
    'nome': 'Garopaba',
    'estado': 'SC'
  },
  {
    'id': '4507',
    'nome': 'Garuva',
    'estado': 'SC'
  },
  {
    'id': '4508',
    'nome': 'Gaspar',
    'estado': 'SC'
  },
  {
    'id': '4509',
    'nome': 'Governador Celso Ramos',
    'estado': 'SC'
  },
  {
    'id': '4510',
    'nome': 'Grão Pará',
    'estado': 'SC'
  },
  {
    'id': '4511',
    'nome': 'Gravatal',
    'estado': 'SC'
  },
  {
    'id': '4512',
    'nome': 'Guabiruba',
    'estado': 'SC'
  },
  {
    'id': '4513',
    'nome': 'Guaraciaba',
    'estado': 'SC'
  },
  {
    'id': '4514',
    'nome': 'Guaramirim',
    'estado': 'SC'
  },
  {
    'id': '4515',
    'nome': 'Guarujá do Sul',
    'estado': 'SC'
  },
  {
    'id': '4516',
    'nome': 'Guatambú',
    'estado': 'SC'
  },
  {
    'id': '4517',
    'nome': 'Herval d`Oeste',
    'estado': 'SC'
  },
  {
    'id': '4518',
    'nome': 'Ibiam',
    'estado': 'SC'
  },
  {
    'id': '4519',
    'nome': 'Ibicaré',
    'estado': 'SC'
  },
  {
    'id': '4520',
    'nome': 'Ibirama',
    'estado': 'SC'
  },
  {
    'id': '4521',
    'nome': 'Içara',
    'estado': 'SC'
  },
  {
    'id': '4522',
    'nome': 'Ilhota',
    'estado': 'SC'
  },
  {
    'id': '4523',
    'nome': 'Imaruí',
    'estado': 'SC'
  },
  {
    'id': '4524',
    'nome': 'Imbituba',
    'estado': 'SC'
  },
  {
    'id': '4525',
    'nome': 'Imbuia',
    'estado': 'SC'
  },
  {
    'id': '4526',
    'nome': 'Indaial',
    'estado': 'SC'
  },
  {
    'id': '4527',
    'nome': 'Iomerê',
    'estado': 'SC'
  },
  {
    'id': '4528',
    'nome': 'Ipira',
    'estado': 'SC'
  },
  {
    'id': '4529',
    'nome': 'Iporã do Oeste',
    'estado': 'SC'
  },
  {
    'id': '4530',
    'nome': 'Ipuaçu',
    'estado': 'SC'
  },
  {
    'id': '4531',
    'nome': 'Ipumirim',
    'estado': 'SC'
  },
  {
    'id': '4532',
    'nome': 'Iraceminha',
    'estado': 'SC'
  },
  {
    'id': '4533',
    'nome': 'Irani',
    'estado': 'SC'
  },
  {
    'id': '4534',
    'nome': 'Irati',
    'estado': 'SC'
  },
  {
    'id': '4535',
    'nome': 'Irineópolis',
    'estado': 'SC'
  },
  {
    'id': '4536',
    'nome': 'Itá',
    'estado': 'SC'
  },
  {
    'id': '4537',
    'nome': 'Itaiópolis',
    'estado': 'SC'
  },
  {
    'id': '4538',
    'nome': 'Itajaí',
    'estado': 'SC'
  },
  {
    'id': '4539',
    'nome': 'Itapema',
    'estado': 'SC'
  },
  {
    'id': '4540',
    'nome': 'Itapiranga',
    'estado': 'SC'
  },
  {
    'id': '4541',
    'nome': 'Itapoá',
    'estado': 'SC'
  },
  {
    'id': '4542',
    'nome': 'Ituporanga',
    'estado': 'SC'
  },
  {
    'id': '4543',
    'nome': 'Jaborá',
    'estado': 'SC'
  },
  {
    'id': '4544',
    'nome': 'Jacinto Machado',
    'estado': 'SC'
  },
  {
    'id': '4545',
    'nome': 'Jaguaruna',
    'estado': 'SC'
  },
  {
    'id': '4546',
    'nome': 'Jaraguá do Sul',
    'estado': 'SC'
  },
  {
    'id': '4547',
    'nome': 'Jardinópolis',
    'estado': 'SC'
  },
  {
    'id': '4548',
    'nome': 'Joaçaba',
    'estado': 'SC'
  },
  {
    'id': '4549',
    'nome': 'Joinville',
    'estado': 'SC'
  },
  {
    'id': '4550',
    'nome': 'José Boiteux',
    'estado': 'SC'
  },
  {
    'id': '4551',
    'nome': 'Jupiá',
    'estado': 'SC'
  },
  {
    'id': '4552',
    'nome': 'Lacerdópolis',
    'estado': 'SC'
  },
  {
    'id': '4553',
    'nome': 'Lages',
    'estado': 'SC'
  },
  {
    'id': '4554',
    'nome': 'Laguna',
    'estado': 'SC'
  },
  {
    'id': '4555',
    'nome': 'Lajeado Grande',
    'estado': 'SC'
  },
  {
    'id': '4556',
    'nome': 'Laurentino',
    'estado': 'SC'
  },
  {
    'id': '4557',
    'nome': 'Lauro Muller',
    'estado': 'SC'
  },
  {
    'id': '4558',
    'nome': 'Lebon Régis',
    'estado': 'SC'
  },
  {
    'id': '4559',
    'nome': 'Leoberto Leal',
    'estado': 'SC'
  },
  {
    'id': '4560',
    'nome': 'Lindóia do Sul',
    'estado': 'SC'
  },
  {
    'id': '4561',
    'nome': 'Lontras',
    'estado': 'SC'
  },
  {
    'id': '4562',
    'nome': 'Luiz Alves',
    'estado': 'SC'
  },
  {
    'id': '4563',
    'nome': 'Luzerna',
    'estado': 'SC'
  },
  {
    'id': '4564',
    'nome': 'Macieira',
    'estado': 'SC'
  },
  {
    'id': '4565',
    'nome': 'Mafra',
    'estado': 'SC'
  },
  {
    'id': '4566',
    'nome': 'Major Gercino',
    'estado': 'SC'
  },
  {
    'id': '4567',
    'nome': 'Major Vieira',
    'estado': 'SC'
  },
  {
    'id': '4568',
    'nome': 'Maracajá',
    'estado': 'SC'
  },
  {
    'id': '4569',
    'nome': 'Maravilha',
    'estado': 'SC'
  },
  {
    'id': '4570',
    'nome': 'Marema',
    'estado': 'SC'
  },
  {
    'id': '4571',
    'nome': 'Massaranduba',
    'estado': 'SC'
  },
  {
    'id': '4572',
    'nome': 'Matos Costa',
    'estado': 'SC'
  },
  {
    'id': '4573',
    'nome': 'Meleiro',
    'estado': 'SC'
  },
  {
    'id': '4574',
    'nome': 'Mirim Doce',
    'estado': 'SC'
  },
  {
    'id': '4575',
    'nome': 'Modelo',
    'estado': 'SC'
  },
  {
    'id': '4576',
    'nome': 'Mondaí',
    'estado': 'SC'
  },
  {
    'id': '4577',
    'nome': 'Monte Carlo',
    'estado': 'SC'
  },
  {
    'id': '4578',
    'nome': 'Monte Castelo',
    'estado': 'SC'
  },
  {
    'id': '4579',
    'nome': 'Morro da Fumaça',
    'estado': 'SC'
  },
  {
    'id': '4580',
    'nome': 'Morro Grande',
    'estado': 'SC'
  },
  {
    'id': '4581',
    'nome': 'Navegantes',
    'estado': 'SC'
  },
  {
    'id': '4582',
    'nome': 'Nova Erechim',
    'estado': 'SC'
  },
  {
    'id': '4583',
    'nome': 'Nova Itaberaba',
    'estado': 'SC'
  },
  {
    'id': '4584',
    'nome': 'Nova Trento',
    'estado': 'SC'
  },
  {
    'id': '4585',
    'nome': 'Nova Veneza',
    'estado': 'SC'
  },
  {
    'id': '4586',
    'nome': 'Novo Horizonte',
    'estado': 'SC'
  },
  {
    'id': '4587',
    'nome': 'Orleans',
    'estado': 'SC'
  },
  {
    'id': '4588',
    'nome': 'Otacílio Costa',
    'estado': 'SC'
  },
  {
    'id': '4589',
    'nome': 'Ouro',
    'estado': 'SC'
  },
  {
    'id': '4590',
    'nome': 'Ouro Verde',
    'estado': 'SC'
  },
  {
    'id': '4591',
    'nome': 'Paial',
    'estado': 'SC'
  },
  {
    'id': '4592',
    'nome': 'Painel',
    'estado': 'SC'
  },
  {
    'id': '4593',
    'nome': 'Palhoça',
    'estado': 'SC'
  },
  {
    'id': '4594',
    'nome': 'Palma Sola',
    'estado': 'SC'
  },
  {
    'id': '4595',
    'nome': 'Palmeira',
    'estado': 'SC'
  },
  {
    'id': '4596',
    'nome': 'Palmitos',
    'estado': 'SC'
  },
  {
    'id': '4597',
    'nome': 'Papanduva',
    'estado': 'SC'
  },
  {
    'id': '4598',
    'nome': 'Paraíso',
    'estado': 'SC'
  },
  {
    'id': '4599',
    'nome': 'Passo de Torres',
    'estado': 'SC'
  },
  {
    'id': '4600',
    'nome': 'Passos Maia',
    'estado': 'SC'
  },
  {
    'id': '4601',
    'nome': 'Paulo Lopes',
    'estado': 'SC'
  },
  {
    'id': '4602',
    'nome': 'Pedras Grandes',
    'estado': 'SC'
  },
  {
    'id': '4603',
    'nome': 'Penha',
    'estado': 'SC'
  },
  {
    'id': '4604',
    'nome': 'Peritiba',
    'estado': 'SC'
  },
  {
    'id': '4605',
    'nome': 'Petrolândia',
    'estado': 'SC'
  },
  {
    'id': '4606',
    'nome': 'Piçarras',
    'estado': 'SC'
  },
  {
    'id': '4607',
    'nome': 'Pinhalzinho',
    'estado': 'SC'
  },
  {
    'id': '4608',
    'nome': 'Pinheiro Preto',
    'estado': 'SC'
  },
  {
    'id': '4609',
    'nome': 'Piratuba',
    'estado': 'SC'
  },
  {
    'id': '4610',
    'nome': 'Planalto Alegre',
    'estado': 'SC'
  },
  {
    'id': '4611',
    'nome': 'Pomerode',
    'estado': 'SC'
  },
  {
    'id': '4612',
    'nome': 'Ponte Alta',
    'estado': 'SC'
  },
  {
    'id': '4613',
    'nome': 'Ponte Alta do Norte',
    'estado': 'SC'
  },
  {
    'id': '4614',
    'nome': 'Ponte Serrada',
    'estado': 'SC'
  },
  {
    'id': '4615',
    'nome': 'Porto Belo',
    'estado': 'SC'
  },
  {
    'id': '4616',
    'nome': 'Porto União',
    'estado': 'SC'
  },
  {
    'id': '4617',
    'nome': 'Pouso Redondo',
    'estado': 'SC'
  },
  {
    'id': '4618',
    'nome': 'Praia Grande',
    'estado': 'SC'
  },
  {
    'id': '4619',
    'nome': 'Presidente Castelo Branco',
    'estado': 'SC'
  },
  {
    'id': '4620',
    'nome': 'Presidente Getúlio',
    'estado': 'SC'
  },
  {
    'id': '4621',
    'nome': 'Presidente Nereu',
    'estado': 'SC'
  },
  {
    'id': '4622',
    'nome': 'Princesa',
    'estado': 'SC'
  },
  {
    'id': '4623',
    'nome': 'Quilombo',
    'estado': 'SC'
  },
  {
    'id': '4624',
    'nome': 'Rancho Queimado',
    'estado': 'SC'
  },
  {
    'id': '4625',
    'nome': 'Rio das Antas',
    'estado': 'SC'
  },
  {
    'id': '4626',
    'nome': 'Rio do Campo',
    'estado': 'SC'
  },
  {
    'id': '4627',
    'nome': 'Rio do Oeste',
    'estado': 'SC'
  },
  {
    'id': '4628',
    'nome': 'Rio do Sul',
    'estado': 'SC'
  },
  {
    'id': '4629',
    'nome': 'Rio dos Cedros',
    'estado': 'SC'
  },
  {
    'id': '4630',
    'nome': 'Rio Fortuna',
    'estado': 'SC'
  },
  {
    'id': '4631',
    'nome': 'Rio Negrinho',
    'estado': 'SC'
  },
  {
    'id': '4632',
    'nome': 'Rio Rufino',
    'estado': 'SC'
  },
  {
    'id': '4633',
    'nome': 'Riqueza',
    'estado': 'SC'
  },
  {
    'id': '4634',
    'nome': 'Rodeio',
    'estado': 'SC'
  },
  {
    'id': '4635',
    'nome': 'Romelândia',
    'estado': 'SC'
  },
  {
    'id': '4636',
    'nome': 'Salete',
    'estado': 'SC'
  },
  {
    'id': '4637',
    'nome': 'Saltinho',
    'estado': 'SC'
  },
  {
    'id': '4638',
    'nome': 'Salto Veloso',
    'estado': 'SC'
  },
  {
    'id': '4639',
    'nome': 'Sangão',
    'estado': 'SC'
  },
  {
    'id': '4640',
    'nome': 'Santa Cecília',
    'estado': 'SC'
  },
  {
    'id': '4641',
    'nome': 'Santa Helena',
    'estado': 'SC'
  },
  {
    'id': '4642',
    'nome': 'Santa Rosa de Lima',
    'estado': 'SC'
  },
  {
    'id': '4643',
    'nome': 'Santa Rosa do Sul',
    'estado': 'SC'
  },
  {
    'id': '4644',
    'nome': 'Santa Terezinha',
    'estado': 'SC'
  },
  {
    'id': '4645',
    'nome': 'Santa Terezinha do Progresso',
    'estado': 'SC'
  },
  {
    'id': '4646',
    'nome': 'Santiago do Sul',
    'estado': 'SC'
  },
  {
    'id': '4647',
    'nome': 'Santo Amaro da Imperatriz',
    'estado': 'SC'
  },
  {
    'id': '4648',
    'nome': 'São Bento do Sul',
    'estado': 'SC'
  },
  {
    'id': '4649',
    'nome': 'São Bernardino',
    'estado': 'SC'
  },
  {
    'id': '4650',
    'nome': 'São Bonifácio',
    'estado': 'SC'
  },
  {
    'id': '4651',
    'nome': 'São Carlos',
    'estado': 'SC'
  },
  {
    'id': '4652',
    'nome': 'São Cristovão do Sul',
    'estado': 'SC'
  },
  {
    'id': '4653',
    'nome': 'São Domingos',
    'estado': 'SC'
  },
  {
    'id': '4654',
    'nome': 'São Francisco do Sul',
    'estado': 'SC'
  },
  {
    'id': '4655',
    'nome': 'São João Batista',
    'estado': 'SC'
  },
  {
    'id': '4656',
    'nome': 'São João do Itaperiú',
    'estado': 'SC'
  },
  {
    'id': '4657',
    'nome': 'São João do Oeste',
    'estado': 'SC'
  },
  {
    'id': '4658',
    'nome': 'São João do Sul',
    'estado': 'SC'
  },
  {
    'id': '4659',
    'nome': 'São Joaquim',
    'estado': 'SC'
  },
  {
    'id': '4660',
    'nome': 'São José',
    'estado': 'SC'
  },
  {
    'id': '4661',
    'nome': 'São José do Cedro',
    'estado': 'SC'
  },
  {
    'id': '4662',
    'nome': 'São José do Cerrito',
    'estado': 'SC'
  },
  {
    'id': '4663',
    'nome': 'São Lourenço do Oeste',
    'estado': 'SC'
  },
  {
    'id': '4664',
    'nome': 'São Ludgero',
    'estado': 'SC'
  },
  {
    'id': '4665',
    'nome': 'São Martinho',
    'estado': 'SC'
  },
  {
    'id': '4666',
    'nome': 'São Miguel da Boa Vista',
    'estado': 'SC'
  },
  {
    'id': '4667',
    'nome': 'São Miguel do Oeste',
    'estado': 'SC'
  },
  {
    'id': '4668',
    'nome': 'São Pedro de Alcântara',
    'estado': 'SC'
  },
  {
    'id': '4669',
    'nome': 'Saudades',
    'estado': 'SC'
  },
  {
    'id': '4670',
    'nome': 'Schroeder',
    'estado': 'SC'
  },
  {
    'id': '4671',
    'nome': 'Seara',
    'estado': 'SC'
  },
  {
    'id': '4672',
    'nome': 'Serra Alta',
    'estado': 'SC'
  },
  {
    'id': '4673',
    'nome': 'Siderópolis',
    'estado': 'SC'
  },
  {
    'id': '4674',
    'nome': 'Sombrio',
    'estado': 'SC'
  },
  {
    'id': '4675',
    'nome': 'Sul Brasil',
    'estado': 'SC'
  },
  {
    'id': '4676',
    'nome': 'Taió',
    'estado': 'SC'
  },
  {
    'id': '4677',
    'nome': 'Tangará',
    'estado': 'SC'
  },
  {
    'id': '4678',
    'nome': 'Tigrinhos',
    'estado': 'SC'
  },
  {
    'id': '4679',
    'nome': 'Tijucas',
    'estado': 'SC'
  },
  {
    'id': '4680',
    'nome': 'Timbé do Sul',
    'estado': 'SC'
  },
  {
    'id': '4681',
    'nome': 'Timbó',
    'estado': 'SC'
  },
  {
    'id': '4682',
    'nome': 'Timbó Grande',
    'estado': 'SC'
  },
  {
    'id': '4683',
    'nome': 'Três Barras',
    'estado': 'SC'
  },
  {
    'id': '4684',
    'nome': 'Treviso',
    'estado': 'SC'
  },
  {
    'id': '4685',
    'nome': 'Treze de Maio',
    'estado': 'SC'
  },
  {
    'id': '4686',
    'nome': 'Treze Tílias',
    'estado': 'SC'
  },
  {
    'id': '4687',
    'nome': 'Trombudo Central',
    'estado': 'SC'
  },
  {
    'id': '4688',
    'nome': 'Tubarão',
    'estado': 'SC'
  },
  {
    'id': '4689',
    'nome': 'Tunápolis',
    'estado': 'SC'
  },
  {
    'id': '4690',
    'nome': 'Turvo',
    'estado': 'SC'
  },
  {
    'id': '4691',
    'nome': 'União do Oeste',
    'estado': 'SC'
  },
  {
    'id': '4692',
    'nome': 'Urubici',
    'estado': 'SC'
  },
  {
    'id': '4693',
    'nome': 'Urupema',
    'estado': 'SC'
  },
  {
    'id': '4694',
    'nome': 'Urussanga',
    'estado': 'SC'
  },
  {
    'id': '4695',
    'nome': 'Vargeão',
    'estado': 'SC'
  },
  {
    'id': '4696',
    'nome': 'Vargem',
    'estado': 'SC'
  },
  {
    'id': '4697',
    'nome': 'Vargem Bonita',
    'estado': 'SC'
  },
  {
    'id': '4698',
    'nome': 'Vidal Ramos',
    'estado': 'SC'
  },
  {
    'id': '4699',
    'nome': 'Videira',
    'estado': 'SC'
  },
  {
    'id': '4700',
    'nome': 'Vitor Meireles',
    'estado': 'SC'
  },
  {
    'id': '4701',
    'nome': 'Witmarsum',
    'estado': 'SC'
  },
  {
    'id': '4702',
    'nome': 'Xanxerê',
    'estado': 'SC'
  },
  {
    'id': '4703',
    'nome': 'Xavantina',
    'estado': 'SC'
  },
  {
    'id': '4704',
    'nome': 'Xaxim',
    'estado': 'SC'
  },
  {
    'id': '4705',
    'nome': 'Zortéa',
    'estado': 'SC'
  },
  {
    'id': '4706',
    'nome': 'Adamantina',
    'estado': 'SP'
  },
  {
    'id': '4707',
    'nome': 'Adolfo',
    'estado': 'SP'
  },
  {
    'id': '4708',
    'nome': 'Aguaí',
    'estado': 'SP'
  },
  {
    'id': '4709',
    'nome': 'Águas da Prata',
    'estado': 'SP'
  },
  {
    'id': '4710',
    'nome': 'Águas de Lindóia',
    'estado': 'SP'
  },
  {
    'id': '4711',
    'nome': 'Águas de Santa Bárbara',
    'estado': 'SP'
  },
  {
    'id': '4712',
    'nome': 'Águas de São Pedro',
    'estado': 'SP'
  },
  {
    'id': '4713',
    'nome': 'Agudos',
    'estado': 'SP'
  },
  {
    'id': '4714',
    'nome': 'Alambari',
    'estado': 'SP'
  },
  {
    'id': '4715',
    'nome': 'Alfredo Marcondes',
    'estado': 'SP'
  },
  {
    'id': '4716',
    'nome': 'Altair',
    'estado': 'SP'
  },
  {
    'id': '4717',
    'nome': 'Altinópolis',
    'estado': 'SP'
  },
  {
    'id': '4718',
    'nome': 'Alto Alegre',
    'estado': 'SP'
  },
  {
    'id': '4719',
    'nome': 'Alumínio',
    'estado': 'SP'
  },
  {
    'id': '4720',
    'nome': 'Álvares Florence',
    'estado': 'SP'
  },
  {
    'id': '4721',
    'nome': 'Álvares Machado',
    'estado': 'SP'
  },
  {
    'id': '4722',
    'nome': 'Álvaro de Carvalho',
    'estado': 'SP'
  },
  {
    'id': '4723',
    'nome': 'Alvinlândia',
    'estado': 'SP'
  },
  {
    'id': '4724',
    'nome': 'Americana',
    'estado': 'SP'
  },
  {
    'id': '4725',
    'nome': 'Américo Brasiliense',
    'estado': 'SP'
  },
  {
    'id': '4726',
    'nome': 'Américo de Campos',
    'estado': 'SP'
  },
  {
    'id': '4727',
    'nome': 'Amparo',
    'estado': 'SP'
  },
  {
    'id': '4728',
    'nome': 'Analândia',
    'estado': 'SP'
  },
  {
    'id': '4729',
    'nome': 'Andradina',
    'estado': 'SP'
  },
  {
    'id': '4730',
    'nome': 'Angatuba',
    'estado': 'SP'
  },
  {
    'id': '4731',
    'nome': 'Anhembi',
    'estado': 'SP'
  },
  {
    'id': '4732',
    'nome': 'Anhumas',
    'estado': 'SP'
  },
  {
    'id': '4733',
    'nome': 'Aparecida',
    'estado': 'SP'
  },
  {
    'id': '4734',
    'nome': 'Aparecida d`Oeste',
    'estado': 'SP'
  },
  {
    'id': '4735',
    'nome': 'Apiaí',
    'estado': 'SP'
  },
  {
    'id': '4736',
    'nome': 'Araçariguama',
    'estado': 'SP'
  },
  {
    'id': '4737',
    'nome': 'Araçatuba',
    'estado': 'SP'
  },
  {
    'id': '4738',
    'nome': 'Araçoiaba da Serra',
    'estado': 'SP'
  },
  {
    'id': '4739',
    'nome': 'Aramina',
    'estado': 'SP'
  },
  {
    'id': '4740',
    'nome': 'Arandu',
    'estado': 'SP'
  },
  {
    'id': '4741',
    'nome': 'Arapeí',
    'estado': 'SP'
  },
  {
    'id': '4742',
    'nome': 'Araraquara',
    'estado': 'SP'
  },
  {
    'id': '4743',
    'nome': 'Araras',
    'estado': 'SP'
  },
  {
    'id': '4744',
    'nome': 'Arco-Íris',
    'estado': 'SP'
  },
  {
    'id': '4745',
    'nome': 'Arealva',
    'estado': 'SP'
  },
  {
    'id': '4746',
    'nome': 'Areias',
    'estado': 'SP'
  },
  {
    'id': '4747',
    'nome': 'Areiópolis',
    'estado': 'SP'
  },
  {
    'id': '4748',
    'nome': 'Ariranha',
    'estado': 'SP'
  },
  {
    'id': '4749',
    'nome': 'Artur Nogueira',
    'estado': 'SP'
  },
  {
    'id': '4750',
    'nome': 'Arujá',
    'estado': 'SP'
  },
  {
    'id': '4751',
    'nome': 'Aspásia',
    'estado': 'SP'
  },
  {
    'id': '4752',
    'nome': 'Assis',
    'estado': 'SP'
  },
  {
    'id': '4753',
    'nome': 'Atibaia',
    'estado': 'SP'
  },
  {
    'id': '4754',
    'nome': 'Auriflama',
    'estado': 'SP'
  },
  {
    'id': '4755',
    'nome': 'Avaí',
    'estado': 'SP'
  },
  {
    'id': '4756',
    'nome': 'Avanhandava',
    'estado': 'SP'
  },
  {
    'id': '4757',
    'nome': 'Avaré',
    'estado': 'SP'
  },
  {
    'id': '4758',
    'nome': 'Bady Bassitt',
    'estado': 'SP'
  },
  {
    'id': '4759',
    'nome': 'Balbinos',
    'estado': 'SP'
  },
  {
    'id': '4760',
    'nome': 'Bálsamo',
    'estado': 'SP'
  },
  {
    'id': '4761',
    'nome': 'Bananal',
    'estado': 'SP'
  },
  {
    'id': '4762',
    'nome': 'Barão de Antonina',
    'estado': 'SP'
  },
  {
    'id': '4763',
    'nome': 'Barbosa',
    'estado': 'SP'
  },
  {
    'id': '4764',
    'nome': 'Bariri',
    'estado': 'SP'
  },
  {
    'id': '4765',
    'nome': 'Barra Bonita',
    'estado': 'SP'
  },
  {
    'id': '4766',
    'nome': 'Barra do Chapéu',
    'estado': 'SP'
  },
  {
    'id': '4767',
    'nome': 'Barra do Turvo',
    'estado': 'SP'
  },
  {
    'id': '4768',
    'nome': 'Barretos',
    'estado': 'SP'
  },
  {
    'id': '4769',
    'nome': 'Barrinha',
    'estado': 'SP'
  },
  {
    'id': '4770',
    'nome': 'Barueri',
    'estado': 'SP'
  },
  {
    'id': '4771',
    'nome': 'Bastos',
    'estado': 'SP'
  },
  {
    'id': '4772',
    'nome': 'Batatais',
    'estado': 'SP'
  },
  {
    'id': '4773',
    'nome': 'Bauru',
    'estado': 'SP'
  },
  {
    'id': '4774',
    'nome': 'Bebedouro',
    'estado': 'SP'
  },
  {
    'id': '4775',
    'nome': 'Bento de Abreu',
    'estado': 'SP'
  },
  {
    'id': '4776',
    'nome': 'Bernardino de Campos',
    'estado': 'SP'
  },
  {
    'id': '4777',
    'nome': 'Bertioga',
    'estado': 'SP'
  },
  {
    'id': '4778',
    'nome': 'Bilac',
    'estado': 'SP'
  },
  {
    'id': '4779',
    'nome': 'Birigui',
    'estado': 'SP'
  },
  {
    'id': '4780',
    'nome': 'Biritiba-Mirim',
    'estado': 'SP'
  },
  {
    'id': '4781',
    'nome': 'Boa Esperança do Sul',
    'estado': 'SP'
  },
  {
    'id': '4782',
    'nome': 'Bocaina',
    'estado': 'SP'
  },
  {
    'id': '4783',
    'nome': 'Bofete',
    'estado': 'SP'
  },
  {
    'id': '4784',
    'nome': 'Boituva',
    'estado': 'SP'
  },
  {
    'id': '4785',
    'nome': 'Bom Jesus dos Perdões',
    'estado': 'SP'
  },
  {
    'id': '4786',
    'nome': 'Bom Sucesso de Itararé',
    'estado': 'SP'
  },
  {
    'id': '4787',
    'nome': 'Borá',
    'estado': 'SP'
  },
  {
    'id': '4788',
    'nome': 'Boracéia',
    'estado': 'SP'
  },
  {
    'id': '4789',
    'nome': 'Borborema',
    'estado': 'SP'
  },
  {
    'id': '4790',
    'nome': 'Borebi',
    'estado': 'SP'
  },
  {
    'id': '4791',
    'nome': 'Botucatu',
    'estado': 'SP'
  },
  {
    'id': '4792',
    'nome': 'Bragança Paulista',
    'estado': 'SP'
  },
  {
    'id': '4793',
    'nome': 'Braúna',
    'estado': 'SP'
  },
  {
    'id': '4794',
    'nome': 'Brejo Alegre',
    'estado': 'SP'
  },
  {
    'id': '4795',
    'nome': 'Brodowski',
    'estado': 'SP'
  },
  {
    'id': '4796',
    'nome': 'Brotas',
    'estado': 'SP'
  },
  {
    'id': '4797',
    'nome': 'Buri',
    'estado': 'SP'
  },
  {
    'id': '4798',
    'nome': 'Buritama',
    'estado': 'SP'
  },
  {
    'id': '4799',
    'nome': 'Buritizal',
    'estado': 'SP'
  },
  {
    'id': '4800',
    'nome': 'Cabrália Paulista',
    'estado': 'SP'
  },
  {
    'id': '4801',
    'nome': 'Cabreúva',
    'estado': 'SP'
  },
  {
    'id': '4802',
    'nome': 'Caçapava',
    'estado': 'SP'
  },
  {
    'id': '4803',
    'nome': 'Cachoeira Paulista',
    'estado': 'SP'
  },
  {
    'id': '4804',
    'nome': 'Caconde',
    'estado': 'SP'
  },
  {
    'id': '4805',
    'nome': 'Cafelândia',
    'estado': 'SP'
  },
  {
    'id': '4806',
    'nome': 'Caiabu',
    'estado': 'SP'
  },
  {
    'id': '4807',
    'nome': 'Caieiras',
    'estado': 'SP'
  },
  {
    'id': '4808',
    'nome': 'Caiuá',
    'estado': 'SP'
  },
  {
    'id': '4809',
    'nome': 'Cajamar',
    'estado': 'SP'
  },
  {
    'id': '4810',
    'nome': 'Cajati',
    'estado': 'SP'
  },
  {
    'id': '4811',
    'nome': 'Cajobi',
    'estado': 'SP'
  },
  {
    'id': '4812',
    'nome': 'Cajuru',
    'estado': 'SP'
  },
  {
    'id': '4813',
    'nome': 'Campina do Monte Alegre',
    'estado': 'SP'
  },
  {
    'id': '4814',
    'nome': 'Campinas',
    'estado': 'SP'
  },
  {
    'id': '4815',
    'nome': 'Campo Limpo Paulista',
    'estado': 'SP'
  },
  {
    'id': '4816',
    'nome': 'Campos do Jordão',
    'estado': 'SP'
  },
  {
    'id': '4817',
    'nome': 'Campos Novos Paulista',
    'estado': 'SP'
  },
  {
    'id': '4818',
    'nome': 'Cananéia',
    'estado': 'SP'
  },
  {
    'id': '4819',
    'nome': 'Canas',
    'estado': 'SP'
  },
  {
    'id': '4820',
    'nome': 'Cândido Mota',
    'estado': 'SP'
  },
  {
    'id': '4821',
    'nome': 'Cândido Rodrigues',
    'estado': 'SP'
  },
  {
    'id': '4822',
    'nome': 'Canitar',
    'estado': 'SP'
  },
  {
    'id': '4823',
    'nome': 'Capão Bonito',
    'estado': 'SP'
  },
  {
    'id': '4824',
    'nome': 'Capela do Alto',
    'estado': 'SP'
  },
  {
    'id': '4825',
    'nome': 'Capivari',
    'estado': 'SP'
  },
  {
    'id': '4826',
    'nome': 'Caraguatatuba',
    'estado': 'SP'
  },
  {
    'id': '4827',
    'nome': 'Carapicuíba',
    'estado': 'SP'
  },
  {
    'id': '4828',
    'nome': 'Cardoso',
    'estado': 'SP'
  },
  {
    'id': '4829',
    'nome': 'Casa Branca',
    'estado': 'SP'
  },
  {
    'id': '4830',
    'nome': 'Cássia dos Coqueiros',
    'estado': 'SP'
  },
  {
    'id': '4831',
    'nome': 'Castilho',
    'estado': 'SP'
  },
  {
    'id': '4832',
    'nome': 'Catanduva',
    'estado': 'SP'
  },
  {
    'id': '4833',
    'nome': 'Catiguá',
    'estado': 'SP'
  },
  {
    'id': '4834',
    'nome': 'Cedral',
    'estado': 'SP'
  },
  {
    'id': '4835',
    'nome': 'Cerqueira César',
    'estado': 'SP'
  },
  {
    'id': '4836',
    'nome': 'Cerquilho',
    'estado': 'SP'
  },
  {
    'id': '4837',
    'nome': 'Cesário Lange',
    'estado': 'SP'
  },
  {
    'id': '4838',
    'nome': 'Charqueada',
    'estado': 'SP'
  },
  {
    'id': '4839',
    'nome': 'Chavantes',
    'estado': 'SP'
  },
  {
    'id': '4840',
    'nome': 'Clementina',
    'estado': 'SP'
  },
  {
    'id': '4841',
    'nome': 'Colina',
    'estado': 'SP'
  },
  {
    'id': '4842',
    'nome': 'Colômbia',
    'estado': 'SP'
  },
  {
    'id': '4843',
    'nome': 'Conchal',
    'estado': 'SP'
  },
  {
    'id': '4844',
    'nome': 'Conchas',
    'estado': 'SP'
  },
  {
    'id': '4845',
    'nome': 'Cordeirópolis',
    'estado': 'SP'
  },
  {
    'id': '4846',
    'nome': 'Coroados',
    'estado': 'SP'
  },
  {
    'id': '4847',
    'nome': 'Coronel Macedo',
    'estado': 'SP'
  },
  {
    'id': '4848',
    'nome': 'Corumbataí',
    'estado': 'SP'
  },
  {
    'id': '4849',
    'nome': 'Cosmópolis',
    'estado': 'SP'
  },
  {
    'id': '4850',
    'nome': 'Cosmorama',
    'estado': 'SP'
  },
  {
    'id': '4851',
    'nome': 'Cotia',
    'estado': 'SP'
  },
  {
    'id': '4852',
    'nome': 'Cravinhos',
    'estado': 'SP'
  },
  {
    'id': '4853',
    'nome': 'Cristais Paulista',
    'estado': 'SP'
  },
  {
    'id': '4854',
    'nome': 'Cruzália',
    'estado': 'SP'
  },
  {
    'id': '4855',
    'nome': 'Cruzeiro',
    'estado': 'SP'
  },
  {
    'id': '4856',
    'nome': 'Cubatão',
    'estado': 'SP'
  },
  {
    'id': '4857',
    'nome': 'Cunha',
    'estado': 'SP'
  },
  {
    'id': '4858',
    'nome': 'Descalvado',
    'estado': 'SP'
  },
  {
    'id': '4859',
    'nome': 'Diadema',
    'estado': 'SP'
  },
  {
    'id': '4860',
    'nome': 'Dirce Reis',
    'estado': 'SP'
  },
  {
    'id': '4861',
    'nome': 'Divinolândia',
    'estado': 'SP'
  },
  {
    'id': '4862',
    'nome': 'Dobrada',
    'estado': 'SP'
  },
  {
    'id': '4863',
    'nome': 'Dois Córregos',
    'estado': 'SP'
  },
  {
    'id': '4864',
    'nome': 'Dolcinópolis',
    'estado': 'SP'
  },
  {
    'id': '4865',
    'nome': 'Dourado',
    'estado': 'SP'
  },
  {
    'id': '4866',
    'nome': 'Dracena',
    'estado': 'SP'
  },
  {
    'id': '4867',
    'nome': 'Duartina',
    'estado': 'SP'
  },
  {
    'id': '4868',
    'nome': 'Dumont',
    'estado': 'SP'
  },
  {
    'id': '4869',
    'nome': 'Echaporã',
    'estado': 'SP'
  },
  {
    'id': '4870',
    'nome': 'Eldorado',
    'estado': 'SP'
  },
  {
    'id': '4871',
    'nome': 'Elias Fausto',
    'estado': 'SP'
  },
  {
    'id': '4872',
    'nome': 'Elisiário',
    'estado': 'SP'
  },
  {
    'id': '4873',
    'nome': 'Embaúba',
    'estado': 'SP'
  },
  {
    'id': '4874',
    'nome': 'Embu',
    'estado': 'SP'
  },
  {
    'id': '4875',
    'nome': 'Embu-Guaçu',
    'estado': 'SP'
  },
  {
    'id': '4876',
    'nome': 'Emilianópolis',
    'estado': 'SP'
  },
  {
    'id': '4877',
    'nome': 'Engenheiro Coelho',
    'estado': 'SP'
  },
  {
    'id': '4878',
    'nome': 'Espírito Santo do Pinhal',
    'estado': 'SP'
  },
  {
    'id': '4879',
    'nome': 'Espírito Santo do Turvo',
    'estado': 'SP'
  },
  {
    'id': '4880',
    'nome': 'Estiva Gerbi',
    'estado': 'SP'
  },
  {
    'id': '4881',
    'nome': 'Estrela d`Oeste',
    'estado': 'SP'
  },
  {
    'id': '4882',
    'nome': 'Estrela do Norte',
    'estado': 'SP'
  },
  {
    'id': '4883',
    'nome': 'Euclides da Cunha Paulista',
    'estado': 'SP'
  },
  {
    'id': '4884',
    'nome': 'Fartura',
    'estado': 'SP'
  },
  {
    'id': '4885',
    'nome': 'Fernando Prestes',
    'estado': 'SP'
  },
  {
    'id': '4886',
    'nome': 'Fernandópolis',
    'estado': 'SP'
  },
  {
    'id': '4887',
    'nome': 'Fernão',
    'estado': 'SP'
  },
  {
    'id': '4888',
    'nome': 'Ferraz de Vasconcelos',
    'estado': 'SP'
  },
  {
    'id': '4889',
    'nome': 'Flora Rica',
    'estado': 'SP'
  },
  {
    'id': '4890',
    'nome': 'Floreal',
    'estado': 'SP'
  },
  {
    'id': '4891',
    'nome': 'Flórida Paulista',
    'estado': 'SP'
  },
  {
    'id': '4892',
    'nome': 'Florínia',
    'estado': 'SP'
  },
  {
    'id': '4893',
    'nome': 'Franca',
    'estado': 'SP'
  },
  {
    'id': '4894',
    'nome': 'Francisco Morato',
    'estado': 'SP'
  },
  {
    'id': '4895',
    'nome': 'Franco da Rocha',
    'estado': 'SP'
  },
  {
    'id': '4896',
    'nome': 'Gabriel Monteiro',
    'estado': 'SP'
  },
  {
    'id': '4897',
    'nome': 'Gália',
    'estado': 'SP'
  },
  {
    'id': '4898',
    'nome': 'Garça',
    'estado': 'SP'
  },
  {
    'id': '4899',
    'nome': 'Gastão Vidigal',
    'estado': 'SP'
  },
  {
    'id': '4900',
    'nome': 'Gavião Peixoto',
    'estado': 'SP'
  },
  {
    'id': '4901',
    'nome': 'General Salgado',
    'estado': 'SP'
  },
  {
    'id': '4902',
    'nome': 'Getulina',
    'estado': 'SP'
  },
  {
    'id': '4903',
    'nome': 'Glicério',
    'estado': 'SP'
  },
  {
    'id': '4904',
    'nome': 'Guaiçara',
    'estado': 'SP'
  },
  {
    'id': '4905',
    'nome': 'Guaimbê',
    'estado': 'SP'
  },
  {
    'id': '4906',
    'nome': 'Guaíra',
    'estado': 'SP'
  },
  {
    'id': '4907',
    'nome': 'Guapiaçu',
    'estado': 'SP'
  },
  {
    'id': '4908',
    'nome': 'Guapiara',
    'estado': 'SP'
  },
  {
    'id': '4909',
    'nome': 'Guará',
    'estado': 'SP'
  },
  {
    'id': '4910',
    'nome': 'Guaraçaí',
    'estado': 'SP'
  },
  {
    'id': '4911',
    'nome': 'Guaraci',
    'estado': 'SP'
  },
  {
    'id': '4912',
    'nome': 'Guarani d`Oeste',
    'estado': 'SP'
  },
  {
    'id': '4913',
    'nome': 'Guarantã',
    'estado': 'SP'
  },
  {
    'id': '4914',
    'nome': 'Guararapes',
    'estado': 'SP'
  },
  {
    'id': '4915',
    'nome': 'Guararema',
    'estado': 'SP'
  },
  {
    'id': '4916',
    'nome': 'Guaratinguetá',
    'estado': 'SP'
  },
  {
    'id': '4917',
    'nome': 'Guareí',
    'estado': 'SP'
  },
  {
    'id': '4918',
    'nome': 'Guariba',
    'estado': 'SP'
  },
  {
    'id': '4919',
    'nome': 'Guarujá',
    'estado': 'SP'
  },
  {
    'id': '4920',
    'nome': 'Guarulhos',
    'estado': 'SP'
  },
  {
    'id': '4921',
    'nome': 'Guatapará',
    'estado': 'SP'
  },
  {
    'id': '4922',
    'nome': 'Guzolândia',
    'estado': 'SP'
  },
  {
    'id': '4923',
    'nome': 'Herculândia',
    'estado': 'SP'
  },
  {
    'id': '4924',
    'nome': 'Holambra',
    'estado': 'SP'
  },
  {
    'id': '4925',
    'nome': 'Hortolândia',
    'estado': 'SP'
  },
  {
    'id': '4926',
    'nome': 'Iacanga',
    'estado': 'SP'
  },
  {
    'id': '4927',
    'nome': 'Iacri',
    'estado': 'SP'
  },
  {
    'id': '4928',
    'nome': 'Iaras',
    'estado': 'SP'
  },
  {
    'id': '4929',
    'nome': 'Ibaté',
    'estado': 'SP'
  },
  {
    'id': '4930',
    'nome': 'Ibirá',
    'estado': 'SP'
  },
  {
    'id': '4931',
    'nome': 'Ibirarema',
    'estado': 'SP'
  },
  {
    'id': '4932',
    'nome': 'Ibitinga',
    'estado': 'SP'
  },
  {
    'id': '4933',
    'nome': 'Ibiúna',
    'estado': 'SP'
  },
  {
    'id': '4934',
    'nome': 'Icém',
    'estado': 'SP'
  },
  {
    'id': '4935',
    'nome': 'Iepê',
    'estado': 'SP'
  },
  {
    'id': '4936',
    'nome': 'Igaraçu do Tietê',
    'estado': 'SP'
  },
  {
    'id': '4937',
    'nome': 'Igarapava',
    'estado': 'SP'
  },
  {
    'id': '4938',
    'nome': 'Igaratá',
    'estado': 'SP'
  },
  {
    'id': '4939',
    'nome': 'Iguape',
    'estado': 'SP'
  },
  {
    'id': '4940',
    'nome': 'Ilha Comprida',
    'estado': 'SP'
  },
  {
    'id': '4941',
    'nome': 'Ilha Solteira',
    'estado': 'SP'
  },
  {
    'id': '4942',
    'nome': 'Ilhabela',
    'estado': 'SP'
  },
  {
    'id': '4943',
    'nome': 'Indaiatuba',
    'estado': 'SP'
  },
  {
    'id': '4944',
    'nome': 'Indiana',
    'estado': 'SP'
  },
  {
    'id': '4945',
    'nome': 'Indiaporã',
    'estado': 'SP'
  },
  {
    'id': '4946',
    'nome': 'Inúbia Paulista',
    'estado': 'SP'
  },
  {
    'id': '4947',
    'nome': 'Ipaussu',
    'estado': 'SP'
  },
  {
    'id': '4948',
    'nome': 'Iperó',
    'estado': 'SP'
  },
  {
    'id': '4949',
    'nome': 'Ipeúna',
    'estado': 'SP'
  },
  {
    'id': '4950',
    'nome': 'Ipiguá',
    'estado': 'SP'
  },
  {
    'id': '4951',
    'nome': 'Iporanga',
    'estado': 'SP'
  },
  {
    'id': '4952',
    'nome': 'Ipuã',
    'estado': 'SP'
  },
  {
    'id': '4953',
    'nome': 'Iracemápolis',
    'estado': 'SP'
  },
  {
    'id': '4954',
    'nome': 'Irapuã',
    'estado': 'SP'
  },
  {
    'id': '4955',
    'nome': 'Irapuru',
    'estado': 'SP'
  },
  {
    'id': '4956',
    'nome': 'Itaberá',
    'estado': 'SP'
  },
  {
    'id': '4957',
    'nome': 'Itaí',
    'estado': 'SP'
  },
  {
    'id': '4958',
    'nome': 'Itajobi',
    'estado': 'SP'
  },
  {
    'id': '4959',
    'nome': 'Itaju',
    'estado': 'SP'
  },
  {
    'id': '4960',
    'nome': 'Itanhaém',
    'estado': 'SP'
  },
  {
    'id': '4961',
    'nome': 'Itaóca',
    'estado': 'SP'
  },
  {
    'id': '4962',
    'nome': 'Itapecerica da Serra',
    'estado': 'SP'
  },
  {
    'id': '4963',
    'nome': 'Itapetininga',
    'estado': 'SP'
  },
  {
    'id': '4964',
    'nome': 'Itapeva',
    'estado': 'SP'
  },
  {
    'id': '4965',
    'nome': 'Itapevi',
    'estado': 'SP'
  },
  {
    'id': '4966',
    'nome': 'Itapira',
    'estado': 'SP'
  },
  {
    'id': '4967',
    'nome': 'Itapirapuã Paulista',
    'estado': 'SP'
  },
  {
    'id': '4968',
    'nome': 'Itápolis',
    'estado': 'SP'
  },
  {
    'id': '4969',
    'nome': 'Itaporanga',
    'estado': 'SP'
  },
  {
    'id': '4970',
    'nome': 'Itapuí',
    'estado': 'SP'
  },
  {
    'id': '4971',
    'nome': 'Itapura',
    'estado': 'SP'
  },
  {
    'id': '4972',
    'nome': 'Itaquaquecetuba',
    'estado': 'SP'
  },
  {
    'id': '4973',
    'nome': 'Itararé',
    'estado': 'SP'
  },
  {
    'id': '4974',
    'nome': 'Itariri',
    'estado': 'SP'
  },
  {
    'id': '4975',
    'nome': 'Itatiba',
    'estado': 'SP'
  },
  {
    'id': '4976',
    'nome': 'Itatinga',
    'estado': 'SP'
  },
  {
    'id': '4977',
    'nome': 'Itirapina',
    'estado': 'SP'
  },
  {
    'id': '4978',
    'nome': 'Itirapuã',
    'estado': 'SP'
  },
  {
    'id': '4979',
    'nome': 'Itobi',
    'estado': 'SP'
  },
  {
    'id': '4980',
    'nome': 'Itu',
    'estado': 'SP'
  },
  {
    'id': '4981',
    'nome': 'Itupeva',
    'estado': 'SP'
  },
  {
    'id': '4982',
    'nome': 'Ituverava',
    'estado': 'SP'
  },
  {
    'id': '4983',
    'nome': 'Jaborandi',
    'estado': 'SP'
  },
  {
    'id': '4984',
    'nome': 'Jaboticabal',
    'estado': 'SP'
  },
  {
    'id': '4985',
    'nome': 'Jacareí',
    'estado': 'SP'
  },
  {
    'id': '4986',
    'nome': 'Jaci',
    'estado': 'SP'
  },
  {
    'id': '4987',
    'nome': 'Jacupiranga',
    'estado': 'SP'
  },
  {
    'id': '4988',
    'nome': 'Jaguariúna',
    'estado': 'SP'
  },
  {
    'id': '4989',
    'nome': 'Jales',
    'estado': 'SP'
  },
  {
    'id': '4990',
    'nome': 'Jambeiro',
    'estado': 'SP'
  },
  {
    'id': '4991',
    'nome': 'Jandira',
    'estado': 'SP'
  },
  {
    'id': '4992',
    'nome': 'Jardinópolis',
    'estado': 'SP'
  },
  {
    'id': '4993',
    'nome': 'Jarinu',
    'estado': 'SP'
  },
  {
    'id': '4994',
    'nome': 'Jaú',
    'estado': 'SP'
  },
  {
    'id': '4995',
    'nome': 'Jeriquara',
    'estado': 'SP'
  },
  {
    'id': '4996',
    'nome': 'Joanópolis',
    'estado': 'SP'
  },
  {
    'id': '4997',
    'nome': 'João Ramalho',
    'estado': 'SP'
  },
  {
    'id': '4998',
    'nome': 'José Bonifácio',
    'estado': 'SP'
  },
  {
    'id': '4999',
    'nome': 'Júlio Mesquita',
    'estado': 'SP'
  },
  {
    'id': '5000',
    'nome': 'Jumirim',
    'estado': 'SP'
  },
  {
    'id': '5001',
    'nome': 'Jundiaí',
    'estado': 'SP'
  },
  {
    'id': '5002',
    'nome': 'Junqueirópolis',
    'estado': 'SP'
  },
  {
    'id': '5003',
    'nome': 'Juquiá',
    'estado': 'SP'
  },
  {
    'id': '5004',
    'nome': 'Juquitiba',
    'estado': 'SP'
  },
  {
    'id': '5005',
    'nome': 'Lagoinha',
    'estado': 'SP'
  },
  {
    'id': '5006',
    'nome': 'Laranjal Paulista',
    'estado': 'SP'
  },
  {
    'id': '5007',
    'nome': 'Lavínia',
    'estado': 'SP'
  },
  {
    'id': '5008',
    'nome': 'Lavrinhas',
    'estado': 'SP'
  },
  {
    'id': '5009',
    'nome': 'Leme',
    'estado': 'SP'
  },
  {
    'id': '5010',
    'nome': 'Lençóis Paulista',
    'estado': 'SP'
  },
  {
    'id': '5011',
    'nome': 'Limeira',
    'estado': 'SP'
  },
  {
    'id': '5012',
    'nome': 'Lindóia',
    'estado': 'SP'
  },
  {
    'id': '5013',
    'nome': 'Lins',
    'estado': 'SP'
  },
  {
    'id': '5014',
    'nome': 'Lorena',
    'estado': 'SP'
  },
  {
    'id': '5015',
    'nome': 'Lourdes',
    'estado': 'SP'
  },
  {
    'id': '5016',
    'nome': 'Louveira',
    'estado': 'SP'
  },
  {
    'id': '5017',
    'nome': 'Lucélia',
    'estado': 'SP'
  },
  {
    'id': '5018',
    'nome': 'Lucianópolis',
    'estado': 'SP'
  },
  {
    'id': '5019',
    'nome': 'Luís Antônio',
    'estado': 'SP'
  },
  {
    'id': '5020',
    'nome': 'Luiziânia',
    'estado': 'SP'
  },
  {
    'id': '5021',
    'nome': 'Lupércio',
    'estado': 'SP'
  },
  {
    'id': '5022',
    'nome': 'Lutécia',
    'estado': 'SP'
  },
  {
    'id': '5023',
    'nome': 'Macatuba',
    'estado': 'SP'
  },
  {
    'id': '5024',
    'nome': 'Macaubal',
    'estado': 'SP'
  },
  {
    'id': '5025',
    'nome': 'Macedônia',
    'estado': 'SP'
  },
  {
    'id': '5026',
    'nome': 'Magda',
    'estado': 'SP'
  },
  {
    'id': '5027',
    'nome': 'Mairinque',
    'estado': 'SP'
  },
  {
    'id': '5028',
    'nome': 'Mairiporã',
    'estado': 'SP'
  },
  {
    'id': '5029',
    'nome': 'Manduri',
    'estado': 'SP'
  },
  {
    'id': '5030',
    'nome': 'Marabá Paulista',
    'estado': 'SP'
  },
  {
    'id': '5031',
    'nome': 'Maracaí',
    'estado': 'SP'
  },
  {
    'id': '5032',
    'nome': 'Marapoama',
    'estado': 'SP'
  },
  {
    'id': '5033',
    'nome': 'Mariápolis',
    'estado': 'SP'
  },
  {
    'id': '5034',
    'nome': 'Marília',
    'estado': 'SP'
  },
  {
    'id': '5035',
    'nome': 'Marinópolis',
    'estado': 'SP'
  },
  {
    'id': '5036',
    'nome': 'Martinópolis',
    'estado': 'SP'
  },
  {
    'id': '5037',
    'nome': 'Matão',
    'estado': 'SP'
  },
  {
    'id': '5038',
    'nome': 'Mauá',
    'estado': 'SP'
  },
  {
    'id': '5039',
    'nome': 'Mendonça',
    'estado': 'SP'
  },
  {
    'id': '5040',
    'nome': 'Meridiano',
    'estado': 'SP'
  },
  {
    'id': '5041',
    'nome': 'Mesópolis',
    'estado': 'SP'
  },
  {
    'id': '5042',
    'nome': 'Miguelópolis',
    'estado': 'SP'
  },
  {
    'id': '5043',
    'nome': 'Mineiros do Tietê',
    'estado': 'SP'
  },
  {
    'id': '5044',
    'nome': 'Mira Estrela',
    'estado': 'SP'
  },
  {
    'id': '5045',
    'nome': 'Miracatu',
    'estado': 'SP'
  },
  {
    'id': '5046',
    'nome': 'Mirandópolis',
    'estado': 'SP'
  },
  {
    'id': '5047',
    'nome': 'Mirante do Paranapanema',
    'estado': 'SP'
  },
  {
    'id': '5048',
    'nome': 'Mirassol',
    'estado': 'SP'
  },
  {
    'id': '5049',
    'nome': 'Mirassolândia',
    'estado': 'SP'
  },
  {
    'id': '5050',
    'nome': 'Mococa',
    'estado': 'SP'
  },
  {
    'id': '5051',
    'nome': 'Mogi das Cruzes',
    'estado': 'SP'
  },
  {
    'id': '5052',
    'nome': 'Mogi Guaçu',
    'estado': 'SP'
  },
  {
    'id': '5053',
    'nome': 'Moji Mirim',
    'estado': 'SP'
  },
  {
    'id': '5054',
    'nome': 'Mombuca',
    'estado': 'SP'
  },
  {
    'id': '5055',
    'nome': 'Monções',
    'estado': 'SP'
  },
  {
    'id': '5056',
    'nome': 'Mongaguá',
    'estado': 'SP'
  },
  {
    'id': '5057',
    'nome': 'Monte Alegre do Sul',
    'estado': 'SP'
  },
  {
    'id': '5058',
    'nome': 'Monte Alto',
    'estado': 'SP'
  },
  {
    'id': '5059',
    'nome': 'Monte Aprazível',
    'estado': 'SP'
  },
  {
    'id': '5060',
    'nome': 'Monte Azul Paulista',
    'estado': 'SP'
  },
  {
    'id': '5061',
    'nome': 'Monte Castelo',
    'estado': 'SP'
  },
  {
    'id': '5062',
    'nome': 'Monte Mor',
    'estado': 'SP'
  },
  {
    'id': '5063',
    'nome': 'Monteiro Lobato',
    'estado': 'SP'
  },
  {
    'id': '5064',
    'nome': 'Morro Agudo',
    'estado': 'SP'
  },
  {
    'id': '5065',
    'nome': 'Morungaba',
    'estado': 'SP'
  },
  {
    'id': '5066',
    'nome': 'Motuca',
    'estado': 'SP'
  },
  {
    'id': '5067',
    'nome': 'Murutinga do Sul',
    'estado': 'SP'
  },
  {
    'id': '5068',
    'nome': 'Nantes',
    'estado': 'SP'
  },
  {
    'id': '5069',
    'nome': 'Narandiba',
    'estado': 'SP'
  },
  {
    'id': '5070',
    'nome': 'Natividade da Serra',
    'estado': 'SP'
  },
  {
    'id': '5071',
    'nome': 'Nazaré Paulista',
    'estado': 'SP'
  },
  {
    'id': '5072',
    'nome': 'Neves Paulista',
    'estado': 'SP'
  },
  {
    'id': '5073',
    'nome': 'Nhandeara',
    'estado': 'SP'
  },
  {
    'id': '5074',
    'nome': 'Nipoã',
    'estado': 'SP'
  },
  {
    'id': '5075',
    'nome': 'Nova Aliança',
    'estado': 'SP'
  },
  {
    'id': '5076',
    'nome': 'Nova Campina',
    'estado': 'SP'
  },
  {
    'id': '5077',
    'nome': 'Nova Canaã Paulista',
    'estado': 'SP'
  },
  {
    'id': '5078',
    'nome': 'Nova Castilho',
    'estado': 'SP'
  },
  {
    'id': '5079',
    'nome': 'Nova Europa',
    'estado': 'SP'
  },
  {
    'id': '5080',
    'nome': 'Nova Granada',
    'estado': 'SP'
  },
  {
    'id': '5081',
    'nome': 'Nova Guataporanga',
    'estado': 'SP'
  },
  {
    'id': '5082',
    'nome': 'Nova Independência',
    'estado': 'SP'
  },
  {
    'id': '5083',
    'nome': 'Nova Luzitânia',
    'estado': 'SP'
  },
  {
    'id': '5084',
    'nome': 'Nova Odessa',
    'estado': 'SP'
  },
  {
    'id': '5085',
    'nome': 'Novais',
    'estado': 'SP'
  },
  {
    'id': '5086',
    'nome': 'Novo Horizonte',
    'estado': 'SP'
  },
  {
    'id': '5087',
    'nome': 'Nuporanga',
    'estado': 'SP'
  },
  {
    'id': '5088',
    'nome': 'Ocauçu',
    'estado': 'SP'
  },
  {
    'id': '5089',
    'nome': 'Óleo',
    'estado': 'SP'
  },
  {
    'id': '5090',
    'nome': 'Olímpia',
    'estado': 'SP'
  },
  {
    'id': '5091',
    'nome': 'Onda Verde',
    'estado': 'SP'
  },
  {
    'id': '5092',
    'nome': 'Oriente',
    'estado': 'SP'
  },
  {
    'id': '5093',
    'nome': 'Orindiúva',
    'estado': 'SP'
  },
  {
    'id': '5094',
    'nome': 'Orlândia',
    'estado': 'SP'
  },
  {
    'id': '5095',
    'nome': 'Osasco',
    'estado': 'SP'
  },
  {
    'id': '5096',
    'nome': 'Oscar Bressane',
    'estado': 'SP'
  },
  {
    'id': '5097',
    'nome': 'Osvaldo Cruz',
    'estado': 'SP'
  },
  {
    'id': '5098',
    'nome': 'Ourinhos',
    'estado': 'SP'
  },
  {
    'id': '5099',
    'nome': 'Ouro Verde',
    'estado': 'SP'
  },
  {
    'id': '5100',
    'nome': 'Ouroeste',
    'estado': 'SP'
  },
  {
    'id': '5101',
    'nome': 'Pacaembu',
    'estado': 'SP'
  },
  {
    'id': '5102',
    'nome': 'Palestina',
    'estado': 'SP'
  },
  {
    'id': '5103',
    'nome': 'Palmares Paulista',
    'estado': 'SP'
  },
  {
    'id': '5104',
    'nome': 'Palmeira d`Oeste',
    'estado': 'SP'
  },
  {
    'id': '5105',
    'nome': 'Palmital',
    'estado': 'SP'
  },
  {
    'id': '5106',
    'nome': 'Panorama',
    'estado': 'SP'
  },
  {
    'id': '5107',
    'nome': 'Paraguaçu Paulista',
    'estado': 'SP'
  },
  {
    'id': '5108',
    'nome': 'Paraibuna',
    'estado': 'SP'
  },
  {
    'id': '5109',
    'nome': 'Paraíso',
    'estado': 'SP'
  },
  {
    'id': '5110',
    'nome': 'Paranapanema',
    'estado': 'SP'
  },
  {
    'id': '5111',
    'nome': 'Paranapuã',
    'estado': 'SP'
  },
  {
    'id': '5112',
    'nome': 'Parapuã',
    'estado': 'SP'
  },
  {
    'id': '5113',
    'nome': 'Pardinho',
    'estado': 'SP'
  },
  {
    'id': '5114',
    'nome': 'Pariquera-Açu',
    'estado': 'SP'
  },
  {
    'id': '5115',
    'nome': 'Parisi',
    'estado': 'SP'
  },
  {
    'id': '5116',
    'nome': 'Patrocínio Paulista',
    'estado': 'SP'
  },
  {
    'id': '5117',
    'nome': 'Paulicéia',
    'estado': 'SP'
  },
  {
    'id': '5118',
    'nome': 'Paulínia',
    'estado': 'SP'
  },
  {
    'id': '5119',
    'nome': 'Paulistânia',
    'estado': 'SP'
  },
  {
    'id': '5120',
    'nome': 'Paulo de Faria',
    'estado': 'SP'
  },
  {
    'id': '5121',
    'nome': 'Pederneiras',
    'estado': 'SP'
  },
  {
    'id': '5122',
    'nome': 'Pedra Bela',
    'estado': 'SP'
  },
  {
    'id': '5123',
    'nome': 'Pedranópolis',
    'estado': 'SP'
  },
  {
    'id': '5124',
    'nome': 'Pedregulho',
    'estado': 'SP'
  },
  {
    'id': '5125',
    'nome': 'Pedreira',
    'estado': 'SP'
  },
  {
    'id': '5126',
    'nome': 'Pedrinhas Paulista',
    'estado': 'SP'
  },
  {
    'id': '5127',
    'nome': 'Pedro de Toledo',
    'estado': 'SP'
  },
  {
    'id': '5128',
    'nome': 'Penápolis',
    'estado': 'SP'
  },
  {
    'id': '5129',
    'nome': 'Pereira Barreto',
    'estado': 'SP'
  },
  {
    'id': '5130',
    'nome': 'Pereiras',
    'estado': 'SP'
  },
  {
    'id': '5131',
    'nome': 'Peruíbe',
    'estado': 'SP'
  },
  {
    'id': '5132',
    'nome': 'Piacatu',
    'estado': 'SP'
  },
  {
    'id': '5133',
    'nome': 'Piedade',
    'estado': 'SP'
  },
  {
    'id': '5134',
    'nome': 'Pilar do Sul',
    'estado': 'SP'
  },
  {
    'id': '5135',
    'nome': 'Pindamonhangaba',
    'estado': 'SP'
  },
  {
    'id': '5136',
    'nome': 'Pindorama',
    'estado': 'SP'
  },
  {
    'id': '5137',
    'nome': 'Pinhalzinho',
    'estado': 'SP'
  },
  {
    'id': '5138',
    'nome': 'Piquerobi',
    'estado': 'SP'
  },
  {
    'id': '5139',
    'nome': 'Piquete',
    'estado': 'SP'
  },
  {
    'id': '5140',
    'nome': 'Piracaia',
    'estado': 'SP'
  },
  {
    'id': '5141',
    'nome': 'Piracicaba',
    'estado': 'SP'
  },
  {
    'id': '5142',
    'nome': 'Piraju',
    'estado': 'SP'
  },
  {
    'id': '5143',
    'nome': 'Pirajuí',
    'estado': 'SP'
  },
  {
    'id': '5144',
    'nome': 'Pirangi',
    'estado': 'SP'
  },
  {
    'id': '5145',
    'nome': 'Pirapora do Bom Jesus',
    'estado': 'SP'
  },
  {
    'id': '5146',
    'nome': 'Pirapozinho',
    'estado': 'SP'
  },
  {
    'id': '5147',
    'nome': 'Pirassununga',
    'estado': 'SP'
  },
  {
    'id': '5148',
    'nome': 'Piratininga',
    'estado': 'SP'
  },
  {
    'id': '5149',
    'nome': 'Pitangueiras',
    'estado': 'SP'
  },
  {
    'id': '5150',
    'nome': 'Planalto',
    'estado': 'SP'
  },
  {
    'id': '5151',
    'nome': 'Platina',
    'estado': 'SP'
  },
  {
    'id': '5152',
    'nome': 'Poá',
    'estado': 'SP'
  },
  {
    'id': '5153',
    'nome': 'Poloni',
    'estado': 'SP'
  },
  {
    'id': '5154',
    'nome': 'Pompéia',
    'estado': 'SP'
  },
  {
    'id': '5155',
    'nome': 'Pongaí',
    'estado': 'SP'
  },
  {
    'id': '5156',
    'nome': 'Pontal',
    'estado': 'SP'
  },
  {
    'id': '5157',
    'nome': 'Pontalinda',
    'estado': 'SP'
  },
  {
    'id': '5158',
    'nome': 'Pontes Gestal',
    'estado': 'SP'
  },
  {
    'id': '5159',
    'nome': 'Populina',
    'estado': 'SP'
  },
  {
    'id': '5160',
    'nome': 'Porangaba',
    'estado': 'SP'
  },
  {
    'id': '5161',
    'nome': 'Porto Feliz',
    'estado': 'SP'
  },
  {
    'id': '5162',
    'nome': 'Porto Ferreira',
    'estado': 'SP'
  },
  {
    'id': '5163',
    'nome': 'Potim',
    'estado': 'SP'
  },
  {
    'id': '5164',
    'nome': 'Potirendaba',
    'estado': 'SP'
  },
  {
    'id': '5165',
    'nome': 'Pracinha',
    'estado': 'SP'
  },
  {
    'id': '5166',
    'nome': 'Pradópolis',
    'estado': 'SP'
  },
  {
    'id': '5167',
    'nome': 'Praia Grande',
    'estado': 'SP'
  },
  {
    'id': '5168',
    'nome': 'Pratânia',
    'estado': 'SP'
  },
  {
    'id': '5169',
    'nome': 'Presidente Alves',
    'estado': 'SP'
  },
  {
    'id': '5170',
    'nome': 'Presidente Bernardes',
    'estado': 'SP'
  },
  {
    'id': '5171',
    'nome': 'Presidente Epitácio',
    'estado': 'SP'
  },
  {
    'id': '5172',
    'nome': 'Presidente Prudente',
    'estado': 'SP'
  },
  {
    'id': '5173',
    'nome': 'Presidente Venceslau',
    'estado': 'SP'
  },
  {
    'id': '5174',
    'nome': 'Promissão',
    'estado': 'SP'
  },
  {
    'id': '5175',
    'nome': 'Quadra',
    'estado': 'SP'
  },
  {
    'id': '5176',
    'nome': 'Quatá',
    'estado': 'SP'
  },
  {
    'id': '5177',
    'nome': 'Queiroz',
    'estado': 'SP'
  },
  {
    'id': '5178',
    'nome': 'Queluz',
    'estado': 'SP'
  },
  {
    'id': '5179',
    'nome': 'Quintana',
    'estado': 'SP'
  },
  {
    'id': '5180',
    'nome': 'Rafard',
    'estado': 'SP'
  },
  {
    'id': '5181',
    'nome': 'Rancharia',
    'estado': 'SP'
  },
  {
    'id': '5182',
    'nome': 'Redenção da Serra',
    'estado': 'SP'
  },
  {
    'id': '5183',
    'nome': 'Regente Feijó',
    'estado': 'SP'
  },
  {
    'id': '5184',
    'nome': 'Reginópolis',
    'estado': 'SP'
  },
  {
    'id': '5185',
    'nome': 'Registro',
    'estado': 'SP'
  },
  {
    'id': '5186',
    'nome': 'Restinga',
    'estado': 'SP'
  },
  {
    'id': '5187',
    'nome': 'Ribeira',
    'estado': 'SP'
  },
  {
    'id': '5188',
    'nome': 'Ribeirão Bonito',
    'estado': 'SP'
  },
  {
    'id': '5189',
    'nome': 'Ribeirão Branco',
    'estado': 'SP'
  },
  {
    'id': '5190',
    'nome': 'Ribeirão Corrente',
    'estado': 'SP'
  },
  {
    'id': '5191',
    'nome': 'Ribeirão do Sul',
    'estado': 'SP'
  },
  {
    'id': '5192',
    'nome': 'Ribeirão dos Índios',
    'estado': 'SP'
  },
  {
    'id': '5193',
    'nome': 'Ribeirão Grande',
    'estado': 'SP'
  },
  {
    'id': '5194',
    'nome': 'Ribeirão Pires',
    'estado': 'SP'
  },
  {
    'id': '5195',
    'nome': 'Ribeirão Preto',
    'estado': 'SP'
  },
  {
    'id': '5196',
    'nome': 'Rifaina',
    'estado': 'SP'
  },
  {
    'id': '5197',
    'nome': 'Rincão',
    'estado': 'SP'
  },
  {
    'id': '5198',
    'nome': 'Rinópolis',
    'estado': 'SP'
  },
  {
    'id': '5199',
    'nome': 'Rio Claro',
    'estado': 'SP'
  },
  {
    'id': '5200',
    'nome': 'Rio das Pedras',
    'estado': 'SP'
  },
  {
    'id': '5201',
    'nome': 'Rio Grande da Serra',
    'estado': 'SP'
  },
  {
    'id': '5202',
    'nome': 'Riolândia',
    'estado': 'SP'
  },
  {
    'id': '5203',
    'nome': 'Riversul',
    'estado': 'SP'
  },
  {
    'id': '5204',
    'nome': 'Rosana',
    'estado': 'SP'
  },
  {
    'id': '5205',
    'nome': 'Roseira',
    'estado': 'SP'
  },
  {
    'id': '5206',
    'nome': 'Rubiácea',
    'estado': 'SP'
  },
  {
    'id': '5207',
    'nome': 'Rubinéia',
    'estado': 'SP'
  },
  {
    'id': '5208',
    'nome': 'Sabino',
    'estado': 'SP'
  },
  {
    'id': '5209',
    'nome': 'Sagres',
    'estado': 'SP'
  },
  {
    'id': '5210',
    'nome': 'Sales',
    'estado': 'SP'
  },
  {
    'id': '5211',
    'nome': 'Sales Oliveira',
    'estado': 'SP'
  },
  {
    'id': '5212',
    'nome': 'Salesópolis',
    'estado': 'SP'
  },
  {
    'id': '5213',
    'nome': 'Salmourão',
    'estado': 'SP'
  },
  {
    'id': '5214',
    'nome': 'Saltinho',
    'estado': 'SP'
  },
  {
    'id': '5215',
    'nome': 'Salto',
    'estado': 'SP'
  },
  {
    'id': '5216',
    'nome': 'Salto de Pirapora',
    'estado': 'SP'
  },
  {
    'id': '5217',
    'nome': 'Salto Grande',
    'estado': 'SP'
  },
  {
    'id': '5218',
    'nome': 'Sandovalina',
    'estado': 'SP'
  },
  {
    'id': '5219',
    'nome': 'Santa Adélia',
    'estado': 'SP'
  },
  {
    'id': '5220',
    'nome': 'Santa Albertina',
    'estado': 'SP'
  },
  {
    'id': '5221',
    'nome': 'Santa Bárbara d`Oeste',
    'estado': 'SP'
  },
  {
    'id': '5222',
    'nome': 'Santa Branca',
    'estado': 'SP'
  },
  {
    'id': '5223',
    'nome': 'Santa Clara d`Oeste',
    'estado': 'SP'
  },
  {
    'id': '5224',
    'nome': 'Santa Cruz da Conceição',
    'estado': 'SP'
  },
  {
    'id': '5225',
    'nome': 'Santa Cruz da Esperança',
    'estado': 'SP'
  },
  {
    'id': '5226',
    'nome': 'Santa Cruz das Palmeiras',
    'estado': 'SP'
  },
  {
    'id': '5227',
    'nome': 'Santa Cruz do Rio Pardo',
    'estado': 'SP'
  },
  {
    'id': '5228',
    'nome': 'Santa Ernestina',
    'estado': 'SP'
  },
  {
    'id': '5229',
    'nome': 'Santa Fé do Sul',
    'estado': 'SP'
  },
  {
    'id': '5230',
    'nome': 'Santa Gertrudes',
    'estado': 'SP'
  },
  {
    'id': '5231',
    'nome': 'Santa Isabel',
    'estado': 'SP'
  },
  {
    'id': '5232',
    'nome': 'Santa Lúcia',
    'estado': 'SP'
  },
  {
    'id': '5233',
    'nome': 'Santa Maria da Serra',
    'estado': 'SP'
  },
  {
    'id': '5234',
    'nome': 'Santa Mercedes',
    'estado': 'SP'
  },
  {
    'id': '5235',
    'nome': 'Santa Rita d`Oeste',
    'estado': 'SP'
  },
  {
    'id': '5236',
    'nome': 'Santa Rita do Passa Quatro',
    'estado': 'SP'
  },
  {
    'id': '5237',
    'nome': 'Santa Rosa de Viterbo',
    'estado': 'SP'
  },
  {
    'id': '5238',
    'nome': 'Santa Salete',
    'estado': 'SP'
  },
  {
    'id': '5239',
    'nome': 'Santana da Ponte Pensa',
    'estado': 'SP'
  },
  {
    'id': '5240',
    'nome': 'Santana de Parnaíba',
    'estado': 'SP'
  },
  {
    'id': '5241',
    'nome': 'Santo Anastácio',
    'estado': 'SP'
  },
  {
    'id': '5242',
    'nome': 'Santo André',
    'estado': 'SP'
  },
  {
    'id': '5243',
    'nome': 'Santo Antônio da Alegria',
    'estado': 'SP'
  },
  {
    'id': '5244',
    'nome': 'Santo Antônio de Posse',
    'estado': 'SP'
  },
  {
    'id': '5245',
    'nome': 'Santo Antônio do Aracanguá',
    'estado': 'SP'
  },
  {
    'id': '5246',
    'nome': 'Santo Antônio do Jardim',
    'estado': 'SP'
  },
  {
    'id': '5247',
    'nome': 'Santo Antônio do Pinhal',
    'estado': 'SP'
  },
  {
    'id': '5248',
    'nome': 'Santo Expedito',
    'estado': 'SP'
  },
  {
    'id': '5249',
    'nome': 'Santópolis do Aguapeí',
    'estado': 'SP'
  },
  {
    'id': '5250',
    'nome': 'Santos',
    'estado': 'SP'
  },
  {
    'id': '5251',
    'nome': 'São Bento do Sapucaí',
    'estado': 'SP'
  },
  {
    'id': '5252',
    'nome': 'São Bernardo do Campo',
    'estado': 'SP'
  },
  {
    'id': '5253',
    'nome': 'São Caetano do Sul',
    'estado': 'SP'
  },
  {
    'id': '5254',
    'nome': 'São Carlos',
    'estado': 'SP'
  },
  {
    'id': '5255',
    'nome': 'São Francisco',
    'estado': 'SP'
  },
  {
    'id': '5256',
    'nome': 'São João da Boa Vista',
    'estado': 'SP'
  },
  {
    'id': '5257',
    'nome': 'São João das Duas Pontes',
    'estado': 'SP'
  },
  {
    'id': '5258',
    'nome': 'São João de Iracema',
    'estado': 'SP'
  },
  {
    'id': '5259',
    'nome': 'São João do Pau d`Alho',
    'estado': 'SP'
  },
  {
    'id': '5260',
    'nome': 'São Joaquim da Barra',
    'estado': 'SP'
  },
  {
    'id': '5261',
    'nome': 'São José da Bela Vista',
    'estado': 'SP'
  },
  {
    'id': '5262',
    'nome': 'São José do Barreiro',
    'estado': 'SP'
  },
  {
    'id': '5263',
    'nome': 'São José do Rio Pardo',
    'estado': 'SP'
  },
  {
    'id': '5264',
    'nome': 'São José do Rio Preto',
    'estado': 'SP'
  },
  {
    'id': '5265',
    'nome': 'São José dos Campos',
    'estado': 'SP'
  },
  {
    'id': '5266',
    'nome': 'São Lourenço da Serra',
    'estado': 'SP'
  },
  {
    'id': '5267',
    'nome': 'São Luís do Paraitinga',
    'estado': 'SP'
  },
  {
    'id': '5268',
    'nome': 'São Manuel',
    'estado': 'SP'
  },
  {
    'id': '5269',
    'nome': 'São Miguel Arcanjo',
    'estado': 'SP'
  },
  {
    'id': '5270',
    'nome': 'São Paulo',
    'estado': 'SP'
  },
  {
    'id': '5271',
    'nome': 'São Pedro',
    'estado': 'SP'
  },
  {
    'id': '5272',
    'nome': 'São Pedro do Turvo',
    'estado': 'SP'
  },
  {
    'id': '5273',
    'nome': 'São Roque',
    'estado': 'SP'
  },
  {
    'id': '5274',
    'nome': 'São Sebastião',
    'estado': 'SP'
  },
  {
    'id': '5275',
    'nome': 'São Sebastião da Grama',
    'estado': 'SP'
  },
  {
    'id': '5276',
    'nome': 'São Simão',
    'estado': 'SP'
  },
  {
    'id': '5277',
    'nome': 'São Vicente',
    'estado': 'SP'
  },
  {
    'id': '5278',
    'nome': 'Sarapuí',
    'estado': 'SP'
  },
  {
    'id': '5279',
    'nome': 'Sarutaiá',
    'estado': 'SP'
  },
  {
    'id': '5280',
    'nome': 'Sebastianópolis do Sul',
    'estado': 'SP'
  },
  {
    'id': '5281',
    'nome': 'Serra Azul',
    'estado': 'SP'
  },
  {
    'id': '5282',
    'nome': 'Serra Negra',
    'estado': 'SP'
  },
  {
    'id': '5283',
    'nome': 'Serrana',
    'estado': 'SP'
  },
  {
    'id': '5284',
    'nome': 'Sertãozinho',
    'estado': 'SP'
  },
  {
    'id': '5285',
    'nome': 'Sete Barras',
    'estado': 'SP'
  },
  {
    'id': '5286',
    'nome': 'Severínia',
    'estado': 'SP'
  },
  {
    'id': '5287',
    'nome': 'Silveiras',
    'estado': 'SP'
  },
  {
    'id': '5288',
    'nome': 'Socorro',
    'estado': 'SP'
  },
  {
    'id': '5289',
    'nome': 'Sorocaba',
    'estado': 'SP'
  },
  {
    'id': '5290',
    'nome': 'Sud Mennucci',
    'estado': 'SP'
  },
  {
    'id': '5291',
    'nome': 'Sumaré',
    'estado': 'SP'
  },
  {
    'id': '5292',
    'nome': 'Suzanápolis',
    'estado': 'SP'
  },
  {
    'id': '5293',
    'nome': 'Suzano',
    'estado': 'SP'
  },
  {
    'id': '5294',
    'nome': 'Tabapuã',
    'estado': 'SP'
  },
  {
    'id': '5295',
    'nome': 'Tabatinga',
    'estado': 'SP'
  },
  {
    'id': '5296',
    'nome': 'Taboão da Serra',
    'estado': 'SP'
  },
  {
    'id': '5297',
    'nome': 'Taciba',
    'estado': 'SP'
  },
  {
    'id': '5298',
    'nome': 'Taguaí',
    'estado': 'SP'
  },
  {
    'id': '5299',
    'nome': 'Taiaçu',
    'estado': 'SP'
  },
  {
    'id': '5300',
    'nome': 'Taiúva',
    'estado': 'SP'
  },
  {
    'id': '5301',
    'nome': 'Tambaú',
    'estado': 'SP'
  },
  {
    'id': '5302',
    'nome': 'Tanabi',
    'estado': 'SP'
  },
  {
    'id': '5303',
    'nome': 'Tapiraí',
    'estado': 'SP'
  },
  {
    'id': '5304',
    'nome': 'Tapiratiba',
    'estado': 'SP'
  },
  {
    'id': '5305',
    'nome': 'Taquaral',
    'estado': 'SP'
  },
  {
    'id': '5306',
    'nome': 'Taquaritinga',
    'estado': 'SP'
  },
  {
    'id': '5307',
    'nome': 'Taquarituba',
    'estado': 'SP'
  },
  {
    'id': '5308',
    'nome': 'Taquarivaí',
    'estado': 'SP'
  },
  {
    'id': '5309',
    'nome': 'Tarabai',
    'estado': 'SP'
  },
  {
    'id': '5310',
    'nome': 'Tarumã',
    'estado': 'SP'
  },
  {
    'id': '5311',
    'nome': 'Tatuí',
    'estado': 'SP'
  },
  {
    'id': '5312',
    'nome': 'Taubaté',
    'estado': 'SP'
  },
  {
    'id': '5313',
    'nome': 'Tejupá',
    'estado': 'SP'
  },
  {
    'id': '5314',
    'nome': 'Teodoro Sampaio',
    'estado': 'SP'
  },
  {
    'id': '5315',
    'nome': 'Terra Roxa',
    'estado': 'SP'
  },
  {
    'id': '5316',
    'nome': 'Tietê',
    'estado': 'SP'
  },
  {
    'id': '5317',
    'nome': 'Timburi',
    'estado': 'SP'
  },
  {
    'id': '5318',
    'nome': 'Torre de Pedra',
    'estado': 'SP'
  },
  {
    'id': '5319',
    'nome': 'Torrinha',
    'estado': 'SP'
  },
  {
    'id': '5320',
    'nome': 'Trabiju',
    'estado': 'SP'
  },
  {
    'id': '5321',
    'nome': 'Tremembé',
    'estado': 'SP'
  },
  {
    'id': '5322',
    'nome': 'Três Fronteiras',
    'estado': 'SP'
  },
  {
    'id': '5323',
    'nome': 'Tuiuti',
    'estado': 'SP'
  },
  {
    'id': '5324',
    'nome': 'Tupã',
    'estado': 'SP'
  },
  {
    'id': '5325',
    'nome': 'Tupi Paulista',
    'estado': 'SP'
  },
  {
    'id': '5326',
    'nome': 'Turiúba',
    'estado': 'SP'
  },
  {
    'id': '5327',
    'nome': 'Turmalina',
    'estado': 'SP'
  },
  {
    'id': '5328',
    'nome': 'Ubarana',
    'estado': 'SP'
  },
  {
    'id': '5329',
    'nome': 'Ubatuba',
    'estado': 'SP'
  },
  {
    'id': '5330',
    'nome': 'Ubirajara',
    'estado': 'SP'
  },
  {
    'id': '5331',
    'nome': 'Uchoa',
    'estado': 'SP'
  },
  {
    'id': '5332',
    'nome': 'União Paulista',
    'estado': 'SP'
  },
  {
    'id': '5333',
    'nome': 'Urânia',
    'estado': 'SP'
  },
  {
    'id': '5334',
    'nome': 'Uru',
    'estado': 'SP'
  },
  {
    'id': '5335',
    'nome': 'Urupês',
    'estado': 'SP'
  },
  {
    'id': '5336',
    'nome': 'Valentim Gentil',
    'estado': 'SP'
  },
  {
    'id': '5337',
    'nome': 'Valinhos',
    'estado': 'SP'
  },
  {
    'id': '5338',
    'nome': 'Valparaíso',
    'estado': 'SP'
  },
  {
    'id': '5339',
    'nome': 'Vargem',
    'estado': 'SP'
  },
  {
    'id': '5340',
    'nome': 'Vargem Grande do Sul',
    'estado': 'SP'
  },
  {
    'id': '5341',
    'nome': 'Vargem Grande Paulista',
    'estado': 'SP'
  },
  {
    'id': '5342',
    'nome': 'Várzea Paulista',
    'estado': 'SP'
  },
  {
    'id': '5343',
    'nome': 'Vera Cruz',
    'estado': 'SP'
  },
  {
    'id': '5344',
    'nome': 'Vinhedo',
    'estado': 'SP'
  },
  {
    'id': '5345',
    'nome': 'Viradouro',
    'estado': 'SP'
  },
  {
    'id': '5346',
    'nome': 'Vista Alegre do Alto',
    'estado': 'SP'
  },
  {
    'id': '5347',
    'nome': 'Vitória Brasil',
    'estado': 'SP'
  },
  {
    'id': '5348',
    'nome': 'Votorantim',
    'estado': 'SP'
  },
  {
    'id': '5349',
    'nome': 'Votuporanga',
    'estado': 'SP'
  },
  {
    'id': '5350',
    'nome': 'Zacarias',
    'estado': 'SP'
  },
  {
    'id': '5351',
    'nome': 'Amparo de São Francisco',
    'estado': 'SE'
  },
  {
    'id': '5352',
    'nome': 'Aquidabã',
    'estado': 'SE'
  },
  {
    'id': '5353',
    'nome': 'Aracaju',
    'estado': 'SE'
  },
  {
    'id': '5354',
    'nome': 'Arauá',
    'estado': 'SE'
  },
  {
    'id': '5355',
    'nome': 'Areia Branca',
    'estado': 'SE'
  },
  {
    'id': '5356',
    'nome': 'Barra dos Coqueiros',
    'estado': 'SE'
  },
  {
    'id': '5357',
    'nome': 'Boquim',
    'estado': 'SE'
  },
  {
    'id': '5358',
    'nome': 'Brejo Grande',
    'estado': 'SE'
  },
  {
    'id': '5359',
    'nome': 'Campo do Brito',
    'estado': 'SE'
  },
  {
    'id': '5360',
    'nome': 'Canhoba',
    'estado': 'SE'
  },
  {
    'id': '5361',
    'nome': 'Canindé de São Francisco',
    'estado': 'SE'
  },
  {
    'id': '5362',
    'nome': 'Capela',
    'estado': 'SE'
  },
  {
    'id': '5363',
    'nome': 'Carira',
    'estado': 'SE'
  },
  {
    'id': '5364',
    'nome': 'Carmópolis',
    'estado': 'SE'
  },
  {
    'id': '5365',
    'nome': 'Cedro de São João',
    'estado': 'SE'
  },
  {
    'id': '5366',
    'nome': 'Cristinápolis',
    'estado': 'SE'
  },
  {
    'id': '5367',
    'nome': 'Cumbe',
    'estado': 'SE'
  },
  {
    'id': '5368',
    'nome': 'Divina Pastora',
    'estado': 'SE'
  },
  {
    'id': '5369',
    'nome': 'Estância',
    'estado': 'SE'
  },
  {
    'id': '5370',
    'nome': 'Feira Nova',
    'estado': 'SE'
  },
  {
    'id': '5371',
    'nome': 'Frei Paulo',
    'estado': 'SE'
  },
  {
    'id': '5372',
    'nome': 'Gararu',
    'estado': 'SE'
  },
  {
    'id': '5373',
    'nome': 'General Maynard',
    'estado': 'SE'
  },
  {
    'id': '5374',
    'nome': 'Gracho Cardoso',
    'estado': 'SE'
  },
  {
    'id': '5375',
    'nome': 'Ilha das Flores',
    'estado': 'SE'
  },
  {
    'id': '5376',
    'nome': 'Indiaroba',
    'estado': 'SE'
  },
  {
    'id': '5377',
    'nome': 'Itabaiana',
    'estado': 'SE'
  },
  {
    'id': '5378',
    'nome': 'Itabaianinha',
    'estado': 'SE'
  },
  {
    'id': '5379',
    'nome': 'Itabi',
    'estado': 'SE'
  },
  {
    'id': '5380',
    'nome': 'Itaporanga d`Ajuda',
    'estado': 'SE'
  },
  {
    'id': '5381',
    'nome': 'Japaratuba',
    'estado': 'SE'
  },
  {
    'id': '5382',
    'nome': 'Japoatã',
    'estado': 'SE'
  },
  {
    'id': '5383',
    'nome': 'Lagarto',
    'estado': 'SE'
  },
  {
    'id': '5384',
    'nome': 'Laranjeiras',
    'estado': 'SE'
  },
  {
    'id': '5385',
    'nome': 'Macambira',
    'estado': 'SE'
  },
  {
    'id': '5386',
    'nome': 'Malhada dos Bois',
    'estado': 'SE'
  },
  {
    'id': '5387',
    'nome': 'Malhador',
    'estado': 'SE'
  },
  {
    'id': '5388',
    'nome': 'Maruim',
    'estado': 'SE'
  },
  {
    'id': '5389',
    'nome': 'Moita Bonita',
    'estado': 'SE'
  },
  {
    'id': '5390',
    'nome': 'Monte Alegre de Sergipe',
    'estado': 'SE'
  },
  {
    'id': '5391',
    'nome': 'Muribeca',
    'estado': 'SE'
  },
  {
    'id': '5392',
    'nome': 'Neópolis',
    'estado': 'SE'
  },
  {
    'id': '5393',
    'nome': 'Nossa Senhora Aparecida',
    'estado': 'SE'
  },
  {
    'id': '5394',
    'nome': 'Nossa Senhora da Glória',
    'estado': 'SE'
  },
  {
    'id': '5395',
    'nome': 'Nossa Senhora das Dores',
    'estado': 'SE'
  },
  {
    'id': '5396',
    'nome': 'Nossa Senhora de Lourdes',
    'estado': 'SE'
  },
  {
    'id': '5397',
    'nome': 'Nossa Senhora do Socorro',
    'estado': 'SE'
  },
  {
    'id': '5398',
    'nome': 'Pacatuba',
    'estado': 'SE'
  },
  {
    'id': '5399',
    'nome': 'Pedra Mole',
    'estado': 'SE'
  },
  {
    'id': '5400',
    'nome': 'Pedrinhas',
    'estado': 'SE'
  },
  {
    'id': '5401',
    'nome': 'Pinhão',
    'estado': 'SE'
  },
  {
    'id': '5402',
    'nome': 'Pirambu',
    'estado': 'SE'
  },
  {
    'id': '5403',
    'nome': 'Poço Redondo',
    'estado': 'SE'
  },
  {
    'id': '5404',
    'nome': 'Poço Verde',
    'estado': 'SE'
  },
  {
    'id': '5405',
    'nome': 'Porto da Folha',
    'estado': 'SE'
  },
  {
    'id': '5406',
    'nome': 'Propriá',
    'estado': 'SE'
  },
  {
    'id': '5407',
    'nome': 'Riachão do Dantas',
    'estado': 'SE'
  },
  {
    'id': '5408',
    'nome': 'Riachuelo',
    'estado': 'SE'
  },
  {
    'id': '5409',
    'nome': 'Ribeirópolis',
    'estado': 'SE'
  },
  {
    'id': '5410',
    'nome': 'Rosário do Catete',
    'estado': 'SE'
  },
  {
    'id': '5411',
    'nome': 'Salgado',
    'estado': 'SE'
  },
  {
    'id': '5412',
    'nome': 'Santa Luzia do Itanhy',
    'estado': 'SE'
  },
  {
    'id': '5413',
    'nome': 'Santa Rosa de Lima',
    'estado': 'SE'
  },
  {
    'id': '5414',
    'nome': 'Santana do São Francisco',
    'estado': 'SE'
  },
  {
    'id': '5415',
    'nome': 'Santo Amaro das Brotas',
    'estado': 'SE'
  },
  {
    'id': '5416',
    'nome': 'São Cristóvão',
    'estado': 'SE'
  },
  {
    'id': '5417',
    'nome': 'São Domingos',
    'estado': 'SE'
  },
  {
    'id': '5418',
    'nome': 'São Francisco',
    'estado': 'SE'
  },
  {
    'id': '5419',
    'nome': 'São Miguel do Aleixo',
    'estado': 'SE'
  },
  {
    'id': '5420',
    'nome': 'Simão Dias',
    'estado': 'SE'
  },
  {
    'id': '5421',
    'nome': 'Siriri',
    'estado': 'SE'
  },
  {
    'id': '5422',
    'nome': 'Telha',
    'estado': 'SE'
  },
  {
    'id': '5423',
    'nome': 'Tobias Barreto',
    'estado': 'SE'
  },
  {
    'id': '5424',
    'nome': 'Tomar do Geru',
    'estado': 'SE'
  },
  {
    'id': '5425',
    'nome': 'Umbaúba',
    'estado': 'SE'
  },
  {
    'id': '5426',
    'nome': 'Abreulândia',
    'estado': 'TO'
  },
  {
    'id': '5427',
    'nome': 'Aguiarnópolis',
    'estado': 'TO'
  },
  {
    'id': '5428',
    'nome': 'Aliança do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5429',
    'nome': 'Almas',
    'estado': 'TO'
  },
  {
    'id': '5430',
    'nome': 'Alvorada',
    'estado': 'TO'
  },
  {
    'id': '5431',
    'nome': 'Ananás',
    'estado': 'TO'
  },
  {
    'id': '5432',
    'nome': 'Angico',
    'estado': 'TO'
  },
  {
    'id': '5433',
    'nome': 'Aparecida do Rio Negro',
    'estado': 'TO'
  },
  {
    'id': '5434',
    'nome': 'Aragominas',
    'estado': 'TO'
  },
  {
    'id': '5435',
    'nome': 'Araguacema',
    'estado': 'TO'
  },
  {
    'id': '5436',
    'nome': 'Araguaçu',
    'estado': 'TO'
  },
  {
    'id': '5437',
    'nome': 'Araguaína',
    'estado': 'TO'
  },
  {
    'id': '5438',
    'nome': 'Araguanã',
    'estado': 'TO'
  },
  {
    'id': '5439',
    'nome': 'Araguatins',
    'estado': 'TO'
  },
  {
    'id': '5440',
    'nome': 'Arapoema',
    'estado': 'TO'
  },
  {
    'id': '5441',
    'nome': 'Arraias',
    'estado': 'TO'
  },
  {
    'id': '5442',
    'nome': 'Augustinópolis',
    'estado': 'TO'
  },
  {
    'id': '5443',
    'nome': 'Aurora do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5444',
    'nome': 'Axixá do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5445',
    'nome': 'Babaçulândia',
    'estado': 'TO'
  },
  {
    'id': '5446',
    'nome': 'Bandeirantes do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5447',
    'nome': 'Barra do Ouro',
    'estado': 'TO'
  },
  {
    'id': '5448',
    'nome': 'Barrolândia',
    'estado': 'TO'
  },
  {
    'id': '5449',
    'nome': 'Bernardo Sayão',
    'estado': 'TO'
  },
  {
    'id': '5450',
    'nome': 'Bom Jesus do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5451',
    'nome': 'Brasilândia do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5452',
    'nome': 'Brejinho de Nazaré',
    'estado': 'TO'
  },
  {
    'id': '5453',
    'nome': 'Buriti do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5454',
    'nome': 'Cachoeirinha',
    'estado': 'TO'
  },
  {
    'id': '5455',
    'nome': 'Campos Lindos',
    'estado': 'TO'
  },
  {
    'id': '5456',
    'nome': 'Cariri do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5457',
    'nome': 'Carmolândia',
    'estado': 'TO'
  },
  {
    'id': '5458',
    'nome': 'Carrasco Bonito',
    'estado': 'TO'
  },
  {
    'id': '5459',
    'nome': 'Caseara',
    'estado': 'TO'
  },
  {
    'id': '5460',
    'nome': 'Centenário',
    'estado': 'TO'
  },
  {
    'id': '5461',
    'nome': 'Chapada da Natividade',
    'estado': 'TO'
  },
  {
    'id': '5462',
    'nome': 'Chapada de Areia',
    'estado': 'TO'
  },
  {
    'id': '5463',
    'nome': 'Colinas do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5464',
    'nome': 'Colméia',
    'estado': 'TO'
  },
  {
    'id': '5465',
    'nome': 'Combinado',
    'estado': 'TO'
  },
  {
    'id': '5466',
    'nome': 'Conceição do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5467',
    'nome': 'Couto de Magalhães',
    'estado': 'TO'
  },
  {
    'id': '5468',
    'nome': 'Cristalândia',
    'estado': 'TO'
  },
  {
    'id': '5469',
    'nome': 'Crixás do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5470',
    'nome': 'Darcinópolis',
    'estado': 'TO'
  },
  {
    'id': '5471',
    'nome': 'Dianópolis',
    'estado': 'TO'
  },
  {
    'id': '5472',
    'nome': 'Divinópolis do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5473',
    'nome': 'Dois Irmãos do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5474',
    'nome': 'Dueré',
    'estado': 'TO'
  },
  {
    'id': '5475',
    'nome': 'Esperantina',
    'estado': 'TO'
  },
  {
    'id': '5476',
    'nome': 'Fátima',
    'estado': 'TO'
  },
  {
    'id': '5477',
    'nome': 'Figueirópolis',
    'estado': 'TO'
  },
  {
    'id': '5478',
    'nome': 'Filadélfia',
    'estado': 'TO'
  },
  {
    'id': '5479',
    'nome': 'Formoso do Araguaia',
    'estado': 'TO'
  },
  {
    'id': '5480',
    'nome': 'Fortaleza do Tabocão',
    'estado': 'TO'
  },
  {
    'id': '5481',
    'nome': 'Goianorte',
    'estado': 'TO'
  },
  {
    'id': '5482',
    'nome': 'Goiatins',
    'estado': 'TO'
  },
  {
    'id': '5483',
    'nome': 'Guaraí',
    'estado': 'TO'
  },
  {
    'id': '5484',
    'nome': 'Gurupi',
    'estado': 'TO'
  },
  {
    'id': '5485',
    'nome': 'Ipueiras',
    'estado': 'TO'
  },
  {
    'id': '5486',
    'nome': 'Itacajá',
    'estado': 'TO'
  },
  {
    'id': '5487',
    'nome': 'Itaguatins',
    'estado': 'TO'
  },
  {
    'id': '5488',
    'nome': 'Itapiratins',
    'estado': 'TO'
  },
  {
    'id': '5489',
    'nome': 'Itaporã do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5490',
    'nome': 'Jaú do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5491',
    'nome': 'Juarina',
    'estado': 'TO'
  },
  {
    'id': '5492',
    'nome': 'Lagoa da Confusão',
    'estado': 'TO'
  },
  {
    'id': '5493',
    'nome': 'Lagoa do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5494',
    'nome': 'Lajeado',
    'estado': 'TO'
  },
  {
    'id': '5495',
    'nome': 'Lavandeira',
    'estado': 'TO'
  },
  {
    'id': '5496',
    'nome': 'Lizarda',
    'estado': 'TO'
  },
  {
    'id': '5497',
    'nome': 'Luzinópolis',
    'estado': 'TO'
  },
  {
    'id': '5498',
    'nome': 'Marianópolis do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5499',
    'nome': 'Mateiros',
    'estado': 'TO'
  },
  {
    'id': '5500',
    'nome': 'Maurilândia do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5501',
    'nome': 'Miracema do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5502',
    'nome': 'Miranorte',
    'estado': 'TO'
  },
  {
    'id': '5503',
    'nome': 'Monte do Carmo',
    'estado': 'TO'
  },
  {
    'id': '5504',
    'nome': 'Monte Santo do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5505',
    'nome': 'Muricilândia',
    'estado': 'TO'
  },
  {
    'id': '5506',
    'nome': 'Natividade',
    'estado': 'TO'
  },
  {
    'id': '5507',
    'nome': 'Nazaré',
    'estado': 'TO'
  },
  {
    'id': '5508',
    'nome': 'Nova Olinda',
    'estado': 'TO'
  },
  {
    'id': '5509',
    'nome': 'Nova Rosalândia',
    'estado': 'TO'
  },
  {
    'id': '5510',
    'nome': 'Novo Acordo',
    'estado': 'TO'
  },
  {
    'id': '5511',
    'nome': 'Novo Alegre',
    'estado': 'TO'
  },
  {
    'id': '5512',
    'nome': 'Novo Jardim',
    'estado': 'TO'
  },
  {
    'id': '5513',
    'nome': 'Oliveira de Fátima',
    'estado': 'TO'
  },
  {
    'id': '5514',
    'nome': 'Palmas',
    'estado': 'TO'
  },
  {
    'id': '5515',
    'nome': 'Palmeirante',
    'estado': 'TO'
  },
  {
    'id': '5516',
    'nome': 'Palmeiras do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5517',
    'nome': 'Palmeirópolis',
    'estado': 'TO'
  },
  {
    'id': '5518',
    'nome': 'Paraíso do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5519',
    'nome': 'Paranã',
    'estado': 'TO'
  },
  {
    'id': '5520',
    'nome': 'Pau d`Arco',
    'estado': 'TO'
  },
  {
    'id': '5521',
    'nome': 'Pedro Afonso',
    'estado': 'TO'
  },
  {
    'id': '5522',
    'nome': 'Peixe',
    'estado': 'TO'
  },
  {
    'id': '5523',
    'nome': 'Pequizeiro',
    'estado': 'TO'
  },
  {
    'id': '5524',
    'nome': 'Pindorama do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5525',
    'nome': 'Piraquê',
    'estado': 'TO'
  },
  {
    'id': '5526',
    'nome': 'Pium',
    'estado': 'TO'
  },
  {
    'id': '5527',
    'nome': 'Ponte Alta do Bom Jesus',
    'estado': 'TO'
  },
  {
    'id': '5528',
    'nome': 'Ponte Alta do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5529',
    'nome': 'Porto Alegre do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5530',
    'nome': 'Porto Nacional',
    'estado': 'TO'
  },
  {
    'id': '5531',
    'nome': 'Praia Norte',
    'estado': 'TO'
  },
  {
    'id': '5532',
    'nome': 'Presidente Kennedy',
    'estado': 'TO'
  },
  {
    'id': '5533',
    'nome': 'Pugmil',
    'estado': 'TO'
  },
  {
    'id': '5534',
    'nome': 'Recursolândia',
    'estado': 'TO'
  },
  {
    'id': '5535',
    'nome': 'Riachinho',
    'estado': 'TO'
  },
  {
    'id': '5536',
    'nome': 'Rio da Conceição',
    'estado': 'TO'
  },
  {
    'id': '5537',
    'nome': 'Rio dos Bois',
    'estado': 'TO'
  },
  {
    'id': '5538',
    'nome': 'Rio Sono',
    'estado': 'TO'
  },
  {
    'id': '5539',
    'nome': 'Sampaio',
    'estado': 'TO'
  },
  {
    'id': '5540',
    'nome': 'Sandolândia',
    'estado': 'TO'
  },
  {
    'id': '5541',
    'nome': 'Santa Fé do Araguaia',
    'estado': 'TO'
  },
  {
    'id': '5542',
    'nome': 'Santa Maria do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5543',
    'nome': 'Santa Rita do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5544',
    'nome': 'Santa Rosa do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5545',
    'nome': 'Santa Tereza do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5546',
    'nome': 'Santa Terezinha do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5547',
    'nome': 'São Bento do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5548',
    'nome': 'São Félix do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5549',
    'nome': 'São Miguel do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5550',
    'nome': 'São Salvador do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5551',
    'nome': 'São Sebastião do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5552',
    'nome': 'São Valério da Natividade',
    'estado': 'TO'
  },
  {
    'id': '5553',
    'nome': 'Silvanópolis',
    'estado': 'TO'
  },
  {
    'id': '5554',
    'nome': 'Sítio Novo do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5555',
    'nome': 'Sucupira',
    'estado': 'TO'
  },
  {
    'id': '5556',
    'nome': 'Taguatinga',
    'estado': 'TO'
  },
  {
    'id': '5557',
    'nome': 'Taipas do Tocantins',
    'estado': 'TO'
  },
  {
    'id': '5558',
    'nome': 'Talismã',
    'estado': 'TO'
  },
  {
    'id': '5559',
    'nome': 'Tocantínia',
    'estado': 'TO'
  },
  {
    'id': '5560',
    'nome': 'Tocantinópolis',
    'estado': 'TO'
  },
  {
    'id': '5561',
    'nome': 'Tupirama',
    'estado': 'TO'
  },
  {
    'id': '5562',
    'nome': 'Tupiratins',
    'estado': 'TO'
  },
  {
    'id': '5563',
    'nome': 'Wanderlândia',
    'estado': 'TO'
  },
  {
    'id': '5564',
    'nome': 'Xambioá',
    'estado': 'TO'
  }]
}



// WEBPACK FOOTER //
// ./src/store/cidades.js